// Auto-generated from js/names.json — pool of randomized employee names
// used to populate org-chart nodes. Regenerate by transforming names.json.
const EMPLOYEE_NAMES = ["Barbara Dillon","Alvin Wyatt","Liberty Hill","Isaac Carter","Lucy Long","Jace Harding","Aniya Nielsen","Tru Cole","Margaret Singh","Louis Beltran","Kaydence Hampton","Hank Blair","Frances Castaneda","Collin Aguilar","Josie Compton","Abner Drake","Jayleen Little","Lennox McKenzie","Briar Lester","Lee Lawrence","Lauren Phillips","Andrew Willis","Alexa Townsend","Alexis Evans","Eliana Marin","Aldo Knox","Kallie Rowe","Kamden Harding","Aniya Sharp","Royce Fernandez","Amara Mata","Ray Burns","Emerson Carr","Kash Rivera","Lillian Short","Hezekiah Sellers","Mercy Santana","Mohamed Simpson","Anastasia Powers","Sean Lim","Giavanna Phan","Maison Trevino","Priscilla Love","Jeffrey Tran","Kylie Clarke","Stetson Ortiz","Anna Arias","Alec Chan","Hattie Boyer","Zeke Bravo","Amoura Stevenson","Callan Chan","Hattie Lynn","Zechariah Pacheco","Paris Dudley","Colter Garrison","Cadence Singleton","Landyn Berger","Laylah Brennan","Curtis Khan","Mabel Rowland","Eliezer Steele","Rylie Levy","Harold Frederick","Sariyah Rich","Miller Shaffer","Alanna Ballard","Kenzo Boyle","Aliya Shelton","Leonel Figueroa","Lilith Villanueva","Huxley Grant","Alaina Goodman","Philip Potter","Rory Bernal","Eithan Hampton","Leona Finley","Calum Leal","Murphy Ellison","Kye Calhoun","Thalia Juarez","Joaquin Murray","Faith McPherson","Foster Campos","Sutton Lindsey","Jayson Blair","Frances Davidson","Dante Curry","Alison Bradford","Ander Summers","Frankie Reese","Alijah Beasley","Jaylah Pitts","Trey Blanchard","Layne Berger","Byron Lin","Makenna Jackson","Sebastian Golden","Giuliana Avery","Jakari Allison","Chelsea Dougherty","Brett Hail","Lainey Rowland","Eliezer Shelton","Makenzie Compton","Abner Crosby","Keily Herman","Juelz Nunez","Mya Lawson","Lane Hull","Andi Rodriguez","Henry Rosario","Louisa Howard","Jeremiah Maddox","Zainab Schaefer","Ishaan Swanson","Helen Bernal","Eithan Adams","Stella Myers","Adam Perkins","Sage Salinas","Edgar Calderon","Serena Chambers","Orion Kent","Jazmine Allen","Carter Fisher","Arya Stevens","Zachary Wall","Jayda Mercado","Abram Golden","Giuliana Sharp","Royce Salinas","Royalty Mathews","Jamir Christensen","Carmen Heath","Lionel Curtis","Alexis Sullivan","Evan Hendrix","Zhuri Simon","Zayne Duarte","Kynlee Myers","Adam Valencia","Maddison Zamora","Quentin Horn","Avah Miller","Benjamin Knapp","Linda Donaldson","Canaan Murray","Faith Ruiz","Austin Felix","Paisleigh Garza","Judah Evans","Eliana Roth","Roy Kirby","Skyla Randolph","Eugene Wade","Evie Huerta","Douglas McConnell","Denise Summers","Darius Hancock","Katelyn Brandt","Damir Potter","Rory Davila","Grey Beltran","Kaydence Tate","Dalton Edwards","Ivy Blackwell","Marcellus Schultz","Briella Lynch","Zane Maxwell","Kyla Ho","Morgan Weaver","Teagan Shah","Zain Gutierrez","Savannah Wise","Frederick Hamilton","Mackenzie Sheppard","Trent Bautista","Antonella Nixon","Cory Medrano","Halle Hicks","Maddox Potts","Ellison May","Finley Santos","Alana Chen","Emmanuel Hancock","Katelyn Copeland","Axton Zuniga","Leslie Case","Bentlee Hayden","Avayah Moss","Porter Lambert","Nina Johns","Joziah Juarez","Juliet Flores","Lincoln Edwards","Ivy Marsh","Bo Allen","Riley Herman","Juelz Mathews","Sloan Patrick","Derrick O’Connell","Jillian Roberson","Shepherd Mendoza","Cora Reed","Easton Potts","Ellison Robbins","Finnegan Colon","Remy Montes","Darren Hurley","Rylan Gilmore","Vihaan Valencia","Maddison Murphy","Cameron Dawson","Veronica Frost","Dario Bush","Everlee Cain","Benson Hurley","Rylan Goodman","Philip Thomas","Elizabeth Torres","Jayden Rich","Sunny Jefferson","Raylan Wyatt","Liberty Michael","Bronson Vasquez","Rose Compton","Abner Dalton","Lilian Vincent","Aarav May","Adriana Sheppard","Trent Sanford","Emerald Shepherd","Ronald Donovan","Azariah Pineda","Gerardo Harrell","Kara Felix","Rodney Watkins","Lola Rocha","Onyx Flynn","Dorothy Freeman","Jayce Hicks","Alina Golden","Amias Leal","Murphy Carson","Ares Bradford","Rhea Rush","Kaiser Larson","Alayna Everett","Camilo Meadows","Pearl Steele","Elian Ho","Calliope Webster","Shawn Malone","Skyler Hurley","Van Case","Cleo Arnold","Abraham Wright","Lily Miles","Jared Lawrence","Lauren Boyle","Robin Wheeler","Sydney Glover","Mack Rivera","Lillian Yoder","Johan Baker","Isla Carter","Maverick White","Layla McMahon","Jakob Hernandez","Camila Perry","Waylon Stanton","Jaycee Crawford","Kevin Ortiz","Anna Boyle","Robin Owens","Amaya Horn","Wilson Liu","Kate Leon","Marshall Maynard","Carolyn Phelps","Hamza Avalos","Paloma French","Corey Hubbard","Rosie Huffman","Chris Odom","Laylani Hartman","Baker Klein","Elianna Cantu","Anakin Dennis","Maisie Roach","Caspian Aguirre","Ariah Galindo","Salvatore Blackwell","Saoirse Enriquez","Elisha Goodman","Carolina Zimmerman","Sergio Ali","Zelda Schaefer","Ishaan Burch","Freyja Huffman","Chris Atkinson","Jazmin Pham","Russell Townsend","Azalea Hammond","Francis Robertson","Harmony Hail","Hector Barnes","Liliana Walls","Larry Gonzales","Hadley Vu","Kamdyn Ramsey","Lyric Wolfe","Donovan Todd","Zariah Martin","Mateo Wallace","Arianna David","Alonso Poole","Bonnie Lynch","Zane Pena","Rachel Underwood","Reece McCarthy","Kira Lambert","Mario Valentine","August Sloan","Ocean Young","Zoey Griffith","Franklin Phillips","Naomi Hardy","Jayceon Melton","Kamiyah Vazquez","Jesse Meza","Rosa Weber","Crew Curtis","Alexis O’Neal","Eddie Chang","Ophelia McFarland","Dane Mejia","Saylor Guerrero","Bryce Doyle","Annalise Anderson","Jacob Patton","Lorelei Wright","Grayson Velazquez","Jaliyah Morales","Aaron Chung","Rivka Jensen","Cash Johnson","Emma Ibarra","Asa Colon","Remy Villa","Clay Wiley","Lauryn Reyes","Eli Peters","Leila Glenn","Zaid Phelps","Laney Welch","Hendrix Howell","Mckenna Goodwin","Kaison Faulkner","Ansley Marsh","Bo Koch","Milana Lindsey","Jayson Thompson","Madison Lowe","Julius Fuentes","Madeleine Underwood","Reece Davenport","Adrianna Beasley","Stanley Schneider","Delaney Duarte","Abdullah Leon","Amora Keller","Nico Sharp","Camryn Ingram","Tripp Porter","Ryleigh Montes","Darren O’Neal","Treasure Pierce","Nicolas Suarez","Jimena Gallagher","Marcos Massey","Clementine Rush","Kaiser Pearson","Kiara Conley","Marvin Kirk","Ellis Hunt","Jesus Jaramillo","Guadalupe Rosario","Jedidiah Crosby","Keily Walls","Larry Camacho","Armani Zhang","Isaias Gross","Angel Mueller","Albert Fisher","Arya Davis","Lucas Baxter","Lara Aguirre","Andy McKenzie","Briar Blackburn","Zahir Saunders","Meadow Benson","Desmond Franco","Charleigh Walters","Colson Morton","Mallory Esparza","Carl Kirk","Ellis Roman","Kian Mays","Denisse Mercado","Abram Cherry","Nyomi Hull","Salem Calhoun","Thalia Webb","Lorenzo Bryant","Parker Livingston","Ambrose Haynes","Lexi Simon","Zayne Maddox","Zainab Briggs","Case Palmer","Juniper Bruce","Uriah Torres","Violet Allison","Dennis Armstrong","Presley Curtis","Muhammad Jordan","Adalynn Fischer","Leonidas Humphrey","Journi Hunt","Jesus Best","Lexie Robertson","Emiliano Bell","Melody Charles","Conrad Hansen","Hope French","Corey Harding","Aniya Willis","Remington Wong","Adelaide Church","Terrance Bennett","Josephine Robles","Otto Barry","Waverly Noble","Idris Michael","Aubriella Holland","Brady Ellison","Raina Fitzpatrick","Blaze Howell","Mckenna Flynn","Kannon Rodriguez","Evelyn Stark","Kristopher Garner","Jacqueline Booker","Dominik Chavez","Nevaeh Bernard","Jair Shelton","Makenzie Hess","Lawrence Serrano","Allie Underwood","Reece Cobb","Aviana Ellison","Kye Raymond","Hadlee Rangel","Saint Sawyer","Marina Parsons","Lewis Henson","Kinslee Lowery","Jaxxon Hammond","Holly Herman","Juelz Bowen","Dream Holloway","Sutton Williamson","Catherine Ford","Luis Paul","Daphne Villa","Clay Rice","Ada Beasley","Stanley Krueger","Kamari Martin","Mateo Mosley","Zaniyah Potter","Lucca Medrano","Halle Eaton","Leighton Beck","Gia Good","Davian Kane","Ellianna Diaz","Nathan Porter","Ryleigh Erickson","Johnny Blackwell","Saoirse Harper","Hayes Duffy","Addisyn Lane","Matias Quintana","Kenia Le","Damien Taylor","Sofia Franco","Gage Saunders","Meadow Perry","Waylon Hobbs","Lacey Fox","Antonio Blanchard","Layne Higgins","Sterling Mills","June Fields","Clayton Case","Cleo Wolfe","Donovan Hurley","Rylan Liu","Pedro Case","Cleo Graham","Giovanni Tapia","Michaela Huynh","Layton Ahmed","Jolie Salgado","Trace Holloway","Mae Nielsen","Tru Chen","Valeria Butler","Ryder Duncan","Elise O’Neill","Marcel Chavez","Nevaeh Foster","Kayden Gaines","Aya Malone","Ruben Daugherty","Magdalena Wall","Issac Ayala","Blair Wilkinson","Leonard Blankenship","Rosalee Cole","Nathaniel Lamb","Amaia Wang","Cohen Petersen","Fernanda Burgess","Kolton Ayers","Simone Barber","Solomon Reid","Charlee Wilkins","Yusuf Mullen","Shay Williamson","Emerson Todd","Zariah Preston","Vincenzo Mosley","Zaniyah Crane","Fox Tucker","Esther Martin","Mateo Lowery","Estelle Sandoval","Brantley Lynch","Malia Blankenship","Ernesto Callahan","Kimber Harris","Samuel Huerta","Dulce Trejo","Wesson Blanchard","Layne Walls","Larry Hahn","Fallon Allen","Carter Austin","Alivia Melendez","Nikolas Rowland","Harleigh Alvarado","Andres Sparks","Aisha Stuart","Dion Stevenson","Regina Blackburn","Zahir Hobbs","Lacey Ward","Jameson Haley","Addilynn Griffin","Ayden Yoder","Emerie Solis","Ronin Nixon","Deborah Christensen","Gregory Mejia","Saylor Fuller","Andre Herring","Denver Orr","Benicio Hensley","Malaya Rubio","Titan Hansen","Hope Tyler","Emmitt Stone","Catalina Berg","Cayson Mason","Sienna Spencer","Ace Stokes","Miranda Kirk","Alessandro McKinney","Gwendolyn Wiggins","Azariah Hester","Zendaya Krueger","Jones Snow","Alexia Valentine","Demetrius Walsh","Leia Coleman","Micah Hickman","Scarlette Fleming","Fernando Chapman","Zuri Chan","Frank Ho","Calliope Singleton","Landyn Marsh","Adelina Lane","Matias Cox","Sadie Jaramillo","Riggs Matthews","Lila Cunningham","Alejandro Rojas","Adaline Bowen","Trevor Ray","Ruth Cruz","Ryan Horn","Avah Vega","Aidan Suarez","Jimena Pratt","Rowen Lara","Heidi Kent","Mekhi Harrington","Legacy Howell","Bradley Quintana","Kenia Gardner","Alan Murillo","Mikaela Lam","Bodie Durham","Tiffany Arellano","Kellan Shaffer","Alanna Valdez","Kyler Elliott","Noelle Osborne","Augustus Friedman","Aspyn Stuart","Dion Xiong","Amayah Middleton","Misael Woodard","Aubrie Frazier","Callum Morrison","Rebecca Chapman","Knox Berg","Emmalyn Gray","Nicholas McBride","Kelsey Roth","Roy Kent","Jazmine Palacios","Thaddeus Joseph","Gracelynn Ortega","Kobe Benson","Collins Charles","Conrad Hart","Gemma Hammond","Francis Rivers","Kiana Lee","Jack Buckley","Theodora Truong","Ayan Orr","Alaiya Zuniga","Sincere Pierce","Arabella Harvey","Cayden Ellison","Raina Cortez","Zayn McGee","Kayleigh Fletcher","Jay Kelley","Rosalie Ali","Arjun Archer","Kadence Ibarra","Asa Prince","Greta Rollins","Wes Hutchinson","Jamie Barr","Harley Terrell","Paityn Holt","Niko Phelps","Laney Sloan","Ocean Waters","Bristol Goodman","Philip Solomon","Mylah Meyers","Julien Moss","Bianca Simpson","Elliott Norton","Kylee Underwood","Reece Lawrence","Lauren Leach","Westin Fernandez","Amara Roach","Caspian Adams","Stella Foley","Mohammad Griffin","Charlie McCoy","Jett Velazquez","Jaliyah Hayden","Leroy Taylor","Sofia Harrell","Nelson Lara","Heidi Pollard","Jad Stanton","Jaycee Berg","Cayson McDaniel","Dahlia Acevedo","Dakari Castillo","Eva Andrews","Lukas James","Quinn Phelps","Hamza Lyons","Kenzie Keith","Jagger Michael","Aubriella Mullins","Allen Jarvis","Elisabeth McConnell","London Lucas","Phoenix Ryan","Timothy Griffin","Charlie Brooks","Jordan Castro","Eloise Hobbs","Brendan Watson","Hailey Galindo","Salvatore Crosby","Keily Cruz","Ryan Logan","Kora Mack","Esteban Nash","Novah Gross","Quinn Daniel","Joy Esquivel","Bridger Lyons","Kenzie Small","Rudy Mullen","Shay Moody","Ryland Parra","Dalary Sparks","Drake Hendrix","Zhuri Romero","Bryson Decker","Aleena Yoder","Johan Portillo","Nathalie Andrews","Lukas Wise","Mira Figueroa","Spencer Gill","Jordan Reyes","Eli Ramsey","Lyric Pham","Russell Reeves","Lana Walter","Lochlan Solomon","Mylah House","Yehuda Palmer","Juniper Carson","Ares Drake","Jayleen Sosa","Emir Trujillo","Danielle Hale","Ezequiel Jacobson","Royal Knight","Beckett Potter","Rory Galvan","Kingsley Nielsen","Vienna Caldwell","Rylan Crane","Della English","Junior Hobbs","Lacey Thomas","Logan Calhoun","Thalia Mitchell","Jaxon Parks","Ainsley Hill","Isaac Blair","Frances Jennings","Corbin Park","Lia Ryan","Timothy Higgins","Leighton Johnston","Felix Walls","Lilianna Heath","Lionel Perez","Eleanor Lyons","Cyrus Stephens","Millie Galvan","Kingsley Edwards","Ivy Hanna","Aydin O’Neal","Treasure Lamb","Kaysen Kim","Gabriella O’brien","Riley Fowler","Lennon Gonzales","Brayden Montes","Roselyn Griffith","Franklin Valencia","Maddison Torres","Jayden Gaines","Aya Ballard","Kenzo Huang","Francesca Cuevas","Brecken Conley","Salem Doyle","Kashton Duke","Melani Huerta","Douglas Leblanc","Novalee Schaefer","Ishaan Hickman","Scarlette Nelson","Dylan Young","Zoey Fernandez","Bentley Portillo","Nathalie Quinn","Rhys Hartman","Kennedi Schaefer","Ishaan Porter","Ryleigh Solis","Ronin Bowers","Elisa Vu","Kamdyn Frost","Paula Herman","Juelz Yoder","Emerie Robles","Otto Moody","Elaine Gates","Ermias Parks","Ainsley Henry","Carlos Hebert","Kyleigh Powell","Bennett Grant","Alaina Cantrell","Harris Xiong","Amayah Lin","Conor Zhang","Sarai Crosby","Tristen Brock","Jada Baker","Ezra Nichols","Aliyah Terrell","Jaxen Daugherty","Magdalena Dominguez","Kaden Coffey","Paola Moon","Nova Acevedo","Ashlynn Conner","Phillip Roach","Lyanna May","Finley Benton","Anais Brown","Elijah McBride","Kelsey Richards","Holden Salinas","Royalty Patrick","Derrick Perkins","Sage Whitaker","Keith Gillespie","Alianna Harvey","Cayden Porter","Ryleigh Austin","Omar Wheeler","Sydney Myers","Adam Duffy","Addisyn Collins","Miles Gill","Jordan Collins","Miles Ramsey","Lyric Guerra","Leland Davidson","Jayla Knight","Beckett Garner","Jacqueline Vaughan","Castiel Huang","Francesca Livingston","Ambrose Ochoa","Luciana Peters","Patrick Quinn","Heaven Mayer","Yahir Watts","Melissa Kennedy","Maxwell Hale","Brinley Hopkins","Ali Fry","Clarissa Ferguson","Miguel Cooper","Serenity Pope","Gunnar Acosta","Kaia Hubbard","Forrest Cook","Aaliyah Leach","Westin Oliver","Camille Hart","Joel Stout","Chana Hardin","Hassan Hodges","Eve Long","Jace Terry","Wren Contreras","Emilio Powers","Michelle Wright","Grayson Woodward","Drew Webb","Lorenzo Randall","Christina Matthews","Preston Wiggins","Capri Guzman","Jude Dunlap","Iliana Leblanc","Braden Duffy","Addisyn McCarty","Blaise Hanna","Cynthia Woods","Zion Fowler","Lennon Holloway","Sutton Fuentes","Madeleine Ponce","Langston McLean","Sky Poole","Quincy Santos","Alana Acosta","Jensen Velez","Megan Bonilla","Aden Delgado","Alani Hurley","Van Byrd","Giselle Buck","Jon Bradshaw","Berkley Rivers","Bear Schmidt","Kimberly Farrell","Ty Bernard","Barbara Bruce","Uriah Orr","Alaiya Crawford","Kevin McCann","Joyce Sanchez","Joseph Merritt","Kaisley Stone","Finn Richardson","Allison Morse","Bode Huffman","Hayley Morrison","Maximus Mosley","Zaniyah Andrews","Lukas Hahn","Fallon Gardner","Alan Villegas","Jessie Todd","Baylor Fowler","Lennon Barron","Dustin Khan","Mabel McCarthy","Devin Casey","Sylvia Schneider","Raymond Krueger","Kamari Young","Asher Barry","Waverly Fuentes","Bowen Castaneda","Keira Farmer","Jamison Mullins","Maliyah Dawson","Iker Gregory","Alaya Blackwell","Marcellus McLean","Sky Daugherty","Turner Knapp","Linda Lamb","Kaysen Mendoza","Cora Benjamin","Kyro Camacho","Armani Cuevas","Brecken Martin","Mila Lamb","Kaysen Wolfe","Hallie West","Diego Marks","Monica Rowland","Eliezer Livingston","Milena Macdonald","Hugh Reid","Charlee Farmer","Jamison Jenkins","Rylee Mayo","Jericho Randall","Christina Ellis","Cole Manning","Jennifer Li","Jorge Wise","Mira Jarvis","Marlon Garrison","Cadence Nelson","Dylan Clay","Aliana Novak","Bishop Owen","Mikayla Jaramillo","Riggs Choi","Karla McIntosh","Kristian Leach","Martha Macdonald","Hugh Skinner","Mara Steele","Elian Shaffer"];

;
// Shared dialog focus management (keyboard + screen-reader support).
// Used by both the company-metrics and selections modals. Moves focus into the
// dialog on open, traps Tab inside it, and restores focus to the trigger on close.
// opts.trap (default true): run as a true modal — steal focus into the dialog,
// trap Tab inside it, and restore focus to the trigger on close. The metrics and
// selections panels pass trap:false on desktop, where they're pinned open beside
// the cards and the player keeps interacting with the card stack — there we must
// not hijack focus, or card keyboard shortcuts would stay disabled while pinned.
function openDialog(modal, opts = {}) {
    const trap = opts.trap !== false;
    modal._trapped = trap;
    modal.setAttribute('aria-modal', trap ? 'true' : 'false');
    modal._lastFocused = document.activeElement;
    modal.style.display = 'flex';
    setTimeout(() => modal.classList.add('show'), 10);

    if (!trap) return;

    // Move focus to the close button (or the dialog itself) once it's visible.
    const focusTarget = modal.querySelector('.close-modal') || modal;
    setTimeout(() => focusTarget.focus(), 20);

    modal._trapHandler = function (e) {
        if (e.key !== 'Tab') return;
        const focusables = Array.from(modal.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )).filter(el => !el.disabled && el.offsetParent !== null);
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    };
    modal.addEventListener('keydown', modal._trapHandler);
}

function closeDialog(modal) {
    modal.classList.remove('show');
    if (modal._trapHandler) {
        modal.removeEventListener('keydown', modal._trapHandler);
        modal._trapHandler = null;
    }
    setTimeout(() => { modal.style.display = 'none'; }, 300);
    // Only pull focus back to the trigger for true modals; a pinned panel never
    // held focus, so yanking it would interrupt card play.
    if (modal._trapped && modal._lastFocused && typeof modal._lastFocused.focus === 'function') {
        modal._lastFocused.focus();
    }
}

// CUSTOM CONFIRMATION DIALOG
// A small styled yes/no dialog used for org-chart actions (promote / lay off /
// co-founder), replacing the browser's native confirm(). Lazily created, reused.
// opts: {
//   tone, icon, title, note, confirmLabel, cancelLabel, onConfirm,
//   rows: [[key,val],...],            // static detail rows, OR
//   computeRows: (value) => rows,     // rows recomputed live from the input
//   input: { label, min, max, step, value, suffix },  // optional numeric input
// }
// onConfirm receives the (clamped) input value when an input is configured.
function showConfirmDialog(opts) {
    opts = opts || {};
    let modal = document.getElementById('confirmDialog');
    if (!modal) {
        modal = document.createElement('div');
        modal.id = 'confirmDialog';
        modal.className = 'confirm-dialog';
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-modal', 'true');
        modal.setAttribute('aria-labelledby', 'confirmTitle');
        document.body.appendChild(modal);
    }

    const tone = opts.tone || 'neutral';
    const inp = opts.input || null;

    const renderRows = (value) => {
        const rows = typeof opts.computeRows === 'function'
            ? opts.computeRows(value)
            : (opts.rows || []);
        return rows.map(([key, val]) => `
            <div class="confirm-row">
                <span class="confirm-row-key">${key}</span>
                <span class="confirm-row-val">${val}</span>
            </div>
        `).join('');
    };

    const clampVal = (v) => {
        v = Number(v);
        if (Number.isNaN(v)) v = Number(inp && inp.value) || 0;
        if (inp && inp.min != null) v = Math.max(inp.min, v);
        if (inp && inp.max != null) v = Math.min(inp.max, v);
        return v;
    };

    const initVal = inp ? clampVal(inp.value) : undefined;

    modal.innerHTML = `
        <div class="confirm-card confirm-${tone}">
            <div class="confirm-head">
                <div class="confirm-icon">${opts.icon || ''}</div>
                <h3 class="confirm-title" id="confirmTitle">${opts.title || 'Are you sure?'}</h3>
            </div>
            ${inp ? `
            <div class="confirm-field">
                <label class="confirm-field-label" for="confirmInput">${inp.label || ''}</label>
                <div class="confirm-field-control">
                    <input type="number" id="confirmInput" class="confirm-input"
                        min="${inp.min ?? 0}" max="${inp.max ?? 100}" step="${inp.step ?? 1}" value="${initVal}" />
                    ${inp.suffix ? `<span class="confirm-input-suffix">${inp.suffix}</span>` : ''}
                </div>
                ${(inp.min != null && inp.max != null) ? `<input type="range" id="confirmRange" class="confirm-range"
                    min="${inp.min}" max="${inp.max}" step="${inp.step ?? 1}" value="${initVal}" aria-hidden="true" />` : ''}
            </div>` : ''}
            <div class="confirm-rows" id="confirmRows">${renderRows(initVal)}</div>
            ${opts.note ? `<p class="confirm-note">${opts.note}</p>` : ''}
            <div class="confirm-actions">
                ${opts.hideCancel ? '' : `<button type="button" class="confirm-btn confirm-cancel">${opts.cancelLabel || 'Cancel'}</button>`}
                <button type="button" class="confirm-btn confirm-accept confirm-accept-${tone}">${opts.confirmLabel || 'Confirm'}</button>
            </div>
        </div>
    `;

    const numberEl = modal.querySelector('#confirmInput');
    const rangeEl = modal.querySelector('#confirmRange');
    const rowsEl = modal.querySelector('#confirmRows');

    const refreshRows = (v) => {
        if (rowsEl && typeof opts.computeRows === 'function') rowsEl.innerHTML = renderRows(v);
    };
    if (numberEl) {
        numberEl.addEventListener('input', () => {
            const v = clampVal(numberEl.value);
            if (rangeEl) rangeEl.value = v;
            refreshRows(v);
        });
    }
    if (rangeEl) {
        rangeEl.addEventListener('input', () => {
            const v = clampVal(rangeEl.value);
            if (numberEl) numberEl.value = v;
            refreshRows(v);
        });
    }

    const finish = (accepted) => {
        document.removeEventListener('keydown', modal._escCapture, true);
        const value = numberEl ? clampVal(numberEl.value) : undefined;
        closeDialog(modal);
        if (accepted && typeof opts.onConfirm === 'function') opts.onConfirm(value);
    };

    const cancelBtn = modal.querySelector('.confirm-cancel');
    if (cancelBtn) cancelBtn.onclick = () => finish(false);
    modal.querySelector('.confirm-accept').onclick = () => finish(true);
    modal.onclick = (e) => { if (e.target === modal) finish(false); };

    // Capture Escape so it closes only this dialog, not the company modal behind it.
    modal._escCapture = (e) => {
        if (e.key === 'Escape') {
            e.stopPropagation();
            e.preventDefault();
            finish(false);
        }
    };
    document.addEventListener('keydown', modal._escCapture, true);

    openDialog(modal); // handles fade-in, focus trap, focus restore on close
    // Focus the input if present (so the player can adjust it), else the accept button.
    setTimeout(() => {
        const target = modal.querySelector('#confirmInput') || modal.querySelector('.confirm-accept');
        if (target) target.focus();
    }, 30);
}

// Single-button info dialog, replacing the browser's native alert(). Reuses the
// confirm dialog's styling/focus management with the cancel button hidden.
// opts: { title, message, tone, icon, okLabel, onOk }
function showAlertDialog(opts) {
    opts = opts || {};
    showConfirmDialog({
        tone: opts.tone || 'neutral',
        icon: opts.icon || 'ⓘ',
        title: opts.title || 'Notice',
        note: opts.message || opts.note || '',
        confirmLabel: opts.okLabel || 'OK',
        hideCancel: true,
        onConfirm: opts.onOk
    });
}

// KEYBOARD SHORTCUTS HELP OVERLAY
// Built lazily the first time it's opened (via the "?" key). Reuses the shared
// openDialog/closeDialog focus management and the existing .close-modal styling.
function createHelpModal() {
    const modal = document.createElement('div');
    modal.className = 'help-modal';
    modal.id = 'helpModal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'helpTitle');

    const rows = [
        ['→', 'Add the current card'],
        ['←', 'Skip the current card'],
        ['Enter / F', 'Flip the card for the full breakdown'],
        ['Esc', 'Flip back, or close an open dialog'],
        ['Tab / Shift + Tab', 'Move between controls'],
        ['?', 'Show or hide this help']
    ];

    modal.innerHTML = `
        <div class="help-modal-content">
            <div class="help-header">
                <h2 id="helpTitle">⌨️ Keyboard Shortcuts</h2>
                <button type="button" class="close-modal" onclick="closeHelpModal()" aria-label="Close keyboard shortcuts">&times;</button>
            </div>
            <div class="help-body">
                <dl class="help-list">
                    ${rows.map(([keys, desc]) => `
                        <div class="help-row">
                            <dt><kbd>${keys}</kbd></dt>
                            <dd>${desc}</dd>
                        </div>
                    `).join('')}
                </dl>
            </div>
        </div>
    `;

    // Click on the backdrop (outside the content box) closes the overlay.
    modal.addEventListener('click', (e) => {
        if (e.target === modal) closeHelpModal();
    });

    document.body.appendChild(modal);
}

function showHelpModal() {
    let modal = document.getElementById('helpModal');
    if (!modal) {
        createHelpModal();
        modal = document.getElementById('helpModal');
    }
    openDialog(modal);
}

function closeHelpModal() {
    const modal = document.getElementById('helpModal');
    if (modal && modal.style.display === 'flex') {
        closeDialog(modal);
    }
}

function toggleHelpModal() {
    const modal = document.getElementById('helpModal');
    if (modal && modal.style.display === 'flex') {
        closeHelpModal();
    } else {
        showHelpModal();
    }
}

// Global "?" to toggle the help overlay; Esc closes it. "?" is ignored while
// another dialog is open (so it doesn't stack) and while typing in a field.
document.addEventListener('keydown', (e) => {
    if (e.key === '?') {
        const target = e.target;
        if (target.matches && target.matches('input, textarea, select')) return;
        const helpOpen = document.querySelector('#helpModal') && document.getElementById('helpModal').style.display === 'flex';
        const otherOpen = document.querySelector('.selections-modal.show, .company-metrics-modal.show');
        if (otherOpen && !helpOpen) return;
        e.preventDefault();
        toggleHelpModal();
    } else if (e.key === 'Escape') {
        closeHelpModal();
    }
});

// COMPANY METRICS MODAL FUNCTIONS
function createCompanyMetricsModal() {
    const modal = document.createElement('div');
    modal.className = 'company-metrics-modal';
    modal.id = 'companyMetricsModal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'companyNameTitle');

    modal.innerHTML = `
        <div class="company-metrics-modal-content">
            <div class="company-metrics-header">
                <div class="company-info">
                    <div class="company-name-edit">
                        <h2 id="companyNameTitle" class="editable-title" onclick="beginCompanyNameEdit()" title="Click to rename">Loading...</h2>
                        <button type="button" class="company-name-edit-btn" id="editCompanyNameBtn" onclick="beginCompanyNameEdit()" aria-label="Rename company" title="Rename company">✏️</button>
                    </div>
                    <span id="companyFoundedInfo">Founded: Loading...</span>
                </div>
                <button type="button" class="close-modal" onclick="closeCompanyMetricsModal()" aria-label="Close company metrics">&times;</button>
            </div>
            <div class="company-tabs" role="tablist" aria-label="Company views">
                <button type="button" class="company-tab active" id="companyTabMetrics" role="tab" aria-selected="true" aria-controls="companyMetricsBody" onclick="switchCompanyTab('metrics')">📊 Metrics</button>
                <button type="button" class="company-tab" id="companyTabOrg" role="tab" aria-selected="false" aria-controls="companyOrgBody" onclick="switchCompanyTab('org')">🏢 Org Chart</button>
                <button type="button" class="company-tab" id="companyTabStory" role="tab" aria-selected="false" aria-controls="companyStoryBody" onclick="switchCompanyTab('story')">📖 Story</button>
            </div>
            <div class="company-metrics-body">
                <div id="companyMetricsBody" class="company-tab-pane active" role="tabpanel" aria-labelledby="companyTabMetrics">
                    <!-- Content will be populated by populateCompanyMetrics() -->
                </div>
                <div id="companyOrgBody" class="company-tab-pane" role="tabpanel" aria-labelledby="companyTabOrg" hidden>
                    <!-- Content will be populated by populateOrgChart() -->
                </div>
                <div id="companyStoryBody" class="company-tab-pane" role="tabpanel" aria-labelledby="companyTabStory" hidden>
                    <!-- Content will be populated by populateCompanyStory() -->
                </div>
            </div>
        </div>
    `;

    document.body.appendChild(modal);
}

function showCompanyMetricsModal() {
    let modal = document.getElementById('companyMetricsModal');
    
    // Create modal if it doesn't exist
    if (!modal) {
        createCompanyMetricsModal();
        modal = document.getElementById('companyMetricsModal');
    }
    
    // Populate with current metrics and default to the Metrics tab
    populateCompanyMetrics();
    switchCompanyTab('metrics');

    // Show modal. On desktop it's a pinned side panel, not a focus-trapping
    // overlay, so the player can keep driving the cards with the keyboard.
    openDialog(modal, { trap: !window.matchMedia('(min-width: 1330px)').matches });
}

function closeCompanyMetricsModal() {
    const modal = document.getElementById('companyMetricsModal');
    if (modal && modal.style.display === 'flex') {
        closeDialog(modal);
    }
}

function toggleCompanyMetricsModal() {
    const modal = document.getElementById('companyMetricsModal');
    if (modal && modal.style.display === 'flex') {
        closeCompanyMetricsModal();
    } else {
        showCompanyMetricsModal();
    }
}

// Inline-rename the company from the metrics-modal header: the pencil button (or
// clicking the title) swaps the <h2> for a text input. Enter or blur saves, Esc
// cancels. We use a real <input> rather than contenteditable so it's announced as
// an editable field and Enter/Esc behave predictably for keyboard users.
function beginCompanyNameEdit() {
    const wrap = document.querySelector('.company-name-edit');
    if (!wrap || wrap.classList.contains('editing')) return; // already editing
    const h2 = document.getElementById('companyNameTitle');

    const input = document.createElement('input');
    input.type = 'text';
    input.className = 'company-name-input';
    input.id = 'companyNameInput';
    input.value = gameState.companyName || '';
    input.maxLength = 40;
    input.setAttribute('aria-label', 'Company name');

    wrap.classList.add('editing');
    wrap.insertBefore(input, h2);
    input.focus();
    input.select();

    let finished = false;
    const commit = (save) => {
        if (finished) return; // guard against blur firing after Enter/Esc removes the input
        finished = true;
        const val = input.value.trim();
        wrap.classList.remove('editing');
        input.remove();
        if (save && val) renameCompany(val);
        // Reflect the live name (covers cancel and empty-input cases).
        if (h2) h2.textContent = gameState.companyName;
    };

    input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); commit(true); }
        else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); commit(false); }
    });
    input.addEventListener('blur', () => commit(true));
}

// Apply a new company name everywhere it's shown (nav button + modal title) and
// persist it with the rest of the run.
function renameCompany(name) {
    gameState.companyName = name;
    const navBtn = document.getElementById('companyName');
    if (navBtn) navBtn.textContent = name;
    const title = document.getElementById('companyNameTitle');
    if (title) title.textContent = name;
    if (typeof saveCurrentGame === 'function') saveCurrentGame();
}

function populateCompanyMetrics() {
    const metricsBody = document.getElementById('companyMetricsBody');
    const companyName = document.getElementById('companyNameTitle');
    const foundedInfo = document.getElementById('companyFoundedInfo');
    
    // Calculate additional metrics
    const burnRate = gameState.monthlyBurn;
    const netIncome = gameState.monthlyRevenue - burnRate;
    // Runway = how many months the current cash covers at the gross burn rate.
    // (Dividing by net burn blows up when revenue ~ covers burn, so we use gross
    // burn, which is always >= the base monthly burn.) isCashPositive still flags
    // profitability for the status label.
    const isCashPositive = gameState.runway > 0 && gameState.monthlyRevenue >= burnRate;
    const runwayMonths = gameState.runway > 0 ? gameState.runway / burnRate : 0;
    const averageRevenuePerCustomer = gameState.customers > 0 ? (gameState.monthlyRevenue / gameState.customers) : 0;
    const stressLevel = getStressLevel(gameState.stress);
    // Outcome cards (acknowledged events, opportunity choices) are pushed into
    // selectedCards for their impact, but they aren't counted in cardsGenerated.
    // Exclude them so the decision count/rate stays consistent (rate can't exceed 100%).
    const businessDecisionsCount = gameState.selectedCards.filter(card => card.category !== 'outcome').length;
    const decisionRate = gameState.cardsGenerated > 0 ? Math.round((businessDecisionsCount / gameState.cardsGenerated) * 100) : 0;
    
    // Update founded info with proper date
    const currentGameDate = getCurrentGameDate();
    foundedInfo.textContent = `Founded: ${gameState.foundedDisplay} • Current: ${formatGameDate(currentGameDate)}`;
    companyName.textContent = `${gameState.companyName}`;
    
    // Graph range slider bounds auto-scale to the company's age.
    const rangeMaxYears = getHistoryMaxYears();
    const rangeValue = rangeSliderValue(rangeMaxYears);

    const metricsHTML = `
        <div class="metrics-grid">
            <!-- Financial Metrics -->
            <div class="metric-category">
                <h3 class="category-title">💰 Financial Health</h3>
                <div class="metric-items">
                    <div class="metric-card">
                        <div class="metric-value">${formatCurrency(gameState.totalRevenue)}</div>
                        <div class="metric-label">Total Revenue</div>
                        <div class="metric-change ${gameState.totalRevenue > 0 ? 'positive' : 'neutral'}">
                            All-time earnings
                        </div>
                    </div>
                    <div class="metric-card">
                        <div class="metric-value">${formatCurrency(burnRate)}/mo</div>
                        <div class="metric-label">Monthly Burn Rate</div>
                        <div class="metric-change ${burnRate < 10000 ? 'positive' : 'negative'}">
                            Operating expenses
                        </div>
                    </div>
                    <div class="metric-card">
                        <div class="metric-value">${formatCurrency(netIncome)}/mo</div>
                        <div class="metric-label">Net Income</div>
                        <div class="metric-change ${netIncome > 0 ? 'positive' : 'negative'}">
                            ${netIncome > 0 ? 'Profitable!' : 'Burning cash'}
                        </div>
                    </div>
                    <div class="metric-card">
                        <div class="metric-value">${formatMonthsDuration(runwayMonths)}</div>
                        <div class="metric-label">Runway Remaining</div>
                        <div class="metric-change ${isCashPositive || runwayMonths > 12 ? 'positive' : runwayMonths > 6 ? 'warning' : 'negative'}">
                            ${isCashPositive ? 'Cash-flow positive' : runwayMonths > 12 ? 'Healthy runway' : runwayMonths > 6 ? 'Monitor closely' : 'Critical!'}
                        </div>
                    </div>
                </div>
                <div class="metric-chart" id="financialChartWrap"><canvas id="financialChart" role="img" aria-label="Financial trend chart"></canvas><div class="metric-chart-empty">Make a few decisions to start charting your progress over time.</div></div>
            </div>

            <!-- Chart range filter -->
            <div class="chart-range-filter">
                <div class="chart-range-top">
                    <span class="chart-range-label">📈 Graph range</span>
                    <span class="chart-range-value" id="chartRangeValue">${rangeLabelText(rangeValue, rangeMaxYears)}</span>
                </div>
                <div class="chart-range-slider">
                    <span class="chart-range-edge">1y</span>
                    <input type="range" id="chartRangeSlider" min="1" max="${rangeMaxYears}" step="1" value="${rangeValue}"
                        oninput="onCompanyRangeSlider(this.value, ${rangeMaxYears})"
                        aria-label="Graph time range" aria-valuetext="${rangeLabelText(rangeValue, rangeMaxYears)}" ${rangeMaxYears <= 1 ? 'disabled' : ''}>
                    <span class="chart-range-edge">All</span>
                </div>
            </div>

            <!-- Customer Metrics -->
            <div class="metric-category">
                <h3 class="category-title">👥 Customer Growth</h3>
                <div class="metric-items">
                    <div class="metric-card">
                        <div class="metric-value">${gameState.customers.toLocaleString()}</div>
                        <div class="metric-label">Total Customers</div>
                        <div class="metric-change ${gameState.customers > 500 ? 'positive' : gameState.customers > 50 ? 'warning' : 'neutral'}">
                            ${gameState.customers > 500 ? 'Strong base' : gameState.customers > 50 ? 'Building up' : 'Early stage'}
                        </div>
                    </div>
                    <div class="metric-card">
                        <div class="metric-value">${formatCurrency(averageRevenuePerCustomer)}</div>
                        <div class="metric-label">Avg Revenue/Customer</div>
                        <div class="metric-change ${averageRevenuePerCustomer > 50 ? 'positive' : averageRevenuePerCustomer > 20 ? 'warning' : 'neutral'}">
                            ${averageRevenuePerCustomer > 50 ? 'High value' : averageRevenuePerCustomer > 20 ? 'Decent ARPC' : 'Focus on pricing'}
                        </div>
                    </div>
                    <div class="metric-card">
                        <div class="metric-value">${Math.round(gameState.growth)}%</div>
                        <div class="metric-label">Growth Score</div>
                        <div class="metric-change ${gameState.growth > 30 ? 'positive' : gameState.growth > 10 ? 'warning' : 'neutral'}">
                            ${gameState.growth > 30 ? 'Rapid growth' : gameState.growth > 10 ? 'Steady progress' : 'Room to improve'}
                        </div>
                    </div>
                    <div class="metric-card">
                        <div class="metric-value">${Math.round(gameState.engagement)}%</div>
                        <div class="metric-label">User Engagement</div>
                        <div class="metric-change ${gameState.engagement > 40 ? 'positive' : gameState.engagement > 20 ? 'warning' : 'neutral'}">
                            ${gameState.engagement > 40 ? 'Highly engaged' : gameState.engagement > 20 ? 'Moderate engagement' : 'Needs attention'}
                        </div>
                    </div>
                </div>
                <div class="metric-chart" id="customerChartWrap"><canvas id="customerChart" role="img" aria-label="Customer growth chart"></canvas><div class="metric-chart-empty">Make a few decisions to start charting your progress over time.</div></div>
            </div>

            <!-- Business Development Metrics -->
            <div class="metric-category">
                <h3 class="category-title">🚀 Business Development</h3>
                <div class="metric-items">
                    <div class="metric-card">
                        <div class="metric-value">${Math.round(gameState.confidence)}%</div>
                        <div class="metric-label">Market Confidence</div>
                        <div class="metric-change ${gameState.confidence > 50 ? 'positive' : gameState.confidence > 25 ? 'warning' : 'neutral'}">
                            ${gameState.confidence > 50 ? 'High confidence' : gameState.confidence > 25 ? 'Building trust' : 'Prove your value'}
                        </div>
                    </div>
                    <div class="metric-card">
                        <div class="metric-value">${Math.round(gameState.credibility)}%</div>
                        <div class="metric-label">Industry Credibility</div>
                        <div class="metric-change ${gameState.credibility > 40 ? 'positive' : gameState.credibility > 20 ? 'warning' : 'neutral'}">
                            ${gameState.credibility > 40 ? 'Well established' : gameState.credibility > 20 ? 'Growing reputation' : 'Build your brand'}
                        </div>
                    </div>
                    <div class="metric-card">
                        <div class="metric-value">${Math.round(gameState.reach)}%</div>
                        <div class="metric-label">Market Reach</div>
                        <div class="metric-change ${gameState.reach > 35 ? 'positive' : gameState.reach > 15 ? 'warning' : 'neutral'}">
                            ${gameState.reach > 35 ? 'Wide reach' : gameState.reach > 15 ? 'Expanding presence' : 'Limited visibility'}
                        </div>
                    </div>
                    <div class="metric-card">
                        <div class="metric-value">${businessDecisionsCount}</div>
                        <div class="metric-label">Business Decisions</div>
                        <div class="metric-change ${businessDecisionsCount > 20 ? 'positive' : businessDecisionsCount > 10 ? 'warning' : 'neutral'}">
                            ${businessDecisionsCount > 20 ? 'Experienced founder' : businessDecisionsCount > 10 ? 'Learning fast' : 'Just getting started'}
                        </div>
                    </div>
                </div>
                <div class="metric-chart" id="businessChartWrap"><canvas id="businessChart" role="img" aria-label="Business development chart"></canvas><div class="metric-chart-empty">Make a few decisions to start charting your progress over time.</div></div>
            </div>

            <!-- Time & Team Metrics -->
            <div class="metric-category">
                <h3 class="category-title">⏱️ Operations</h3>
                <div class="metric-items">
                    <div class="metric-card">
                        <div class="metric-value">Y${gameState.currentYear} M${getDisplayMonth()}</div>
                        <div class="metric-label">Current Period</div>
                        <div class="metric-change ${gameState.currentMonth < 12 ? 'positive' : gameState.currentMonth < 24 ? 'warning' : 'negative'}">
                            ${gameState.currentMonth < 12 ? 'Early stage' : gameState.currentMonth < 24 ? 'Scaling phase' : 'Mature startup'}
                        </div>
                    </div>
                    <div class="metric-card">
                        <div class="metric-value">${gameState.teamSize}</div>
                        <div class="metric-label">Team Members</div>
                        <div class="metric-change ${gameState.teamSize > 5 ? 'positive' : gameState.teamSize > 2 ? 'warning' : 'neutral'}">
                            ${gameState.teamSize > 5 ? 'Strong team' : gameState.teamSize > 2 ? 'Small team' : 'Solo founder'}
                        </div>
                    </div>
                    <div class="metric-card">
                        <div class="metric-value">${stressLevel.emoji} ${gameState.stress}%</div>
                        <div class="metric-label">Founder Wellbeing</div>
                        <div class="metric-change ${stressLevel.class}">
                            ${stressLevel.label}
                        </div>
                    </div>
                    <div class="metric-card">
                        <div class="metric-value">${gameState.cardsGenerated}</div>
                        <div class="metric-label">Decisions Faced</div>
                        <div class="metric-change neutral">
                            Business opportunities seen
                        </div>
                    </div>
                    <div class="metric-card">
                        <div class="metric-value">${decisionRate}%</div>
                        <div class="metric-label">Decision Rate</div>
                        <div class="metric-change ${decisionRate > 30 ? 'warning' : 'positive'}">
                            ${decisionRate > 30 ? 'Taking many risks' : 'Selective approach'}
                        </div>
                    </div>
                </div>
                <div class="metric-chart" id="operationsChartWrap"><canvas id="operationsChart" role="img" aria-label="Operations chart"></canvas><div class="metric-chart-empty">Make a few decisions to start charting your progress over time.</div></div>
            </div>
        </div>
        <div class="company-metrics-actions">
            <button type="button" class="btn btn-export" onclick="exportCompanyReport()">Export Report JSON</button>
        </div>
    `;

    metricsBody.innerHTML = metricsHTML;

    // Draw the time-series graphs for each section now that the canvases exist.
    renderCompanyCharts();
}

// ---- Company section graphs (Chart.js) ----
// Live Chart instances, keyed by canvas id, so we can tear them down and rebuild
// each time the modal is (re)populated.
const companyCharts = {};

// Currently selected graph time range, in months. null = all time. Persists
// across modal re-populations so the chosen filter sticks.
let companyChartRangeMonths = 12;

// Collapse the raw history into one point per (rounded) in-game month, keeping the
// latest snapshot for each month. Also derives net new customers per month from
// the cumulative total. Returns the full series (range filtering happens later).
function getCompanyMonthlySeries() {
    const byMonth = new Map();
    (gameState.history || []).forEach(snap => {
        const bucket = Math.max(1, Math.round(snap.month));
        const prev = byMonth.get(bucket);
        // Keep the latest snapshot for rate/level metrics, but ACCUMULATE one-time costs —
        // several decisions can land in the same month, each with its own spend.
        const oneTimeCost = (prev ? prev.oneTimeCost || 0 : 0) + (snap.oneTimeCost || 0);
        byMonth.set(bucket, { ...snap, monthBucket: bucket, oneTimeCost });
    });
    const series = Array.from(byMonth.values()).sort((a, b) => a.monthBucket - b.monthBucket);
    let prevCustomers = 0;
    series.forEach(s => {
        s.newCustomers = s.customers - prevCustomers; // can be negative if churn occurs
        prevCustomers = s.customers;
    });
    return series;
}

// Limit a monthly series to the most recent `months` months (null = keep all).
function filterSeriesByRange(series, months) {
    if (!months || !series.length) return series;
    const latest = series[series.length - 1].monthBucket;
    return series.filter(s => s.monthBucket > latest - months);
}

// Whole years of history the company has accumulated (min 1). Drives the slider's
// upper bound, so the control auto-scales as the game runs longer.
function getHistoryMaxYears() {
    const series = getCompanyMonthlySeries();
    const maxMonth = series.length ? series[series.length - 1].monthBucket : 1;
    return Math.max(1, Math.ceil(maxMonth / 12));
}

// Human label for a slider value. The far end (value === maxYears) means all time.
function rangeLabelText(value, maxYears) {
    if (value >= maxYears) return 'All time';
    return value === 1 ? 'Last 1 year' : `Last ${value} years`;
}

// Slider position the persisted range corresponds to, clamped to the current max.
function rangeSliderValue(maxYears) {
    if (companyChartRangeMonths === null) return maxYears;
    return Math.min(maxYears, Math.max(1, Math.round(companyChartRangeMonths / 12)));
}

// Handle slider movement: update the persisted range + label, then re-slice the
// data into the existing charts. We update in place (no destroy/recreate) so
// dragging stays smooth even though oninput fires continuously.
function onCompanyRangeSlider(value, maxYears) {
    value = Number(value);
    maxYears = Number(maxYears);
    companyChartRangeMonths = value >= maxYears ? null : value * 12;
    const text = rangeLabelText(value, maxYears);
    const label = document.getElementById('chartRangeValue');
    if (label) label.textContent = text;
    const slider = document.getElementById('chartRangeSlider');
    if (slider) slider.setAttribute('aria-valuetext', text); // announce "Last N years"
    updateCompanyCharts();
}

// Format an in-game month number as a "Y# M#" axis label.
function companyMonthLabel(month) {
    const year = Math.floor((month - 1) / 12) + 1;
    const m = ((month - 1) % 12) + 1;
    return year > 1 ? `Y${year} M${m}` : `M${m}`;
}

// (Re)create a single Chart on the given canvas, destroying any previous instance.
function makeCompanyChart(canvasId, config) {
    const canvas = document.getElementById(canvasId);
    if (!canvas || typeof Chart === 'undefined') return;
    if (companyCharts[canvasId]) {
        companyCharts[canvasId].destroy();
        delete companyCharts[canvasId];
    }
    companyCharts[canvasId] = new Chart(canvas.getContext('2d'), config);
}

// Extract the plotted arrays for the current series. The dataset order here is the
// contract shared by the create path (chart configs below) and the update path
// (updateCompanyCharts) — keep them in sync.
function computeChartData(series) {
    return {
        labels: series.map(s => companyMonthLabel(s.monthBucket)),
        financial: [
            series.map(s => Math.round(s.monthlyRevenue)),
            series.map(s => Math.round(s.monthlyBurn)),
            series.map(s => Math.round(s.netIncome)),
            series.map(s => Math.round(s.oneTimeCost || 0))
        ],
        customer: [
            series.map(s => s.newCustomers),
            series.map(s => s.customers)
        ],
        business: [
            series.map(s => s.confidence),
            series.map(s => s.credibility),
            series.map(s => s.reach)
        ],
        operations: [
            series.map(s => s.teamSize),
            series.map(s => s.stress)
        ]
    };
}

// Human description of the active range, for screen-reader summaries.
function describeChartRange() {
    if (companyChartRangeMonths === null) return 'all time';
    const years = Math.round(companyChartRangeMonths / 12);
    return years <= 1 ? 'the last year' : `the last ${years} years`;
}

// Refresh each canvas's aria-label so screen readers get a spoken summary of what
// the (otherwise opaque) chart currently shows. Re-run whenever the data changes.
function updateChartAccessibility(series) {
    const setAria = (id, text) => {
        const el = document.getElementById(id);
        if (el) el.setAttribute('aria-label', text);
    };
    if (series.length < 2) {
        ['financialChart', 'customerChart', 'businessChart', 'operationsChart']
            .forEach(id => setAria(id, 'Chart: not enough data yet — make a few decisions to see trends over time.'));
        return;
    }
    const last = series[series.length - 1];
    const range = describeChartRange();
    setAria('financialChart',
        `Financial trend over ${range}. Latest monthly revenue ${formatCurrency(last.monthlyRevenue)}, burn ${formatCurrency(last.monthlyBurn)}, net income ${formatCurrency(last.netIncome)}`
        + (last.oneTimeCost ? `, one-time costs ${formatCurrency(last.oneTimeCost)}` : '') + '.');
    setAria('customerChart',
        `Customer growth over ${range}. ${last.customers.toLocaleString()} total customers, ${Math.round(last.newCustomers).toLocaleString()} new in the latest month.`);
    setAria('businessChart',
        `Business development over ${range}. Confidence ${last.confidence}%, credibility ${last.credibility}%, reach ${last.reach}%.`);
    setAria('operationsChart',
        `Operations over ${range}. Team size ${last.teamSize}, founder stress ${last.stress}%.`);
}

// Show the "not enough data" overlay on each chart when the window has < 2 points,
// without destroying the chart instances underneath.
function applyChartEmptyState(isEmpty) {
    ['financialChartWrap', 'customerChartWrap', 'businessChartWrap', 'operationsChartWrap']
        .forEach(id => {
            const wrap = document.getElementById(id);
            if (wrap) wrap.classList.toggle('is-empty', isEmpty);
        });
}

// Full (re)build of all four charts. Used when the modal opens, since the canvases
// are recreated each time the body's innerHTML is rebuilt.
function renderCompanyCharts() {
    if (typeof Chart === 'undefined') return; // CDN failed to load — skip gracefully
    const series = filterSeriesByRange(getCompanyMonthlySeries(), companyChartRangeMonths);
    const d = computeChartData(series);

    const baseOptions = {
        responsive: true,
        maintainAspectRatio: false,
        // Short, eased animation so scrubbing the range slider morphs the charts
        // smoothly. Kept brief (vs. Chart.js's 1s default) so rapid drags keep up.
        animation: { duration: 250, easing: 'easeOutQuart' },
        interaction: { mode: 'index', intersect: false },
        plugins: {
            legend: { labels: { boxWidth: 12, font: { size: 11 } } },
            tooltip: { enabled: true }
        },
        elements: { line: { tension: 0.3, borderWidth: 2 }, point: { radius: 2, hoverRadius: 4 } },
        scales: {
            x: { grid: { display: false }, ticks: { font: { size: 10 }, maxRotation: 0, autoSkipPadding: 8 } },
            y: { beginAtZero: true, ticks: { font: { size: 10 } } }
        }
    };
    const currencyTicks = { callback: (v) => formatCurrency(v), font: { size: 10 } };

    // Financial: monthly revenue vs. burn vs. net income (lines, left axis) +
    // one-time costs (bars, right axis — they're lump spends, not a monthly rate)
    makeCompanyChart('financialChart', {
        type: 'line',
        data: {
            labels: d.labels,
            // Dataset order MUST match computeChartData().financial so the update path
            // (applyChartData maps array[i] → datasets[i]) stays in sync. Visual stacking
            // (bar behind lines) is handled by the `order` property, not array position.
            datasets: [
                { label: 'Revenue', data: d.financial[0], borderColor: '#10b981', backgroundColor: 'rgba(16,185,129,0.08)', fill: true, yAxisID: 'y', order: 0 },
                { label: 'Burn', data: d.financial[1], borderColor: '#ef4444', backgroundColor: 'rgba(239,68,68,0.05)', fill: false, yAxisID: 'y', order: 0 },
                { label: 'Net Income', data: d.financial[2], borderColor: '#3b82f6', backgroundColor: 'rgba(59,130,246,0.05)', fill: false, yAxisID: 'y', order: 0 },
                { type: 'bar', label: 'One-time cost', data: d.financial[3], backgroundColor: 'rgba(234,88,12,0.30)', borderColor: 'rgba(234,88,12,0.8)', borderWidth: 1, yAxisID: 'yOneTime', order: 1 }
            ]
        },
        options: {
            ...baseOptions,
            scales: {
                x: baseOptions.scales.x,
                y: { beginAtZero: false, ticks: currencyTicks },
                yOneTime: { type: 'linear', position: 'right', beginAtZero: true, grid: { drawOnChartArea: false }, ticks: currencyTicks }
            },
            plugins: {
                ...baseOptions.plugins,
                tooltip: { callbacks: { label: (c) => `${c.dataset.label}: ${formatCurrency(c.parsed.y)}` + (c.dataset.label === 'One-time cost' ? '' : '/mo') } }
            }
        }
    });

    // Customer: total customers (line, left axis) + net new customers/mo (bars, right axis)
    makeCompanyChart('customerChart', {
        type: 'bar',
        data: {
            labels: d.labels,
            datasets: [
                { type: 'bar', label: 'New / mo', data: d.customer[0], backgroundColor: 'rgba(96,165,250,0.45)', borderColor: 'rgba(96,165,250,0.85)', borderWidth: 1, yAxisID: 'yNew', order: 1 },
                { type: 'line', label: 'Total Customers', data: d.customer[1], borderColor: '#2563eb', backgroundColor: 'rgba(37,99,235,0.10)', fill: true, yAxisID: 'yTotal', order: 0 }
            ]
        },
        options: {
            ...baseOptions,
            scales: {
                x: baseOptions.scales.x,
                yTotal: { type: 'linear', position: 'left', beginAtZero: true, ticks: { font: { size: 10 } } },
                yNew: { type: 'linear', position: 'right', beginAtZero: true, grid: { drawOnChartArea: false }, ticks: { precision: 0, font: { size: 10 } } }
            },
            plugins: {
                ...baseOptions.plugins,
                tooltip: { callbacks: { label: (c) => `${c.dataset.label}: ${Math.round(c.parsed.y).toLocaleString()}` } }
            }
        }
    });

    // Business Development: confidence, credibility, reach (all 0–100)
    makeCompanyChart('businessChart', {
        type: 'line',
        data: {
            labels: d.labels,
            datasets: [
                { label: 'Confidence', data: d.business[0], borderColor: '#7c3aed', backgroundColor: 'rgba(124,58,237,0.06)', fill: false },
                { label: 'Credibility', data: d.business[1], borderColor: '#db2777', backgroundColor: 'rgba(219,39,119,0.06)', fill: false },
                { label: 'Reach', data: d.business[2], borderColor: '#0891b2', backgroundColor: 'rgba(8,145,178,0.06)', fill: false }
            ]
        },
        options: {
            ...baseOptions,
            scales: { x: baseOptions.scales.x, y: { beginAtZero: true, max: 100, ticks: { font: { size: 10 } } } }
        }
    });

    // Operations: team size (count, left axis) vs. founder stress (%, right axis)
    makeCompanyChart('operationsChart', {
        type: 'line',
        data: {
            labels: d.labels,
            datasets: [
                { label: 'Team Size', data: d.operations[0], borderColor: '#d97706', backgroundColor: 'rgba(217,119,6,0.10)', fill: true, yAxisID: 'yTeam' },
                { label: 'Stress %', data: d.operations[1], borderColor: '#dc2626', backgroundColor: 'rgba(220,38,38,0.05)', fill: false, yAxisID: 'yStress' }
            ]
        },
        options: {
            ...baseOptions,
            scales: {
                x: baseOptions.scales.x,
                yTeam: { type: 'linear', position: 'left', beginAtZero: true, ticks: { precision: 0, font: { size: 10 } }, title: { display: false } },
                yStress: { type: 'linear', position: 'right', beginAtZero: true, max: 100, grid: { drawOnChartArea: false }, ticks: { font: { size: 10 } } }
            }
        }
    });

    applyChartEmptyState(series.length < 2);
    updateChartAccessibility(series);
}

// Push freshly sliced data into one existing chart and repaint without animation.
function applyChartData(canvasId, labels, dataArrays) {
    const chart = companyCharts[canvasId];
    if (!chart) return;
    chart.data.labels = labels;
    dataArrays.forEach((arr, i) => {
        if (chart.data.datasets[i]) chart.data.datasets[i].data = arr;
    });
    chart.update(); // uses the chart's short configured animation (see baseOptions)
}

// Lightweight redraw used while dragging the range slider: re-slice the series and
// update the existing chart instances in place instead of tearing them down.
function updateCompanyCharts() {
    if (typeof Chart === 'undefined') return;
    // If the charts haven't been built yet (e.g. first open), fall back to a full build.
    if (!companyCharts.financialChart) { renderCompanyCharts(); return; }
    const series = filterSeriesByRange(getCompanyMonthlySeries(), companyChartRangeMonths);
    const d = computeChartData(series);
    applyChartData('financialChart', d.labels, d.financial);
    applyChartData('customerChart', d.labels, d.customer);
    applyChartData('businessChart', d.labels, d.business);
    applyChartData('operationsChart', d.labels, d.operations);
    applyChartEmptyState(series.length < 2);
    updateChartAccessibility(series);
}

// Switch between the Metrics, Org Chart, and Story panes inside the company modal.
function switchCompanyTab(tab) {
    const panes = {
        metrics: document.getElementById('companyMetricsBody'),
        org: document.getElementById('companyOrgBody'),
        story: document.getElementById('companyStoryBody')
    };
    const tabs = {
        metrics: document.getElementById('companyTabMetrics'),
        org: document.getElementById('companyTabOrg'),
        story: document.getElementById('companyTabStory')
    };
    if (!panes.metrics || !panes.org) return;

    Object.keys(panes).forEach(key => {
        const pane = panes[key];
        const tabBtn = tabs[key];
        const active = key === tab;
        if (pane) {
            pane.hidden = !active;
            pane.classList.toggle('active', active);
        }
        if (tabBtn) {
            tabBtn.classList.toggle('active', active);
            tabBtn.setAttribute('aria-selected', String(active));
        }
    });

    // Build the pane's content lazily, on demand, when its tab is shown.
    if (tab === 'org') populateOrgChart();
    else if (tab === 'story') populateCompanyStory();
}

// Persist the player's CEO name as they type (used elsewhere later).
function updateCeoName(value) {
    gameState.ceoName = value;
}

// Build up-to-two-letter initials from a person's name for the avatar circle.
function orgInitials(name) {
    const parts = (name || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '?';
    const letters = parts.length === 1
        ? parts[0].slice(0, 2)
        : parts[0][0] + parts[parts.length - 1][0];
    return letters.toUpperCase();
}

// Render the org chart: the player as CEO up top, then hired employees laid out
// in seniority tiers (Senior above Mid above Junior). Re-rendered each time the
// Org Chart tab is opened so newly hired slots appear.
function populateOrgChart() {
    const body = document.getElementById('companyOrgBody');
    if (!body) return;

    const employees = gameState.employees || [];
    const byLevel = { Senior: [], Mid: [], Junior: [] };
    const coFounders = [];
    // Tag each employee with its index in gameState.employees so the action buttons
    // act on the right person regardless of tier sorting. Co-founders are pulled out
    // and shown up top alongside the CEO instead of in the seniority tiers.
    employees.forEach((e, i) => {
        if (e.coFounder) { coFounders.push({ emp: e, idx: i }); return; }
        (byLevel[e.level] || byLevel.Mid).push({ emp: e, idx: i });
    });
    // Within a tier, group the same roles together (e.g. all Sr. PMs side by side).
    Object.values(byLevel).forEach(arr => arr.sort((a, b) => a.emp.role.localeCompare(b.emp.role)));

    const hasCoFounder = coFounders.length > 0;
    const tiers = [
        ['Senior', 'Senior'],
        ['Mid', 'Mid-Level'],
        ['Junior', 'Junior']
    ];

    const nodeHTML = ({ emp: e, idx }) => {
        const tenure = formatTenure(employeeYearsOfService(e));
        const safeName = (e.name || '').replace(/"/g, '&quot;');
        // Right-side action: promote for Junior/Mid; "make co-founder" for a Senior
        // when no co-founder exists yet; otherwise a spacer to keep the avatar centered.
        let rightAction;
        if (e.level !== 'Senior') {
            rightAction = `<button type="button" class="org-action org-promote" onclick="promoteEmployee(${idx})"
                title="Promote ${safeName}" aria-label="Promote ${safeName}">▲</button>`;
        } else if (!hasCoFounder) {
            rightAction = `<button type="button" class="org-action org-cofound" onclick="makeCoFounder(${idx})"
                title="Make ${safeName} a co-founder" aria-label="Make ${safeName} a co-founder">★</button>`;
        } else {
            rightAction = `<span class="org-action org-action-spacer" aria-hidden="true"></span>`;
        }
        return `
        <div class="org-node org-level-${e.level.toLowerCase()}">
            <div class="org-node-top">
                <button type="button" class="org-action org-fire" onclick="fireEmployee(${idx})"
                    title="Lay off ${safeName}" aria-label="Lay off ${safeName}">✕</button>
                <div class="org-avatar org-avatar-initials">${orgInitials(e.name)}</div>
                ${rightAction}
            </div>
            <div class="org-name">${e.name || e.role}</div>
            <div class="org-title">${e.role}</div>
            <div class="org-meta">
                <span class="org-badge org-badge-${e.level.toLowerCase()}">${e.level}</span>
                <span class="org-salary">$${Math.round(e.salary / 1000)}k</span>
            </div>
            <div class="org-tenure">${tenure} of service</div>
        </div>
    `;
    };

    const coFounderNodeHTML = ({ emp: e }) => `
        <div class="org-node org-ceo org-cofounder">
            <div class="org-ceo-label">CO-FOUNDER</div>
            <div class="org-cofounder-name">${e.name || e.role}</div>
            <div class="org-role">${e.role} · ${e.equity || 0}% equity</div>
        </div>
    `;

    const tierRows = tiers
        .filter(([key]) => byLevel[key].length)
        .map(([key, label]) => `
            <div class="org-tier">
                <div class="org-tier-label">${label}</div>
                <div class="org-row">${byLevel[key].map(nodeHTML).join('')}</div>
            </div>
        `).join('');

    const ceoName = (gameState.ceoName || '');
    const tieredCount = employees.length - coFounders.length;
    const founders = 1 + coFounders.length;

    body.innerHTML = `
        <div class="org-chart">
            <div class="org-row org-ceo-row">
                <div class="org-node org-ceo">
                    <div class="org-ceo-label">CEO</div>
                    <input type="text" class="org-ceo-name" id="orgCeoName"
                        placeholder="Your name" value="${ceoName.replace(/"/g, '&quot;')}"
                        oninput="updateCeoName(this.value)" aria-label="Your name (CEO)" />
                    <div class="org-role">Chief Executive Officer · Founder</div>
                </div>
                ${coFounders.map(coFounderNodeHTML).join('')}
            </div>
            ${tieredCount ? '<div class="org-trunk"></div>' : ''}
            <div class="org-tiers">
                ${tierRows}
            </div>
            ${employees.length
                ? `<div class="org-footnote">${tieredCount} employee${tieredCount === 1 ? '' : 's'} · ${founders} founder${founders === 1 ? '' : 's'}</div>`
                : '<div class="org-empty">No employees yet. Hire team members to grow your org chart.</div>'}
        </div>
    `;
}

// Render a month count as "yr mo" with fractional months, e.g. 63.4 -> "5yr 3.4mo".
// Under a year it drops the "yr" part (e.g. "3.4mo"). Used for the runway readout.
// "mo" rather than "M" so months aren't misread as millions next to the cash figures.
function formatMonthsDuration(totalMonths) {
    totalMonths = Math.max(0, totalMonths);
    const years = Math.floor(totalMonths / 12);
    const months = totalMonths - years * 12;
    return years > 0 ? `${years}yr ${months.toFixed(1)}mo` : `${months.toFixed(1)}mo`;
}

function formatCurrency(amount) {
    const absAmount = Math.abs(amount);
    const isNegative = amount < 0;
    const prefix = isNegative ? '-$' : '$';
    
    if (absAmount >= 1000000) {
        return prefix + (absAmount / 1000000).toFixed(1) + 'M';
    } else if (absAmount >= 1000) {
        return prefix + (absAmount / 1000).toFixed(1) + 'K';
    } else {
        return prefix + absAmount.toFixed(0);
    }
}

function exportCompanyReport() {
    const reportData = {
        companyName: document.getElementById('companyName').textContent,
        reportDate: new Date().toISOString(),
        // Elapsed time since founding (founding = month 1 = 0 elapsed), matching
        // companyAgePhrase's convention. currentYear is an ordinal (1 all through year
        // one), so it can't be used as a count of elapsed years.
        timeInBusiness: (() => {
            const months = Math.max(0, gameState.currentMonth - 1);
            const yrs = Math.floor(months / 12);
            const mos = Math.round((months - yrs * 12) * 10) / 10;
            return yrs > 0 ? `${yrs} year${yrs === 1 ? '' : 's'}, ${mos} months` : `${mos} months`;
        })(),
        
        // Financial metrics
        financial: {
            totalRevenue: gameState.totalRevenue,
            monthlyRevenue: gameState.monthlyRevenue,
            monthlyBurn: gameState.monthlyBurn,
            netIncome: gameState.monthlyRevenue - gameState.monthlyBurn,
            currentRunway: gameState.runway,
            runwayMonths: gameState.runway > 0 ? Math.floor(gameState.runway / Math.max(gameState.monthlyBurn - gameState.monthlyRevenue, 1)) : 0
        },
        
        // Customer metrics
        customer: {
            totalCustomers: gameState.customers,
            averageRevenuePerCustomer: gameState.customers > 0 ? (gameState.monthlyRevenue / gameState.customers) : 0,
            engagement: gameState.engagement,
            growth: gameState.growth
        },
        
        // Business metrics
        business: {
            teamSize: gameState.teamSize,
            confidence: gameState.confidence,
            credibility: gameState.credibility,
            reach: gameState.reach,
            founderStress: gameState.stress,
            founderWellbeing: getStressLevel(gameState.stress).label,
            decisionsCount: gameState.selectedCards.filter(card => card.category !== 'outcome').length,
            decisionRate: gameState.cardsGenerated > 0 ? (gameState.selectedCards.filter(card => card.category !== 'outcome').length / gameState.cardsGenerated) * 100 : 0
        },
        
        // Full selections for context
        businessDecisions: gameState.selectedCards,
        
        // Generated at
        exportedAt: new Date().toISOString()
    };
    
    const dataStr = JSON.stringify(reportData, null, 2);
    const dataBlob = new Blob([dataStr], {type: 'application/json'});
    
    const link = document.createElement('a');
    link.href = URL.createObjectURL(dataBlob);
    link.download = `${reportData.companyName.replace(/\s+/g, '_')}_company_metrics_report.json`;
    link.click();
    
    // Also log to console for debugging
    console.log('Company Metrics Report:', reportData);
    
    // Show a brief success message
    const originalText = event.target.textContent;
    event.target.textContent = 'Exported! ✓';
    event.target.style.background = '#10b981';
    
    setTimeout(() => {
        event.target.textContent = originalText;
        event.target.style.background = '';
    }, 2000);
}

// Initialize company metrics modal functionality
function initializeCompanyMetricsModal() {
    const companyNameDiv = document.getElementById('companyName');
    
    if (companyNameDiv) {
        // Make it look clickable
        companyNameDiv.style.cursor = 'pointer';
        companyNameDiv.style.transition = 'all 0.2s ease';
        
        // Add hover effect
        companyNameDiv.addEventListener('mouseenter', function() {
            this.style.transform = 'scale(1.05)';
            this.style.boxShadow = '0 4px 12px rgba(30, 58, 138, 0.3)';
        });
        
        companyNameDiv.addEventListener('mouseleave', function() {
            this.style.transform = 'scale(1)';
            this.style.boxShadow = '';
        });
        
        // Add click event (toggle: opens, or closes if already open)
        companyNameDiv.addEventListener('click', toggleCompanyMetricsModal);
    }
    
    // Modal event listeners for clicking outside to close
    document.addEventListener('click', (e) => {
        const modal = document.getElementById('companyMetricsModal');
        if (modal && e.target === modal) {
            closeCompanyMetricsModal();
        }
    });
    
    // Escape key to close modal
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeCompanyMetricsModal();
        }
    });
}
;
// generate the instructions card
function generateInstructionsCard() {
    return `
        <div class="business-card flippable instructions">
            <div class="card-inner">
                <div class="card-face card-front">
                    <div class="card-header instructions">
                        <div class="card-type-wrapper">
                            <div><p>Getting Started</p></div>
                            <div class="card-type">TUTORIAL</div>
                        </div>
                        
                        <div class="instructions-logo">
                            <img src="svg/startupCards-light.svg" alt="Startup Cards" />
                        </div>
                        <a class="storyset-link" href="https://storyset.com" target="_blank" rel="noopener">Illustration by Cuate on Storyset</a>
                    </div>
                    <div class="card-svg-section">
                        <div class="svg-container">
                            <img class="card-img" data-src="svg/market-launch-animate.svg" alt=""/>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="impact-metrics">
                            <div class="metric">
                                <span class="metric-value">📊</span>
                                <span class="metric-label">View Stats</span>
                            </div>
                            <div class="metric">
                                <span class="metric-value">💡</span>
                                <span class="metric-label">Make Choices</span>
                            </div>
                            <div class="metric">
                                <span class="metric-value">📋</span>
                                <span class="metric-label">Track Progress</span>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="content-title">
                                Build Your Startup
                            </div>
                            <div class="content-desc">
                                You are the CEO and decision maker of your very own startup. Each choice impacts your confidence, credability, and reach.
                                <strong>Add</strong> cards that you want for your startup or <strong>Skip</strong> ones you don't.
                            </div>
                        </div>
                        <div class="flip-hint flip-hint-front" aria-hidden="true">Tap card for tips &amp; how-to&nbsp;⟳</div>
                        <div class="action-buttons">
                            <button class="btn btn-skip" onclick="skipCard(this)">
                                Skip Tutorial
                            </button>
                            <button class="btn btn-select" onclick="skipCard(this)">
                                Start Building
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card-face card-back instructions-back">
                    <div class="card-header instructions card-back-header">
                        <div class="card-type-wrapper">
                            <div><p>How It Works</p></div>
                            <div class="card-type">QUICK GUIDE</div>
                        </div>
                        <h2>Playing the Cards</h2>
                    </div>
                    <div class="card-body card-back-body">
                        <div class="card-content">
                            <div class="content-title">Reading a Card</div>
                            <div class="content-desc">
                                Every decision moves your metrics — runway, revenue and burn-rate are calculated every turn. Top level impacts are on the front of the card. <strong>Tap most cards</strong> to flip them over for a full breakdown.
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="content-title">Making a Move</div>
                            <div class="content-desc">
                                <strong>Swipe right</strong> (or click Add) to accept a card, <strong>swipe left</strong> (or Skip) to pass on it.
                                Keyboard: <strong>→</strong> adds, <strong>←</strong> skips, <strong>Enter</strong> flips.  (press <strong>?</strong> anytime for shortcuts key)
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="content-title">Metrics Over Time</div>
                            <div class="content-desc">
                                <strong>Your Business Name</strong> button holds the key to long term forcasting and current trajectory <strong>study it often</strong>
                            </div>
                        </div>
                        <div class="pro-tip">
                            <span class="pro-tip-icon">💡</span>
                            <span class="pro-tip-text"><strong>Pro tip:</strong> Balance your bets. Loading up on one area while ignoring validation or marketing will trigger setbacks down the road.</span>
                        </div>
                        <div class="flip-hint" aria-hidden="true">↩&nbsp;Tap to flip back</div>
                    </div>
                </div>
            </div>
        </div>
    `;
}

;
// Validation cards — customer discovery, market research, MVP testing
const validationMethods = [
    {
        title: "Customer Discovery Interviews",
        description: "Talk to 20+ potential customers to understand their pain points",
        detail: "Talking to real customers before you build is the cheapest insurance against shipping the wrong thing. The conversations sharpen your conviction about what to build and surface a handful of early believers who can become your first customers.",
        impact: { time: .5, cost: 500, confidence: 15, customers: 5, stress: -5 },
        category: "validation",
        svg: "svg/active-support-animate.svg"
    },
    {
        title: "Landing Page MVP",
        description: "Create a simple page to test demand before building",
        detail: "A simple landing page measures genuine demand through real sign-ups before you write a line of production code. It's a fast, low-cost gut-check, though putting something public out into the world can be nerve-wracking.",
        impact: { time: 1, cost: 1000, confidence: 10, stress: 8 },
        category: "validation",
        svg: "svg/static-website-animate.svg"
    },
    {
        title: "Prototype Testing",
        description: "Build interactive mockup for user validation",
        detail: "An interactive mockup puts something tangible in front of users so you can watch how they actually behave instead of guessing. The feedback dramatically de-risks your roadmap, but building the prototype costs real time and money.",
        impact: { time: 1, cost: 3000, confidence: 20, stress: -10 },
        category: "validation",
        svg: "svg/prototyping-process-animate.svg"
    },
    {
        title: "A/B Testing Framework",
        description: "Set up systematic testing for all major decisions",
        detail: "A testing framework turns major decisions into measurable experiments instead of opinions and gut calls. It compounds your confidence over time, though standing up the infrastructure is an upfront investment before you see returns.",
        impact: { time: 2, cost: 2000, confidence: 12, stress: -4 },
        category: "validation",
        svg: "svg/usability-testing-animate.svg"
    },
    {
        title: "Beta Customer Program",
        description: "10 beta customers at $50/month each to test and provide feedback",
        detail: "A paid beta cohort gives you early revenue and a tight feedback loop from users invested enough to actually pay. Their input shapes the product while their dollars start to validate your pricing.",
        impact: { monthlyRevenue: 500, recurringPayTime: 3, confidence: 15, time: 1.5, customers: 10, stress: -5 },
        category: "validation",
        svg: "svg/business-merger-animate.svg"
    },
    {
        title: "Cohort Analysis",
        description: "Track how each group of users behaves and retains over time",
        detail: "Grouping users by when they signed up reveals whether your product is actually getting stickier — are newer cohorts retaining better than older ones? It turns a vague sense of 'growth' into hard evidence of product-market fit and shows you exactly where users drop off.",
        impact: { time: 1, cost: 1000, confidence: 18, engagement: 10, stress: -5 },
        category: "validation",
        svg: "svg/cohort-analysis-animate.svg"
    },
    {
        title: "Community Q&A",
        description: "Host open Q&A sessions and mine the questions users actually ask",
        detail: "The questions people ask in an open Q&A are a goldmine — they reveal the objections, confusion, and unmet needs standing between a prospect and a purchase. Answering in public builds trust while handing you a prioritized list of what to fix or explain next.",
        impact: { time: 0.5, cost: 500, confidence: 15, customers: 8, engagement: 10, stress: -3 },
        category: "validation",
        svg: "svg/my-answer-animate.svg"
    },
    {
        title: "Feature Voting Board",
        description: "Let users upvote what to build next so you prioritize what they actually want",
        detail: "A public voting board turns roadmap guesswork into hard signal — users tell you exactly which features they want most by voting with their clicks. It keeps you from building in the wrong direction and makes the community feel heard, which deepens their investment in the product.",
        impact: { time: 0.5, cost: 500, confidence: 18, engagement: 12, customers: 5, stress: 2 },
        category: "validation",
        svg: "svg/upvote-animate.svg"
    }
];

;
// Team cards — hiring roles and people-ops policies
const teamMembers = [
    {
        title: "UX/UI Designer",
        description: "Create intuitive, beautiful user experiences that drive engagement",
        detail: "A dedicated designer makes the product feel intuitive and polished, which directly drives engagement and word-of-mouth. Handing off design also lifts a heavy creative load off the founders and steadies day-to-day stress.",
        salary: 85000,
        impact: { time: 1, quality: 25, engagement: 15, stress: -10 },
        category: "team",
        level: "Mid-Senior",
        svg: "svg/mobile-wireframe-animate.svg"
    },
    {
        title: "Full-Stack Developer",
        description: "Build and maintain your platform with versatile technical skills",
        detail: "A versatile full-stack hire moves across your entire codebase, shipping features without waiting on specialists. They add serious build capacity and quality while sharing the technical burden you've been carrying alone.",
        salary: 95000,
        impact: { time: 2, quality: 30, stress: -12 },
        category: "team",
        level: "Mid Level",
        svg: "svg/coding-animate.svg"
    },
    {
        title: "Customer Success Manager",
        description: "Retain and grow existing users through exceptional support",
        detail: "A customer success manager keeps the customers you've already won, turning churn-prone accounts into loyal, expanding ones. Strong retention is far cheaper than constant acquisition and steadies both revenue and your nerves.",
        salary: 75000,
        impact: { time: 1, quality: 10, retention: 40, stress: -10 },
        category: "team",
        level: "Mid",
        svg: "svg/follow-the-leader-animate.svg"
    },
    {
        title: "Content Marketing Manager",
        description: "Scale thought leadership and drive organic growth",
        detail: "A content marketer builds an organic growth engine through thought leadership that keeps working long after each post ships. It compounds credibility and reach without the recurring spend of paid ads.",
        salary: 70000,
        impact: { time: .5, quality: 30, growth: 35, stress: -8 },
        category: "team",
        level: "Mid Level",
        svg: "svg/mobile-marketing-animate.svg"
    },
    {
        title: "DevOps Engineer",
        description: "Scale infrastructure and ensure platform reliability",
        detail: "A DevOps engineer hardens your infrastructure so the platform stays fast and reliable as usage climbs. It's the difference between scaling smoothly and a public outage, and it lets the whole team ship with confidence.",
        salary: 105000,
        impact: { time: 1.5, quality: 40, scalability: 50, stress: -12 },
        category: "team",
        level: "Senior",
        svg: "svg/programmer-animate.svg"
    },
    {
        title: "Sales Manager",
        description: "Drive enterprise sales and close high-value deals",
        detail: "A sales manager owns the pipeline and closes the high-value enterprise deals founders rarely have time to chase. They bring credibility to the table and turn scattered interest into signed, predictable revenue.",
        salary: 90000,
        impact: { time: 1, monthlyRevenue: 4000, credibility: 25, growth: 20, stress: -8},
        category: "team",
        level: "Senior",
        svg: "svg/finance-animate.svg"
    },
    {
        title: "Product Manager",
        description: "Coordinate development priorities and market strategy",
        detail: "A product manager aligns engineering, design, and the market so the team builds the right things in the right order. They free the founders from constant prioritization firefights and lift overall execution quality.",
        salary: 110000,
        impact: { time: 2, quality: 35, stress: -15},
        category: "team",
        level: "Senior",
        svg: "svg/selecting-team-animate.svg"
    },
    {
        title: "Remote-First Policy",
        description: "Go remote-first to cut office overhead and hire from anywhere",
        detail: "Committing to remote-first work slashes office overhead and opens your hiring pool to global talent, improving your ability to scale the team. It also meaningfully lowers founder stress by removing the cost and logistics burden of maintaining a physical office.",
        impact: { time: 0.5, cost: -2000, monthlyCost: 300, scalability: 15, stress: -10 },
        category: "team",
        svg: "svg/remote-team-animate.svg",
        // unlock: Ethical Charter adopted
    },
    {
        title: "4-Day Work Week Pilot",
        description: "Trial a four-day week to boost morale at a small velocity cost",
        detail: "A four-day week is a major founder-health and morale win that improves team retention, at the cost of roughly 10% less weekly output. It's a bet that a happier, more focused team sustains the company better over the long run than raw hours do.",
        impact: { time: 0.5, growth: -5, stress: -15 },
        category: "team",
        svg: "svg/co-workers-animate.svg",
        // unlock: Team size >= 3
    },
    {
        title: "Team Offsite",
        description: "Get everyone together for a few days of bonding and big-picture planning",
        detail: "Pulling the team out of the daily grind for a proper offsite rebuilds the trust and camaraderie that remote work and crunch quietly erode. Morale and retention climb and people come back aligned and energized — it costs a chunk of cash and a few days of output, but a tight team ships better.",
        impact: { time: 0.5, cost: 5000, retention: 20, quality: 10, stress: -15 },
        category: "team",
        svg: "svg/group-photo-animate.svg"
    },
    {
        title: "Adopt Agile Process",
        description: "Run the team on sprints, standups, and retrospectives to ship predictably",
        detail: "Adopting agile ceremonies — short sprints, daily standups, regular retrospectives — turns chaotic effort into a steady cadence the team can sustain. Working in small, shippable increments means you course-correct early instead of discovering problems at the end, and the rhythm keeps everyone pulling in the same direction.",
        impact: { time: 0.5, cost: 500, quality: 25, scalability: 15, stress: -8 },
        category: "team",
        svg: "svg/scrum-method-animate.svg"
    },
    {
        title: "Streamlined Collaboration",
        description: "Adopt shared tooling that keeps the whole team aligned and in sync",
        detail: "A shared workspace where everyone can see who's doing what kills the status-meeting churn and the 'I thought you had it' mix-ups. Clear ownership and visibility keep the team coordinated as it grows, so good work doesn't slip through the cracks.",
        impact: { time: 0.5, cost: 500, monthlyCost: 200, quality: 15, retention: 10, stress: -8 },
        category: "team",
        svg: "svg/scrum-board-animate.svg"
    },
    {
        title: "3D Motion Designer",
        description: "Render 3D concepts and animated demos that turn ideas into shippable product",
        detail: "A 3D motion designer renders precise concept models of what you're building — visualizing the product from every angle long before it's real, so the team can pressure-test and refine the design before committing to build it. The same renders double as striking animated demos that stop the scroll, lifting engagement and giving your launches a reach most early startups can't match.",
        salary: 88000,
        impact: { time: 1, quality: 20, engagement: 20, reach: 15, stress: -8 },
        category: "team",
        level: "Mid-Senior",
        svg: "svg/3d-modeling-animate.svg"
    },
    {
        title: "Team Certification Program",
        description: "Sponsor training and certifications to level up the team's skills",
        detail: "Paying for your people to earn real certifications sharpens the skills the company runs on and signals you're invested in their careers — one of the cheapest, stickiest ways to keep good people from leaving. It costs cash and pulls them away from the work while they study, but a credentialed team ships better and lends outside credibility when customers ask who's behind the product.",
        impact: { time: 1, cost: 4000, quality: 20, retention: 25, credibility: 10, stress: -8 },
        category: "team",
        svg: "svg/certification-animate.svg"
    },
    {
        title: "General Counsel",
        description: "Bring legal in-house to handle contracts, compliance, and risk before it bites",
        detail: "A seasoned general counsel reviews every contract, keeps you on the right side of regulators, and spots the legal landmines founders never see coming. Having that judgment in the room means fewer nasty surprises, more confidence signing big deals, and one less thing keeping you up at night — though senior legal talent doesn't come cheap.",
        salary: 140000,
        impact: { time: 1, predictability: 25, credibility: 20, confidence: 15, stress: -12 },
        category: "team",
        level: "Senior",
        svg: "svg/lawyer-animate.svg"
    },
    {
        title: "Law Firm on Retainer",
        description: "Put a full-service law firm on retainer for litigation, deals, and IP",
        detail: "Retaining an outside firm gives you a whole bench of specialists on call — litigators, deal lawyers, IP experts — far more firepower than any single hire when something big lands on your desk. A respected firm's name on your side reassures partners and investors and steadies the founders, though that kind of coverage bills every month whether you use it or not.",
        impact: { time: 0.5, cost: 2000, monthlyCost: 3500, credibility: 25, predictability: 20, confidence: 10, stress: -10 },
        category: "team",
        svg: "svg/law-firm-animate.svg"
    },
    {
        title: "Copywriter",
        description: "Sharpen the words everywhere — landing pages, emails, and in-product copy",
        detail: "A good copywriter makes every headline, button, and error message pull its weight — turning vague, founder-written text into clear, persuasive words. Outside the product, sharper marketing copy lifts conversion and makes the brand read polished and trustworthy; inside it, clear onboarding and UX writing guide users past the spots where they'd otherwise get stuck and give up.",
        salary: 62000,
        impact: { time: 0.5, growth: 20, engagement: 15, credibility: 15, retention: 10, stress: -6 },
        category: "team",
        level: "Mid Level",
        svg: "svg/online-article-animate.svg"
    },
    {
        title: "Videographer",
        description: "Produce demos, testimonials, and social video that grab attention and spread",
        detail: "A dedicated videographer turns your product and customers into scroll-stopping video — crisp demos, real testimonials, and social clips that travel far further than text or stills. Video is the format that earns reach and holds attention, and polished production makes the whole brand look a tier more established than it is.",
        salary: 72000,
        impact: { time: 1, reach: 30, engagement: 20, growth: 10, credibility: 10, stress: -6 },
        category: "team",
        level: "Mid Level",
        svg: "svg/videographer-animate.svg"
    },
    {
        title: "Interaction Designer",
        description: "Hire a specialist to perfect the micro-interactions that make the product feel alive",
        detail: "An interaction designer sweats the details most teams skip — the responsive buttons, the transitions that guide the eye, the small moments of delight that make software feel crafted. Their polish lifts engagement and turns first impressions into word-of-mouth, while taking the finickiest part of design off the founders' plate.",
        salary: 82000,
        impact: { time: 1, quality: 20, engagement: 20, retention: 10, stress: -8 },
        category: "team",
        level: "Mid-Senior",
        svg: "svg/interaction-design-animate.svg"
    },
    {
        title: "Recruiter",
        description: "Bring in a recruiter to build a steady hiring pipeline and run people ops",
        detail: "A dedicated recruiter turns hiring from a frantic, founder-draining scramble into a steady pipeline of vetted candidates — and picks up the HR load of onboarding and keeping the team happy. They let you grow the team faster and smarter while taking the endless sourcing, screening, and paperwork off your plate.",
        salary: 75000,
        impact: { time: 1, quality: 10, growth: 15, stress: -12 },
        category: "team",
        level: "Mid Level",
        svg: "svg/job-hunt-animate.svg"
    }
];

;
// Product cards — feature development and improvements
const productFeatures = [
    {
        title: "AI-Powered Recommendations",
        description: "Intelligent suggestions based on user behavior and industry trends",
        detail: "Smart recommendations surface the right content at the right moment, deepening engagement and extending your reach into new use cases. They're powerful but complex to tune, and a poorly trained model can frustrate users before it helps them.",
        impact: { time: 3, cost: 15000, reach: 25, engagement: 30, retention: -10, stress: 15 },
        category: "product",
        svg: "svg/robotics-animate.svg"
    },
    {
        title: "Real-time Collaboration",
        description: "Add features for collaboration",
        detail: "Real-time collaboration turns your product into a shared workspace people return to with their teammates, sharply lifting engagement. That multiplayer dynamic also helps each account pull in new users on its own.",
        impact: { time: 2, cost: 8000, reach: 25, engagement: 60, retention: 10, stress: 10 },
        category: "product",
        svg: "svg/design-team-animate.svg"
    },
    {
        title: "Mobile Application",
        description: "Native iOS and Android apps for on-the-go access",
        detail: "Native mobile apps put your product in users' pockets and unlock a huge new channel of reach. They're a major build across two platforms, so weigh the cost against how mobile-first your customers really are.",
        impact: { time: 4, cost: 25000, reach: 50, engagement: 10, retention: -5, stress: 18 },
        category: "product",
        svg: "svg/mobile-login-animate.svg"
    },
    {
        title: "Integration Marketplace",
        description: "Connect your product with popular business tools and platforms by connecting APIs",
        detail: "Connecting to the tools customers already use makes your product stickier and harder to rip out, boosting retention. Each integration also opens a partner channel that quietly expands your reach.",
        impact: { time: 3.5, cost: 12000, reach: 30, engagement: 20, retention: 20, stress: 12 },
        category: "product",
        svg: "svg/website-setup-animate.svg"
    },
    {
        title: "Green Cloud Hosting",
        description: "Migrate to carbon-neutral cloud infrastructure, cutting long-term costs",
        detail: "Moving to a green cloud provider lowers your infrastructure spend over time and improves how efficiently you scale. It's also a genuine sustainability win that eases founder stress knowing your stack aligns with your values.",
        impact: { time: 1, cost: 2000, monthlyCost: -200, scalability: 15, stress: -5 },
        category: "product",
        svg: "svg/server-animate.svg",
        // unlock: Ethical Charter adopted
    },
    {
        title: "Open-Source Sustainability Tools",
        description: "Release free sustainability tooling that builds community goodwill",
        detail: "By open-sourcing tools for measuring and reducing environmental impact, you earn credibility and organic word-of-mouth from a values-driven developer community. There's no direct revenue, but it lays the groundwork for becoming an industry standard-setter later (Open-Impact Standards).",
        impact: { time: 2, cost: 3000, credibility: 25, growth: 15, stress: -5 },
        category: "product",
        svg: "svg/open-source-animate.svg",
        // unlock: Ethical Charter adopted
        // unlocks: Open-Impact Standards
    },
    {
        title: "Carbon Calculator Integration",
        description: "Let users track their carbon footprint directly inside your product",
        detail: "Embedding a carbon calculator turns sustainability into a visible, sticky in-app feature. It's a genuine marketing differentiator that boosts engagement and reach with eco-conscious users, and shipping it reduces founder stress by aligning the product with the company's values.",
        impact: { time: 2, cost: 6000, reach: 20, engagement: 25, stress: -3 },
        category: "product",
        svg: "svg/visual-data-animate.svg",
        // unlock: Ethical Charter adopted
    },
    {
        title: "Sustainable Packaging",
        description: "Switch to eco-friendly packaging at a higher unit cost",
        detail: "Moving to sustainable packaging raises unit costs by roughly 15%, but conscious customers reward it with markedly higher retention (~25%). It also signals the kind of operational commitment that unlocks a 'Green Enterprise Deal' with sustainability-minded buyers later.",
        impact: { time: 1.5, cost: 4000, retention: 25, stress: 2 },
        category: "product",
        svg: "svg/checking-boxes-animate.svg",
        // unlock: Physical product
        // unlocks: Green Enterprise Deal
    },
    {
        title: "In-App Support Channel",
        description: "Add a contact form and live chat so users can reach you without leaving the product",
        detail: "Giving users a one-click way to get in touch turns silent frustration into solvable conversations — you catch problems before they churn and learn exactly where people get stuck. Responsive support builds trust and keeps hard-won customers from quietly slipping away.",
        impact: { time: 1.5, cost: 2500, monthlyCost: 300, retention: 20, engagement: 15, credibility: 10, stress: 5 },
        category: "product",
        svg: "svg/get-in-touch-animate.svg"
    },
    {
        title: "Proprietary Hardware",
        description: "Invest in custom hardware that competitors can't easily copy",
        detail: "Designing your own chips and boards is slow, expensive, and unforgiving — but it builds a defensible moat that pure-software rivals can't replicate. Owning the hardware layer unlocks performance and reliability you can't buy off the shelf, and signals serious technical credibility to customers and investors.",
        impact: { time: 4, cost: 30000, scalability: 25, credibility: 25, retention: 15, stress: 20 },
        category: "product",
        svg: "svg/printed-circuit-board-animate.svg"
    },
    {
        title: "Multi-Format Export",
        description: "Let users import and export their work freely in any format they need",
        detail: "Supporting clean import and export across formats means customers never feel trapped — they can bring their data in and take their work out however they need it. That openness builds trust, fits the messy real-world tools your customers already use, and quietly removes a major objection during enterprise deals.",
        impact: { time: 1.5, cost: 5000, retention: 20, credibility: 15, reach: 10, stress: 6 },
        category: "product",
        svg: "svg/video-files-animate.svg"
    },
    {
        title: "Customizable Workflows",
        description: "Let customers configure the product to match how they already work",
        detail: "Rather than forcing one rigid process, configurable workflows let each customer bend the product to fit their own way of working. That flexibility widens the range of businesses you can serve and makes the product far harder to abandon once it's molded around a team's habits.",
        impact: { time: 2.5, cost: 9000, retention: 25, reach: 20, scalability: 10, stress: 12 },
        category: "product",
        svg: "svg/user-flow-animate.svg"
    },
    {
        title: "Focus Mode",
        description: "A distraction-free flow state that strips the UI down to just the work",
        detail: "A dedicated focus mode hides the notifications, panels, and clutter so users can drop into deep work with nothing but the task in front of them. It turns the product into the place people go to actually get things done — the kind of calm, flow-state experience that builds a daily habit and keeps them coming back.",
        impact: { time: 1.5, cost: 4000, engagement: 30, retention: 20, stress: 5 },
        category: "product",
        svg: "svg/floating-animate.svg"
    },
    {
        title: "Guided Product Tour",
        description: "Walk new users through the product step-by-step with interactive pop-overs",
        detail: "An interactive tour takes new users by the hand on their first visit — highlighting the key actions with pop-over tips so they reach their first win before they get lost or give up. Strong onboarding is the difference between a signup and an active user: it lifts activation, keeps people coming back, and quietly cuts the support questions that come from confusion.",
        impact: { time: 1.5, cost: 3500, engagement: 20, retention: 25, growth: 10, stress: 4 },
        category: "product",
        svg: "svg/product-tour-animate.svg"
    },
    {
        title: "Advanced Customization",
        description: "Let users tailor colors, fonts, and layout with sliders and toggles to make the product their own",
        detail: "Giving users granular control over how the product looks and feels — theming, type, sizing, the little toggles — turns a generic tool into something that feels like theirs. That sense of ownership keeps people invested and makes the product far harder to leave, and the white-label polish opens doors with brand-conscious enterprise buyers.",
        impact: { time: 2, cost: 7000, retention: 25, engagement: 20, credibility: 10, stress: 10 },
        category: "product",
        svg: "svg/advanced-customization-animate.svg"
    },
    {
        title: "Secure Sign-On",
        description: "Add two-factor authentication and a hardened login so users know their accounts are safe",
        detail: "Locking down the front door with two-factor auth and proper session security turns 'can I trust this with my data?' into a non-question. It's table stakes for any security review and the kind of quiet, foundational work that wins enterprise trust and keeps a breach from ever ending your company — even if users rarely notice it's there.",
        impact: { time: 2, cost: 6000, credibility: 25, retention: 15, scalability: 10, stress: 8 },
        category: "product",
        svg: "svg/enter-otp-animate.svg"
    },
    {
        title: "In-App Messaging",
        description: "Let users chat and collaborate with each other directly inside the product",
        detail: "Adding messaging turns a solo tool into a place where people connect, and every conversation is another reason to come back. That social layer deepens engagement and quietly pulls each user's contacts onto the platform.",
        impact: { time: 2, cost: 7000, engagement: 35, retention: 20, growth: 10, stress: 10 },
        category: "product",
        svg: "svg/messaging-fun-animate.svg"
    },
    {
        title: "Progressive Web App",
        description: "Make the product installable and usable offline, without an app store",
        detail: "A progressive web app installs straight from the browser and keeps working offline, giving users a near-native experience without the friction of an app store. It widens your reach across every device from a single codebase you actually maintain.",
        impact: { time: 2, cost: 6500, reach: 30, engagement: 15, scalability: 15, stress: 8 },
        category: "product",
        svg: "svg/progresive-app-animate.svg"
    },
    {
        title: "Real-Time Sync",
        description: "Keep every user's data instantly in sync across all their devices",
        detail: "When changes appear everywhere the instant they happen — no refreshing, no conflicts, no lost work — the product fades into the background and just works. That reliability is what turns a try-it tool into one people trust with their daily workflow.",
        impact: { time: 2.5, cost: 9000, retention: 25, engagement: 20, scalability: 10, stress: 12 },
        category: "product",
        svg: "svg/real-time-sync-animate.svg"
    },
    {
        title: "Smart Home IOT Integration",
        description: "Connect your product to the smart-home and IoT devices customers already own",
        detail: "Tying into the smart devices people already live with makes your product part of their everyday environment, not just another tab. It's a real engineering lift across finicky hardware, but it opens a whole new surface of reach and daily engagement.",
        impact: { time: 3, cost: 12000, reach: 25, engagement: 25, scalability: -5, stress: 15 },
        category: "product",
        svg: "svg/smart-home-animate.svg"
    },
    {
        title: "Immersive VR Mode",
        description: "Build an experimental virtual-reality experience that rivals won't dare to match",
        detail: "A VR experience is a bold, expensive bet most competitors won't make — and that's exactly what makes it a headline-grabbing differentiator. It won't be for every user, but the novelty draws press, reach, and a wow-factor that sets the brand apart.",
        impact: { time: 4, cost: 28000, reach: 35, engagement: 20, credibility: 10, stress: 22 },
        category: "product",
        svg: "svg/virtual-reality-animate.svg"
    },
    {
        title: "Voice Control",
        description: "Let users navigate and control the product hands-free with their voice",
        detail: "Voice control makes the product usable hands-free and far more accessible to people who can't or won't type, widening who you can serve. It's a modern, sticky convenience that keeps users engaged in moments a keyboard never could.",
        impact: { time: 2.5, cost: 10000, reach: 20, engagement: 20, retention: 10, stress: 14 },
        category: "product",
        svg: "svg/voice-control-animate.svg"
    },
    {
        title: "Granular Permissions",
        description: "Let admins control exactly what each teammate can see and do with role-based access",
        detail: "Role-based permissions let an account admin tick exactly who can view, edit, or manage each part of the product — the control every serious organization demands before they'll trust you with their team. It's unglamorous plumbing, but it's the line item that clears security reviews, makes the product impossible to outgrow, and turns single-seat users into whole-company rollouts.",
        impact: { time: 2, cost: 6500, credibility: 20, retention: 15, scalability: 15, stress: 10 },
        category: "product",
        svg: "svg/select-animate.svg"
    }
];

;
// Marketing cards — growth strategies and customer acquisition
const marketingStrategies = [
    {
        title: "Content-Led Growth",
        description: "Build audience through educational blog posts and guides",
        detail: "Educational content attracts the exact people searching for what you solve and positions you as a trusted authority. It's a slow-burn engine that keeps compounding traffic and credibility long after each piece is published.",
        impact: { time: 1, cost: 3000, growth: 35, credibility: 35, stress: 5 },
        category: "marketing",
        svg: "svg/social-dashboard-animate.svg"
    },
    {
        title: "Partnership Program",
        description: "Strategic alliances with business accelerators and incubators",
        detail: "Aligning with accelerators and incubators puts you in front of warm, qualified audiences through partners they already trust. Deals take time to negotiate, but each one can unlock a whole network at once.",
        impact: { time: 2, cost: 5000, growth: 15, credibility: 15, stress: 8 },
        category: "marketing",
        svg: "svg/live-collaboration-animate.svg"
    },
    {
        title: "Community Building",
        description: "Create engaged entrepreneur community around your platform",
        detail: "A genuine community gives users a reason to stay and advocate, generating word-of-mouth growth you could never buy outright. It takes patience to nurture, but a thriving community becomes a moat competitors can't copy.",
        impact: { time: 4, cost: 4000, growth: 45, credibility: 25, stress: 10 },
        category: "marketing",
        svg: "svg/group-chat-animate.svg"
    },
    {
        title: "Paid Acquisition",
        description: "Targeted ads on Google, LinkedIn, and Facebook",
        detail: "Paid ads buy fast, predictable traffic and let you test messaging at scale almost overnight. The growth is real but rented — it stops the moment you stop spending, so keep a close eye on your unit economics.",
        impact: { time: .5, cost: 8000, growth: 25, credibility: -5, stress: 3 },
        category: "marketing",
        svg: "svg/mobile-payments-animate.svg"
    },
    {
        title: "Cornerstone Content",
        description: "Produce one in-depth flagship post designed to rank and get shared",
        detail: "Instead of churning out posts, you pour everything into a single definitive piece — the one people bookmark, cite, and link back to. It takes real effort to build, but a true cornerstone article keeps pulling in traffic and backlinks for years.",
        impact: { time: 1.5, cost: 2500, growth: 20, reach: 30, engagement: 20, credibility: 25, stress: 6 },
        category: "marketing",
        svg: "svg/blog-post-animate.svg"
    },
    {
        title: "Email Marketing",
        description: "Nurture leads and customers with targeted email campaigns",
        detail: "Email is the one channel you actually own — no algorithm standing between you and your audience. Well-timed campaigns and drip sequences keep your product top of mind, re-engage quiet users, and convert leads at a fraction of the cost of paid ads.",
        impact: { time: 0.5, cost: 1000, growth: 20, engagement: 20, reach: 10, stress: 4 },
        category: "marketing",
        svg: "svg/emails-animate.svg"
    },
    {
        title: "Influencer Partnerships",
        description: "Pay creators to put your product in front of their engaged audiences",
        detail: "The right creator puts your product in front of a huge, already-trusting audience overnight — borrowed reach that converts far warmer than cold ads. It's pricey and a little unpredictable (a flop or a mismatched voice can fizzle), but a good fit can spike growth and awareness fast.",
        impact: { time: 0.5, cost: 7000, reach: 35, growth: 25, engagement: 10, stress: 6 },
        category: "marketing",
        svg: "svg/influencer-animate.svg"
    },
    {
        title: "Build a Newsletter",
        description: "Grow an owned subscriber audience with a regular, must-read newsletter",
        detail: "A newsletter turns one-time visitors into a standing audience you can reach any time — a compounding, owned channel no algorithm can take away. Each issue deepens trust and keeps you top of mind, slowly building a list that becomes one of your most valuable growth assets.",
        impact: { time: 1, cost: 1500, growth: 15, reach: 25, engagement: 15, credibility: 15, stress: 5 },
        category: "marketing",
        svg: "svg/newsletter-animate.svg"
    },
    {
        title: "Launch a Podcast",
        description: "Start a show to build authority and a loyal audience one conversation at a time",
        detail: "A podcast builds a uniquely intimate connection with listeners — hours of your voice in their ears earns trust a blog post can't. Inviting industry guests doubles as networking, opening doors to partners and customers, while each episode compounds your credibility in the niche.",
        impact: { time: 1.5, cost: 2500, reach: 20, credibility: 25, engagement: 15, growth: 10, stress: 6 },
        category: "marketing",
        svg: "svg/podcast-animate.svg"
    }
];

;
// Business model cards — business strategy and operational decisions
const businessModels = [
    {
        title: "Freemium SaaS",
        description: "Free tier with premium features for power users",
        detail: "A free tier lowers the barrier to entry and lets the product sell itself, with power users converting to paid as they grow. It scales beautifully, though you carry the cost of free users until enough of them upgrade.",
        impact: { time: 3.5, cost: 2000, oneTimeRevenue: 20000, growth: 25, scalability: 40, stress: 8 },
        category: "business",
        svg: "svg/setup-wizard-animate.svg"
    },
    {
        title: "Enterprise Licensing",
        description: "Custom solutions for large organizations and corporations",
        detail: "Custom enterprise deals command large contracts and lend instant credibility from marquee logos. The sales cycles are long and bespoke, but each win is sizable and pushes your revenue per customer dramatically higher.",
        impact: { time: 2, cost: 5000, oneTimeRevenue: 6000, growth: 5, scalability: 60, stress: 6 },
        category: "business",
        svg: "svg/business-deal-animate.svg"
    },
    {
        title: "Marketplace Commission",
        description: "Take percentage of transactions facilitated through platform",
        detail: "Taking a cut of every transaction means your revenue grows automatically as activity on the platform grows. It aligns your success with your users', though you need real transaction volume before the model pays off.",
        impact: { time: 3, cost: 3600, monthlyRevenue: 1000, recurringPayTime: 24, growth: 15, scalability: 10, stress: 7 },
        category: "business",
        svg: "svg/paid-idea-animate.svg"
    },
    {
        title: "Subscription Tiers",
        description: "Multiple pricing levels based on features and usage",
        detail: "Tiered pricing captures more value by matching plans to how much each customer uses, nudging them upward as they grow. Predictable recurring revenue makes the whole business easier to forecast and scale.",
        impact: { time: 3, cost: 2500, oneTimeRevenue: 10000, growth: 5, scalability: 30, stress: 7 },
        category: "business",
        svg: "svg/subscriber-animate.svg"
    },
    {
        title: "Global Expansion",
        description: "Open up to international markets and chase customers across borders",
        detail: "Expanding into new countries multiplies your addressable market and signals you're playing a bigger game. It means localizing the product, navigating new regulations, and a lot of time in airports — but the reach and growth upside is hard to match.",
        impact: { time: 4, cost: 8000, monthlyRevenue: 1500, recurringPayTime: 24, growth: 30, reach: 40, scalability: 20, stress: 12 },
        category: "business",
        svg: "svg/online-world-animate.svg"
    },
    {
        title: "Business Travel",
        description: "Hit the road to meet partners, customers, and investors face-to-face",
        detail: "Nothing closes deals like showing up in person. Flights, hotels, and dinners add up fast and pull you away from the office — but the relationships you build on the road tend to open doors that email never could.",
        impact: { time: 1, cost: 9000, credibility: 20, reach: 25, growth: 10, stress: 12 },
        category: "business",
        svg: "svg/airport-terminal-animate.svg"
    },
    {
        title: "Distributed Operations",
        description: "Run the company across time zones with a worldwide team and partners",
        detail: "Spreading operations across regions buys you round-the-clock momentum, access to global talent, and resilience when any single market wobbles. The flip side is real coordination overhead — time-zone juggling, compliance in every jurisdiction, and a heavier management load on the founders.",
        impact: { time: 3, cost: 6000, scalability: 40, growth: 10, stress: 14 },
        category: "business",
        svg: "svg/globalization-animate.svg"
    },
    {
        title: "Bulk Inventory Order",
        description: "Place a large inventory order to meet demand and lock in better unit costs",
        detail: "Committing to a big inventory run earns volume discounts and means you can fulfill the orders rolling in instead of turning them away. It's a heavy upfront bet on demand — cash tied up in stock — but if the orders keep coming it pays back in revenue and healthier margins.",
        impact: { time: 1, cost: 20000, monthlyRevenue: 2000, recurringPayTime: 12, scalability: 15, growth: 15, stress: 12 },
        category: "business",
        svg: "svg/messenger-animate.svg"
    },
    {
        title: "Short-Term Deal",
        description: "Run a limited-time promo to pull in a quick wave of new customers",
        detail: "A flash sale floods the door with bargain-hunters and spikes your customer count overnight, with a burst of one-off sales. But deal-chasers aren't loyal — the dip in overall engagement means they churn out fast once the discount ends, unless you give them a reason to stay.",
        impact: { time: 0.5, cost: 1500, customers: 300, oneTimeRevenue: 4000, engagement: -10, stress: 6 },
        category: "business",
        svg: "svg/price-animate.svg"
    },
    {
        title: "Core Infrastructure",
        description: "Invest in core infrastructure that everything you build next will run on",
        detail: "Some work isn't a feature — it's the foundation the whole company crosses. Re-architecting your core platform is slow, costly, and invisible to customers while it's underway, but laying the right structural blocks now means every future product ships faster and holds up under load. It's an engineering bet on the company you're trying to become, not the one you are today.",
        impact: { time: 4, cost: 12000, scalability: 50, predictability: 30, quality: 20, stress: -3 },
        category: "business",
        svg: "svg/bridge-construction-animate.svg"
    },
    {
        title: "Customer Support Line",
        description: "Stand up a staffed support line so a real person always picks up",
        detail: "Spinning up a dedicated support line means customers reach a live human instead of a ticket queue, and the founders stop being the after-hours help desk. It's a standing operational cost to staff and run, but fast, personal answers keep frustrated users from churning and earn the kind of word-of-mouth credibility that self-serve never quite matches.",
        impact: { time: 1, cost: 2000, monthlyCost: 1500, retention: 30, credibility: 15, stress: -8 },
        category: "business",
        svg: "svg/call-center-animate.svg"
    },
    {
        title: "International Distribution Deal",
        description: "Sign an overseas partner to import and sell your product in their market",
        detail: "Rather than setting up shop abroad yourself, you hand distribution to a partner who already knows the market — they handle import, logistics, and local sales while you supply the product. It cracks open a whole new country's worth of customers fast and with little founder overhead, though you trade away a slice of the margin and some control over how your brand shows up overseas.",
        impact: { time: 1.5, cost: 4000, monthlyRevenue: 2500, recurringPayTime: 24, reach: 30, scalability: 20, stress: 6 },
        category: "business",
        svg: "svg/international-trade-animate.svg"
    },
    {
        title: "Tech Debt Paydown",
        description: "Refactor and upgrade the creaky systems holding the product together",
        detail: "Every shortcut taken to ship fast eventually comes due. Setting aside a stretch to refactor messy code, upgrade aging dependencies, and patch the things that keep breaking isn't glamorous and customers won't see it — but it makes the product more stable, easier to build on, and far less likely to fall over at the worst possible moment. The whole team breathes easier when the foundation stops creaking.",
        impact: { time: 1.5, cost: 4000, quality: 20, scalability: 20, predictability: 15, stress: -8 },
        category: "business",
        svg: "svg/operating-system-upgrade-B-animate.svg"
    },
    {
        title: "SEO & Analytics",
        description: "Instrument your site and tune it to climb search and learn what converts",
        detail: "Putting your own site under the magnifying glass — auditing it for search rankings and wiring up real analytics — turns guesswork into evidence. You climb the search results to pull in steady organic traffic, and you finally see which pages and flows actually convert, so every decision after this is grounded in data instead of hunches.",
        impact: { time: 1, cost: 3000, monthlyCost: 200, reach: 25, growth: 15, predictability: 15, stress: -3 },
        category: "business",
        svg: "svg/seo-analytics-team-animate.svg"
    }
];

;
// Revenue cards — monetization strategies and revenue streams
const revenueCards = [
    {
        title: "Premium Customer",
        description: "Premium customers generate $100/month",
        detail: "Your premium customer is proof that someone values the product enough to open their wallet. Beyond the monthly revenue, that validation is a huge confidence boost and a story you can tell the next prospect.",
        impact: { monthlyRevenue: 100, recurringPayTime: 36, confidence: 25, time: 0, customers: 1, stress: -8 },
        category: "revenue",
        svg: "svg/credit-card-payment-animate.svg"
    },
    {
        title: "Freelance/Consulting Revenue",
        description: "Use your expertise to generate $3k/month while building your product by consulting for another company",
        detail: "Consulting on the side funds the company from your own expertise without giving up any equity. It buys runway and keeps you close to real customer problems, though the billable hours compete with building your product.",
        impact: { time: 1, monthlyRevenue: 3000, recurringPayTime: 2, confidence: 30, stress: 10 },
        category: "revenue",
        svg: "svg/online-consulting-animate.svg"
    },
    { // should only appear if business model subscriptions are selected
        title: "Subscription Launch",
        description: "Launch paid subscriptions at $29/month, acquire 20 customers",
        detail: "Turning on paid subscriptions converts interest into recurring revenue and a base of committed customers. The steady monthly income smooths your cash flow and proves people will pay on an ongoing basis.",
        impact: { monthlyRevenue: 580, recurringPayTime: 6, confidence: 15, growth: 25, time: 2, customers: 20, stress: -5 },
        category: "revenue",
        svg: "svg/subscriber-gold-animate.svg"
    },
    {
        title: "Enterprise Pilot Deal",
        description: "Land a 6-month pilot with a corporation for $5k/month",
        detail: "A paid pilot lands meaningful revenue and a credible enterprise logo while you prove value to a big customer. Nail the pilot and it can expand into a much larger, longer-term contract.",
        impact: { time: .5, monthlyRevenue: 5000, recurringPayTime: 6, credibility: 30, stress: -3 },
        category: "revenue",
        svg: "svg/happy-announcement-animate.svg"
    },
    {
        title: "Affiliate Program Launch",
        description: "Partners drive $1.5k in monthly recurring revenue through referrals",
        detail: "An affiliate program turns partners into a commission-driven sales force that grows your revenue while you sleep. It scales reach without upfront ad spend, since you only pay out when partners actually deliver customers.",
        impact: { monthlyRevenue: 1500, recurringPayTime: 8, time: .5, customers: 10, stress: -3 },
        category: "revenue",
        svg: "svg/payment-information-animate.svg"
    },
    {
        title: "Upsell Existing Customers",
        description: "Increase average revenue per customer by $75/month through premium features",
        detail: "Selling premium features to customers you already have is the fastest, cheapest revenue you can find. They already trust you, so a well-timed upgrade lifts revenue per account with minimal new acquisition cost.",
        impact: { monthlyRevenue: 750, recurringPayTime: 36, retention: -5, time: 1, stress: 3 },
        category: "revenue",
        svg: "svg/operating-system-upgrade-animate.svg"
    },
    {
        title: "Corporate Training Contract",
        description: "Monthly training sessions generate $2.5k recurring revenue",
        detail: "Recurring training sessions create dependable monthly revenue and deepen the relationship with a sizable client. The hands-on contact strengthens retention and often surfaces new needs you can sell into later.",
        impact: { monthlyRevenue: 2500, recurringPayTime: 2, retention: 25, time: 1, customers: 25, stress: 5 },
        category: "revenue",
        svg: "svg/product-presentation-animate-copy.svg"
    }
];

;
// ESG / Governance cards — establish internal rules, ethical baselines, and legal
// frameworks. Unlike Product/Marketing (acquisition/retention) or Revenue (cash),
// these set the company's commitments and unlock values-driven paths later.
const esgCards = [
    {
        title: "Supply Chain Audit",
        description: "Vet your suppliers for labor and environmental standards",
        detail: "A formal audit of your supply chain confirms your suppliers actually meet the ethical and environmental standards you claim. It's a must-have for physical products or enterprise buyers, and it inoculates you against a future 'Greenwashing Accusation' challenge that could wreck your credibility.",
        impact: { time: 1.5, cost: 4000, confidence: 15, stress: 5 },
        category: "esg",
        svg: "svg/environmental-audit-animate.svg",
        // unlock: Physical product OR B2B enterprise target
        // prevents: Greenwashing Accusation challenge
    },
    {
        title: "Ethical AI Guidelines",
        description: "Adopt formal guidelines governing how your AI is built and used",
        detail: "Publishing clear ethical AI guidelines heads off future regulatory and reputational risk before it can bite, and builds credibility with customers and partners wary of black-box systems. It also lays the governance groundwork to justify a dedicated Trust & Safety Officer hire down the line.",
        impact: { time: 1, cost: 1500, credibility: 15, stress: -3 },
        category: "esg",
        svg: "svg/consent-animate.svg",
        // unlock: AI/ML product
        // unlocks: Trust & Safety Officer hire
    },
    {
        title: "B-Corp Pitch Deck",
        description: "Build the deck that puts you on the B-Corp certification path",
        detail: "A dedicated B-Corp pitch deck is the entry ticket to the certification path and the language impact investors expect. It sharpens how you tell your mission story, boosting credibility with values-aligned funders, and the clarity it brings the founders is a small but real stress relief.",
        impact: { time: 0.5, cost: 500, credibility: 15, confidence: 5, stress: -5 },
        category: "esg",
        svg: "svg/presentation-animate.svg",
        // unlock: Ethical Charter adopted
        // unlocks: B-Corp certification path
    },
    {
        title: "Profit & Purpose Balance",
        description: "Codify the values and red lines that govern every business decision",
        detail: "Weighing the planet and your principles against the bottom line forces the founders to decide, in advance, where profit ends and purpose begins — so the hard calls are already made before money is on the line. It anchors your culture and reassures values-driven customers and investors.",
        impact: { time: 0.5, cost: 500, credibility: 15, confidence: 10, stress: -5 },
        category: "esg",
        svg: "svg/business-ethics-animate.svg",
        // idea: could gate values-driven outcomes or temper a future ethics challenge
    },
    {
        title: "Carbon Neutral Pledge",
        description: "Commit to measuring, cutting, and offsetting your carbon footprint",
        detail: "A public pledge to reach carbon neutrality holds you accountable to measure emissions, cut what you can, and offset the rest. Offsets and audits cost real money, but the commitment earns credibility with climate-conscious customers, investors, and talent who increasingly choose who they work with by their values.",
        impact: { time: 1, cost: 3000, credibility: 20, confidence: 5, stress: -3 },
        category: "esg",
        svg: "svg/global-warming-animate.svg",
        // idea: could unlock green/eco partnerships or temper a future climate-scrutiny challenge
    },
    {
        title: "Circular Economy Pledge",
        description: "Commit to reusing materials and designing out waste and finite resources",
        detail: "Rather than the take-make-waste model, a circular commitment designs products and operations to reuse materials and lean on renewable inputs instead of finite ones. It takes upfront rework to re-engineer, but it future-proofs you against resource scarcity and earns credibility with sustainability-minded buyers and partners.",
        impact: { time: 1.5, cost: 4000, credibility: 20, scalability: 10, stress: -2 },
        category: "esg",
        svg: "svg/compost-cycle-animate.svg",
        // idea: could hedge against a future resource-scarcity / supply-shock challenge
    },
    {
        title: "Divest from Big Oil",
        description: "Pull your money and partnerships out of fossil fuels and refuse oil-industry deals",
        detail: "Taking a public stand to divest from fossil fuels — and turning down oil-industry money and contracts — is a bold values statement that wins deep loyalty from climate-conscious customers and talent. It can cost you lucrative deals you'd otherwise take, but it draws a clear line about who you are.",
        impact: { time: 0.5, cost: 2000, credibility: 25, confidence: 5, stress: -3 },
        category: "esg",
        svg: "svg/natural-resource-depletion-animate.svg",
        // idea: turning down oil deals could forgo a future high-revenue opportunity
    },
    {
        title: "Community Volunteer Program",
        description: "Give the team paid time to volunteer on local and environmental causes",
        detail: "Offering paid volunteer days gets the team out planting trees and cleaning up the neighborhood — building genuine goodwill in your community and a sense of shared purpose that money can't buy. It costs some productive hours, but it earns credibility and noticeably lifts team morale.",
        impact: { time: 0.5, cost: 1500, credibility: 15, retention: 10, stress: -8 },
        category: "esg",
        svg: "svg/volunteering-animate.svg",
        // idea: could boost employer brand / aid future hiring or community-goodwill outcomes
    },
    {
        title: "Sustainable by Design",
        description: "Rebuild your core offering to be sustainable from the ground up",
        detail: "Committing to sustainability at the design stage — renewable-powered infrastructure, efficient low-waste processes, durable goods or a tree planted for every purchase — bakes your values into the offering itself rather than bolting them on after. It works for physical and digital products alike, takes real investment to build in, but sets a high bar competitors struggle to match and earns deep credibility with conscious customers.",
        impact: { time: 2, cost: 6000, credibility: 25, confidence: 5, stress: 2 },
        category: "esg",
        svg: "svg/world-animate.svg",
        // idea: could unlock eco-conscious enterprise deals or premium green positioning
    },
    {
        title: "Open Knowledge Sharing",
        description: "Open-source your tools and publish your playbooks for the whole field",
        detail: "Committing to share what you've built — open-sourcing internal tools, publishing the playbooks and research you'd normally guard — turns your company into a contributor the whole field builds on. You give up a little proprietary edge, but the goodwill, reputation, and reach you earn as a good-faith leader compounds, drawing talent, partners, and customers who want to work with the company that gives back.",
        impact: { time: 1, cost: 1000, credibility: 20, reach: 20, confidence: 5, stress: -3 },
        category: "esg",
        svg: "svg/connecting-teams-animate.svg",
        // idea: could unlock community/ecosystem goodwill or developer-adoption outcomes
    },
    {
        title: "1% for the Planet",
        description: "Pledge 1% of revenue to environmental restoration, permanently",
        detail: "Committing a real 1% of revenue to reforestation, conservation, and climate causes — no matter how the quarter goes — turns sustainability from a slogan into a standing promise. The donation scales with the business: it costs you almost nothing while you're small and grows as you do, and in return you earn deep loyalty from values-driven customers and the quiet pride of leaving the world a little better than you found it.",
        impact: { time: 0.5, cost: 500, revenuePledgePct: 0.01, credibility: 25, retention: 10, confidence: 5, stress: -3 },
        category: "esg",
        svg: "svg/save-the-earth-animate.svg",
        // revenuePledgePct: recurring donation = 1% of live monthly revenue (see recalcMonthlyBurn)
        // idea: could deepen loyalty / unlock values-driven partnerships or outcomes
    }
];

;
// Outcome cards — dynamic events triggered by game state (positive, challenges,
// opportunities, revenue milestones)
const outcomeCards = {
    // POSITIVE OUTCOMES
    positive: [
        {
            title: "Early Customer Traction",
            description: "Your customer discovery interviews paid off! 3 potential customers are ready to pre-order.",
            trigger: "customer_discovery_interviews",
            impact: { monthlyRevenue: 300, recurringPayTime: 24, confidence: 20, time: -1, customers: 3, stress: -15 },
            category: "outcome",
            type: "positive",
            svg: "svg/in-no-time-animate.svg",
            followUp: "A local startup accelerator noticed your early traction and wants to meet."
        },
        {
            title: "Viral Product Demo",
            description: "Your prototype testing went viral on social media. 10k signups in 48 hours!",
            trigger: "prototype_testing",
            impact: { customers: 1000, engagement: 30, time: -.5, cost: -2000, stress: -20 },
            category: "outcome",
            type: "positive",
            svg: "svg/deconstructed-animate.svg",
            followUp: "TechCrunch wants to write about your rapid user growth."
        },
        {
            title: "Key Hire Success",
            description: "Your new UX designer just won a design award, boosting your company's credibility.",
            trigger: "ux/ui_designer",
            impact: { time: 1, credibility: 25, stress: -12 },
            category: "outcome",
            type: "positive",
            svg: "svg/awards-animate.svg",
            followUp: "Other top designers are now interested in joining your team."
        },
        {
            title: "Partnership Goldmine",
            description: "Your partnership program landed a major client worth $50k annually.",
            trigger: "partnership_program",
            impact: { oneTimeRevenue: 50000, credibility: 30, time: -1, growth: 20, stress: -20 },
            category: "outcome",
            type: "positive",
            svg: "svg/shared-goals-animate.svg",
            followUp: "They want to introduce you to their network of similar companies."
        },
        {
            title: "Community Champions",
            description: "Your user community is creating content and tutorials, reducing your marketing costs.",
            trigger: "community_building",
            impact: { time: -2, cost: -5000, engagement: 40, stress: -15 },
            category: "outcome",
            type: "positive",
            svg: "svg/team-spirit-animate.svg",
            followUp: "Users are asking about a referral program and premium community features."
        },
        {
            title: "Loyal Customer Base",
            description: "Your obsession with support is paying off — happy users are sticking around and pulling their friends in with them.",
            trigger: "brand_loyalty",
            impact: { customers: 200, engagement: 25, growth: 20, credibility: 20, stress: -15 },
            category: "outcome",
            type: "positive",
            svg: "svg/brand-loyalty-animate.svg",
            followUp: "Your fans are leaving glowing reviews and referring new customers organically."
        },
        {
            title: "Glowing Reviews",
            description: "Your users are leaving five-star reviews and singing your praises. The social proof is rolling in.",
            trigger: "beta_customer_program",
            impact: { customers: 150, credibility: 25, confidence: 20, engagement: 15, stress: -12 },
            category: "outcome",
            type: "positive",
            svg: "svg/feedback-animate.svg",
            followUp: "Prospects are citing your reviews as the reason they signed up."
        },
        {
            title: "Audience Takes Off",
            description: "Your posts struck a nerve — people are following you in droves and hanging on every update.",
            trigger: "marketing",
            impact: { reach: 35, customers: 200, growth: 20, engagement: 15, credibility: 15, stress: -10 },
            category: "outcome",
            type: "positive",
            svg: "svg/followers-animate.svg",
            followUp: "Brands and podcasts are sliding into your DMs about collaborations."
        },
        {
            title: "Personal Growth",
            description: "Months of looking after yourself instead of just grinding have paid off — you're a sharper, steadier leader, and the whole company can feel the lift.",
            trigger: "founder_growth",
            impact: { confidence: 20, credibility: 15, growth: 10, stress: -10 },
            category: "outcome",
            type: "positive",
            svg: "svg/personal-growth-animate.svg",
            followUp: "Your team is feeding off your energy, and decisions that used to rattle you feel easy now."
        },
        {
            title: "Industry Award",
            description: "Your team just took home a major industry award. Months of work, validated on stage — and the whole crew is celebrating.",
            trigger: "industry_award",
            impact: { credibility: 25, reach: 20, confidence: 15, retention: 10, stress: -12 },
            category: "outcome",
            type: "positive",
            svg: "svg/winners-animate.svg",
            followUp: "The recognition is opening doors — press, partners, and candidates are all reaching out."
        },
        {
            title: "Your Podcast Catches On",
            description: "You spot two strangers on the train quoting your latest episode to each other. The show has taken on a life of its own.",
            trigger: "podcast_audience",
            impact: { reach: 30, customers: 200, growth: 20, credibility: 20, engagement: 10, stress: -12 },
            category: "outcome",
            type: "positive",
            svg: "svg/podcast-audience-animate.svg",
            followUp: "Listeners are subscribing in droves and passing episodes around their own networks."
        },
        {
            // A long-serving junior who was never promoted moves on to a bigger role
            // elsewhere — happy and sad. The departure is applied when the card reaches
            // the top of the stack, where the description is rewritten to name them and
            // their tenure (see employee_moves_on in applyCardActivateEffect / ui.js).
            title: "On to Bigger Things",
            description: "One of your longest-serving team members is moving on.",
            trigger: "employee_moves_on",
            impact: { credibility: 10, confidence: 8, reach: 5 },
            category: "outcome",
            type: "positive",
            svg: "svg/end-of-workday-animate.svg",
            followUp: "Word gets around that your startup is where good careers get their start — but make sure you're also promoting from within."
        }
    ],

// NEGATIVE CHALLENGES
    challenges: [
        {
            title: "Feature Creep Crisis",
            description: "Without customer validation, you built features nobody wants. Pivot required.",
            trigger: "no_validation",
            impact: { time: .5, cost: 10000, confidence: -25, stress: 20 },
            category: "outcome",
            type: "challenge",
            svg: "svg/bug-fixing-animate.svg",
            followUp: "Your team is frustrated, and you need to rebuild user trust.",
            solutions: ["Start customer interviews now", "Simplify to core features", "Run user surveys"]
        },
        {
            title: "Founder Burnout",
            description: "Working alone is taking its toll. You're making mistakes and missing opportunities.",
            trigger: "solo_founder",
            impact: { time: .5, quality: -20, growth: -15, confidence: -15, stress: 40 },
            category: "outcome",
            type: "challenge",
            svg: "svg/student-stress-animate.svg",
            followUp: "A potential co-founder approached you, but you're not sure about giving up equity.",
            solutions: ["Find a co-founder", "Look within your own organization", "Join founder support group"]
        },
        {
            title: "Cash Flow Crunch",
            description: "Your expensive staff/features are burning through budget faster than expected.",
            trigger: "high_budget",
            impact: { cost: 15000, time: .5, stress: 30, confidence: -45 },
            category: "outcome",
            type: "challenge",
            svg: "svg/money-stress-animate.svg",
            followUp: "You need to either raise funds or significantly cut costs within 2 months.",
            solutions: ["Seek angel investment", "Reduce feature scope", "Find paying customers quickly"]
        },
        {
            // Surfaced the moment the runway goes negative while still unprofitable —
            // the start of the insolvency grace window (see updateInsolvencyTracker /
            // INSOLVENCY_GRACE_MONTHS in endings.js). A deadline warning, not a death
            // sentence: it names the clock and points at the fastest lever (payroll).
            // priority so it jumps the queue and lands while it still matters.
            title: "Obligations Coming Due",
            description: "You've crossed into the red — more is going out each month than coming in, and the cash is gone. You have a few months to turn this around before you can't make payroll. Cut your burn or bring in cash, fast.",
            trigger: "cash_crisis_warning",
            priority: true,
            impact: { stress: 12 },
            category: "outcome",
            type: "challenge",
            svg: "svg/obligations-animate.svg",
            followUp: "Your biggest cost is payroll. Open your company (tap the name) → Org chart to lay someone off — or raise cash / drive revenue before the runway runs out.",
            solutions: ["Lay someone off to cut burn (company → Org chart)", "Raise a round or take a bank loan", "Turn your pipeline into paying customers now"]
        },
        {
            title: "Launch Day Disaster",
            description: "Your mobile app crashes under load. No DevOps means no quick recovery.",
            trigger: "no_devops",
            impact: { time: 1.5, cost: 25000, customers: -500, confidence: -30, stress: 30 },
            category: "outcome",
            type: "challenge",
            svg: "svg/500-internal-server-error-animate.svg",
            followUp: "Social media is buzzing with complaints. Your App Store rating dropped to 2 stars.",
            solutions: ["Hire DevOps engineer immediately", "Use cloud auto-scaling", "Issue public apology"]
        },
        {
            title: "Marketing Void",
            description: "You built it, but they didn't come. Great product, but nobody knows about it.",
            trigger: "no_marketing",
            impact: { customers: -200, time: 1.5, growth: -25, cost: 10000, stress: 15 },
            category: "outcome",
            type: "challenge",
            svg: "svg/empty-animate.svg",
            followUp: "Competitors with inferior products are gaining market share.",
            solutions: ["Start content marketing", "Launch referral program", "Partner with influencers"]
        },
        {
            // Fires when enough "reasons to leave" pile up (see getAttritionReasons:
            // no professional growth, no flexible work, no team cohesion, stale work,
            // burnout). The actual departure is applied when the card reaches the top
            // of the stack, where the description below is rewritten to name who left
            // and cite the specific reason (see applyCardActivateEffect in ui.js).
            title: "Employee Quits",
            description: "One of your team has handed in their notice.",
            trigger: "employee_quit",
            impact: { time: 2, cost: -10000, stress: 20 },
            category: "outcome",
            type: "challenge",
            svg: "svg/quitting-a-job-animate.svg",
            followUp: "You'll need to backfill the role — and invest in the people who stayed before more of them walk.",
            solutions: ["Sponsor team training & certifications", "Offer remote-friendly, flexible work", "Run a team offsite to rebuild morale"]
        },
        {
            title: "Public Backlash",
            description: "An unhappy customer's angry rant went viral. Now everyone's piling on, and your support inbox is on fire.",
            trigger: "public_backlash",
            impact: { time: 1, cost: 8000, customers: -300, credibility: -25, confidence: -15, stress: 35 },
            category: "outcome",
            type: "challenge",
            svg: "svg/react-animate.svg",
            followUp: "How you respond in the next 24 hours will define your brand's reputation.",
            solutions: ["Issue a sincere public apology", "Reach out to the customer directly", "Fix the underlying issue fast"]
        },
        {
            title: "Online Pile-On",
            description: "A post about you got ripped out of context and the internet mob has decided you're today's villain. The pointing fingers are relentless.",
            trigger: "founder_pile_on",
            impact: { time: 0.5, customers: -150, confidence: -30, growth: -10, stress: 45 },
            category: "outcome",
            type: "challenge",
            svg: "svg/cyber-bullying-animate.svg",
            followUp: "Your team is rattled and you're losing sleep. Engaging the trolls will only feed them.",
            solutions: ["Step back and protect your mental health", "Let your community vouch for you", "Address it once, calmly, then move on"]
        },
        {
            title: "Onboarding Nightmare",
            description: "Your product got so feature-packed that new users can't figure it out without a manual. They sign up — and bounce just as fast.",
            trigger: "complex_onboarding",
            impact: { time: 1, cost: 6000, customers: -250, engagement: -20, growth: -15, stress: 20 },
            category: "outcome",
            type: "challenge",
            svg: "svg/instruction-manual-animate.svg",
            followUp: "Your activation rate is cratering and support tickets are piling up.",
            solutions: ["Strip the UI back to the core flow", "Add guided in-app onboarding", "Run usability tests on new users"]
        },
        {
            title: "The Product Is Crawling",
            description: "Every shortcut you took to ship fast has caught up with you. Pages hang, the app stutters, and users are staring at spinners instead of getting work done.",
            trigger: "performance_debt",
            impact: { time: 1, cost: 5000, customers: -200, engagement: -20, retention: -15, stress: 22 },
            category: "outcome",
            type: "challenge",
            svg: "svg/loading-animate.svg",
            followUp: "Reviews are calling it 'sluggish,' and the tech debt under the hood won't fix itself.",
            solutions: ["Pay down the tech debt dragging you down", "Optimize the worst bottlenecks now", "Move to scalable cloud infrastructure"]
        },
        {
            title: "The Long Road Ahead",
            description: "Months in, and the summit still looks impossibly far. Every milestone you plant just reveals three more. Doubt is creeping in.",
            trigger: "long_haul",
            impact: { time: 0.5, confidence: -25, growth: -10, stress: 25 },
            category: "outcome",
            type: "challenge",
            svg: "svg/milestones-of-business-projects-animate.svg",
            followUp: "You need a near-term win to remind yourself — and your team — why you started.",
            solutions: ["Break the goal into small, shippable wins", "Celebrate a milestone you've already hit", "Reconnect with your original 'why'"]
        },
        {
            title: "Regulatory Fine",
            description: "A regulator caught a compliance gap — data, tax, or licensing — and the penalty just landed with your name on it.",
            trigger: "regulatory_fine",
            impact: { time: 1, cost: 20000, customers: -100, credibility: -20, confidence: -20, stress: 35 },
            category: "outcome",
            type: "challenge",
            svg: "svg/fine-animate.svg",
            followUp: "The fine is public record, and customers and investors are asking how it happened.",
            solutions: ["Pay the fine and fix the gap fast", "Bring in a compliance advisor", "Get ahead of it with a public statement"]
        },
        {
            title: "Repeat Offense Fine",
            description: "Same gap, second strike. The regulator isn't amused that nothing changed — and repeat offenders don't get the friendly rate.",
            trigger: "regulatory_fine_repeat",
            impact: { time: 1.5, cost: 45000, customers: -200, credibility: -30, confidence: -25, stress: 45 },
            category: "outcome",
            type: "challenge",
            svg: "svg/fine-animate.svg",
            followUp: "Word is getting around that you cut corners. Investors want a compliance plan before they'll talk.",
            solutions: ["Pay up and finally close the gap for good", "Hire dedicated compliance help now", "Take an ESG/governance step before it's a third strike"]
        },
        {
            title: "Hauled Into Court",
            description: "Two fines ignored, and now it's a courtroom. The evidence is damning, the judge isn't sympathetic, and your lawyer is the only thing between you and the end.",
            trigger: "regulatory_prosecution",
            impact: { time: 3, cost: 120000, customers: -400, credibility: -45, confidence: -40, growth: -25, stress: 60 },
            category: "outcome",
            type: "challenge",
            svg: "svg/prosecutor-animate.svg",
            followUp: "Survive this and compliance is no longer optional — it's the only thing keeping the doors open.",
            solutions: ["Settle, pay the penalty, and fix everything now", "Mount a costly legal defense and hope", "Bring governance and ESG in immediately to show good faith"]
        },
        {
            title: "Mixed Reviews",
            description: "The reviews are rolling in — and they're all over the map. Five stars from some, one star from others, and prospects can't tell which version they'll get.",
            trigger: "mixed_reviews",
            impact: { time: 0.5, customers: -100, credibility: -15, confidence: -10, growth: -5, stress: 15 },
            category: "outcome",
            type: "challenge",
            svg: "svg/online-review-animate.svg",
            followUp: "An inconsistent reputation is scaring off fence-sitters who'd rather not gamble.",
            solutions: ["Dig into the 1-star reviews for the real pattern", "Tighten quality so the experience is consistent", "Reply to unhappy reviewers and win them back"]
        },
        {
            title: "Regulatory Scrutiny",
            description: "A regulator wants a closer look at how you operate. The auditor's questions are piling up — and your paperwork is nowhere near ready.",
            trigger: "regulatory_audit",
            impact: { time: 1, cost: 3000, confidence: -10, credibility: -5, stress: 20 },
            category: "outcome",
            type: "challenge",
            svg: "svg/oversight-animate.svg",
            followUp: "Consider this a warning shot — get your house in order, or the fines start landing.",
            solutions: ["Scramble your documentation into shape", "Bring in legal help before it escalates", "Take a compliance or ESG step to show good faith"]
        },
        {
            title: "Pop-Up Overload",
            description: "In the rush to monetize, you've buried the product under pop-ups, upsells, and banner ads. Users feel ambushed every time they open it.",
            trigger: "popup_overload",
            impact: { time: 0.5, customers: -150, engagement: -25, retention: -15, credibility: -15, stress: 20 },
            category: "outcome",
            type: "challenge",
            svg: "svg/pop-up-animate.svg",
            followUp: "Reviews are calling it 'adware,' and the people who stuck around are using it less every week.",
            solutions: ["Strip the intrusive ads back out", "Move to a single clean paid tier", "Rebalance toward the user experience"]
        },
        {
            title: "Market Downturn",
            description: "The economy just turned. Budgets are freezing, customers are cutting spend, and money you were counting on is evaporating — across the whole market, not just your books.",
            trigger: "market_downturn",
            // marketClimate drag is a sustained headwind: acquisition slows and churn rises
            // for months until the climate recovers (engine tick). Survive it, don't fix it.
            impact: { time: 1, marketClimate: -0.4, customers: -150, confidence: -15, stress: 25 },
            category: "outcome",
            type: "challenge",
            svg: "svg/bankruptcy-animate.svg",
            followUp: "This isn't about you — every company in your space is feeling it. Conserve cash and ride it out.",
            solutions: ["Extend runway by cutting nonessential spend", "Double down on retaining the customers you have", "Wait it out — the market will recover"]
        },
        {
            title: "War Breaks Out",
            description: "A war has broken out and like the crowds filling the streets, everyone here is against it. People are frightened, some have family in harm's way. Business as usual isn't an option, so you organize.",
            trigger: "war_shock",
            // The macro hit (marketClimate −0.5) lands regardless — war drags the whole market.
            // The card is unambiguously anti-war: the company stands with the protestors and
            // mobilizes, rather than treating it as a problem to weather (anti-war on purpose).
            impact: { time: 1, marketClimate: -0.5, cost: 5000, stress: 15 },
            category: "outcome",
            type: "challenge",
            svg: "svg/anti-war-protest-animate.svg",
            followUp: "The market will take a hit — let it. Standing with your people and using your voice is the only call that matters right now.",
            solutions: ["Give the team time to protest and be with their families", "Organize and fund relief and aid for those affected", "Use your platform to call for an end to the war"]
        }
    ],

// OPPORTUNITY CARDS
    opportunities: [
        {
            title: "Acquisition Offer",
            // description + sale price are filled in dynamically (valuation: true)
            // so the offer reflects the company's financial health — see
            // buildAcquisitionOffer / computeAcquisitionOffer in outcomes-engine.js.
            description: "A larger company wants to buy your startup. Take the exit or keep building?",
            trigger: "strong_growth",
            valuation: true,
            impact: {},
            category: "outcome",
            type: "opportunity",
            svg: "svg/agreement-animate.svg",
            choices: [
                { text: "Accept Offer", exit: true, salePrice: 2000000, impact: { oneTimeRevenue: 2000000, stress: -40 }},
                { text: "Keep Building", impact: { growth: 20, stress: 15 }}
            ]
        },
        {
            title: "Investor Interest",
            description: "A VC firm wants to lead your Series A round. $5M for 25% equity.",
            trigger: "proven_model",
            impact: {},
            category: "outcome",
            type: "opportunity",
            svg: "svg/investment-data-animate.svg",
            choices: [
                { text: "Take $5M for 25%", impact: { oneTimeRevenue: 5000000, investorEquity: 25, growth: 40, stress: 32 }},
                { text: "Bootstrap Longer", impact: { growth: 10, stress: 5 }}
            ]
        },
        {
            title: "Enterprise Pivot",
            description: "Your B2C product is struggling, but enterprises love a modified version.",
            trigger: "b2c_struggles",
            impact: {},
            category: "outcome",
            type: "opportunity",
            svg: "svg/dark-analytics-animate.svg",
            choices: [
                { text: "Pivot to B2B", impact: { time: 1, cost: 10000, customers: -50, stress: 15 }},
                { text: "Stay B2C", impact: { engagement: -25, customers: -130, stress: 10 }}
            ]
        },
        {
            title: "Deal on the Tarmac",
            description: "A connection you made on your travels wants to get serious — there's a partnership and a check on the table if you commit now.",
            trigger: "business_travel",
            impact: {},
            category: "outcome",
            type: "opportunity",
            svg: "svg/airport-runway-animate.svg",
            choices: [
                { text: "Sign the Partnership", impact: { oneTimeRevenue: 40000, time: 1, growth: 25, credibility: 20, stress: 12 }},
                { text: "Walk Away", impact: { confidence: -5, stress: 5 }}
            ]
        },
        {
            title: "Burnout Warning",
            description: "You're running on fumes. A week floating in a pool would put you back together — but the product won't move while you're gone.",
            trigger: "high_stress",
            impact: {},
            category: "outcome",
            type: "opportunity",
            svg: "svg/floating-in-water-animate.svg",
            choices: [
                { text: "Take a Vacation", impact: { time: 1, stress: -40, growth: -5, confidence: 10 }},
                { text: "Keep Grinding", impact: { growth: 10, engagement: 5, stress: 18 }}
            ]
        },
        {
            title: "Sued by a Competitor",
            description: "You've grown into a real threat — and a bigger rival just filed suit, claiming you crossed a line. It's flimsy, but fighting it isn't cheap. Settle quietly or take them on?",
            trigger: "competitor_lawsuit",
            impact: {},
            category: "outcome",
            type: "opportunity",
            svg: "svg/prosecutor-O-animate.svg",
            choices: [
                { text: "Settle Out of Court", impact: { time: 0.5, cost: 25000, credibility: -10, stress: 10 }},
                { text: "Fight It in Court", impact: { time: 2, cost: 60000, credibility: 25, confidence: 15, reach: 15, stress: 25 }}
            ]
        },
        {
            title: "Time for a Rebrand?",
            description: "Your designers have mocked up a bold new identity — name, logo, the works. A fresh look could change how the market sees you, but rebrands are expensive and risky. Go for it, or stick with what people already know?",
            trigger: "rebrand_opportunity",
            impact: {},
            category: "outcome",
            type: "opportunity",
            svg: "svg/rebranding-animate.svg",
            choices: [
                { text: "Commit to the Rebrand", impact: { time: 2, cost: 15000, credibility: 25, reach: 25, growth: 15, engagement: -5, stress: 12 }},
                { text: "Keep the Current Brand", impact: { confidence: 5, stress: 3 }}
            ]
        },
        {
            title: "A Competitor Enters the Race",
            description: "Your traction got noticed. A well-funded rival just launched straight at your market and is sprinting for the same customers. Out-execute them, or hold your lane and let them set the pace?",
            trigger: "competitor_enters",
            impact: {},
            category: "outcome",
            type: "opportunity",
            svg: "svg/track-cycling-animate.svg",
            // Both paths put a rival in the market (competitorPressure > 0), which keeps
            // taking share each month until it decays. Out-executing sets LESS pressure and
            // buys real growth — and growth is exactly what makes the pressure fade faster
            // (engine tick). Holding your lane is cheap now but lets the rival linger and bleed you.
            choices: [
                { text: "Out-Execute Them", impact: { competitorPressure: 0.3, time: 1, cost: 20000, growth: 18, engagement: 10, confidence: 10, stress: 18 }},
                { text: "Hold Your Lane", impact: { competitorPressure: 0.6, stress: 12 }}
            ]
        },
        {
            title: "An Investor Comes Knocking",
            description: "An investor has been watching your numbers climb and likes what the charts are showing. They'll wire $500K to supercharge your growth — in exchange for 15% of the company. Take the money and the dilution, or stay independent and keep every share?",
            trigger: "investor_raise",
            impact: {},
            category: "outcome",
            type: "opportunity",
            svg: "svg/analyze-animate.svg",
            // Taking the money sets investorEquity, which (like co-founder equity) is
            // carved out of the founder's payout at exit — see acceptExit in actions.js.
            // The cash + growth are real now; the dilution only bites if you sell later.
            // Keep the $ and % here in sync with the description above.
            choices: [
                { text: "Take $500K for 15%", impact: { oneTimeRevenue: 500000, investorEquity: 15, growth: 30, credibility: 15, reach: 15, stress: 28 }},
                { text: "Stay Independent", impact: { confidence: 10, stress: 5 }}
            ]
        },
        {
            // The lifeline. Surfaced if the company is still underwater a month into the
            // grace window (see checkForOutcomes / updateInsolvencyTracker). The amount and
            // the monthly repayment are filled in dynamically (emergencyLoan: true) from the
            // live deficit and burn — see buildEmergencyLoan in outcomes-engine.js. priority
            // so a founder racing the clock sees it without waiting on the batch gate.
            title: "Emergency Bank Loan",
            description: "You're out of cash. The bank will extend an emergency line of credit to keep the lights on — but a loan you can't out-earn just digs the hole deeper.",
            trigger: "cash_crisis_loan",
            emergencyLoan: true,
            priority: true,
            impact: {},
            category: "outcome",
            type: "opportunity",
            svg: "svg/vault-animate.svg",
            // The take-the-loan choice's loan figures are placeholders — buildEmergencyLoan
            // overwrites them (and the button label) with the real principal, repayment, and
            // term. loanPrincipal lands as cash; loanRepayment adds to burn until it's paid
            // off after loanTermMonths. The decline keeps a small stress hit.
            choices: [
                { text: "Take the Loan", impact: { loanPrincipal: 75000, loanRepayment: 2500, loanTermMonths: 36, stress: 12 }},
                { text: "Tough It Out", impact: { stress: 8 }}
            ]
        }
    ],

    revenueMilestones: [
        {
            title: "First $1K MRR! 🎉",
            description: "You've hit your first major revenue milestone. The product-market fit is starting to show.",
            trigger: "revenue_1k",
            impact: { confidence: 25, credibility: 20, stress: -15 },
            category: "outcome",
            type: "positive",
            svg: "svg/make-it-rain-animate.svg",
            followUp: "Local startup community is taking notice. You got invited to speak at a meetup."
        },
        {
            title: "Ramen Profitability Achieved",
            description: "Your revenue now covers basic living expenses. You can focus full-time on growth!",
            trigger: "revenue_profitable",
            impact: { stress: -20 },
            category: "outcome",
            type: "positive",
            svg: "svg/going-up-animate.svg",
            followUp: "You can finally quit your day job and go full-time on the startup."
        }
    ],

    // Capstone milestone: fires once when the player has both validated the idea
    // (a validation card) and shipped a product feature (a product card) — together
    // that's a Minimum Viable Product. The description is built at trigger time
    // (see checkMVPLaunch in outcomes-engine.js) so it can name the specific cards
    // the player picked. `priority` lets it jump the outcome queue's drain gate.
    mvpLaunch: {
        title: "MVP Launched!",
        trigger: "mvp_launch",
        impact: { confidence: 20, credibility: 15, stress: -15 },
        category: "outcome",
        type: "positive",
        priority: true,
        svg: "svg/launching-animate.svg",
        followUp: "Get it in front of real users and start the build-measure-learn loop."
    }
};

;
// NEW FUNCTIONS FOR SELECTIONS VIEW
function createSelectionsModal() {
    const modal = document.createElement('div');
    modal.className = 'selections-modal';
    modal.id = 'selectionsModal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'selectionsTitle');

    modal.innerHTML = `
        <div class="selections-modal-content">
            <div class="selections-header">
                <h2 id="selectionsTitle">📋 Your Selections</h2>
                <button type="button" class="close-modal" onclick="closeSelectionsModal()" aria-label="Close selections">&times;</button>
            </div>
            <div class="selections-body" id="selectionsBody">
                <!-- Content will be populated by showSelections() -->
            </div>
            <div class="selections-footer">
                <button type="button" class="btn btn-export" onclick="exportSelections()">Export Plan</button>
            </div>
        </div>
    `;

    document.body.appendChild(modal);
}

function showSelectionsModal() {
    let modal = document.getElementById('selectionsModal');
    
    // Create modal if it doesn't exist
    if (!modal) {
        createSelectionsModal();
        modal = document.getElementById('selectionsModal');
    }
    
    // Populate with current selections
    populateSelections();

    // Show modal. On desktop it's a pinned side panel, not a focus-trapping
    // overlay, so the player can keep driving the cards with the keyboard.
    openDialog(modal, { trap: !window.matchMedia('(min-width: 1330px)').matches });
}

function closeSelectionsModal() {
    const modal = document.getElementById('selectionsModal');
    if (modal && modal.style.display === 'flex') {
        closeDialog(modal);
    }
}

function toggleSelectionsModal() {
    const modal = document.getElementById('selectionsModal');
    if (modal && modal.style.display === 'flex') {
        closeSelectionsModal();
    } else {
        showSelectionsModal();
    }
}

// Tracks how many selections were shown in the previous render, so we can tell
// when a new card was just added (and animate only that one).
let lastSelectionCount = 0;

function populateSelections() {
    const selectionsBody = document.getElementById('selectionsBody');
    
    if (gameState.selectedCards.length === 0) {
        lastSelectionCount = 0;
        if (selectionsChart) { selectionsChart.destroy(); selectionsChart = null; }
        selectionsBody.innerHTML = `
            <div class="no-selections">
                <div class="no-selections-icon">🎯</div>
                <h3>No selections yet</h3>
                <p>Start building your startup by adding cards!</p>
            </div>
        `;
        return;
    }
    
    const categoryEmojis = {
        validation: "🎯",
        team: "🤜🤛",
        product: "⚡",
        marketing: "📈",
        business: "💼",
        revenue: "💰",
        outcome: "✨",
        esg: "🌐"
    };
    
    // Cumulative one-time spend across every decision (costs are stored negative)
    const totalInvested = gameState.selectedCards.reduce(
        (sum, c) => sum + Math.abs(c.impact && c.impact.cost ? c.impact.cost : 0), 0);
    const formatInvested = (abs) => {
        if (abs >= 1000000) return '$' + (abs / 1000000).toFixed(1).replace('.0', '') + 'M';
        if (abs >= 1000) return '$' + (abs / 1000).toFixed(1).replace('.0', '') + 'k';
        return '$' + abs;
    };

    let html = `
        <div class="selections-summary">
            <div class="summary-stats">
                <div class="summary-stat">
                    <span class="summary-value">${gameState.selectedCards.length}</span>
                    <span class="summary-label">Total Selections</span>
                </div>
                <div class="summary-stat">
                    <span class="summary-value">${formatInvested(totalInvested)}</span>
                    <span class="summary-label">Total Invested</span>
                </div>
                <div class="summary-stat">
                    <span class="summary-value">${gameState.timeToMVP > 0 ? Math.round(gameState.timeToMVP) + 'mo' : '—'}</span>
                    <span class="summary-label">Time to MVP</span>
                </div>
            </div>
            <div class="selections-chart"><canvas id="selectionsChart" role="img" aria-label="Bar chart of selections by category"></canvas></div>
        </div>
    `;
    
    // Only animate when the list actually grew (a card was added) — not on every
    // repopulate (open / remove / clear). The newest card sits at the last index.
    const justAdded = gameState.selectedCards.length > lastSelectionCount;
    const newestIndex = gameState.selectedCards.length - 1;

    // Newest selection on top: render in reverse, but keep the real index in
    // gameState.selectedCards so removeSelection() targets the right card.
    gameState.selectedCards.map((card, i) => [card, i]).reverse().forEach(([card, globalIndex]) => {
        const category = card.category;
        const isRemovable = category !== 'outcome'; // Don't allow removing outcome/opportunity cards
        const isNew = justAdded && globalIndex === newestIndex;
        
        // Use the stored calendar date or fall back to relative time
        const timeDisplay = card.selectedAt || card.relativeTime || 'Time not recorded';
        const detailTime = card.relativeTime ? `(${card.relativeTime})` : '';
        
        html += `
            <div class="selection-item ${category}${isNew ? ' is-new' : ''}">
                <div class="selection-content">
                    <div class="timeline-item-info">
                        <div class="selection-title">${card.title}</div>
                        <a href="javascript:learnMore('${card.category}')" aria-label="Learn more about ${card.category} (opens in new tab)">
                            <div class="card-type selection-timeline">${card.category}&nbsp; ${categoryEmojis[category]}</div>
                        </a>
                    </div>
                    <div class="selection-time">
                        <div class="selection-date">${timeDisplay}</div>&nbsp;
                        ${detailTime ? `<div class="selection-relative-time">${detailTime}</div>` : ''}
                    </div>
                </div>
                ${isRemovable ? `
                    <button type="button" class="remove-selection" onclick="removeSelection(${globalIndex})" title="Remove this selection" aria-label="Remove ${card.title}">
                        &times;
                    </button>
                ` : `
                    <div class="remove-selection" style="background: #f1f5f9; color: #94a3b8; cursor: not-allowed;" title="Outcome cards cannot be removed" aria-hidden="true">
                        🔒
                    </div>
                `}
            </div>
        `;
    });
    
    selectionsBody.innerHTML = html;
    lastSelectionCount = gameState.selectedCards.length;
    // Draw the by-category bar chart now that the canvas exists in the DOM.
    renderSelectionsChart();
    // Newest selection is on top now, so keep the view at the top.
    selectionsBody.scrollTop = 0;
}

// Live Chart instance for the selections-by-category bar chart, so we can tear it
// down and rebuild whenever the modal body's innerHTML is regenerated.
let selectionsChart = null;

// Display order + colors for each category, matching the card border colors used
// across the app (see css/selections-modal.css and css/biz-sim.css).
const SELECTION_CATEGORY_META = [
    { key: 'validation', label: 'Validation', color: '#059669' },
    { key: 'team',       label: 'Team',       color: '#dc2626' },
    { key: 'product',    label: 'Product',    color: '#7c3aed' },
    { key: 'marketing',  label: 'Marketing',  color: '#ea580c' },
    { key: 'business',   label: 'Business',   color: '#0369a1' },
    { key: 'revenue',    label: 'Revenue',    color: '#d1ad3a' },
    { key: 'esg',        label: 'ESG',        color: '#95d609' },
    { key: 'outcome',    label: 'Outcome',    color: '#64748b' }
];

function renderSelectionsChart() {
    const canvas = document.getElementById('selectionsChart');
    if (!canvas || typeof Chart === 'undefined') return; // CDN failed — skip gracefully

    if (selectionsChart) {
        selectionsChart.destroy();
        selectionsChart = null;
    }

    // Count selections per category, then keep only categories the player has used.
    const counts = {};
    gameState.selectedCards.forEach(c => { counts[c.category] = (counts[c.category] || 0) + 1; });
    const present = SELECTION_CATEGORY_META.filter(m => counts[m.key]);

    selectionsChart = new Chart(canvas.getContext('2d'), {
        type: 'bar',
        data: {
            labels: present.map(m => m.label),
            datasets: [{
                label: 'Selections',
                data: present.map(m => counts[m.key]),
                backgroundColor: present.map(m => m.color),
                borderRadius: 6,
                maxBarThickness: 48
            }]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            animation: { duration: 250, easing: 'easeOutQuart' },
            plugins: {
                tooltip: { enabled: true },
                // Single-dataset bar chart, so build one legend entry per category
                // (colored square + label). Mirrors the company-modal charts' top legend.
                legend: {
                    position: 'top',
                    labels: {
                        boxWidth: 12,
                        boxHeight: 12,
                        font: { size: 11 },
                        generateLabels: (chart) => {
                            const ds = chart.data.datasets[0];
                            return chart.data.labels.map((text, i) => ({
                                text,
                                fillStyle: ds.backgroundColor[i],
                                strokeStyle: ds.backgroundColor[i],
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            }));
                        }
                    },
                    onClick: (e, legendItem, legend) => {
                        legend.chart.toggleDataVisibility(legendItem.index);
                        legend.chart.update();
                    }
                }
            },
            scales: {
                // The legend identifies each bar, so the x-axis ticks would just
                // duplicate it — hide them for a cleaner look.
                x: { grid: { display: false }, ticks: { display: false } },
                y: { beginAtZero: true, ticks: { font: { size: 10 }, precision: 0 } }
            }
        }
    });
}

// FIXED: Use global index instead of category-based index
function removeSelection(globalIndex) {
    // Validate index
    if (globalIndex < 0 || globalIndex >= gameState.selectedCards.length) {
        console.error('Invalid selection index:', globalIndex);
        return;
    }
    
    const card = gameState.selectedCards[globalIndex];
    
    // Don't allow removing outcome/opportunity cards
    if (card.category === 'outcome') {
        showAlertDialog({
            icon: '🔒',
            title: 'Can\'t remove this card',
            message: 'Outcome cards represent permanent outcomes of your decisions and can\'t be removed.'
        });
        return;
    }
    
    // If this decision hired someone still on the team, drop their org-chart record too.
    // No severance and no metric reversal here — the timeline rebuild below recomputes
    // every metric, burn, and teamSize from the decisions that remain.
    const empIdx = gameState.employees.findIndex(e => e.card === card);
    if (empIdx !== -1) gameState.employees.splice(empIdx, 1);

    // Remove the card at the specific global index
    gameState.selectedCards.splice(globalIndex, 1);

    // Rebuild all derived state (metrics, financials, customers, team) from what remains
    recalculateGameStats();

    // Update the modal content
    populateSelections();

    // Update button text
    updateSelectionsButtonText();

    // Refresh the org chart (a hire may have been removed) and persist the edited run.
    if (typeof populateOrgChart === 'function') populateOrgChart();
    if (typeof saveCurrentGame === 'function') saveCurrentGame();
}

// Rebuilds gameState from the remaining selections after a removal — a faithful
// re-simulation, not an approximation. It resets to the founding baseline and replays
// every remaining decision through the SAME deterministic engine live play uses
// (advanceCustomers, the metric-decay constants, recomputeMonthlyRevenue), re-applying
// each card's CACHED category roll (card._roll) and the subscription price that was active
// when it was played (card._priceAtDecision). gameState.employees is authoritative org-chart
// state and is left untouched here — removeSelection() drops the employee for a removed
// hire, and teamSize is re-derived from it below.
function recalculateGameStats() {
    // Reset everything the timeline derives. Identity (company name, founder, employees,
    // price policy) and the milestone guards are preserved.
    gameState.timeToMVP = 0; // recomputed during the replay below
    gameState.monthlyBurn = 1000;
    gameState.monthlyRevenue = 0;
    gameState.oneTimeRevenue = 0;
    gameState.totalRevenue = 0;
    gameState.runway = 100000;
    gameState.revenueStreams = [];
    gameState.history = [];
    gameState.currentMonth = 1;
    gameState.currentYear = 1;
    gameState.customers = 0;
    gameState.growth = 0;
    gameState.engagement = 0;
    gameState.confidence = 0;
    gameState.credibility = 0;
    gameState.reach = 0;
    gameState.stress = 0;

    // MVP launches the first month the player holds both a validation and a product card
    // (mirrors checkMVPLaunch). Recomputed here so removing an unrelated card doesn't move
    // it — and removing the last validation/product card un-launches it (timeToMVP = 0).
    let seenValidation = false;
    let seenProduct = false;

    // Burn is rebuilt incrementally: baseBurn = base + salaries + recurring costs as they
    // appear; the revenue-share pledge (% of revenue) is folded in per card below, matching
    // live play's per-decision recomputeMonthlyRevenue / recalcMonthlyBurn.
    let baseBurn = 1000;
    let pledgePctSoFar = 0;

    gameState.selectedCards.forEach(card => {
        const impact = card.impact || {};
        // A laid-off hire contributes nothing ongoing — their salary, metric impacts and
        // category roll were reversed when they left (detachEmployee). They still cost the
        // time and one-time cash the original decision took, so those are replayed below.
        const fired = card.category === 'team' && card.fired;
        const prevMonth = gameState.currentMonth;

        if (impact.time) gameState.currentMonth += Math.abs(impact.time);
        const monthsPassed = gameState.currentMonth - prevMonth;

        if (card.category === 'validation') seenValidation = true;
        if (card.category === 'product') seenProduct = true;
        if (seenValidation && seenProduct && gameState.timeToMVP === 0) {
            gameState.timeToMVP = gameState.currentMonth;
        }

        // A still-employed hire adds salary to burn; recurring non-salary costs too. Burn is
        // built up as these appear (baseBurn); the revenue-share pledge is folded in after
        // this card's accrual below, exactly where live play recomputes it.
        if (isHireCard(card) && !fired) baseBurn += (card.salary || 0) / 12;
        if (impact.monthlyCost && !fired) baseBurn += impact.monthlyCost;

        // One-time cash moves happened regardless of any later layoff.
        if (impact.cost) gameState.runway -= impact.cost;
        if (impact.oneTimeRevenue) {
            gameState.runway += impact.oneTimeRevenue;
            gameState.totalRevenue += impact.oneTimeRevenue;
        }
        if (impact.monthlyRevenue && !fired) {
            gameState.revenueStreams.push({
                amount: impact.monthlyRevenue,
                monthsRemaining: impact.recurringPayTime || Infinity
            });
        }

        // Metric impacts + the cached category roll — net zero for a fired hire, so skip both.
        if (!fired) {
            applyImpactMetrics(card, 1);
            applyCategoryRoll(card, 1);
        }

        // Step decay, organic customer growth, and revenue accrual one (or fractional)
        // month at a time — identical to updateGameStats — using the price that was active
        // when this decision was made.
        const price = card._priceAtDecision !== undefined ? card._priceAtDecision : gameState.pricePerCustomer;
        let revenueThisPeriod = 0;
        let remaining = monthsPassed;
        while (remaining > 0.0001) {
            const dt = Math.min(1, remaining);
            gameState.engagement  = Math.max(0, gameState.engagement - 2 * dt);
            gameState.reach       = Math.max(0, gameState.reach       * (1 - REACH_DECAY * dt));
            gameState.growth      = Math.max(0, gameState.growth      * (1 - GROWTH_DECAY * dt));
            gameState.confidence  = Math.max(0, gameState.confidence  * (1 - CONFIDENCE_DECAY * dt));
            gameState.credibility = Math.max(0, gameState.credibility * (1 - CREDIBILITY_DECAY * dt));
            advanceCustomers(dt);
            revenueThisPeriod += gameState.customers * price * dt;
            for (const stream of gameState.revenueStreams) {
                if (stream.monthsRemaining > 0) {
                    revenueThisPeriod += stream.amount * dt;
                    stream.monthsRemaining -= dt;
                }
            }
            remaining -= dt;
        }
        gameState.revenueStreams = gameState.revenueStreams.filter(s => s.monthsRemaining > 0);
        clampMetrics();

        // Recompute burn the way live play does at the end of each decision (recompute-
        // MonthlyRevenue → recalcMonthlyBurn): baseBurn plus the revenue-share pledge sized
        // off the revenue rate now in effect (subscriptions at this decision's price + active
        // streams). Live charges THIS card's months at this freshly-recomputed rate, so the
        // pledge taxes the same decision that introduced it.
        if (impact.revenuePledgePct && !fired) pledgePctSoFar += impact.revenuePledgePct;
        const streamsSum = gameState.revenueStreams.reduce((sum, s) => sum + s.amount, 0);
        gameState.monthlyBurn = baseBurn + pledgePctSoFar * Math.round(gameState.customers * price + streamsSum);

        if (monthsPassed > 0) {
            gameState.runway -= gameState.monthlyBurn * monthsPassed;
            gameState.runway += revenueThisPeriod;
            gameState.totalRevenue += revenueThisPeriod;
        }

        gameState.currentYear = Math.floor((gameState.currentMonth - 1) / 12) + 1;
        // Re-plot this decision's point on the company graphs (bar its one-time spend).
        recordHistorySnapshot(impact.cost > 0 ? impact.cost : 0);
    });

    // Final authoritative monthly rate: subscriptions + active streams. This also rebuilds
    // burn from gameState.employees with revenue-share pledges folded in (recalcMonthlyBurn).
    recomputeMonthlyRevenue();

    gameState.teamSize = 1 + gameState.employees.length;

    if (!gameState.milestonesHit) gameState.milestonesHit = {};
    gameState.milestonesHit.mvpLaunched = gameState.timeToMVP > 0;

    // updateUI() repaints the header (team / month / runway / revenue) and any open
    // modal panes from the rebuilt gameState.
    if (typeof updateUI === 'function') updateUI();
}

function exportSelections() {
    const exportData = {
        companyName: document.getElementById('companyName').textContent,
        stats: {
            teamSize: gameState.teamSize,
            timeToMVP: gameState.timeToMVP,
            // Total annual salary across all hired (team) cards, computed fresh
            cost: gameState.selectedCards.reduce(
                (sum, c) => sum + (c.category === 'team' ? (c.salary || 0) : 0), 0)
        },
        selections: gameState.selectedCards,
        exportedAt: new Date().toISOString()
    };
    
    const dataStr = JSON.stringify(exportData, null, 2);
    const dataBlob = new Blob([dataStr], {type: 'application/json'});
    
    const link = document.createElement('a');
    link.href = URL.createObjectURL(dataBlob);
    link.download = `${exportData.companyName.replace(/\s+/g, '_')}_business_plan.json`;
    link.click();
    
    // Also show a summary in console for debugging
    console.log('Startup Plan Export:', exportData);
}

function learnMore(category) {
    const links = {
        validation: 'project-validation-methods.html',
        team: 'careers-list.html',
        product: 'business-idea-generator.html',
        marketing: 'entrepreneur-decision-tree.html',
        business: 'decision-tools.html'
    };

    // Not every category has a companion page yet (e.g. esg); bail rather than
    // opening an "undefined" URL.
    if (!links[category]) return;

    // In a real implementation, this would navigate to the Dlightning tool
    console.log(`Navigate to: ${links[category]}`);
    window.open(links[category], '_blank', 'noopener');
}
;
// state — extracted from biz-sim.js (see CLAUDE.md / js/game)

// Enhanced Game State Management
let gameState = {
    companyName: "YourStartup Inc.",
    founded: new Date(),
    foundedDisplay: new Date().toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'short', 
        day: 'numeric' 
    }),
    teamSize: 1,
    employees: [], // Hired employees (excludes the founder/CEO). Each: { role, title, level, salary }
    ceoName: "", // Player-entered name shown in the CEO slot of the org chart
    runway: 100000, // Starting runway in dollars
    oneTimeRevenue: 0, // one time payments
    totalRevenue: 0,

    monthlyRevenue: 0, // recurring payments: customers × pricePerCustomer + active streams
    pricePerCustomer: 10, // player-set monthly subscription price per customer (bottom-nav dial)
    revenueStreams: [], // Active recurring streams: { amount, monthsRemaining }
    // Outstanding loans (e.g. the emergency bank loan). Each: { monthly, monthsRemaining }.
    // The monthly repayment is added to burn (recalcMonthlyBurn) until the term runs out,
    // then the loan is paid off and stops costing — see updateGameStats. Authoritative,
    // path-dependent state like customers/investorEquity (not replayed by recalc).
    loans: [],
    history: [], // Time-series snapshots of key metrics, used by the company graphs
    monthlyBurn: 1000, // Base monthly burn rate
    
    currentMonth: 1,
    currentYear: 1,
    timeToMVP: 0,
    selectedCards: [],
    cardsGenerated: 0,
    customers: 0,
    // ===== Market & competition (path-dependent, like `customers`) =====
    // marketClimate is a macro acquisition/retention multiplier: 1 = normal, <1 = a
    // downturn or war dragging the whole market. competitorPressure (0–1) is how hard a
    // rival is currently taking share. Both are SHOCKED by outcome cards and then drift
    // back toward baseline each month (see engine.js tick + advanceCustomers in pricing.js)
    // so external events are sustained headwinds with a recovery arc, not one-frame blips.
    marketClimate: 1,
    competitorPressure: 0,
    // Total equity (%) sold to outside investors. Like a co-founder's stake, this is
    // carved out of the founder's take-home at exit (see acceptExit in actions.js) —
    // a boost now, a smaller payday if you sell later. Shocked once by raise cards;
    // not a capped metric and not replayed by recalculateAllMetrics.
    investorEquity: 0,
    milestonesHit: {}, // Revenue milestones already awarded, e.g. { first1k, profitable }
    // One-shot outcome guards: set true the first time each event fires so it never repeats
    travelOpportunityFired: false,
    brandLoyaltyFired: false,
    pileOnFired: false,
    backlashFired: false,
    onboardingFired: false,
    longHaulFired: false,
    downturnFired: false,        // market downturn (macro climate shock)
    competitorEnteredFired: false, // a rival entered the market (sets competitorPressure)
    warFired: false,             // war/geopolitical shock (macro climate shock)
    investorRaiseFired: false,   // investor raise offer (sets investorEquity if taken)
    podcastAudienceFired: false, // podcast marketing paid off with an organic audience
    perfDebtFired: false,        // product slowed to a crawl from neglected tech debt
    // Terminal failure state. Set true the moment a game-over condition fires (see
    // endings.js); halts further card loading and pins the verdict card. endingKey
    // names which ending was shown so a restored run can re-display it.
    gameOver: false,
    endingKey: null,
    // In-game month the founder's stress first hit max, or null when below it. The
    // burnout ending fires only after stress stays pinned at max for a sustained
    // stretch (see endings.js); any breather that drops it resets this to null.
    burnoutSince: null,
    // In-game month the runway first went negative-AND-unprofitable, or null when
    // solvent. Running dry is no longer an instant game over: the insolvency ending
    // fires only after staying underwater for a grace window (see endings.js), and
    // clawing back to positive cash or to profitability resets this to null — a
    // late comeback is possible. The two crisis flags gate the cards surfaced per
    // episode — cashCrisisWarned for the "obligations" deadline warning (at crisis
    // start) and cashCrisisFired for the bank-loan lifeline (if still underwater after).
    // Both are cleared alongside insolventSince when the crisis lifts, so a fresh
    // relapse warns and offers again.
    insolventSince: null,
    cashCrisisWarned: false,
    cashCrisisFired: false,
    // True once the player adds/skips a card — gates auto-focusing the next card
    hasInteracted: false,
    // True when the last skip/add came from the keyboard — gates the focus ring
    lastActionViaKeyboard: false,
    // Extra stats
    engagement: 0,
    growth: 0,
    confidence: 0,
    reach: 0,
    credibility: 0,
    stress: 0 // Founder stress: 0 = balanced, 100 = burnt out. Bad events raise it, wins lower it.
};

// ===== Customer model v2 (organic acquisition + churn) =====
// Customers grow per in-game month from acquisition (reach × momentum + word-of-mouth
// referrals) minus churn (driven by weak engagement and founder stress), tapered by
// market saturation. Cards influence customers indirectly via reach/growth/engagement;
// explicit impact.customers values still apply as one-time shocks. Tunable knobs:
const CUSTOMER_MARKET_CAP   = 100000; // soft ceiling — acquisition tapers toward it
const CUSTOMER_ACQ_BASE     = 300;    // max organic new/mo from reach at full momentum
// Acquisition from reach is weighted by (FLOOR + growth/100): the floor is what you
// still pull in from raw reach with zero momentum, and growth adds on top. Keep this
// LOW so neglecting growth genuinely stalls acquisition (and lets a no-traction run
// reach the "idea didn't land" ending) while real momentum is clearly rewarded.
const CUSTOMER_ACQ_GROWTH_FLOOR = 0.15;
const CUSTOMER_REF_RATE     = 0.02;   // referrals: engaged existing customers bring others
// Referrals still need awareness to land: a happy customer's word-of-mouth only converts
// people who can find/recognise you, so the referral term is scaled by (FLOOR + the rest
// from reach). At zero reach (no marketing) referrals run at just FLOOR strength, so a
// marketing-free run can't snowball on word-of-mouth alone — reach (marketing) is what
// turns engaged customers into compounding growth.
const CUSTOMER_REF_REACH_FLOOR = 0.15;
const CUSTOMER_CHURN_BASE   = 0.10;   // up to 10%/mo lost when engagement = 0
const CUSTOMER_CHURN_STRESS = 0.05;   // extra monthly churn at max founder stress
// Pricing tradeoff: price above the "fair" baseline slows acquisition + adds churn;
// below it gives an acquisition bonus (cheap = faster growth).
const CUSTOMER_FAIR_PRICE     = 10;     // price/customer/mo with no growth penalty
const CUSTOMER_PRICE_ACQ_SENS = 40;    // $ above fair that fully suppresses acquisition
const CUSTOMER_PRICE_CHURN    = 0.002;  // extra monthly churn per $ above fair
const PRICE_STEP              = 5;      // bottom-nav stepper increment
// Metric decay: confidence/credibility/reach drift down each month without upkeep, so
// they can't just ratchet to 100 and stay there. Percentage decay — stronger near the
// top, gentle near 0. Reach fades fastest (attention), credibility slowest (reputation).
const REACH_DECAY       = 0.05; // 5%/mo
const GROWTH_DECAY      = 0.04; // 4%/mo — momentum fades without continued effort
const CONFIDENCE_DECAY  = 0.03; // 3%/mo
const CREDIBILITY_DECAY = 0.02; // 2%/mo

// Voluntary attrition (the "Employee Quits" challenge) is driven by NEGLECT, not one
// volatile metric: each thing the founder hasn't invested in — professional growth,
// flexible work, team cohesion, fresh/innovative work, plus burnout — is a "reason"
// someone might walk (see getAttritionReasons). It fires once REASONS_NEEDED of them
// stack up on a team big enough to lose someone.
const EMPLOYEE_QUIT_STRESS = 60;        // founder stress above this counts as a burnout reason
const EMPLOYEE_QUIT_REASONS_NEEDED = 3; // how many reasons must pile up before someone quits
// A junior who's stayed this long without a promotion eventually moves on to a bigger
// role elsewhere — the bittersweet "On to Bigger Things" positive (see checkForOutcomes).
const EMPLOYEE_GRADUATE_YEARS = 3;

// ===== Market climate & competition tuning =====
// External shocks (downturn, war) push marketClimate below 1; each month it recovers a
// share of the gap back toward 1, so a bad climate is survivable, not permanent.
const MARKET_RECOVERY      = 0.15; // 15% of the gap to 1.0 reclaimed per month
// A competitor in the market both slows new sign-ups and accelerates churn, scaled by
// competitorPressure (0–1). You beat them by out-executing: strong growth fades pressure
// faster (COMPETITOR_DECAY_GROWTH), while neglecting growth lets a rival linger and bleed you.
const COMPETITOR_ACQ_DRAG     = 0.40; // up to −40% acquisition at full pressure
const COMPETITOR_CHURN        = 0.06; // up to +6%/mo churn at full pressure
const COMPETITOR_DECAY_BASE   = 0.04; // pressure fades this much per month on its own
const COMPETITOR_DECAY_GROWTH = 0.16; // extra fade per month at full growth (out-executing)

// ===== Team capacity → variable timelines =====
// Cards are authored at solo-founder pace — that's the baseline a one-person team
// experiences (see CLAUDE.md: existing card times are tuned for a solo founder).
// When the player hires specialists, work in their wheelhouse moves faster; a few
// roles instead TRADE speed for quality (slower, but better output). The effect is
// applied to each newly generated card's timeline by applyTeamTimeModifier().
//
// Keyed by employee role (the unprefixed `baseTitle` stored on each hire). Each
// entry lists the card categories that role touches:
//   speed  > 0  → faster (specialist handles this kind of work)
//   speed  < 0  → slower (more care taken — e.g. a UX designer polishing product)
//   quality     → optional engagement lift folded into the affected card
const ROLE_TIME_EFFECTS = {
    'Full-Stack Developer':      [{ category: 'product', speed: 0.35 }],
    'DevOps Engineer':           [{ category: 'product', speed: 0.25 }],
    '3D Motion Designer':        [{ category: 'product', speed: 0.20 }],
    'Product Manager':           [{ category: 'product', speed: 0.25 }, { category: 'validation', speed: 0.15 }, { category: 'business', speed: 0.10 }],
    'UX/UI Designer':            [{ category: 'product', speed: -0.25, quality: 8 }, { category: 'validation', speed: 0.20 }], // slows product for quality; speeds validation (user research/usability testing)
    'Content Marketing Manager': [{ category: 'marketing', speed: 0.35 }],
    'Copywriter':                [{ category: 'marketing', speed: 0.20 }, { category: 'esg', speed: 0.15 }], // also speeds ESG disclosures/reporting
    'Videographer':              [{ category: 'marketing', speed: 0.25 }],
    'Sales Manager':             [{ category: 'revenue', speed: 0.40 }, { category: 'business', speed: 0.15 }],
    'Customer Success Manager':  [{ category: 'validation', speed: 0.20 }, { category: 'product', speed: 0.10 }, { category: 'revenue', speed: 0.12 }], // also speeds revenue (expansion/upsell/renewals)
    'General Counsel':           [{ category: 'business', speed: 0.30 }, { category: 'esg', speed: 0.25 }]
};
const TIME_LEVEL_WEIGHT     = { Junior: 0.7, Mid: 1.0, Senior: 1.3 }; // seniority scales the effect
const TIME_SPEEDUP_DIMINISH = 0.5; // each EXTRA matching specialist counts half as much as the last
const TIME_MIN_FACTOR       = 0.3; // never compress a timeline below 30% of its solo-founder estimate

// A Recruiter / HR lead is the one exception to "no one speeds up their own onboarding":
// they compress the RAMP TIME of every OTHER new hire (sourcing, screening, onboarding
// handled by someone whose job it is). Applied to hire cards by applyRecruiterRampModifier()
// in card-render.js. Multiple recruiters stack with the usual diminishing returns
// (TIME_SPEEDUP_DIMINISH), floored so a hire always takes some time to get productive.
const RECRUITER_RAMP_REDUCTION  = 0.30; // first recruiter cuts a new hire's ramp time by 30%
const RECRUITER_RAMP_MIN_FACTOR = 0.4;  // never compress ramp below 40% of its baseline

// ===== Coordination overhead (Brooks's Law) =====
// A growing team adds communication overhead to EVERY kind of work — more people
// means more syncing, handoffs, and "who's doing what." Process/collaboration
// cards (below) are the counter. A founder plus COORD_FREE_HEADS people coordinate
// freely; beyond that each extra head adds COORD_TAX_PER_HEAD to every timeline,
// capped at COORD_TAX_CAP so a big team is slower but never paralyzed.
const COORD_FREE_HEADS   = 4;    // employees that coordinate with no overhead
const COORD_TAX_PER_HEAD = 0.04; // +4% time per extra head beyond the free count
const COORD_TAX_CAP      = 0.30; // overhead never exceeds +30%

// ===== Process / collaboration cards → team-wide efficiency =====
// Adopting a way of working speeds up (or, for the four-day week, slightly slows)
// EVERY category of work — the org-wide counterpart to per-role specialist speedups,
// and the lever that claws back coordination overhead. Keyed by card title:
//   speed > 0 = faster, speed < 0 = slower; `label` is how the card-back note names it.
// Each process counts once (adopting the same one twice doesn't stack).
const PROCESS_TIME_EFFECTS = {
    'Adopt Agile Process':       { speed: 0.12, label: 'Agile process' },
    'Streamlined Collaboration': { speed: 0.10, label: 'collaboration tooling' },
    '4-Day Work Week Pilot':     { speed: -0.08, label: 'four-day week' }
};

    let isLoading = false;

// Performance optimizations
    const CARD_RENDER_BATCH_SIZE = 3;
    const SCROLL_THROTTLE_MS = 100;
    let scrollTimeout = null;

// Cache DOM elements for better performance
    const domCache = {
        teamSize: null,
        currentMonth: null,
        runway: null,
        revenue: null,
        simulatorContainer: null,
        selectionsBtn: null,
        companyName: null
    };

// Initialize DOM cache
    function initDOMCache() {
        domCache.teamSize = document.getElementById('teamSize');
        domCache.currentMonth = document.getElementById('currentMonth');
        domCache.runway = document.getElementById('runway');
        domCache.revenue = document.getElementById('revenue');
        domCache.simulatorContainer = document.getElementById('simulatorContainer');
        domCache.selectionsBtn = document.getElementById('selectionsBtn');
        domCache.companyName = document.getElementById('companyName');
    }

;
// date-utils — extracted from biz-sim.js (see CLAUDE.md / js/game)


// Map a cumulative stress score (0-100) to a founder wellbeing level for display.
function getStressLevel(stress) {
    if (stress >= 80) return { label: "Burnt Out", emoji: "🔥", class: "negative" };
    if (stress >= 60) return { label: "Overwhelmed", emoji: "😣", class: "negative" };
    if (stress >= 40) return { label: "Stressed", emoji: "😰", class: "warning" };
    if (stress >= 20) return { label: "Steady", emoji: "🙂", class: "positive" };
    return { label: "Energized", emoji: "😌", class: "positive" };
}

// Function to calculate the current game date based on months elapsed
function getCurrentGameDate() {
    const foundedDate = new Date(gameState.founded);
    const monthsElapsed = gameState.currentMonth - 1;
    // Add months to the founded date
    const currentGameDate = new Date(foundedDate);
    currentGameDate.setMonth(currentGameDate.getMonth() + monthsElapsed);
    
    return currentGameDate;
}

// Function to format game date for display
    function formatGameDate(date, includeTime = false) {
        const options = {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        };
        
        if (includeTime) {
            options.hour = '2-digit';
            options.minute = '2-digit';
        }
        return date.toLocaleDateString('en-US', options);
    }

// Function to get a relative time description
    function getRelativeTimeDescription(gameDate, foundedDate) {
        const monthsElapsed = Math.round((gameDate - foundedDate) / (1000 * 60 * 60 * 24 * 30.44)); // Average days per month
        
        if (monthsElapsed === 0) {
            return "Founding";
        } else if (monthsElapsed === 1) {
            return "1 month in";
        } else if (monthsElapsed < 12) {
            return `${monthsElapsed} months in`;
        } else {
            const years = Math.floor(monthsElapsed / 12);
            const remainingMonths = monthsElapsed % 12;
            if (remainingMonths === 0) {
                return years === 1 ? "1 year in" : `${years} years in`;
            } else {
                return `${years}y ${remainingMonths}m in`;
            }
        }
    }

// Month-within-year for display, rounded to one decimal. Ramp times can be
// fractional (e.g. a scaled hire at 2.6mo), and accumulating them drifts in
// floating point — without rounding the header would read "M4.7999999". Shared
// by the company and selections modals so every month readout matches.
    function getDisplayMonth() {
        return Math.round((((gameState.currentMonth - 1) % 12) + 1) * 10) / 10;
    }

;
// card-render — extracted from biz-sim.js (see CLAUDE.md / js/game)

    // Serialize a card/payload for embedding inside a double-quoted HTML attribute
    // (data-base-card, onclick="...(this, {...})"). The HTML parser decodes entities
    // in attribute values, so `&` MUST be escaped before `"` — otherwise a raw `&` in
    // card text (e.g. "SEO & Analytics", "Community Q&A") corrupts the JSON and the
    // card fails to parse/swipe. Order matters: escape & first so we don't double-hit
    // the & we just introduced in &quot;.
    function jsonAttr(value) {
        return JSON.stringify(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
    }

    function getAllCardTypes() {
        return [
            ...validationMethods,
            ...teamMembers,
            ...productFeatures,
            ...marketingStrategies,
            ...businessModels,
            ...revenueCards,
            ...esgCards
        ];
    }

// Variable timelines: a card's authored `time` is the solo-founder estimate. The
// current team reshapes it from three directions — (1) relevant SPECIALISTS compress
// the work (a few roles instead trade speed for quality); (2) COORDINATION OVERHEAD
// from a bigger team drags every timeline out (Brooks's Law); (3) PROCESS cards
// (Agile, collaboration tooling) speed the whole org up and claw that overhead back.
// Returns a card with an adjusted impact.time (and a `_timeMod` note for the UI);
// the shared pool card is cloned only when a modifier applies, so the baseline is
// never mutated. Tuning: ROLE_TIME_EFFECTS / TIME_* / COORD_* / PROCESS_TIME_EFFECTS.
// A Recruiter / HR lead compresses the RAMP TIME of every OTHER new hire — sourcing,
// screening, and onboarding handled by someone whose job it is. Only hire cards have a
// ramp time to cut (policy team cards like Remote-First don't); only recruiters ALREADY
// on staff count, so a recruiter never speeds up their own onboarding. Multiple recruiters
// stack with diminishing returns, floored at RECRUITER_RAMP_MIN_FACTOR. Tuning in state.js.
    function applyRecruiterRampModifier(card) {
        if (!isHireCard(card)) return card;
        const baseTime = card.impact && card.impact.time;
        if (!baseTime || baseTime <= 0) return card;
        const recruiters = (gameState.employees || []).filter(e => e.role === 'Recruiter');
        if (!recruiters.length) return card;

        let factor = 1;
        recruiters.forEach((_, i) => {
            factor *= (1 - RECRUITER_RAMP_REDUCTION * Math.pow(TIME_SPEEDUP_DIMINISH, i));
        });
        factor = Math.max(RECRUITER_RAMP_MIN_FACTOR, factor);

        const newTime = Math.max(0.5, Math.round(baseTime * factor * 10) / 10);
        if (newTime === baseTime) return card;

        // Clone so the shared pool card keeps its authored baseline.
        const adjusted = { ...card, impact: { ...card.impact } };
        adjusted.impact.time = newTime;
        adjusted._timeMod = {
            base: baseTime,
            adjusted: newTime,
            faster: true,
            fasterReasons: ['Recruiter'],
            qualityReasons: [],
            coord: false,
            processSlower: []
        };
        return adjusted;
    }

    function applyTeamTimeModifier(card) {
        const baseTime = card.impact && card.impact.time;
        // Only positive build/ramp time is reshaped — leave time-savers, instant
        // cards and outcomes alone. Hires don't get the specialist/coord/process
        // treatment (no one speeds up their OWN onboarding), but a Recruiter on staff
        // compresses every other new hire's ramp time — handled separately.
        if (!baseTime || baseTime <= 0) return card;
        if (card.category === 'outcome') return card;
        if (card.category === 'team') return applyRecruiterRampModifier(card);

        // (1) Specialists: every employee whose expertise touches this category,
        // scaled by seniority. speed > 0 = faster, speed < 0 = slower (quality trade).
        const speedups = []; // positive contributions, combined with diminishing returns
        let roleFactor = 1;
        let qualityBonus = 0;
        const fasterRoles = []; // roles pushing this faster — named in the card-back note
        const qualityRoles = []; // roles trading speed for quality (e.g. UX designer)
        (gameState.employees || []).forEach(emp => {
            const effects = ROLE_TIME_EFFECTS[emp.role];
            if (!effects) return;
            const weight = TIME_LEVEL_WEIGHT[emp.level] || 1;
            effects.forEach(fx => {
                if (fx.category !== card.category) return;
                const s = fx.speed * weight;
                if (s > 0) { speedups.push(s); fasterRoles.push(emp.role); }
                else if (s < 0) { roleFactor *= (1 - s); qualityRoles.push(emp.role); } // slower
                if (fx.quality) qualityBonus += fx.quality * weight;
            });
        });
        // Strongest specialist counts fully; each additional matching hire counts
        // less, so a deep team keeps compressing time without ever zeroing it.
        speedups.sort((a, b) => b - a)
            .forEach((s, i) => { roleFactor *= (1 - s * Math.pow(TIME_SPEEDUP_DIMINISH, i)); });

        // (2) Coordination overhead: grows with headcount beyond the free count.
        const heads = (gameState.employees || []).length;
        const coordTax = Math.min(COORD_TAX_CAP, Math.max(0, heads - COORD_FREE_HEADS) * COORD_TAX_PER_HEAD);
        const coordFactor = 1 + coordTax;

        // (3) Process / collaboration cards: a team-wide multiplier. Each adopted
        // process counts once (a duplicate selection doesn't stack).
        let processFactor = 1;
        const processFaster = []; // labels speeding work up
        const processSlower = []; // labels slowing it down (e.g. the four-day week)
        const seenProcess = new Set();
        (gameState.selectedCards || []).forEach(c => {
            const fx = c && !c.fired && PROCESS_TIME_EFFECTS[c.title];
            if (!fx || seenProcess.has(c.title)) return;
            seenProcess.add(c.title);
            processFactor *= (1 - fx.speed);
            (fx.speed > 0 ? processFaster : processSlower).push(fx.label || c.title);
        });

        let factor = Math.max(TIME_MIN_FACTOR, roleFactor * coordFactor * processFactor);
        if (Math.abs(factor - 1) < 0.05 && !qualityBonus) return card; // negligible

        // Clone so the shared pool card keeps its authored baseline.
        const adjusted = { ...card, impact: { ...card.impact } };
        // Round to one decimal (0.1-month steps) so small effects still show, with a
        // floor so real work still takes time. Integer ÷ 10 renders cleanly (no FP tail).
        const newTime = Math.max(0.5, Math.round(baseTime * factor * 10) / 10);
        adjusted.impact.time = newTime;
        if (qualityBonus) {
            // A quality-minded specialist makes the work better, not just slower —
            // fold a small engagement lift into the card.
            adjusted.impact.engagement = (adjusted.impact.engagement || 0) + Math.round(qualityBonus);
        }
        if (newTime !== baseTime) {
            // Record what drove the change so the card-back note can explain it.
            adjusted._timeMod = {
                base: baseTime,
                adjusted: newTime,
                faster: newTime < baseTime,
                fasterReasons: [...new Set([...fasterRoles, ...processFaster])],
                qualityReasons: [...new Set(qualityRoles)],
                coord: coordTax > 0,
                processSlower: [...new Set(processSlower)]
            };
        }
        return adjusted;
    }

// Enhanced card generation with better performance
    function generateBusinessCard() {
        const allCards = getAllCardTypes();
        let baseCard = allCards[Math.floor(Math.random() * allCards.length)];
        // Hires appear at a randomly rolled seniority, scaled from their Mid baseline.
        // scaleHireCard returns a fresh object so the pool's base card stays untouched.
        if (isHireCard(baseCard)) {
            baseCard = scaleHireCard(baseCard, randomHireLevel());
        }
        // `baseCard` is the authored (solo-founder) timeline; `card` is it reshaped by
        // the current team. We stash baseCard on the element (data-base-card) so the
        // card can be re-estimated in place when the team later changes.
        const card = applyTeamTimeModifier(baseCard);
        const baseCardAttr = jsonAttr(baseCard);
        gameState.cardsGenerated++;

        const categoryConfig = {
            validation: { emoji: "🎯", color: "validation" },
            team: { emoji: "🤝", color: "team" },
            product: { emoji: "⚡", color: "product" },
            marketing: { emoji: "📈", color: "marketing" },
            business: { emoji: "💼", color: "business" },
            revenue: { emoji: "💰", color: "revenue" },
            esg: { emoji: "🌐", color: "esg" }
        };

        const config = categoryConfig[card.category] || { emoji: "❓", color: "default" };
        const metricsHTML = generateMetricsHTML(card);
        const backHTML = generateCardBackHTML(card, config);

        return `
            <div class="business-card flippable ${config.color}" data-base-card="${baseCardAttr}">
                <div class="card-inner">
                    <div class="card-face card-front">
                        <div class="card-header ${config.color}">
                            <div class="card-type-wrapper">
                                <div><p>Decision #${gameState.cardsGenerated}</p></div>
                                <a href="javascript:learnMore('${card.category}')" aria-label="Learn more about ${card.category} (opens in new tab)">
                                    <div class="card-type">${card.category}&nbsp; ${config.emoji}</div>
                                </a>
                            </div>
                            <h2>${card.title}</h2>
                            <a class="storyset-link" href="https://storyset.com" target="_blank" rel="noopener">Illustration by Cuate on Storyset</a>
                        </div>
                        <div class="card-svg-section">
                            <div class="svg-container">
                                <img class="card-img" data-src="${card.svg}" alt=""/>
                            </div>
                        </div>
                        <div class="card-body">
                            ${metricsHTML}
                            <div class="card-content">
                                <div class="content-desc">${card.description}</div>
                            </div>
                            <div class="flip-hint flip-hint-front" aria-hidden="true">Tap card for full metrics&nbsp;⟳</div>
                            <div class="action-buttons">
                                <button class="btn btn-skip" onclick="skipCard(this)">Skip</button>
                                <button class="btn btn-select" onclick="selectCard(this, ${jsonAttr(card)})">Add</button>
                            </div>
                        </div>
                    </div>
                    ${backHTML}
                </div>
            </div>
        `;
    }

    // Join role names into readable prose: "X", "X and Y", "X, Y, and Z".
    // Empty falls back to "team" so an older card without recorded roles still reads.
    function formatRoleList(roles) {
        const list = roles || [];
        if (!list.length) return 'team';
        if (list.length === 1) return list[0];
        if (list.length === 2) return `${list[0]} and ${list[1]}`;
        return `${list.slice(0, -1).join(', ')}, and ${list[list.length - 1]}`;
    }

    function metricTile(label, value) {
        return `
            <div class="metric">
                <span class="metric-label">${label}</span>
                <span class="metric-value">${value}</span>
            </div>
        `;
    }

    // The full-breakdown tiles on a card's back: hiring economics first (hires only),
    // then every impact key so nothing the card does is hidden. Shared by the initial
    // render and the live re-estimate so the two never drift.
    function buildBackTiles(card) {
        const tiles = [];
        if (isHireCard(card)) {
            tiles.push(metricTile('Salary', `$${(card.salary / 1000).toFixed(0)}k`));
            tiles.push(metricTile('Level', card.level));
            tiles.push(metricTile('Monthly Cost', `$${(card.salary / 12 / 1000).toFixed(1)}k`));
        }
        const impact = card.impact || {};
        Object.keys(impact).forEach(key => {
            tiles.push(metricTile(metricLabel(key, card), formatMetricValue(key, impact[key])));
        });
        return tiles;
    }

    // The card-back note explaining why the team reshaped this timeline. It names
    // the cause so the player learns the system: specialists/process speed work up
    // (green), a quality role trades speed for a better result (blue), and a bigger
    // team's coordination overhead or the four-day week stretch it out (amber).
    function buildTimeNote(card) {
        const m = card._timeMod;
        if (!m) return '';
        let icon, cls, msg;
        if (m.faster) {
            const r = m.fasterReasons && m.fasterReasons.length ? m.fasterReasons : ['team'];
            icon = '⚡'; cls = 'faster';
            msg = `Your ${formatRoleList(r)} ${r.length > 1 ? 'speed' : 'speeds'} this up`;
        } else if (m.qualityReasons && m.qualityReasons.length) {
            const r = m.qualityReasons;
            icon = '✨'; cls = 'slower';
            msg = `Your ${formatRoleList(r)} ${r.length > 1 ? 'take' : 'takes'} extra time for higher quality`;
        } else if (m.coord) {
            icon = '🐢'; cls = 'overhead';
            msg = `A bigger team adds coordination overhead — adopt Agile or collaboration tooling to claw it back`;
        } else if (m.processSlower && m.processSlower.length) {
            icon = '🐢'; cls = 'overhead';
            msg = `Your ${formatRoleList(m.processSlower)} ${m.processSlower.length > 1 ? 'trade' : 'trades'} a little speed here`;
        } else {
            icon = '🐢'; cls = 'overhead';
            msg = `Your team takes a bit longer here`;
        }
        return `<div class="time-mod-note ${cls}">
                    <span class="time-mod-msg">${icon} ${msg}</span>
                    <span class="time-mod-delta">${m.base}mo → ${m.adjusted}mo</span>
                </div>`;
    }

    function generateCardBackHTML(card, config) {
        return `
            <div class="card-face card-back">
                <div class="card-header ${config.color} card-back-header">
                    <div class="card-type-wrapper">
                        <div><p>Full Breakdown</p></div>
                        <div class="card-type">${card.category}&nbsp; ${config.emoji}</div>
                    </div>
                    <h2>${card.title}</h2>
                </div>
                <div class="card-body card-back-body">
                    <div class="back-label">Every metric this move affects</div>
                    <div class="impact-metrics back-metrics">
                        ${buildBackTiles(card).join('')}
                    </div>
                    ${buildTimeNote(card)}
                    <div class="card-content">
                        <div class="content-desc">${card.detail || card.description}</div>
                    </div>
                    <div class="flip-hint" aria-hidden="true">↩&nbsp;Tap to flip back</div>
                </div>
            </div>
        `;
    }

    // Re-estimate the timelines of cards still in the stack after the team changes
    // (a hire, layoff, promotion, or process adoption). Each business card carries
    // its authored base in `data-base-card`; we recompute the modifier from that
    // base — so it's idempotent — and patch the front/back metrics, the note, and
    // the select button's payload in place, leaving the flip state and image alone.
    function reestimateStackCards() {
        const container = domCache.simulatorContainer || document.getElementById('simulatorContainer');
        if (!container) return;
        container.querySelectorAll('.business-card[data-base-card]').forEach(el => {
            if (el.dataset.swiping) return; // mid-fling, about to leave the stack
            let base;
            try { base = JSON.parse(el.dataset.baseCard); } catch (e) { return; }
            const fresh = applyTeamTimeModifier(base);
            const hadNote = !!el.querySelector('.time-mod-note');
            if (!fresh._timeMod && !hadNote) return; // nothing changed — skip the churn

            // Front metric tiles (the time value the player reads at a glance).
            const frontMetrics = el.querySelector('.card-front .impact-metrics');
            if (frontMetrics) frontMetrics.outerHTML = generateMetricsHTML(fresh);

            // Back: full breakdown + the explanatory note.
            const backMetrics = el.querySelector('.card-back .back-metrics');
            if (backMetrics) {
                backMetrics.outerHTML = `<div class="impact-metrics back-metrics">${buildBackTiles(fresh).join('')}</div>`;
            }
            el.querySelector('.card-back .time-mod-note')?.remove();
            const noteHTML = buildTimeNote(fresh);
            const newBackMetrics = el.querySelector('.card-back .back-metrics');
            if (noteHTML && newBackMetrics) newBackMetrics.insertAdjacentHTML('afterend', noteHTML);

            // Keep the select payload in sync so the new timeline is what's applied.
            // NOTE: setAttribute stores the value literally — the handler is compiled
            // from this exact string with NO HTML-entity decoding (unlike the innerHTML
            // path above). So embed raw JSON here; escaping `"`→`&quot;` would inject
            // literal entities into the JS source and break the button.
            const selectBtn = el.querySelector('.card-front .btn-select');
            if (selectBtn) {
                selectBtn.setAttribute('onclick', `selectCard(this, ${JSON.stringify(fresh)})`);
            }
        });
    }

// Optimized metrics HTML generation
function generateMetricsHTML(card) {
    if (isHireCard(card)) {
        return `
            <div class="impact-metrics">
                <div class="metric">
                    <span class="metric-label">Salary</span>
                    <span class="metric-value">$${(card.salary / 1000).toFixed(0)}k</span>
                </div>
                <div class="metric">
                    <span class="metric-label">Level</span>
                    <span class="metric-value">${card.level}</span>
                </div>
                <div class="metric">
                    <span class="metric-label">Monthly Cost</span>
                    <span class="metric-value">$${(card.salary / 12 / 1000).toFixed(1)}k</span>
                </div>
            </div>
        `;
    } else if (card.category === 'revenue') {
        return `
            <div class="impact-metrics">
                <div class="metric">
                    <span class="metric-label">Revenue/mo</span>
                    <span class="metric-value">${formatMetricValue('monthlyRevenue', card.impact.monthlyRevenue)}</span>
                </div>
                <div class="metric">
                    <span class="metric-label">${metricLabel('time', card)}</span>
                    <span class="metric-value">${formatMetricValue('time', card.impact.time || 0)}</span>
                </div>
                <div class="metric">
                    <span class="metric-label">Pays for</span>
                    <span class="metric-value">${card.impact.recurringPayTime ? card.impact.recurringPayTime + 'mo' : 'Ongoing'}</span>
                </div>
            </div>
        `;
    } else {
        const impactKeys = Object.keys(card.impact || {});
        return `
            <div class="impact-metrics">
                ${impactKeys.slice(0, 3).map(key => `
                    <div class="metric">
                        <span class="metric-label">${metricLabel(key, card)}</span>
                        <span class="metric-value">${formatMetricValue(key, card.impact[key])}</span>
                    </div>
                `).join('')}
            </div>
        `;
    }
}

// Per-category wording for the `time` metric, so it reads as the kind of work the
// card represents. Falls back to "Timeline" for outcomes and time-saving (negative) cards.
    const timeLabelsByCategory = {
        validation: 'Research Time',
        team: 'Ramp Time',
        product: 'Build Time',
        marketing: 'Campaign Time',
        business: 'Setup Time',
        revenue: 'Lead Time',
        esg: 'Compliance Time'
    };

// Human-readable label for an impact key (card is used to contextualize `time`)
    function metricLabel(key, card) {
        if (key === 'time') {
            const value = card && card.impact ? card.impact.time : 0;
            if (!card || card.category === 'outcome' || value < 0) return 'Timeline';
            return timeLabelsByCategory[card.category] || 'Timeline';
        }
        // A negative cost is money saved, so label it as such for clear direction.
        if (key === 'cost') {
            const value = card && card.impact ? card.impact.cost : 0;
            return value < 0 ? 'Saved' : 'Cost';
        }
        const labels = {
            cost: 'Cost',
            oneTimeRevenue: 'Revenue',
            monthlyRevenue: 'Revenue/mo',
            monthlyCost: 'Cost/mo',
            recurringPayTime: 'Pays for',
            customers: 'Customers',
            revenuePledgePct: 'Donates'
        };
        return labels[key] || (key.charAt(0).toUpperCase() + key.slice(1));
    }

// Format a dollar amount compactly: $100, $1.5k, $25k, $2M
    function formatMoney(value) {
        const abs = Math.abs(value);
        let amount;
        if (abs >= 1000000) amount = '$' + (abs / 1000000).toFixed(1).replace('.0', '') + 'M';
        else if (abs >= 1000) amount = '$' + (abs / 1000).toFixed(1).replace('.0', '') + 'k';
        else amount = '$' + abs;
        return value < 0 ? '-' + amount : amount;
    }

// Format an impact value for display, based on what kind of metric the key is
    function formatMetricValue(key, value) {
        // Currency metrics
        if (key === 'cost' || key === 'oneTimeRevenue' || key === 'monthlyRevenue' || key === 'monthlyCost') {
            const amount = formatMoney(Math.abs(value));
            // Signed by money direction: money out shows '-', money in/saved shows '+'.
            // (A negative cost is a saving, so it reads as money in.)
            if (key === 'cost') return (value < 0 ? '+' : '-') + amount;
            if (key === 'monthlyCost') return (value < 0 ? '+' : '-') + amount;
            return (value < 0 ? '-' : '+') + amount;
        }
        // A revenue-share pledge is a fraction of revenue, shown as "1% rev"
        if (key === 'revenuePledgePct') {
            return (Math.round(value * 1000) / 10) + '% rev';
        }
        // Duration metrics
        if (key === 'recurringPayTime') {
            return value + 'mo';
        }
        if (key === 'time') {
            return (value > 0 ? '+' : '') + value + 'mo';
        }
        // Count metrics
        if (key === 'customers') {
            return (value > 0 ? '+' : '') + value;
        }
        // Percentage-based metrics (growth, engagement, confidence, stress, …)
        return (value > 0 ? '+' : '') + value + '%';
    }

;
// team-ops — extracted from biz-sim.js (see CLAUDE.md / js/game)


// Build the flip-side of a decision card: the full set of metrics this move
// affects, including ones the compact front face leaves off (it shows only the
// first three). Tapping the card anywhere but a button/link flips between faces.
    // A team card is a *hire* only if it has hiring economics (a salary). Policy/
    // initiative team cards (Remote-First, 4-Day Week) have no salary or level.
    function isHireCard(card) {
        return card.category === 'team' && typeof card.salary === 'number';
    }

    // Seniority tiers for hires. Each team hire card in sim-data.js is authored as the
    // *Mid* baseline; when a hire card is generated we roll a random level and derive
    // Junior/Senior procedurally from these multipliers, so each role shows up at a
    // varying salary level without duplicating cards.
    const TIER_MULTIPLIERS = { Junior: 0.7, Mid: 1.0, Senior: 1.4 };
    const HIRE_LEVELS = ['Junior', 'Mid', 'Senior'];
    // Two candidates for the same role rarely cost exactly the same, so each hire's
    // salary gets a small ± jitter. Rolled once in scaleHireCard so the figure shown
    // on the card is the figure charged to burn and recorded for the employee.
    const SALARY_VARIANCE = 0.08;

    function randomHireLevel() {
        return HIRE_LEVELS[Math.floor(Math.random() * HIRE_LEVELS.length)];
    }

    // Scale a base (Mid) hire card to the chosen seniority. Salary and the card's metric
    // contributions scale with the factor (juniors cost less and contribute less). `time`
    // is the exception: it's *ramp time*, so it scales inversely — juniors ramp slower,
    // seniors faster.
    function scaleHireCard(baseCard, level) {
        const factor = TIER_MULTIPLIERS[level] || 1;
        // ±SALARY_VARIANCE jitter around the tier salary, rounded to the nearest $1k.
        const jitter = 1 + (Math.random() * 2 - 1) * SALARY_VARIANCE;
        const scaled = {
            ...baseCard,
            level,
            baseTitle: baseCard.title, // unprefixed role, used for the org chart
            salary: Math.round(baseCard.salary * factor * jitter / 1000) * 1000,
            title: level === 'Mid' ? baseCard.title : `${level} ${baseCard.title}`
        };
        const impact = {};
        Object.keys(baseCard.impact || {}).forEach(key => {
            const value = baseCard.impact[key];
            if (typeof value !== 'number') { impact[key] = value; return; }
            if (key === 'time') {
                impact[key] = Math.round(value * (2 - factor) * 10) / 10;
            } else {
                impact[key] = Math.round(value * factor);
            }
        });
        scaled.impact = impact;
        return scaled;
    }

    // Pick a randomized name for a new hire from the EMPLOYEE_NAMES pool (names.js),
    // avoiding anyone already on the team so the org chart has no duplicates.
    function pickEmployeeName() {
        const pool = (typeof EMPLOYEE_NAMES !== 'undefined' && EMPLOYEE_NAMES) || [];
        if (!pool.length) return 'New Hire';
        const used = new Set(gameState.employees.map(e => e.name));
        for (let i = 0; i < 12; i++) {
            const name = pool[Math.floor(Math.random() * pool.length)];
            if (!used.has(name)) return name;
        }
        // Pool nearly exhausted — fall back to the first free name, else allow a repeat.
        return pool.find(n => !used.has(n)) || pool[Math.floor(Math.random() * pool.length)];
    }

    // Fractional years an employee has been with the company (0 if just hired).
    function employeeYearsOfService(emp) {
        const months = Math.max(0, gameState.currentMonth - (emp.hireMonth || gameState.currentMonth));
        return months / 12;
    }

    // Severance = one month of pay per year of service, with a half-month floor.
    function computeSeverance(emp) {
        const monthly = emp.salary / 12;
        return Math.round(monthly * Math.max(0.5, employeeYearsOfService(emp)));
    }

    // Compact tenure label, e.g. "<1 mo", "7 mo", "1.5 yrs".
    function formatTenure(years) {
        if (years < 1) {
            const months = Math.round(years * 12);
            return months <= 0 ? '<1 mo' : months + ' mo';
        }
        return (Math.round(years * 10) / 10) + ' yrs';
    }

    // Remove an employee from the team and undo their footprint: reverse their metric
    // contributions, take their salary out of burn, shrink the team, and flag the
    // linked card as fired so it's excluded from any future full recalculation.
    function detachEmployee(idx) {
        const emp = gameState.employees[idx];
        if (!emp) return null;
        if (emp.card) {
            applyImpactMetrics(emp.card, -1);
            const b = emp.card._teamBonus;
            if (b) {
                gameState.credibility -= b.credibility;
                gameState.growth -= b.growth;
            }
            // Undo a co-founder elevation's leadership bonus, if any.
            const cf = emp.card._coFounderBonus;
            if (cf) {
                gameState.credibility -= cf.credibility;
                gameState.confidence -= cf.confidence;
                gameState.stress -= cf.stress;
            }
            emp.card.fired = true;
        }
        gameState.employees.splice(idx, 1);
        gameState.teamSize = 1 + gameState.employees.length;
        recalcMonthlyBurn();
        clampMetrics();
        return emp;
    }

    // Refresh time-series + header + any open modal panes after a team change.
    function afterTeamChange() {
        recordHistorySnapshot();
        // The team just changed, so re-estimate the timelines of cards still in the stack.
        if (typeof reestimateStackCards === 'function') reestimateStackCards();
        updateUI();
        if (typeof updateSelectionsButtonText === 'function') updateSelectionsButtonText();
        if (typeof populateCompanyMetrics === 'function') populateCompanyMetrics();
        if (typeof populateOrgChart === 'function') populateOrgChart();
        if (typeof saveCurrentGame === 'function') saveCurrentGame();
    }

    // When an employee quits, the most junior hire is the one who realistically walks.
    // True when a junior has stuck around past EMPLOYEE_GRADUATE_YEARS without ever
    // being promoted AND there's more than one junior — so they can realistically move
    // on to a bigger role elsewhere without leaving you with no juniors at all. Drives
    // the bittersweet "On to Bigger Things" positive (see checkForOutcomes).
    function hasGraduatingJunior() {
        const juniors = gameState.employees.filter(e => e.level === 'Junior');
        return juniors.length >= 2 &&
               juniors.some(e => employeeYearsOfService(e) > EMPLOYEE_GRADUATE_YEARS);
    }

    // Remove that long-serving, never-promoted junior — the longest-tenured one when
    // there are several. Returns the employee (or null) so the card can name them.
    function removeLongTenuredJunior() {
        let targetIdx = -1, best = EMPLOYEE_GRADUATE_YEARS;
        gameState.employees.forEach((e, i) => {
            if (e.level !== 'Junior') return;
            const yrs = employeeYearsOfService(e);
            if (yrs > best) { best = yrs; targetIdx = i; }
        });
        return targetIdx >= 0 ? detachEmployee(targetIdx) : null;
    }

    // Returns the employee who left (or null if there was no one to lose) so callers
    // can name them on the "Employee Quits" card.
    function removeMostJuniorEmployee() {
        if (!gameState.employees.length) return null;
        const rank = { Junior: 0, Mid: 1, Senior: 2 };
        let idx = 0;
        gameState.employees.forEach((e, i) => {
            if ((rank[e.level] ?? 1) < (rank[gameState.employees[idx].level] ?? 1)) idx = i;
        });
        return detachEmployee(idx);
    }

    // Lay off an employee (org-chart button). Pays severance from runway based on
    // tenure, then reverses their metric/burn/team footprint and refreshes the UI.
    function fireEmployee(idx) {
        const emp = gameState.employees[idx];
        if (!emp) return;
        const severance = computeSeverance(emp);
        const tenure = formatTenure(employeeYearsOfService(emp));
        showConfirmDialog({
            tone: 'danger',
            icon: '✕',
            title: `Lay off ${emp.name}?`,
            rows: [
                ['Role', emp.title],
                ['Tenure', `${tenure} of service`],
                ['Severance', formatCurrency(severance)]
            ],
            note: 'Their salary leaves your burn and their contribution to your metrics is removed.',
            cancelLabel: 'Keep',
            confirmLabel: 'Lay off',
            onConfirm: () => {
                gameState.runway -= severance;
                detachEmployee(idx);
                afterTeamChange();
            }
        });
    }

    // Promote a Junior → Mid → Senior employee (org-chart button). Re-scales the
    // linked hire card to the new tier, swaps their metric contribution and salary,
    // and refreshes the UI. Seniors have no higher tier and can't be promoted.
    function promoteEmployee(idx) {
        const emp = gameState.employees[idx];
        if (!emp) return;
        const next = { Junior: 'Mid', Mid: 'Senior' }[emp.level];
        if (!next) return;
        const baseCard = teamMembers.find(c => c.title === emp.role);
        if (!baseCard) return;
        const rescaled = scaleHireCard(baseCard, next);
        const oldSalary = emp.salary;
        const raise = rescaled.salary - oldSalary;

        showConfirmDialog({
            tone: 'success',
            icon: '▲',
            title: `Promote ${emp.name}?`,
            rows: [
                ['Level', `${emp.level} → ${next}`],
                ['Salary', `${formatCurrency(oldSalary)} → ${formatCurrency(rescaled.salary)}/yr`],
                ['Raise', `+${formatCurrency(raise)}/yr (+${formatCurrency(raise / 12)}/mo burn)`]
            ],
            note: 'A more senior hire contributes more to your metrics.',
            cancelLabel: 'Cancel',
            confirmLabel: 'Approve raise',
            onConfirm: () => {
                if (emp.card) {
                    applyImpactMetrics(emp.card, -1); // remove old-tier contribution
                    emp.card.level = rescaled.level;
                    emp.card.title = rescaled.title;
                    emp.card.salary = rescaled.salary;
                    emp.card.baseTitle = rescaled.baseTitle;
                    emp.card.impact = rescaled.impact;
                    applyImpactMetrics(emp.card, 1);  // apply new-tier contribution
                }
                emp.level = next;
                emp.title = rescaled.title;
                emp.salary = rescaled.salary;
                recalcMonthlyBurn();
                clampMetrics();
                afterTeamChange();
            }
        });
    }

    // Is there already a co-founder? Only one Senior member can be elevated.
    function coFounderExists() {
        return (gameState.employees || []).some(e => e.coFounder);
    }

    // Elevate a Senior employee to co-founder (org-chart button). Opens a dialog to
    // choose how much equity to grant; the grant scales their cash-for-equity pay cut
    // and a leadership bonus (credibility/confidence up, founder stress down). One max.
    function makeCoFounder(idx) {
        const emp = gameState.employees[idx];
        if (!emp) return;
        if (emp.level !== 'Senior' || emp.coFounder) return;
        if (coFounderExists()) return;

        const baseSalary = emp.salary;
        // Effects derived from the equity % granted, so the live preview can show them.
        const effectsFor = (equity) => {
            const cut = Math.min(0.6, equity / 100); // trades cash for ownership
            return {
                equity,
                newSalary: Math.round(baseSalary * (1 - cut) / 1000) * 1000,
                credibility: Math.round(equity * 0.5),
                confidence: Math.round(equity * 0.3),
                stress: Math.round(equity * 0.6)
            };
        };

        showConfirmDialog({
            tone: 'founder',
            icon: '★',
            title: `Make ${emp.name} a co-founder?`,
            input: { label: 'Equity to grant', min: 1, max: 49, step: 1, value: 10, suffix: '%' },
            computeRows: (equity) => {
                const fx = effectsFor(equity);
                return [
                    ['Role', `Co-Founder · ${emp.role}`],
                    ['Your stake after', `${100 - equity}%`],
                    ['Salary', `${formatCurrency(baseSalary)} → ${formatCurrency(fx.newSalary)}/yr`],
                    ['Leadership', `+${fx.credibility} cred · +${fx.confidence} conf · −${fx.stress} stress`]
                ];
            },
            note: 'Co-founders trade salary for equity. You can only appoint one.',
            cancelLabel: 'Cancel',
            confirmLabel: 'Appoint co-founder',
            onConfirm: (equity) => {
                const fx = effectsFor(equity);
                emp.coFounder = true;
                emp.equity = equity;
                emp.title = 'Co-Founder';
                emp.salary = fx.newSalary;
                gameState.credibility += fx.credibility;
                gameState.confidence += fx.confidence;
                gameState.stress -= fx.stress;
                if (emp.card) {
                    emp.card._coFounderBonus = {
                        credibility: fx.credibility,
                        confidence: fx.confidence,
                        stress: fx.stress
                    };
                }
                recalcMonthlyBurn();
                clampMetrics();
                afterTeamChange();
            }
        });
    }

;
// pricing — extracted from biz-sim.js (see CLAUDE.md / js/game)


// Enhanced game state updates with proper time and financial tracking
// Advance organic customer growth by one in-game month: acquisition (reach + referrals)
// minus churn (low engagement / high stress), tapered by market saturation. Mutates
// gameState.customers. See the CUSTOMER_* constants for tuning.
function advanceCustomers(dt = 1) {
    const reachF = gameState.reach / 100, growthF = gameState.growth / 100;
    const engF = gameState.engagement / 100, stressF = gameState.stress / 100;
    const saturation = 1 - Math.min(1, gameState.customers / CUSTOMER_MARKET_CAP);
    // Pricing pressure: above fair price, fewer sign up and more churn; below it, a boost.
    const overFair = gameState.pricePerCustomer - CUSTOMER_FAIR_PRICE;
    const acqPriceMult = Math.max(0.1, Math.min(1.5, 1 - overFair / CUSTOMER_PRICE_ACQ_SENS));
    const churnPriceAdd = Math.max(0, overFair) * CUSTOMER_PRICE_CHURN;
    // Market state: a macro climate multiplier (downturn/war drags it below 1) and a
    // competitor that both suppresses acquisition and adds churn. Defaults keep old saves
    // (no such fields) at a neutral market.
    const climate = (typeof gameState.marketClimate === 'number') ? gameState.marketClimate : 1;
    const compP = gameState.competitorPressure || 0;
    const compAcqMult = 1 - COMPETITOR_ACQ_DRAG * compP;
    // Word-of-mouth still needs awareness to land on new people, so referrals scale with
    // reach (floor + the rest from reachF) — see CUSTOMER_REF_REACH_FLOOR. Without marketing
    // (reach ≈ 0) referrals run at just the floor, so they can't carry growth on their own.
    const refReachMult = CUSTOMER_REF_REACH_FLOOR + (1 - CUSTOMER_REF_REACH_FLOOR) * reachF;
    const acquisition = (CUSTOMER_ACQ_BASE * reachF * (CUSTOMER_ACQ_GROWTH_FLOOR + growthF)
                         + CUSTOMER_REF_RATE * gameState.customers * engF * refReachMult)
                         * saturation * acqPriceMult * climate * compAcqMult * dt;
    const churn = gameState.customers * (CUSTOMER_CHURN_BASE * (1 - engF)
                         + CUSTOMER_CHURN_STRESS * stressF + churnPriceAdd
                         + COMPETITOR_CHURN * compP) * dt;
    gameState.customers = Math.max(0, Math.round(gameState.customers + acquisition - churn));
}

// Current monthly revenue rate = per-customer subscriptions + active discrete streams.
function recomputeMonthlyRevenue() {
    const subs = gameState.customers * gameState.pricePerCustomer;
    const streams = gameState.revenueStreams.reduce((sum, s) => sum + s.amount, 0);
    gameState.monthlyRevenue = Math.round(subs + streams);
    // Burn can include revenue-share pledges (% of revenue), so rebuild it now that
    // the current revenue is known — keeps the donation tracking live revenue.
    if (typeof recalcMonthlyBurn === 'function') recalcMonthlyBurn();
}

// Reflect the current price in the bottom-nav stepper.
function updatePriceDisplay() {
    const el = document.getElementById('priceValue');
    if (el) el.textContent = '$' + gameState.pricePerCustomer;
}

// Set the subscription price (clamped ≥ 0). Price is a FORWARD policy: it must not
// retroactively rewrite already-earned revenue or the current rate. So we only store it
// and update the stepper label — the new price first takes effect on the next decision,
// when updateGameStats() accrues that month and recomputes monthlyRevenue.
function setPrice(newPrice) {
    gameState.pricePerCustomer = Math.max(0, newPrice);
    updatePriceDisplay();
    showPriceProjection();
    // The price is forward-looking policy but still part of the saved run.
    if (typeof saveCurrentGame === 'function') saveCurrentGame();
}

// Briefly float a projection toast showing the estimated next-month net income at the
// current price + customer base. Purely a hint — it does NOT change actual revenue/runway.
let priceProjectionTimer = null;
function showPriceProjection() {
    const el = document.getElementById('priceProjection');
    if (!el) return;
    const projRevenue = gameState.customers * gameState.pricePerCustomer
                        + gameState.revenueStreams.reduce((sum, s) => sum + s.amount, 0);
    const projNet = Math.round(projRevenue - gameState.monthlyBurn);
    const sign = projNet >= 0 ? '+' : '−';
    el.textContent = `Next mo ≈ ${sign}$${Math.abs(projNet).toLocaleString()}/mo`;
    el.classList.toggle('positive', projNet >= 0);
    el.classList.toggle('negative', projNet < 0);
    el.classList.add('is-visible');
    clearTimeout(priceProjectionTimer);
    priceProjectionTimer = setTimeout(() => el.classList.remove('is-visible'), 2500);
}

// Bottom-nav − / + handlers.
function changePrice(delta) {
    setPrice(gameState.pricePerCustomer + delta);
}

;
// engine — extracted from biz-sim.js (see CLAUDE.md / js/game)


    // Apply (sign = +1) or reverse (sign = -1) a card's metric impacts on gameState.
    // Mirrors the impact-tracking in updateGameStats so a hire's contribution can be
    // taken back exactly when they leave, or swapped out when they're re-leveled.
    function applyImpactMetrics(card, sign) {
        const im = card && card.impact;
        if (!im) return;
        if (im.customers) gameState.customers += sign * im.customers;
        if (im.growth) gameState.growth += sign * im.growth;
        if (im.engagement) gameState.engagement += sign * im.engagement;
        if (im.confidence) gameState.confidence += sign * im.confidence;
        if (im.credibility) gameState.credibility += sign * im.credibility;
        if (im.reach) gameState.reach += sign * im.reach;
        if (im.retention) gameState.engagement += sign * Math.floor(im.retention * 0.5);
        if (im.quality) gameState.confidence += sign * Math.floor(im.quality * 0.3);
        // Scalability is infrastructure capacity, NOT market awareness — it must not feed
        // reach (that's marketing's lever). A reliable, scalable product is a better
        // experience, so it gives a small engagement bump instead. (Was reach * 0.4.)
        if (im.scalability) gameState.engagement += sign * Math.floor(im.scalability * 0.2);
        if (im.stress) gameState.stress += sign * im.stress;
    }

    // The per-category metric bonus is rolled randomly the first time a card is played,
    // then CACHED on the card (card._roll). A later timeline rebuild (after a selection
    // is removed) re-applies the exact same roll instead of re-rolling — a rebuild must
    // reproduce the run, not reshuffle it. randInt(lo, hi) is inclusive on both ends and
    // reproduces the original `Math.floor(Math.random() * span) + lo` ranges exactly.
    function randInt(lo, hi) { return Math.floor(Math.random() * (hi - lo + 1)) + lo; }
    function rollCategoryBonus(category) {
        switch (category) {
            case 'validation': return { confidence: randInt(5, 9) };
            case 'team':       return { credibility: randInt(4, 11), growth: randInt(2, 7) };
            case 'product':    return { engagement: randInt(8, 12) };
            case 'marketing':  return { reach: randInt(15, 34), growth: randInt(8, 19) };
            case 'business':   return { confidence: randInt(6, 17), credibility: randInt(5, 14) };
            case 'revenue':    return { confidence: randInt(10, 24) };
            case 'esg':        return { credibility: randInt(4, 9) };
            default:           return {};
        }
    }
    // Apply (sign +1) or reverse (sign -1) a card's category bonus, rolling + caching it
    // on first use. For team hires the roll is also mirrored into card._teamBonus, which
    // detachEmployee() reverses on layoff (kept for backward compatibility).
    function applyCategoryRoll(card, sign = 1) {
        if (!card._roll) {
            // Old saves predate _roll: a team card still carries its real rolled bonus in
            // _teamBonus, so reuse that to stay faithful; other categories re-roll once.
            if (card.category === 'team' && card._teamBonus) {
                card._roll = { credibility: card._teamBonus.credibility, growth: card._teamBonus.growth };
            } else {
                card._roll = rollCategoryBonus(card.category);
            }
        }
        const roll = card._roll;
        for (const k in roll) gameState[k] += sign * roll[k];
        if (card.category === 'team') {
            card._teamBonus = { credibility: roll.credibility || 0, growth: roll.growth || 0 };
        }
    }

    // Keep the percentage metrics in [0, 100] and counts non-negative after an
    // adjustment (matches the clamping at the end of updateGameStats).
    function clampMetrics() {
        ['growth', 'engagement', 'confidence', 'credibility', 'reach', 'stress'].forEach(k => {
            gameState[k] = Math.min(100, Math.max(0, gameState[k]));
        });
        gameState.customers = Math.max(0, gameState.customers);
    }

    // Recompute monthly burn from scratch: base + each current employee's monthly
    // salary + recurring non-salary costs from active (non-fired) cards.
    function recalcMonthlyBurn() {
        let burn = 1000; // base monthly burn
        gameState.employees.forEach(e => { burn += e.salary / 12; });
        gameState.selectedCards.forEach(c => {
            if (c.fired || !c.impact) return;
            if (c.impact.monthlyCost) burn += c.impact.monthlyCost;
            // Revenue-share pledges (e.g. 1% for the Planet) donate a percentage of
            // CURRENT monthly revenue every month — a recurring cost that scales with
            // the business instead of a flat fee. Tracks live revenue because this is
            // rebuilt whenever recomputeMonthlyRevenue() runs.
            if (c.impact.revenuePledgePct) burn += c.impact.revenuePledgePct * (gameState.monthlyRevenue || 0);
        });
        // Outstanding loan repayments add to burn until each loan's term is paid off
        // (monthsRemaining is drawn down in updateGameStats; a cleared loan is dropped).
        (gameState.loans || []).forEach(l => { if (l.monthsRemaining > 0) burn += l.monthly; });
        gameState.monthlyBurn = burn;
    }

function updateGameStats(card) {
    const prevMonth = gameState.currentMonth;

    // Record the subscription price active for this decision. Price is forward-only
    // policy and isn't otherwise stored per decision, so a later timeline rebuild needs
    // this to accrue the same per-customer revenue for the months this card spans.
    card._priceAtDecision = gameState.pricePerCustomer;

    // Update time progression
    if (card.impact && card.impact.time) {
        gameState.currentMonth += Math.abs(card.impact.time);
    }
    
    // Hires grow the team and add their monthly salary to burn. Policy team cards
    // (Remote-First, 4-Day Week) aren't people, so they do neither here.
    if (isHireCard(card)) {
        gameState.teamSize++;
        gameState.monthlyBurn += card.salary / 12; // Add monthly salary to burn rate
        // Record the hire so it can be drawn as a slot in the org chart. `card` is the
        // same object stored in selectedCards, so we keep a reference to it — promotions
        // re-scale it in place and layoffs reverse its metric contributions.
        gameState.employees.push({
            name: pickEmployeeName(),
            role: card.baseTitle || card.title,
            title: card.title,
            level: card.level || 'Mid',
            salary: card.salary,
            hireMonth: card.selectedMonth || gameState.currentMonth,
            hireDate: formatGameDate(getCurrentGameDate()),
            card: card
        });
    }

    // Recurring non-salary costs (e.g. Remote-First's video/SaaS tooling) add to burn.
    if (card.impact && card.impact.monthlyCost) {
        gameState.monthlyBurn += card.impact.monthlyCost;
    }

    // Update one-time costs (positive cost = money spent, negative = money saved)
    if (card.impact && card.impact.cost) {
        gameState.runway -= card.impact.cost;
    }

    // One-time revenue lands immediately as cash and counts toward total revenue
    if (card.impact && card.impact.oneTimeRevenue) {
        gameState.runway += card.impact.oneTimeRevenue;
        gameState.totalRevenue += card.impact.oneTimeRevenue;
    }

    // A loan: the principal lands as cash NOW (runway only — borrowed money isn't
    // revenue, so it doesn't touch totalRevenue), and the monthly repayment is booked
    // as a fixed-term obligation that adds to burn until it's paid off (loanTermMonths,
    // default 36). The term is drawn down by elapsed months in the loop below.
    if (card.impact && card.impact.loanPrincipal) {
        gameState.runway += card.impact.loanPrincipal;
    }
    if (card.impact && card.impact.loanRepayment) {
        if (!gameState.loans) gameState.loans = [];
        gameState.loans.push({
            monthly: card.impact.loanRepayment,
            monthsRemaining: card.impact.loanTermMonths || 36
        });
    }

    // Register a recurring revenue stream. recurringPayTime caps how many months it
    // pays out (omitted = pays indefinitely). Active streams are summed below.
    if (card.impact && card.impact.monthlyRevenue) {
        gameState.revenueStreams.push({
            amount: card.impact.monthlyRevenue,
            monthsRemaining: card.impact.recurringPayTime || Infinity
        });
    }

    // Market shocks from outcome cards (downturn, war, a competitor entering) move
    // path-dependent market state rather than a capped metric. Applied once, here, BEFORE
    // the month loop below so the months this card spans already feel the headwind; the
    // monthly tick then recovers climate / decays pressure back toward baseline over time.
    // (Not replayed by recalculateAllMetrics — like `customers`, this is authoritative.)
    if (card.impact && card.impact.marketClimate) {
        const base = (typeof gameState.marketClimate === 'number') ? gameState.marketClimate : 1;
        gameState.marketClimate = Math.max(0.1, base + card.impact.marketClimate);
    }
    if (card.impact && card.impact.competitorPressure) {
        gameState.competitorPressure = Math.max(0, Math.min(1,
            (gameState.competitorPressure || 0) + card.impact.competitorPressure));
    }
    // Equity sold to investors accumulates (capped at 100%); carved out of the exit
    // payout in acceptExit. Authoritative like the market state above — applied once,
    // here, and not replayed by recalculateAllMetrics.
    if (card.impact && card.impact.investorEquity) {
        gameState.investorEquity = Math.max(0, Math.min(100,
            (gameState.investorEquity || 0) + card.impact.investorEquity));
    }

        // ===== NEW METRICS TRACKING CODE =====

    // Apply the card's metric impacts (customers/growth/engagement/etc.). Factored
    // into a helper so layoffs can reverse a hire's exact contribution.
    applyImpactMetrics(card, 1);

    // Category-specific metric bonus (validation→confidence, marketing→reach/growth,
    // etc.). Rolled once and cached on the card so a later timeline rebuild re-applies
    // the same values. Customers grow organically from these metrics, not per card.
    applyCategoryRoll(card, 1);

    // Step metric decay, organic customers, and revenue accrual together, one in-game
    // month (or fractional remainder) at a time, so everything tracks elapsed time
    // accurately — including the 0.5-month cards the old integer loop skipped entirely.
        const monthsPassed = gameState.currentMonth - prevMonth;
        // Pay down outstanding loans by the months that just elapsed, dropping any that
        // reach the end of their term. Done before the burn recompute below so a loan that
        // finishes this decision stops adding to burn from here on (it's paid off).
        if (monthsPassed > 0 && gameState.loans && gameState.loans.length) {
            gameState.loans.forEach(l => { l.monthsRemaining -= monthsPassed; });
            gameState.loans = gameState.loans.filter(l => l.monthsRemaining > 0);
        }
        let revenueThisPeriod = 0;
        let remaining = monthsPassed;
        while (remaining > 0.0001) {
            const dt = Math.min(1, remaining);
            // Metrics erode without upkeep (scaled to the step) so they can't sit at 100.
            // Engagement slips first so neglect feeds churn the same step.
            gameState.engagement  = Math.max(0, gameState.engagement - 2 * dt);
            gameState.reach       = Math.max(0, gameState.reach       * (1 - REACH_DECAY * dt));
            gameState.growth      = Math.max(0, gameState.growth      * (1 - GROWTH_DECAY * dt));
            gameState.confidence  = Math.max(0, gameState.confidence  * (1 - CONFIDENCE_DECAY * dt));
            gameState.credibility = Math.max(0, gameState.credibility * (1 - CREDIBILITY_DECAY * dt));
            // Market climate drifts back toward normal — downturns and wars are weathered,
            // not permanent. Competitor pressure fades on its own, faster when you're
            // out-growing the rival (strong growth), slower if you've let momentum stall.
            if (typeof gameState.marketClimate !== 'number') gameState.marketClimate = 1;
            gameState.marketClimate += (1 - gameState.marketClimate) * MARKET_RECOVERY * dt;
            if (gameState.competitorPressure > 0) {
                const fade = COMPETITOR_DECAY_BASE + COMPETITOR_DECAY_GROWTH * (gameState.growth / 100);
                gameState.competitorPressure = Math.max(0, gameState.competitorPressure - fade * dt);
            }
            advanceCustomers(dt);
            // This step's revenue: per-customer subscriptions plus any active discrete streams
            revenueThisPeriod += gameState.customers * gameState.pricePerCustomer * dt;
            for (const stream of gameState.revenueStreams) {
                if (stream.monthsRemaining > 0) {
                    revenueThisPeriod += stream.amount * dt;
                    stream.monthsRemaining -= dt;
                }
            }
            remaining -= dt;
        }
        gameState.revenueStreams = gameState.revenueStreams.filter(s => s.monthsRemaining > 0);

        // Cap all percentage-based metrics at 100
        gameState.growth = Math.min(100, gameState.growth);
        gameState.engagement = Math.min(100, gameState.engagement);
        gameState.confidence = Math.min(100, gameState.confidence);
        gameState.credibility = Math.min(100, gameState.credibility);
        gameState.reach = Math.min(100, gameState.reach);
        gameState.stress = Math.min(100, Math.max(0, gameState.stress));

        // Ensure no negative values
        gameState.customers = Math.max(0, gameState.customers);
        gameState.engagement = Math.max(0, gameState.engagement);
        gameState.credibility = Math.max(0, gameState.credibility);
        gameState.reach = Math.max(0, gameState.reach);

        // Recompute the current monthly revenue rate (subscriptions + active streams).
        recomputeMonthlyRevenue();

        // Apply burn for the months passed and bank the revenue actually earned
        if (monthsPassed > 0) {
            gameState.runway -= gameState.monthlyBurn * monthsPassed;
            gameState.runway += revenueThisPeriod;
            gameState.totalRevenue += revenueThisPeriod;
        }

        // Update year tracking
        gameState.currentYear = Math.floor((gameState.currentMonth - 1) / 12) + 1;

        // Capture a snapshot for the company graphs (revenue/customers/etc. over time).
        // Pass this decision's one-time cash spend so the financial chart can bar it.
        recordHistorySnapshot(card.impact && card.impact.cost > 0 ? card.impact.cost : 0);

        updateUI();
        updateSelectionsButtonText();

        // Persist the run so a refresh can return to this business.
        if (typeof saveCurrentGame === 'function') saveCurrentGame();

        // Did this decision end the run (out of money, etc.)? Checked last, against
        // the now-settled state. Ends the game and shows the verdict card if so.
        if (typeof maybeEndRun === 'function') maybeEndRun();
    }

// Append a point to the time-series history used by the company-metrics graphs.
// Called after each decision (and once at startup) so charts can plot how the
// business evolved month over month.
function recordHistorySnapshot(oneTimeCost = 0) {
    gameState.history.push({
        month: gameState.currentMonth,
        year: gameState.currentYear,
        totalRevenue: gameState.totalRevenue,
        monthlyRevenue: gameState.monthlyRevenue,
        monthlyBurn: gameState.monthlyBurn,
        netIncome: gameState.monthlyRevenue - gameState.monthlyBurn,
        runway: gameState.runway,
        oneTimeCost: oneTimeCost, // one-time cash spent on this decision (summed per month for the chart)
        customers: gameState.customers,
        engagement: Math.round(gameState.engagement),
        growth: gameState.growth,
        confidence: gameState.confidence,
        credibility: gameState.credibility,
        reach: gameState.reach,
        teamSize: gameState.teamSize,
        stress: gameState.stress
    });
}

    function recalculateAllMetrics() {
        // Reset derived metrics. NOTE: customers is authoritative, path-dependent state
        // (see Customer model v2) and is intentionally NOT recomputed here — a true restore
        // would need to re-simulate the timeline. Today this only runs at init with no cards.
        gameState.growth = 0;
        gameState.engagement = 0;
        gameState.confidence = 0;
        gameState.credibility = 0;
        gameState.reach = 0;
        gameState.stress = 0;

        // Recalculate from all selected cards
        gameState.selectedCards.forEach(card => {
            // Skip hires who have since been laid off — they no longer contribute.
            if (card.fired) return;
            // Apply the metrics tracking logic without affecting time/money
            const tempCard = { ...card, impact: { ...card.impact } };
            // Remove financial impacts to avoid double-counting
            delete tempCard.impact.time;
            delete tempCard.impact.cost;
            delete tempCard.impact.monthlyRevenue;
            
            // Apply just the metric tracking part
            if (tempCard.impact) {
                if (tempCard.impact.growth) gameState.growth += tempCard.impact.growth;
                if (tempCard.impact.engagement) gameState.engagement += tempCard.impact.engagement;
                if (tempCard.impact.confidence) gameState.confidence += tempCard.impact.confidence;
                if (tempCard.impact.credibility) gameState.credibility += tempCard.impact.credibility;
                if (tempCard.impact.reach) gameState.reach += tempCard.impact.reach;
                if (tempCard.impact.retention) gameState.engagement += Math.floor(tempCard.impact.retention * 0.5);
                if (tempCard.impact.quality) gameState.confidence += Math.floor(tempCard.impact.quality * 0.3);
                // Scalability → engagement (not reach); see applyImpactMetrics.
                if (tempCard.impact.scalability) gameState.engagement += Math.floor(tempCard.impact.scalability * 0.2);
                if (tempCard.impact.stress) gameState.stress += tempCard.impact.stress;
            }
            
            // Category-specific impacts
            switch (tempCard.category) {
                case 'validation':
                    gameState.confidence += 7;
                    break;
                case 'team':
                    gameState.credibility += 6;
                    gameState.growth += 4;
                    break;
                case 'product':
                    gameState.engagement += 12;
                    break;
                case 'marketing':
                    gameState.reach += 17;
                    gameState.growth += 10;
                    break;
                case 'business':
                    gameState.confidence += 9;
                    gameState.credibility += 7;
                    break;
                case 'revenue':
                    gameState.confidence += 12;
                    break;
                case 'esg':
                    gameState.credibility += 5;
                    break;
            }
        });
        
        // Cap all metrics
        gameState.growth = Math.min(100, Math.max(0, gameState.growth));
        gameState.engagement = Math.min(100, Math.max(0, gameState.engagement));
        gameState.confidence = Math.min(100, Math.max(0, gameState.confidence));
        gameState.credibility = Math.min(100, Math.max(0, gameState.credibility));
        gameState.reach = Math.min(100, Math.max(0, gameState.reach));
        gameState.stress = Math.min(100, Math.max(0, gameState.stress));
        gameState.customers = Math.max(0, gameState.customers);
    }

;
// outcomes-engine — extracted from biz-sim.js (see CLAUDE.md / js/game)


// Why a hire might walk. People don't quit because you're short on customers — they
// quit when the things that keep good people are missing: a path to grow, flexible
// work, a team they feel part of, interesting work, and a founder who isn't burning
// everyone out. Each gap the founder hasn't addressed is one reason; this returns the
// ones currently in play. Enough of them at once triggers the "Employee Quits" card
// (see checkForOutcomes), and one of them is cited by name on the card itself (see
// applyCardActivateEffect in ui.js). Add a reason here to teach a new lesson.
function getAttritionReasons() {
    const has = (title) => gameState.selectedCards.some(c => c.title === title);
    const productCards = gameState.selectedCards.filter(c => c.category === 'product').length;
    const reasons = [];
    if (!has('Team Certification Program'))      reasons.push('no_growth');     // no professional development
    if (!has('Remote-First Policy'))             reasons.push('rigid_work');    // no flexible/remote work
    if (!has('Team Offsite'))                    reasons.push('no_cohesion');   // team never bonded
    if (productCards === 0)                      reasons.push('no_innovation'); // work went stale
    if (gameState.stress > EMPLOYEE_QUIT_STRESS) reasons.push('burnout');       // founder ran everyone ragged
    return reasons;
}

// Enhanced outcome checking with better performance
function checkForOutcomes() {
    const recentSelections = gameState.selectedCards.slice(-3);
    const categoryCount = gameState.selectedCards.reduce((acc, card) => {
        acc[card.category] = (acc[card.category] || 0) + 1;
        return acc;
    }, {});

    // How many reasons-to-leave are currently stacked up (see getAttritionReasons).
    const attritionReasons = getAttritionReasons();

    // Check for various triggers with improved logic
    const triggers = [
        { condition: !categoryCount.validation && gameState.selectedCards.length > 5, outcome: "no_validation" },
        { condition: gameState.teamSize === 1 && gameState.selectedCards.length > 8, outcome: "solo_founder" },
        { condition: gameState.runway < 10000 && gameState.monthlyRevenue < 2000 && gameState.selectedCards.length > 6, outcome: "high_budget" },
        { condition: !categoryCount.marketing && gameState.selectedCards.length > 6, outcome: "no_marketing" },
        // Someone walks once enough reasons-to-leave pile up on a team big enough to
        // lose a hire (see getAttritionReasons / EMPLOYEE_QUIT_REASONS_NEEDED). Picking
        // the neglected team-investment cards clears reasons and makes departures rarer.
        { condition: gameState.teamSize >= 3 && gameState.selectedCards.length > 12 && attritionReasons.length >= EMPLOYEE_QUIT_REASONS_NEEDED, outcome: "employee_quit" },
        { condition: (categoryCount.product || 0) >= 2 && gameState.customers > 600 && !gameState.selectedCards.some(c => c.title === "DevOps Engineer"), outcome: "no_devops" }
    ];

    // These challenges track ongoing conditions (no validation, still solo, cash
    // crunch, no marketing, stressed-out team, scaled without DevOps), so they're
    // allowed to recur while the condition holds — that's the intended nudge to fix
    // the underlying problem. (queueOutcomeCard dedups within a batch, and the 25%
    // emit gate in loadMoreCards keeps them from spamming.) The reason they no longer
    // ambush a freshly loaded save is the skip-flag on that first deal, not a fired
    // guard here. The truly one-shot challenges are gated by their own …Fired flags.
    //
    // Note: employee_quit's actual departure is NOT applied here. It's deferred to the
    // moment the card reaches the top of the stack (see data-activate-effect in
    // generateOutcomeCard + applyCardActivateEffect), so the team change lands on the
    // same beat the player reads about it — never silently, several cards earlier.
    triggers.forEach(trigger => {
        if (trigger.condition) {
            const outcome = outcomeCards.challenges.find(c => c.trigger === trigger.outcome);
            if (outcome) queueOutcomeCard(outcome);
        }
    });
    
    // Check for positive outcomes. A positive's `trigger` is matched against either the
    // selected card's category, or its title lowercased with SPACES → underscores.
    // NOTE: only whitespace is replaced — other characters (/, &, -, %) are left as-is.
    // So a card like "UX/UI Designer" snake-cases to "ux/ui_designer" (slash kept); its
    // trigger must match that literally. Get this wrong and the outcome silently never fires.
    recentSelections.forEach(selection => {
        const positiveOutcome = outcomeCards.positive.find(outcome =>
            outcome.trigger === selection.title.toLowerCase().replace(/\s+/g, '_') ||
            outcome.trigger === selection.category
        );
        
        if (positiveOutcome && Math.random() > 0.7) {
            queueOutcomeCard(positiveOutcome);
        }
    });
    
    // Revenue-based opportunities
        if (gameState.monthlyRevenue > 5000 && gameState.growth > 0) {
            const opportunity = outcomeCards.opportunities.find(o => o.trigger === "strong_growth");
            if (opportunity && Math.random() > 0.6) {
                queueOutcomeCard(opportunity);
            }
        }
        
        if (gameState.monthlyRevenue > 300000 && gameState.selectedCards.length > 15 && gameState.customers > 10) {
            const opportunity = outcomeCards.opportunities.find(o => o.trigger === "proven_model");
            if (opportunity && Math.random() > 0.75) {
                queueOutcomeCard(opportunity);
            }
        }
        
        if (gameState.monthlyRevenue > 50000 && gameState.selectedCards.length > 25) {
            const opportunity = outcomeCards.opportunities.find(o => o.trigger === "b2c_struggles");
            if (opportunity && Math.random() > 0.4) {
                queueOutcomeCard(opportunity);
            }
        }

        // Selection-driven opportunity: Business Travel can open a partnership deal (fires once)
        if (gameState.selectedCards.some(c => c.title === "Business Travel") && !gameState.travelOpportunityFired && Math.random() > 0.5) {
            const opportunity = outcomeCards.opportunities.find(o => o.trigger === "business_travel");
            if (opportunity) {
                queueOutcomeCard(opportunity);
                gameState.travelOpportunityFired = true;
            }
        }

        // Selection + satisfaction driven positive: happy users + strong support => brand loyalty (fires once)
        if (gameState.engagement > 50 &&
            gameState.selectedCards.some(c => c.title === "Customer Success Manager") &&
            !gameState.brandLoyaltyFired && Math.random() > 0.5) {
            const outcome = outcomeCards.positive.find(o => o.trigger === "brand_loyalty");
            if (outcome) {
                queueOutcomeCard(outcome);
                gameState.brandLoyaltyFired = true;
            }
        }

        // Podcast pays off: a marketing podcast plus real momentum and a calm founder lets the
        // show find an organic audience that spreads it for you (fires once). Custom trigger so
        // it only fires here, not from the generic title/category positive loop above.
        if (gameState.selectedCards.some(c => c.title === "Launch a Podcast") &&
            gameState.growth > 30 && gameState.stress < 50 &&
            !gameState.podcastAudienceFired && Math.random() > 0.5) {
            const outcome = outcomeCards.positive.find(o => o.trigger === "podcast_audience");
            if (outcome) {
                queueOutcomeCard(outcome);
                gameState.podcastAudienceFired = true;
            }
        }

        // Founder wellbeing compounds: kept stress low and confidence high well into the
        // journey => you've grown into the role and it lifts the whole company (fires once)
        if (gameState.stress < 30 && gameState.confidence > 40 && gameState.selectedCards.length > 8 &&
            !gameState.founderGrowthFired && Math.random() > 0.5) {
            const outcome = outcomeCards.positive.find(o => o.trigger === "founder_growth");
            if (outcome) {
                queueOutcomeCard(outcome);
                gameState.founderGrowthFired = true;
            }
        }

        // A long-serving junior you never promoted moves on to a bigger role elsewhere —
        // bittersweet, but a credit to the team you built. Not a one-shot: it can happen
        // again for a different long-tenured junior. The actual departure is applied when
        // the card surfaces (see employee_moves_on in applyCardActivateEffect / ui.js).
        if (typeof hasGraduatingJunior === 'function' && hasGraduatingJunior() && Math.random() > 0.5) {
            const outcome = outcomeCards.positive.find(o => o.trigger === "employee_moves_on");
            if (outcome) queueOutcomeCard(outcome);
        }

        // Over-monetization: leaned hard on revenue with little product and no UX advocate
        // => intrusive ads and upsells smother the experience and drive users off (fires once)
        if ((categoryCount.revenue || 0) >= 3 && (categoryCount.product || 0) <= 1 &&
            !gameState.selectedCards.some(c => c.title === "UX/UI Designer") &&
            gameState.customers > 100 && !gameState.popupOverloadFired && Math.random() > 0.5) {
            const outcome = outcomeCards.challenges.find(c => c.trigger === "popup_overload");
            if (outcome) {
                queueOutcomeCard(outcome);
                gameState.popupOverloadFired = true;
            }
        }

        // Team recognition: a real team plus strong credibility earns an industry award —
        // a morale and reputation win the whole crew shares (fires once)
        if (gameState.teamSize >= 4 && gameState.credibility > 50 &&
            !gameState.industryAwardFired && Math.random() > 0.5) {
            const outcome = outcomeCards.positive.find(o => o.trigger === "industry_award");
            if (outcome) {
                queueOutcomeCard(outcome);
                gameState.industryAwardFired = true;
            }
        }

        // Visibility-driven challenge: high reach makes you a target for an online mob (fires once)
        if (gameState.reach > 60 && !gameState.pileOnFired && Math.random() > 0.5) {
            const outcome = outcomeCards.challenges.find(c => c.trigger === "founder_pile_on");
            if (outcome) {
                queueOutcomeCard(outcome);
                gameState.pileOnFired = true;
            }
        }

        // Overhype challenge: heavy marketing with no product to back it => public backlash (fires once)
        if ((categoryCount.marketing || 0) >= 3 && (categoryCount.product || 0) === 0 && !gameState.backlashFired && Math.random() > 0.5) {
            const outcome = outcomeCards.challenges.find(c => c.trigger === "public_backlash");
            if (outcome) {
                queueOutcomeCard(outcome);
                gameState.backlashFired = true;
            }
        }

        // Complexity challenge: lots of features built on little validation, with no guided
        // onboarding to soften it => product too hard to use (fires once)
        if ((categoryCount.product || 0) >= 3 && (categoryCount.validation || 0) <= 1 &&
            !gameState.selectedCards.some(c => c.title === "Guided Product Tour") &&
            !gameState.onboardingFired && Math.random() > 0.5) {
            const outcome = outcomeCards.challenges.find(c => c.trigger === "complex_onboarding");
            if (outcome) {
                queueOutcomeCard(outcome);
                gameState.onboardingFired = true;
            }
        }

        // Performance debt: lots of features shipped fast onto a growing user base, but the
        // tech debt was never paid down => the product grinds to a crawl. Solutions point at
        // the Tech Debt Paydown business card. (fires once)
        if ((categoryCount.product || 0) >= 3 && gameState.customers > 150 &&
            !gameState.selectedCards.some(c => c.title === "Tech Debt Paydown") &&
            !gameState.perfDebtFired && Math.random() > 0.5) {
            const outcome = outcomeCards.challenges.find(c => c.trigger === "performance_debt");
            if (outcome) {
                queueOutcomeCard(outcome);
                gameState.perfDebtFired = true;
            }
        }

        // Morale wall: deep into the journey with weak traction => the long haul gets demoralizing (fires once)
        if (gameState.currentMonth > 18 && gameState.monthlyRevenue < 3000 && gameState.customers < 100 && !gameState.longHaulFired && Math.random() > 0.5) {
            const outcome = outcomeCards.challenges.find(c => c.trigger === "long_haul");
            if (outcome) {
                queueOutcomeCard(outcome);
                gameState.longHaulFired = true;
            }
        }

        // Inconsistent experience: a real customer base but lukewarm engagement => reviews
        // come in polarized, scaring off prospects (fires once)
        if (gameState.customers > 150 && gameState.engagement < 35 &&
            !gameState.mixedReviewsFired && Math.random() > 0.5) {
            const outcome = outcomeCards.challenges.find(c => c.trigger === "mixed_reviews");
            if (outcome) {
                queueOutcomeCard(outcome);
                gameState.mixedReviewsFired = true;
            }
        }

        // Legal cover: an ESG/governance commitment OR a General Counsel hire keeps a
        // regulator off your back and defuses the whole fine escalation chain.
        const hasLegalCover = !!categoryCount.esg ||
            gameState.selectedCards.some(c => c.title === "General Counsel" || c.title === "Law Firm on Retainer");

        // Regulatory scrutiny: early sign of trouble for a scaling company with no legal
        // cover — a warning shot before the fines begin (fires once)
        if (gameState.selectedCards.length > 8 && gameState.monthlyRevenue > 4000 &&
            !hasLegalCover && !gameState.auditFired && Math.random() > 0.5) {
            const outcome = outcomeCards.challenges.find(c => c.trigger === "regulatory_audit");
            if (outcome) {
                queueOutcomeCard(outcome);
                gameState.auditFired = true;
            }
        }

        // Compliance gap: operating at real scale and revenue with zero legal cover
        // => a regulator eventually catches a gap and fines you (fires once)
        if (gameState.selectedCards.length > 12 && gameState.monthlyRevenue > 4000 &&
            !hasLegalCover && !gameState.fineFired && Math.random() > 0.5) {
            const outcome = outcomeCards.challenges.find(c => c.trigger === "regulatory_fine");
            if (outcome) {
                queueOutcomeCard(outcome);
                gameState.fineFired = true;
            }
        }

        // Repeat compliance gap: still no legal cover well after the first
        // fine => a harsher second penalty (fires once)
        if (gameState.selectedCards.length > 24 && gameState.monthlyRevenue > 4000 &&
            !hasLegalCover && gameState.fineFired && !gameState.fineRepeatFired && Math.random() > 0.5) {
            const outcome = outcomeCards.challenges.find(c => c.trigger === "regulatory_fine_repeat");
            if (outcome) {
                queueOutcomeCard(outcome);
                gameState.fineRepeatFired = true;
            }
        }

        // Third strike: ignored two fines and still no legal cover => the regulator
        // stops fining and takes you to court — a near-fatal blow (fires once)
        if (gameState.selectedCards.length > 36 && gameState.monthlyRevenue > 4000 &&
            !hasLegalCover && gameState.fineRepeatFired && !gameState.prosecutionFired && Math.random() > 0.5) {
            const outcome = outcomeCards.challenges.find(c => c.trigger === "regulatory_prosecution");
            if (outcome) {
                queueOutcomeCard(outcome);
                gameState.prosecutionFired = true;
            }
        }

        // Success makes you a target: strong growth + visibility => a bigger rival sues
        // to slow you down. Fires once, as a settle-vs-fight fork.
        if (gameState.growth > 20 && gameState.reach > 45 && gameState.monthlyRevenue > 3000 &&
            !gameState.competitorLawsuitFired && Math.random() > 0.5) {
            const opportunity = outcomeCards.opportunities.find(o => o.trigger === "competitor_lawsuit");
            if (opportunity) {
                queueOutcomeCard(opportunity);
                gameState.competitorLawsuitFired = true;
            }
        }

        // Brand isn't landing: weak credibility well into the journey => a rebrand goes on
        // the table, fresh-start upside vs. stay-the-course. Fires once.
        if (gameState.credibility < 35 && gameState.selectedCards.length > 12 &&
            !gameState.rebrandFired && Math.random() > 0.5) {
            const opportunity = outcomeCards.opportunities.find(o => o.trigger === "rebrand_opportunity");
            if (opportunity) {
                queueOutcomeCard(opportunity);
                gameState.rebrandFired = true;
            }
        }

        // Macro downturn: an established company gets hit by a market-wide slump it didn't
        // cause — a sustained climate headwind to weather, not a problem to solve (fires once)
        if (gameState.monthlyRevenue > 5000 && gameState.selectedCards.length > 14 &&
            !gameState.downturnFired && Math.random() > 0.7) {
            const outcome = outcomeCards.challenges.find(c => c.trigger === "market_downturn");
            if (outcome) {
                queueOutcomeCard(outcome);
                gameState.downturnFired = true;
            }
        }

        // Competition emerges from success: real growth and a customer base make your market
        // attractive, so a funded rival enters and starts taking share — out-execute vs. coast.
        // This is the strategic loop: winning draws competition you then have to fight (fires once)
        if (gameState.growth > 25 && gameState.customers > 400 && gameState.monthlyRevenue > 3000 &&
            !gameState.competitorEnteredFired && Math.random() > 0.5) {
            const opportunity = outcomeCards.opportunities.find(o => o.trigger === "competitor_enters");
            if (opportunity) {
                queueOutcomeCard(opportunity);
                gameState.competitorEnteredFired = true;
            }
        }

        // Geopolitical shock: a rare, out-of-nowhere macro event (war) that drags the whole
        // market regardless of how well you've played — pure external risk (fires once, rare)
        if (gameState.selectedCards.length > 10 && !gameState.warFired && Math.random() > 0.85) {
            const outcome = outcomeCards.challenges.find(c => c.trigger === "war_shock");
            if (outcome) {
                queueOutcomeCard(outcome);
                gameState.warFired = true;
            }
        }

        // Numbers are climbing: real growth + early revenue catches an investor's eye, who
        // offers cash for equity — a growth boost now vs. dilution at exit. Fires once,
        // gated below the Series A bar (proven_model) so it reads as an earlier raise.
        if (gameState.growth > 18 && gameState.monthlyRevenue > 1000 && gameState.selectedCards.length > 8 &&
            !gameState.investorRaiseFired && Math.random() > 0.5) {
            const opportunity = outcomeCards.opportunities.find(o => o.trigger === "investor_raise");
            if (opportunity) {
                queueOutcomeCard(opportunity);
                gameState.investorRaiseFired = true;
            }
        }

        // Wellbeing fork: when the founder is overwhelmed, offer a real break vs. pushing on
        if (gameState.stress > 60) {
            const opportunity = outcomeCards.opportunities.find(o => o.trigger === "high_stress");
            if (opportunity && Math.random() > 0.6) {
                queueOutcomeCard(opportunity);
            }
        }

        // Cash crisis: the runway has gone negative and the company is still losing money
        // (insolventSince is set by updateInsolvencyTracker once the grace clock starts).
        // Escalate over the window: a deadline WARNING the moment it begins, then a bank-loan
        // LIFELINE if still underwater a month later. Both are one-shot per episode and reset
        // when the crisis clears (updateInsolvencyTracker), so a relapse warns and offers again.
        if (gameState.insolventSince != null) {
            if (!gameState.cashCrisisWarned) {
                const warn = outcomeCards.challenges.find(c => c.trigger === "cash_crisis_warning");
                if (warn) {
                    queueOutcomeCard(warn);
                    gameState.cashCrisisWarned = true;
                }
            } else if (!gameState.cashCrisisFired &&
                       gameState.currentMonth - gameState.insolventSince >= 1) {
                const loan = outcomeCards.opportunities.find(o => o.trigger === "cash_crisis_loan");
                if (loan) {
                    queueOutcomeCard(loan);
                    gameState.cashCrisisFired = true;
                }
            }
        }
    }

    let outcomeQueue = [];

    function queueOutcomeCard(outcome) {
        if (!outcomeQueue.find(c => c.title === outcome.title)) {
            outcomeQueue.push(outcome);
        }
    }

    // How much of the cash on hand an offer credits. Cash is hard value, so it's
    // added OUTSIDE the health/luck multiplier (a bad luck roll can't discount the
    // bank balance) — but only partially, since the founder never walks with the
    // whole treasury. This keeps the *business* fundamentals, not the cash pile,
    // as what makes an offer good or bad.
    const ACQ_CASH_CREDIT = 0.6;

    // Value the company the way an acquirer roughly would. Enterprise value — a
    // revenue multiple (richer for fast growers) plus strategic value per customer
    // — is tilted by overall health (reputation, reach, confidence; founder burnout
    // drags it down) and a per-acquirer luck swing so some offers come in low and
    // others high. A fraction of the cash balance is then added on top at face.
    function computeAcquisitionOffer() {
        const f01 = (v) => Math.max(0, Math.min(1, v));

        const arr = Math.max(0, gameState.monthlyRevenue) * 12;
        const growthF = f01(gameState.growth / 100);
        const revenueMultiple = 3 + growthF * 5; // 3x–8x ARR
        const revenueValue = arr * revenueMultiple;

        const engagementF = f01(gameState.engagement / 100);
        const perCustomer = 50 + engagementF * 250; // $50–$300 ea.
        const customerValue = gameState.customers * perCustomer;

        const enterpriseValue = revenueValue + customerValue;

        const health = f01((gameState.credibility + gameState.reach + gameState.confidence) / 300);
        const stressDrag = f01(gameState.stress / 100);
        const healthFactor = 0.7 + health * 0.6 - stressDrag * 0.3; // ~0.4–1.3

        const sentiment = 0.75 + Math.random() * 0.5; // ±25% per-acquirer swing

        const cash = Math.max(0, gameState.runway);
        const cashCredit = cash * ACQ_CASH_CREDIT;

        // Floor keeps an early-but-promising company from getting an insulting bid.
        const businessValue = enterpriseValue * healthFactor * sentiment;
        const offerRaw = Math.max(businessValue + cashCredit, 250000);
        const offer = roundOffer(offerRaw);

        // Return the whole derivation, not just the number, so the card can teach
        // the player how an acquirer arrived at the price (see acquisitionBreakdownHTML).
        return {
            offer,
            arr, revenueMultiple, revenueValue,
            customers: gameState.customers, perCustomer, customerValue,
            enterpriseValue, healthFactor, sentiment, businessValue,
            cash, cashCredit,
            // Effective multiple the buyer is paying on the company's current revenue —
            // the headline number a founder cares about ("we sold for Nx revenue").
            effectiveMultiple: arr > 0 ? offer / arr : null
        };
    }

    // The emergency loan repays over this many months, then it's paid off and stops
    // adding to burn (the term is drawn down in updateGameStats).
    const LOAN_TERM_MONTHS = 36; // 3 years

    // Size an emergency loan to the company's actual hole at the moment it surfaces.
    // Principal clears the deficit and buys ~5 months of breathing room — a real shot
    // at a turnaround, not a fortune (banks won't lend a trivial sum or a blank cheque).
    // The repayment adds to monthly burn over a fixed 3-year term (~15% total interest)
    // and then ends — borrowed money isn't free, and a loan you can't out-earn in the
    // meantime only deepens the hole. Overwrites the take-the-loan choice (amount + label),
    // like buildAcquisitionOffer rewrites the exit choice.
    function buildEmergencyLoan(template) {
        const netBurn = Math.max(0, gameState.monthlyBurn - gameState.monthlyRevenue);
        const deficit = Math.max(0, -gameState.runway);
        let principal = deficit + netBurn * 5;
        principal = Math.max(50000, Math.min(principal, 500000));
        principal = Math.round(principal / 5000) * 5000;
        let repayment = principal * 1.15 / LOAN_TERM_MONTHS;
        repayment = Math.max(500, Math.round(repayment / 100) * 100);
        const years = Math.round(LOAN_TERM_MONTHS / 12);

        const card = Object.assign({}, template);
        card.title = `Emergency Bank Loan — ${formatMoney(principal)}`;
        card.description =
            `The cash is gone and you're underwater. The bank will wire <strong>${formatMoney(principal)}</strong> `
            + `to keep the lights on — repaid at <strong>${formatMoney(repayment)}/mo for ${years} years</strong>, `
            + `which adds to your burn until it's paid off. A lifeline if it buys time to turn the corner; a deeper `
            + `hole if you still can't out-earn the gap. The cheaper fix is cutting burn — lay someone off from your Org chart.`;
        card.choices = template.choices.map(choice =>
            choice.impact && choice.impact.loanPrincipal
                ? Object.assign({}, choice, {
                    text: `Take ${formatMoney(principal)}`,
                    impact: Object.assign({}, choice.impact, {
                        loanPrincipal: principal,
                        loanRepayment: repayment,
                        loanTermMonths: LOAN_TERM_MONTHS
                    })
                })
                : choice
        );
        return card;
    }

    // Round to a figure that reads like a real offer ($50k / $100k / $500k steps).
    function roundOffer(v) {
        if (v < 1000000)  return Math.round(v / 50000) * 50000;
        if (v < 10000000) return Math.round(v / 100000) * 100000;
        return Math.round(v / 500000) * 500000;
    }

    // Clone the static acquisition template with a freshly computed price baked
    // into both the description and the "Accept Offer" choice (salePrice drives
    // the exit proceeds; oneTimeRevenue keeps the impact consistent).
    function buildAcquisitionOffer(template) {
        const b = computeAcquisitionOffer();
        const offer = b.offer;
        const card = Object.assign({}, template);
        card.title = `Acquisition Offer — ${formatMoney(offer)}`;
        card.description =
            `A larger company wants to buy your startup for <strong>${formatMoney(offer)}</strong>. `
            + `Take the exit or keep building?`
            + acquisitionBreakdownHTML(b);
        // Carry the full valuation derivation on the exit choice so, if the player
        // accepts, acceptExit can stash it for the post-mortem's "How the buyer
        // valued you" table (the card itself only shows the headline + tip).
        card.choices = template.choices.map(choice =>
            choice.exit
                ? Object.assign({}, choice, {
                    salePrice: offer,
                    acqBreakdown: b,
                    impact: Object.assign({}, choice.impact, { oneTimeRevenue: offer })
                })
                : choice
        );
        return card;
    }

    // Teaching moment, on the card: just the headline (what multiple of revenue
    // this offer represents) and the tip on what acquirers actually pay for. The
    // full step-by-step derivation lives in the post-mortem (see renderExitValuation
    // in company-modal.js) so the card stays scannable.
    function acquisitionBreakdownHTML(b) {
        const mult = (x) => `${x.toFixed(1)}×`;
        const headline = b.effectiveMultiple !== null
            ? `<strong>${mult(b.effectiveMultiple)}</strong> your current annual revenue (${formatMoney(b.arr)} ARR)`
            : `you're pre-revenue, so this offer is for your customer base and momentum — not earnings`;

        return `
            <div class="acq-breakdown">
                <div class="acq-headline">This values you at ${headline}.</div>
                <p class="acq-tip">💡 Acquirers and investors pay for <em>recurring revenue, growth, and a loyal customer base</em>. Grow those, and the multiple grows with you.</p>
            </div>
        `;
    }

    function generateOutcomeCard() {
        if (outcomeQueue.length === 0) return null;

        // Priority cards (e.g. the MVP launch capstone) jump ahead of normal outcomes.
        const priorityIdx = outcomeQueue.findIndex(c => c.priority);
        let outcome = priorityIdx >= 0 ? outcomeQueue.splice(priorityIdx, 1)[0] : outcomeQueue.shift();

        // Cards priced off the company's current health (e.g. the acquisition
        // offer) get their price computed now, at display time, against live state.
        if (outcome.valuation) outcome = buildAcquisitionOffer(outcome);
        // The emergency loan is sized to the live deficit/burn the same way.
        if (outcome.emergencyLoan) outcome = buildEmergencyLoan(outcome);

        const typeConfig = {
            positive: { emoji: "✨", color: "positive" },
            challenge: { emoji: "⚠️", color: "challenge" },
            opportunity: { emoji: "🚀", color: "opportunity" }
        };
        
        const config = typeConfig[outcome.type] || { emoji: "❓", color: "default" };
        let actionsHTML = generateOutcomeActions(outcome);

        // Some outcomes apply a state change only once the card actually surfaces (see
        // applyCardActivateEffect in ui.js). Tag the element so updateStackClasses can
        // run that effect when the card reaches the top of the stack. The effect name
        // matches the trigger for these.
        const DEFERRED_EFFECTS = ['employee_quit', 'employee_moves_on'];
        const activateAttr = DEFERRED_EFFECTS.includes(outcome.trigger)
            ? ` data-activate-effect="${outcome.trigger}"` : '';

        return `
            <div class="business-card ${config.color} outcome-card"${activateAttr}>
                <div class="card-header ${config.color}">
                    <div class="card-type-wrapper">
                        <div><p>Outcome</p></div>
                        <div class="card-type">${outcome.type.toUpperCase()} ${config.emoji}</div>
                    </div>
                    <h2>${outcome.title}</h2>
                    <a class="storyset-link" href="https://storyset.com" target="_blank" rel="noopener">Illustration by Cuate on Storyset</a>
                </div>
                <div class="card-svg-section">
                    <div class="svg-container">
                        <img class="card-img" data-src="${outcome.svg}" alt=""/>
                    </div>
                </div>
                <div class="card-body">
                    <div class="card-content">
                        <div class="content-desc">${outcome.description}</div>
                    </div>
                    ${outcome.followUp ? `
                        <div class="follow-up-section">
                            <strong>Follow-up:</strong> ${outcome.followUp}
                        </div>
                    ` : ''}
                    ${actionsHTML}
                </div>
            </div>
        `;
    }

    function generateOutcomeActions(outcome) {
        if (outcome.type === 'opportunity' && outcome.choices) {
            // Match the swipe convention used on normal cards: the left button is the
            // skip (swipe-left, btn-skip) and the right button is the affirmative
            // (swipe-right, btn-select). The affirmative is the first choice — EXCEPT
            // we never let an irreversible `exit` be the right-swipe default, since
            // swipe-right is the easy/habitual gesture and accepting an exit ends the
            // run. So an exit choice is forced to the left (btn-skip); the player must
            // deliberately swipe left to take it.
            let selectIdx = outcome.choices.findIndex(c => !c.exit);
            if (selectIdx === -1) selectIdx = 0; // all-exit (shouldn't happen) — fall back
            const ordered = outcome.choices
                .map((choice, index) => ({ choice, cls: index === selectIdx ? 'btn-select' : 'btn-skip' }))
                // btn-skip(s) first (left), the single btn-select last (right)
                .sort((a, b) => (a.cls === 'btn-select' ? 1 : 0) - (b.cls === 'btn-select' ? 1 : 0));
            return `
                <div class="action-buttons">
                    ${ordered.map(({ choice, cls }) => `
                        <button class="btn ${cls}"
                                onclick="handleOpportunityChoice(${jsonAttr(choice)}, this)">
                            ${choice.text}
                        </button>
                    `).join('')}
                </div>
            `;
        } else if (outcome.type === 'challenge' && outcome.solutions) {
            return `
                <div class="solutions-section">
                    <h4>💡 Potential Solutions:</h4>
                    <ul class="solutions-list">
                        ${outcome.solutions.map(solution => `<li>${solution}</li>`).join('')}
                    </ul>
                </div>
                <div class="action-buttons">
                    <button class="btn btn-select" onclick="acknowledgeOutcome(${jsonAttr(outcome)}, this)">
                        Acknowledge
                    </button>
                </div>
            `;
        }
        
        return `
            <div class="action-buttons">
                <button class="btn btn-select" onclick="acknowledgeOutcome(${JSON.stringify(outcome).replace(/"/g, '&quot;')}, this)">
                    Acknowledge
                </button>
            </div>
        `;
    }

// Enhanced milestone checking
    function checkRevenueMilestones() {
        if (!gameState.milestonesHit) gameState.milestonesHit = {};
        
        if (gameState.monthlyRevenue >= 1000 && !gameState.milestonesHit.first1k) {
            queueOutcomeCard(outcomeCards.revenueMilestones[0]);
            gameState.milestonesHit.first1k = true;
        }
        
        const netBurn = gameState.monthlyBurn - gameState.monthlyRevenue;
        if (netBurn <= 0 && gameState.monthlyRevenue > 2000 && !gameState.milestonesHit.profitable) {
            queueOutcomeCard(outcomeCards.revenueMilestones[1]);
            gameState.milestonesHit.profitable = true;
        }
    }

// Capstone: validating the idea AND shipping a product feature together make an
// MVP. Fires once, queuing a celebratory launch card that names both milestone
// cards the player picked to get there.
    function checkMVPLaunch() {
        if (!gameState.milestonesHit) gameState.milestonesHit = {};
        if (gameState.milestonesHit.mvpLaunched) return;

        const validationCard = gameState.selectedCards.find(c => c.category === 'validation');
        const productCard = gameState.selectedCards.find(c => c.category === 'product');
        if (!validationCard || !productCard) return;

        // Clone the template so the dynamic, player-specific description doesn't
        // mutate the shared data object.
        const launch = Object.assign({}, outcomeCards.mvpLaunch);
        launch.description =
            `You've turned an idea into something real — your MVP is live! `
            + `Two milestones came together to get you here:`
            + `<ul class="mvp-milestones">`
            + `<li><span class="mvp-check">✓</span> <strong>Validated the idea</strong> &mdash; ${validationCard.title}</li>`
            + `<li><span class="mvp-check">✓</span> <strong>Built your first feature</strong> &mdash; ${productCard.title}</li>`
            + `</ul>`;

        // Record how long it took to reach the MVP — the month it launched. This is
        // the only place timeToMVP is set during normal play (the selections modal
        // reads it). Before launch it stays 0 and the modal shows a dash.
        gameState.timeToMVP = gameState.currentMonth;

        queueOutcomeCard(launch);
        gameState.milestonesHit.mvpLaunched = true;

        // Reflect the new value immediately if the selections modal is pinned open.
        if (typeof updateOpenModals === 'function') updateOpenModals();
    }

;
// endings — terminal "game over" states (see CLAUDE.md / js/game)
//
// The acquisition exit (actions.js → acceptExit) is the WIN ending. This module is
// its mirror: the ways a run can FAIL. Each ending is a config entry below; a check
// runs after every decision (maybeEndRun, called from engine.js) and, when one
// fires, the stack is swept away and a single terminal verdict card is shown.
//
// Adding an ending is ~one config entry + one clause in checkForGameOver():
//   • insolvency — out of cash, underwater past the grace window (money-stress)       — LIVE
//   • ideaFlop   — gave it years, the market never showed up    (broken-light-bulb)  — LIVE
//   • burnout    — founder ran at max stress too long, walked   (overwhelmed)        — LIVE
//
// Verdict cards default to a DARK treatment (white text). Endings whose art is
// coloured dark — the lightbulb and the overwhelmed figure — add the shared
// `is-light` class so they sit on a pale background with dark text instead.

// ── "Idea didn't land" thresholds ───────────────────────────────────────────────
// The slow death: you had the runway and the time, but the market never showed up.
// This is the terminal end of the "long_haul" morale arc — distinct from insolvency
// (which is about money). It only fires after a real, sustained attempt: well past
// the two-year mark, many decisions in, with almost no customers, no revenue, and
// no momentum that might still turn it around. (If you ALSO ran out of cash, the
// insolvency check fires first — running dry is the more immediate cause.)
const FLOP_MIN_MONTH      = 24;   // give it a full two years before calling it
const FLOP_MIN_DECISIONS  = 12;   // and a genuine number of attempts, not a quick quit
const FLOP_MAX_CUSTOMERS  = 50;   // essentially no adoption
const FLOP_MAX_REVENUE    = 1000; // no real revenue
const FLOP_MAX_GROWTH     = 10;   // and no momentum hinting it's about to take off

// ── Burnout thresholds ───────────────────────────────────────────────────────
// The human failure: the founder, not the business, gives out. It doesn't fire the
// instant stress maxes — running hot for one decision is recoverable. It fires only
// after stress stays pinned at the max for BURNOUT_MONTHS of in-game time. Stress
// doesn't decay on its own (only cards move it; see engine.js), so staying maxed is
// a choice — and any decision that brings it back down resets the clock
// (updateBurnoutTracker). The elapsed-month count uses gameState.burnoutSince.
const BURNOUT_STRESS = 100;  // "pinned at the max" (stress is clamped to 100)
const BURNOUT_MONTHS = 3;    // months it must stay there before the founder breaks

// ── Insolvency grace window ────────────────────────────────────────────────────
// Running out of cash is no longer an instant game over. The first time the runway
// goes negative WHILE still losing money each month (no recovery in sight), a clock
// starts (gameState.insolventSince, kept by updateInsolvencyTracker). The doors only
// close if the company stays underwater for this many in-game months — long enough to
// scramble: raise a loan (the emergency card below), cut burn by laying someone off,
// or out-earn the gap. Clawing back to a non-negative runway OR to profitability
// (revenue ≥ burn — climbing out of the hole) clears the clock, so a late comeback is
// genuinely possible. (A negative runway while ALREADY profitable was always survivable
// debt and never starts the clock.)
const INSOLVENCY_GRACE_MONTHS = 6;

const ENDINGS = {
    insolvency: {
        className: 'insolvency',
        svg: 'svg/money-stress-animate.svg',
        kicker: 'The End',
        tag: 'GAME OVER',
        emoji: '💸',
        title: 'Out of money.',
        epitaph(gs) {
            const name = endingEscape(gs.companyName || 'Your startup');
            return `${name} spent months in the red, hoping the next month would close the gap — `
                + `but the bills kept coming and the revenue never caught up. With no cash left to make `
                + `payroll and no loan big enough to fix the math, the doors close.`;
        }
    },
    ideaFlop: {
        className: 'idea-flop is-light',
        svg: 'svg/broken-light-bulb-animate.svg',
        kicker: 'The End',
        tag: 'GAME OVER',
        emoji: '💡',
        title: "The idea didn't land.",
        epitaph(gs) {
            const name = endingEscape(gs.companyName || 'Your startup');
            return `Years in, ${name} never found its people. The product got built and the months `
                + `went by, but the customers never showed up in the numbers it needed. `
                + `Sometimes the market just isn't there — and the hardest call is knowing when to stop.`;
        }
    },
    burnout: {
        className: 'burnout is-light',
        svg: 'svg/overwhelmed-animate.svg',
        kicker: 'The End',
        tag: 'GAME OVER',
        emoji: '🔥',
        title: 'Burnt out.',
        epitaph(gs) {
            const name = endingEscape(gs.companyName || 'Your startup');
            return `For months you ran ${name} on empty — and the late nights stopped adding up to progress. `
                + `No company is worth your health, and a founder who breaks can't build anything. `
                + `You step away to put yourself back together. That takes its own kind of courage.`;
        }
    }
};

// Small local HTML escaper so a player-entered company name can't inject markup
// into the verdict card. Prefer the shared escapeHtml (persistence.js) when present.
function endingEscape(s) {
    if (typeof escapeHtml === 'function') return escapeHtml(s);
    return String(s == null ? '' : s).replace(/[&<>"]/g, c =>
        ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
}

// Decide whether the run has ended, returning the ending key (or null). Called
// after every decision once state has settled.
function checkForGameOver() {
    if (gameState.gameOver || gameState.exited) return null;

    // Insolvency: out of cash and still losing money every month — but no longer an
    // instant cliff. The clock (insolventSince, kept by updateInsolvencyTracker) must
    // have run the full grace window before the doors close, giving the founder months
    // to raise a loan, cut burn, or out-earn the gap. Recovering to a non-negative
    // runway or to profitability clears the clock (mirrors the buy-back-into-the-red
    // model in persistence.js).
    if (gameState.insolventSince != null &&
        gameState.currentMonth - gameState.insolventSince >= INSOLVENCY_GRACE_MONTHS) {
        return 'insolvency';
    }

    // Burnout: stress has stayed pinned at the max for a sustained stretch (the
    // clock is kept by updateBurnoutTracker). Checked before the slow-death flop so
    // a maxed-out founder gets the human ending, not the generic one.
    if (gameState.burnoutSince != null &&
        gameState.currentMonth - gameState.burnoutSince >= BURNOUT_MONTHS) {
        return 'burnout';
    }

    // Idea didn't land: a long, real attempt (time + decisions) that never found
    // traction — almost no customers, no revenue, and no growth still building.
    // The slow death of a company the market never wanted (see thresholds above).
    if (gameState.currentMonth >= FLOP_MIN_MONTH &&
        (gameState.selectedCards || []).length >= FLOP_MIN_DECISIONS &&
        gameState.customers < FLOP_MAX_CUSTOMERS &&
        gameState.monthlyRevenue < FLOP_MAX_REVENUE &&
        gameState.growth < FLOP_MAX_GROWTH) {
        return 'ideaFlop';
    }

    return null;
}

// Advance (or reset) the sustained-max-stress clock that gates the burnout ending.
// Called once per decision from maybeEndRun, after stress has settled. Marks the
// month stress first reached the max; clears the mark the moment it eases off. The
// mark is set to the POST-advance month, so the months that elapsed within the very
// decision that maxed stress don't count — burnout never fires the instant you hit
// the ceiling, only after enduring it (see BURNOUT_* above).
function updateBurnoutTracker() {
    if (gameState.gameOver || gameState.exited) return;
    if (gameState.stress >= BURNOUT_STRESS) {
        if (gameState.burnoutSince == null) gameState.burnoutSince = gameState.currentMonth;
    } else {
        gameState.burnoutSince = null;
    }
}

// Advance (or reset) the insolvency clock that gates the out-of-money ending. Called
// once per decision from maybeEndRun, after the runway/burn/revenue have settled. Marks
// the month the company first went negative-AND-unprofitable; clears the mark — and the
// per-crisis warning/loan flags — the moment it claws back to a non-negative runway or
// to profitability, so recovering resets the deadline and a relapse re-warns. The grace
// window is measured from this mark in checkForGameOver (see INSOLVENCY_GRACE_MONTHS).
function updateInsolvencyTracker() {
    if (gameState.gameOver || gameState.exited) return;
    const underwater = gameState.runway < 0 && gameState.monthlyRevenue < gameState.monthlyBurn;
    if (underwater) {
        if (gameState.insolventSince == null) gameState.insolventSince = gameState.currentMonth;
    } else {
        gameState.insolventSince = null;
        gameState.cashCrisisWarned = false;
        gameState.cashCrisisFired = false;
    }
}

// Run the check and, if the run is over, end it. Sets gameOver SYNCHRONOUSLY so any
// loadMoreCards triggered by the just-finished swipe is short-circuited, then defers
// the verdict render so the card the player swiped finishes dismissing first (380ms
// matches the stack-settle timing in ui.js).
function maybeEndRun() {
    updateBurnoutTracker();
    updateInsolvencyTracker();
    const key = checkForGameOver();
    if (!key) return;
    gameState.gameOver = true;
    gameState.endingKey = key;
    if (typeof saveCurrentGame === 'function') saveCurrentGame();
    setTimeout(() => renderEnding(key), 380);
}

// Sweep the stack (visible + buffered) and drop in the single terminal card.
function renderEnding(key) {
    const ending = ENDINGS[key];
    if (!ending) return;
    const container = domCache.simulatorContainer || document.getElementById('simulatorContainer');
    if (!container) return;

    container.querySelectorAll('.business-card').forEach(c => c.remove());

    const wrap = document.createElement('div');
    wrap.innerHTML = generateEndingCard(ending);
    const card = wrap.firstElementChild;
    if (!card) return;
    container.appendChild(card);

    // Make it the active card and load its image. updateStackClasses may try to
    // top up the stack, but loadMoreCards is gated on gameOver, so nothing loads.
    if (typeof updateStackClasses === 'function') updateStackClasses();
}

// A few headline numbers for the epitaph — how far the run got before it ended.
function buildRunSummary() {
    const gs = gameState;
    const hist = gs.history || [];
    const months = Math.max(0, Math.round(gs.currentMonth - 1));
    let survived;
    if (months < 12) {
        survived = `${months} month${months === 1 ? '' : 's'}`;
    } else {
        const y = Math.floor(months / 12);
        const m = months % 12;
        survived = m ? `${y}y ${m}m` : `${y} year${y === 1 ? '' : 's'}`;
    }
    const peakRevenue = Math.max(gs.monthlyRevenue || 0, ...hist.map(h => h.monthlyRevenue || 0));
    const peakCustomers = Math.max(gs.customers || 0, ...hist.map(h => h.customers || 0));
    return {
        survived,
        peakRevenue,
        peakCustomers,
        decisions: (gs.selectedCards || []).length
    };
}

// The verdict card. Not a flip (there's no front to turn over — the run is simply
// over), so it's a plain no-swipe card styled like the exit back: SVG, an epitaph,
// a short run summary, and the same two onward paths the exit offers.
function generateEndingCard(ending) {
    const s = buildRunSummary();
    const peakRev = typeof formatMoney === 'function' ? formatMoney(s.peakRevenue) : `$${Math.round(s.peakRevenue)}`;
    const peakCust = Math.round(s.peakCustomers).toLocaleString();

    return `
        <div class="business-card no-swipe ending-card ${ending.className}">
            <div class="card-header ending-header">
                <div class="card-type-wrapper">
                    <div><p>${ending.kicker}</p></div>
                    <div class="card-type">${ending.tag}&nbsp; ${ending.emoji}</div>
                </div>
                <h2>${ending.title}</h2>
                <a class="storyset-link" href="https://storyset.com" target="_blank" rel="noopener">Illustration by Cuate on Storyset</a>
            </div>
            <div class="card-svg-section ending-svg-section">
                <div class="svg-container">
                    <img class="card-img" src="${ending.svg}" alt=""/>
                </div>
            </div>
            <div class="card-body ending-body">
                <div class="content-desc ending-epitaph">${ending.epitaph(gameState)}</div>
                <div class="action-buttons ending-actions">
                    <button class="btn btn-postmortem" onclick="openPostMortem()">📖 Read the post-mortem</button>
                    <button class="btn btn-select" onclick="startNewBusiness(0)">Start a new business</button>
                    <a class="btn btn-skip" href="https://dlightning.org/">Build a real business</a>
                </div>
            </div>
        </div>
    `;
}

;
// ui — extracted from biz-sim.js (see CLAUDE.md / js/game)


// Optimized UI update function
    function updateUI() {
        if (!domCache.teamSize) initDOMCache();
        
        // Update team size
        domCache.teamSize.textContent = gameState.teamSize;

        // Update month display with year tracking
        // (getDisplayMonth defined below; declarations hoist, so order is fine)
        const displayMonth = getDisplayMonth();
        if (gameState.currentYear > 1) {
            domCache.currentMonth.textContent = `Y${gameState.currentYear} M${displayMonth}`;
        } else {
            domCache.currentMonth.textContent = `M${displayMonth}`;
        }
        
        // Updated runway display - show actual dollar amount
        let runwayDisplay;
        
        if (gameState.runway >= 1000000) {
            runwayDisplay = '$' + (gameState.runway / 1000000).toFixed(1) + 'M';
        } else if (gameState.runway >= 1000) {
            runwayDisplay = '$' + (gameState.runway / 1000).toFixed(0) + 'K';
        } else if (gameState.runway >= 0) {
            runwayDisplay = '$' + gameState.runway.toFixed(0);
        } else {
            // Handle negative runway
            const absRunway = Math.abs(gameState.runway);
            if (absRunway >= 1000000) {
                runwayDisplay = '-$' + (absRunway / 1000000).toFixed(1) + 'M';
            } else if (absRunway >= 1000) {
                runwayDisplay = '-$' + (absRunway / 1000).toFixed(0) + 'K';
            } else {
                runwayDisplay = '-$' + absRunway.toFixed(0);
            }
        }
        
        domCache.runway.textContent = runwayDisplay;
        // In the red: flag negative runway so the stat shows in dark red (see biz-sim.css).
        domCache.runway.classList.toggle('stat-negative', gameState.runway < 0);
        
        // Update revenue display
        domCache.revenue.textContent = formatMoney(gameState.monthlyRevenue) + '/mo';
    }

// Enhanced selections button update
    function updateSelectionsButtonText() {
        if (!domCache.selectionsBtn) return;
        
        const count = gameState.selectedCards.length;
        const icon = '<i class="fas fa-eye mr-2" aria-hidden="true"></i>';
        domCache.selectionsBtn.innerHTML = count > 0 ?
            `${icon}Selections (${count})` :
            '<i class="fas fa-pencil mr-2" aria-hidden="true"></i>Selections';
    }

// Optimized company name update
    function updateCompanyName() {
        if (!domCache.companyName) return;
        
        const names = [
            "InnovateCorp", "VentureFlow", "BuildFast Inc", "ScaleUp Labs", 
            "NextGen Ventures", "DisruptTech", "GrowthEngine Co", "LaunchPad Inc",
            "StartupForge", "RapidScale", "TechCatalyst", "BuildForward",
            "Nudgeloop", "Threadbare AI", "Siltbox", "Quorumly",
            "Flickerpath", "Halftide", "Driftloom", "Parcelmind",
            "Tinkergrain", "Cobweb Systems", "Helix & Hearth", "Softcellar",
            "Kindling Health", "Dormant Labs", "Sparrowbone", "Warmstart",
            "Borrowed Sun", "Thawline", "Patchwork Earth", "Secondgrowth",
            "Dewpoint Grid", "Pennyjarrel", "Ledgerloft", "Trustgap",
            "Smallchange", "Coinquest", "Sunday Habit", "The Good Enough",
            "Thirdshelf", "Slowcart", "Homeroom Goods", "Wobble & Co.",
            "Draftling", "Scribblegate", "Moodboardly", "Pixelmoss",
            "Roughcut", "Vantaflux", "Kernal", "Brightdrift",
            "Stackmorrow", "Plainworks", "Coastline", "The Loop"
        ];
        const randomName = names[Math.floor(Math.random() * names.length)];
        // update game state
        gameState.companyName = randomName;
        domCache.companyName.textContent = randomName;
    }

// Function to check if we're on a large screen
    function isLargeScreen() {
        return window.innerWidth >= 1330;
    }

// Function to update both modals if they're open
    function updateOpenModals() {
        // Update selections modal if it's open
        const selectionsModal = document.getElementById('selectionsModal');
        if (selectionsModal && selectionsModal.style.display === 'flex') {
            populateSelections();
        }
        
        // Update company metrics modal if it's open. Refresh every pane so a new
        // hire / decision (or a just-loaded save) shows up immediately whichever
        // tab is showing (the modal stays pinned open on large screens).
        const companyMetricsModal = document.getElementById('companyMetricsModal');
        if (companyMetricsModal && companyMetricsModal.style.display === 'flex') {
            populateCompanyMetrics();
            const orgPane = document.getElementById('companyOrgBody');
            if (orgPane && !orgPane.hidden) populateOrgChart();
            const storyPane = document.getElementById('companyStoryBody');
            if (storyPane && !storyPane.hidden) populateCompanyStory();
        }
    }

    // Deferred outcome effects: applied when the tagged card reaches the top of the
    // stack (see data-activate-effect in generateOutcomeCard + the index===0 hook in
    // updateStackClasses). Fired at most once per card via the activateFired guard.
    function applyCardActivateEffect(effect, cardEl) {
        if (effect === 'employee_quit') {
            const emp = (typeof removeMostJuniorEmployee === 'function') ? removeMostJuniorEmployee() : null;
            // Cite a real reason they left — one of the neglected investments currently
            // in play (see getAttritionReasons) — so the player learns what to fix.
            const reasonText = {
                no_growth:     "there was no path to grow their skills or career here",
                rigid_work:    "the rigid, always-in-office setup wore them down",
                no_cohesion:   "they never felt connected to the rest of the team",
                no_innovation: "the work had gone stale, with nothing new to build",
                burnout:       "the relentless pressure burned them out"
            };
            const reasons = (typeof getAttritionReasons === 'function') ? getAttritionReasons() : [];
            const reason = reasons.length
                ? reasonText[reasons[Math.floor(Math.random() * reasons.length)]]
                : "they've found a better opportunity elsewhere";
            // Name whoever actually walked, so the player always knows who they lost.
            const desc = cardEl.querySelector('.content-desc');
            if (desc) {
                desc.innerHTML = emp
                    ? `<strong>${emp.name}</strong>, your ${(emp.level || '').toLowerCase()} ${emp.role || 'team member'}, `
                      + `has handed in their notice — ${reason}.`
                    : `One of your team has handed in their notice — ${reason}.`;
            }
            // Reflect the smaller team / lower burn immediately (updateUI, org chart, save).
            if (typeof afterTeamChange === 'function') afterTeamChange();
        } else if (effect === 'employee_moves_on') {
            // A long-serving junior leaves for a bigger role elsewhere — happy and sad.
            const emp = (typeof removeLongTenuredJunior === 'function') ? removeLongTenuredJunior() : null;
            const desc = cardEl.querySelector('.content-desc');
            if (desc) {
                const yrs = emp && typeof employeeYearsOfService === 'function'
                    ? Math.max(1, Math.floor(employeeYearsOfService(emp))) : null;
                desc.innerHTML = emp
                    ? `<strong>${emp.name}</strong>, your ${(emp.level || '').toLowerCase()} ${emp.role || 'team member'}, `
                      + `has landed a bigger role at another company after ${yrs}+ years with you. `
                      + `Happy and sad to see them go — people who got their start here going on to great things is its own kind of win.`
                    : `One of your longest-serving team members has landed a bigger role elsewhere — happy and sad to see them go.`;
            }
            if (typeof afterTeamChange === 'function') afterTeamChange();
        }
    }

// Stack management
    function updateStackClasses() {
        const container = domCache.simulatorContainer || document.getElementById('simulatorContainer');
        const cards = Array.from(container.querySelectorAll('.business-card:not(.dismissing-skip):not(.dismissing-select)'));

        cards.forEach((card, index) => {
            // Remember whether this card was already part of the visible stack so we
            // can tell a promotion (card moving up a slot) from a fresh reveal.
            const wasVisible = card.classList.contains('stack-active') ||
                               card.classList.contains('stack-next') ||
                               card.classList.contains('stack-third');
            card.classList.remove('stack-active', 'stack-next', 'stack-third');
            delete card.dataset.pendingThird;
            // Only the top card is interactive — keep the cards behind it out of the
            // tab order and the accessibility tree so keyboard/screen-reader users
            // aren't trapped cycling through buttons they can't see.
            const isActive = index === 0;
            card.inert = !isActive;
            card.setAttribute('aria-hidden', isActive ? 'false' : 'true');
            if (isActive) {
                // Make the top card itself a focusable target so keyboard users can
                // flip it and use the arrow-key shortcuts (see swipe-cards.js).
                card.tabIndex = 0;
                card.setAttribute('role', 'group');
                card.setAttribute('aria-roledescription', 'Decision card');
                card.setAttribute('aria-describedby', 'cardKeyHelp');
                card.setAttribute('aria-keyshortcuts', 'ArrowRight ArrowLeft Enter');
            } else {
                card.tabIndex = -1;
            }
            if (index === 0) {
                card.classList.add('stack-active');
                loadImageForCard(card);       // fresh element → animation from frame 0
                // Run any deferred state change now that this card has reached the top,
                // so the effect lands on the same beat the player sees the card.
                if (card.dataset.activateEffect && !card.dataset.activateFired) {
                    card.dataset.activateFired = '1';
                    applyCardActivateEffect(card.dataset.activateEffect, card);
                }
            } else if (index === 1) {
                card.classList.add('stack-next');
                warmImageCache(card);         // fetch bytes into cache, don't start SVG
            } else if (index === 2) {
                if (wasVisible || !gameState.hasInteracted) {
                    // Already in the stack (just promoting up a slot), or the very
                    // first render — reveal immediately.
                    card.classList.add('stack-third');
                } else {
                    // A fresh card entering the bottom slot from the hidden buffer.
                    // Revealing it now would fade it in *underneath* the cards still
                    // animating upward, so it appears to "leak" through. Wait for the
                    // promotion transition (0.35s) to settle, then fade it in alone.
                    card.dataset.pendingThird = 'true';
                    setTimeout(() => {
                        if (card.isConnected && card.dataset.pendingThird === 'true') {
                            delete card.dataset.pendingThird;
                            card.classList.add('stack-third');
                        }
                    }, 380);
                }
            }
        });

        // After a card is dismissed its focus is lost to <body>; move focus to the
        // new top card so keyboard users keep their place. Guarded on hasInteracted
        // so the page doesn't grab focus on first load.
        if (gameState.hasInteracted && cards[0] && document.activeElement === document.body) {
            const next = cards[0];
            next.focus();
            // Programmatic focus doesn't trigger :focus-visible, so show an explicit
            // ring only when the dismissal came from the keyboard (not a swipe/click).
            if (gameState.lastActionViaKeyboard) {
                next.classList.add('kbd-focus');
                next.addEventListener('blur', () => next.classList.remove('kbd-focus'), { once: true });
            }
        }

        if (cards.length < 4 && !isLoading) {
            loadMoreCards(3);
        }
    }

    // Warm the network cache for the upcoming card's SVG, without painting
    // anything visible — so a cached SVG can later appear instantly with its
    // intro animation intact, rather than always flashing a placeholder.
    function warmImageCache(card) {
        const img = card.querySelector('img[data-src]:not([data-precached]):not([data-loaded])');
        if (img && img.dataset.src) {
            new Image().src = img.dataset.src; // pre-fetch real SVG into cache
            img.dataset.precached = 'true';
        }
    }

    function loadImageForCard(card) {
        const slot = card.querySelector('img[data-src]:not([data-loaded])');
        if (!slot || !slot.dataset.src) return;

        // Mark handled immediately so repeat calls from updateStackClasses
        // don't insert a second image.
        slot.dataset.loaded = 'true';

        const container = slot.parentNode;
        const realSrc = slot.dataset.src;

        // Fresh element guarantees the SVG's intro animation plays from frame 0.
        // No placeholder: SVGs are tiny (<100kb) and load fast even on slow
        // connections, so we just show the real image the moment it's ready and
        // never flash a placeholder. The empty slot holds the card's fixed
        // height until the real image is in.
        const real = document.createElement('img');
        real.className = slot.className;
        real.alt = '';
        real.dataset.loaded = 'true';
        real.style.opacity = '0';
        container.insertBefore(real, slot);

        real.addEventListener('load', function () {
            real.style.opacity = '1';
            slot.remove();
        }, { once: true });

        real.src = realSrc; // instant if cached → load fires almost immediately
    }

;
// actions — extracted from biz-sim.js (see CLAUDE.md / js/game)


// Enhanced card selection with real calendar dates
    function selectCard(button, card) {
        const cardElement = button.closest('.business-card');
        const alreadyFlung = cardElement.dataset.swiping;
        gameState.hasInteracted = true;

        // Only add dismiss animation if swipe-cards.js hasn't already flung it
        if (!alreadyFlung) {
            cardElement.classList.add('selected-card', 'dismissing-select');
        }

        const currentGameDate = getCurrentGameDate();
        card.selectedAt = formatGameDate(currentGameDate);
        card.selectedAtDate = new Date(currentGameDate);
        card.selectedMonth = gameState.currentMonth;
        card.selectedYear = gameState.currentYear;
        card.relativeTime = getRelativeTimeDescription(currentGameDate, gameState.founded);

        gameState.selectedCards.push(card);
        updateGameStats(card);

        // A hire or a newly-adopted process reshapes the team's capacity, so the
        // timelines of cards still in the stack should re-estimate right away.
        if (isHireCard(card) || (typeof PROCESS_TIME_EFFECTS !== 'undefined' && PROCESS_TIME_EFFECTS[card.title])) {
            if (typeof reestimateStackCards === 'function') reestimateStackCards();
        }

        if (isLargeScreen()) {
            updateOpenModals();
        }

        // Match the fling duration (280ms) when swiped, otherwise use button duration
        setTimeout(() => {
            cardElement.remove();
            updateStackClasses();
        }, alreadyFlung ? 300 : 350);
    }

    function skipCard(button) {
        const cardElement = button.closest('.business-card');
        const alreadyFlung = cardElement.dataset.swiping;
        gameState.hasInteracted = true;

        if (!alreadyFlung) {
            cardElement.classList.add('skipped-card', 'dismissing-skip');
        }

        setTimeout(() => {
            cardElement.remove();
            updateStackClasses();
        }, alreadyFlung ? 300 : 350);
    }

    function handleOpportunityChoice(choice, button) {
        // An exit (e.g. accepting an acquisition) ends this company instead of
        // applying an impact — flip the card to a congratulations back.
        if (choice.exit) {
            acceptExit(choice, button);
            return;
        }
        // selectCard records the card and calls updateGameStats once — don't
        // pre-apply the impact here or it gets counted multiple times.
        selectCard(button, {
            title: choice.text,
            description: `Chose: ${choice.text}`,
            impact: choice.impact,
            category: 'outcome'
        });
    }

    // Accepting an acquisition: the player cashes out. Compute their take-home
    // proceeds (sale price minus any co-founder's equity slice), then flip the
    // outcome card over to a "Congratulations on your exit" back with two paths:
    // start fresh with the cash, or go build a real business.
    function acceptExit(choice, button) {
        const cardElement = button.closest('.business-card');
        if (!cardElement || cardElement.dataset.exited) return;
        cardElement.dataset.exited = 'true';

        // If this exit was triggered by a swipe or arrow-key fling, the card was
        // just animated off-screen (translateX/opacity:0) before the button fired.
        // An exit keeps the card in place and flips it to a congrats screen, so undo
        // the fling here — otherwise that screen renders on an invisible, flung-away
        // card and the game looks frozen.
        delete cardElement.dataset.swiping;
        cardElement.style.transition = '';
        cardElement.style.transform = '';
        cardElement.style.opacity = '';

        const salePrice = choice.salePrice || (choice.impact && choice.impact.oneTimeRevenue) || 0;
        const cofounder = (gameState.employees || []).find(e => e.coFounder);
        const equityPct = cofounder ? (cofounder.equity || 0) : 0;
        const cofounderCut = Math.round(salePrice * equityPct / 100);
        const investorPct = gameState.investorEquity || 0;
        const investorCut = Math.round(salePrice * investorPct / 100);
        const proceeds = salePrice - cofounderCut - investorCut;

        // Tag the saved run as a completed exit so the picker can badge it, and
        // record what it sold for (the buy-back price if the founder later returns).
        // Persist that before the page reloads into a new business.
        gameState.exited = true;
        gameState.exitSalePrice = salePrice;
        // Keep the accepted offer's valuation derivation for the post-mortem's
        // "How the buyer valued you" breakdown (buildAcquisitionOffer attaches it).
        if (choice.acqBreakdown) gameState.exitValuation = choice.acqBreakdown;
        if (typeof saveCurrentGame === 'function') saveCurrentGame();

        // Carve-out preamble from whichever equity holders exist (co-founder and/or
        // investors); if neither, the founder keeps the whole sale price.
        const stakeParts = [];
        if (cofounder) stakeParts.push(`${cofounder.name}'s ${equityPct}% co-founder stake (${formatMoney(cofounderCut)})`);
        if (investorPct > 0) stakeParts.push(`investors' ${investorPct}% stake (${formatMoney(investorCut)})`);
        const splitLine = stakeParts.length
            ? `After ${stakeParts.join(' and ')}, you walk away with`
            : `You walk away with`;

        // Keep the real offer as the front face so the flip reads as THIS card
        // turning over — just wrap it in the flip scaffolding and bolt on a
        // congratulations back. The front's Accept/Keep buttons are dropped so a
        // flip-back can't re-trigger the deal.
        const frontContent = cardElement.innerHTML;
        cardElement.classList.remove('outcome-card');
        cardElement.classList.add('flippable', 'exit-card');
        cardElement.innerHTML = `
            <div class="card-inner">
                <div class="card-face card-front">${frontContent}</div>
                <div class="card-face card-back exit-back">
                    <div class="card-header opportunity card-back-header">
                        <div class="card-type-wrapper">
                            <div><p>Exit</p></div>
                            <div class="card-type">CONGRATS&nbsp; 🎉</div>
                        </div>
                        <h2>Congratulations on your exit!</h2>
                        <a class="storyset-link" href="https://storyset.com" target="_blank" rel="noopener">Illustration by Cuate on Storyset</a>
                    </div>
                    <div class="card-svg-section exit-svg-section">
                        <div class="svg-container">
                            <img class="card-img" src="svg/celebration-animate.svg" alt=""/>
                        </div>
                    </div>
                    <div class="card-body card-back-body">
                        <div class="content-desc">
                            You sold ${gameState.companyName} for ${formatMoney(salePrice)}.
                            ${splitLine}
                        </div>
                        <div class="exit-proceeds">${formatMoney(proceeds)}</div>
                        <div class="content-desc exit-next-prompt">What's next?</div>
                        <div class="action-buttons exit-actions">
                            <button class="btn btn-postmortem" onclick="openPostMortem()">📖 Read the story</button>
                            <button class="btn btn-select" onclick="startNewBusiness(${proceeds})">Start a new business</button>
                            <a class="btn btn-skip" href="https://dlightning.org/">Build a real business</a>
                        </div>
                        <button type="button" class="exit-give-away" onclick="giveItAway(this, ${proceeds})">…or give it all away 🕊️</button>
                    </div>
                </div>
            </div>
        `;
        cardElement.querySelector('.card-front .action-buttons')?.remove();

        // Play the same lift-and-flip used elsewhere, locked to the back face.
        const inner = cardElement.querySelector('.card-inner');
        requestAnimationFrame(() => {
            cardElement.classList.add('flipped');
            if (inner) {
                inner.style.animation = 'none';
                void inner.offsetWidth; // force reflow so the animation restarts
                inner.style.animation = 'cardFlipToBack 0.6s cubic-bezier(0.4, 0, 0.2, 1) forwards';
            }
            cardElement.classList.add('flipping', 'flip-to-back');
            setTimeout(() => cardElement.classList.remove('flipping', 'flip-to-back'), 600);
        });
    }

    // Restart the simulator with the exit proceeds as the new starting runway. A
    // reload is the cleanest reset; the proceeds are stashed in sessionStorage (not
    // the URL, which would be trivially editable) for initializeSimulator to pick up
    // and consume on the next load. Navigate to the bare path so any stale query is dropped.
    function startNewBusiness(proceeds) {
        try {
            sessionStorage.setItem('startupSim:proceeds', String(Math.round(proceeds)));
        } catch (e) { /* sessionStorage unavailable — runway just starts at the default */ }
        window.location.href = window.location.pathname;
    }

    // The quiet third path on the exit screen: instead of pocketing the proceeds
    // or starting over with them, give it all away. Counts the take-home number
    // down to $0 (so the gesture is felt, not just stated), rewrites the copy,
    // and points at a real place to actually do it. Fires once per exit card.
    function giveItAway(button, proceeds) {
        const back = button.closest('.exit-back');
        if (!back || back.dataset.gaveItAway) return;
        back.dataset.gaveItAway = 'true';

        const amount = Math.max(0, Math.round(proceeds));
        const proceedsEl = back.querySelector('.exit-proceeds');
        const promptEl = back.querySelector('.exit-next-prompt');
        const actions = back.querySelector('.exit-actions');

        // The link is spent; hide the two original choices while the number falls.
        button.remove();
        if (actions) actions.style.visibility = 'hidden';
        if (promptEl) promptEl.textContent = 'Giving it all away…';

        const DURATION = 1100;
        const start = performance.now();
        (function tick(now) {
            const t = Math.min(1, (now - start) / DURATION);
            const eased = 1 - Math.pow(1 - t, 3); // ease-out so it slows as it lands on $0
            if (proceedsEl) proceedsEl.textContent = formatMoney(Math.round(amount * (1 - eased)));
            if (t < 1) {
                requestAnimationFrame(tick);
                return;
            }
            // Landed on zero — reframe the screen around the gesture.
            if (proceedsEl) proceedsEl.classList.add('given');
            if (promptEl) {
                promptEl.innerHTML = `You gave away ${formatMoney(amount)}.<br>Some founders measure success differently.`;
            }
            if (actions) {
                actions.style.visibility = '';
                actions.innerHTML = `
                    <a class="btn btn-select" href="https://www.coolearth.org/" target="_blank" rel="noopener">Do it for real → Cool Earth</a>
                    <button class="btn btn-skip" onclick="startNewBusiness(0)">Start over with nothing</button>
                `;
            }
        })(performance.now());
    }

    function acknowledgeOutcome(outcome, button) {
        // selectCard applies the impact via updateGameStats — don't double-apply here.
        selectCard(button, outcome);
    }

// Card loading for stack
    function loadMoreCards(cardCount = CARD_RENDER_BATCH_SIZE, skipOutcomeChecks = false) {
        // The run is over (see endings.js) — the verdict card is the only card left,
        // so never top up the stack again.
        if (isLoading || gameState.gameOver) return;
        isLoading = true;

        const container = domCache.simulatorContainer || document.getElementById('simulatorContainer');

        // The first deal of a freshly loaded save skips outcome evaluation: a restored
        // company often still satisfies past conditions, and re-checking here would
        // surface a stale event (e.g. Launch Day Disaster) as the very first card. The
        // next batch re-checks as normal, and the milestone/MVP guards mean nothing is
        // permanently missed.
        if (!skipOutcomeChecks) {
            checkForOutcomes();
            checkRevenueMilestones();
            checkMVPLaunch();
        }

        // Add outcome card if queued. Normally a 25% chance per batch, but a
        // priority card (e.g. the MVP launch capstone) is shown right away.
        if (outcomeQueue.length > 0 && (outcomeQueue.some(c => c.priority) || Math.random() > 0.75)) {
            const outcomeHTML = generateOutcomeCard();
            if (outcomeHTML) {
                const cardElement = document.createElement('div');
                cardElement.innerHTML = outcomeHTML;
                container.appendChild(cardElement.firstElementChild);
                cardCount--;
            }
        }

        const fragment = document.createDocumentFragment();
        for (let i = 0; i < cardCount; i++) {
            const cardHTML = generateBusinessCard();
            const cardElement = document.createElement('div');
            cardElement.innerHTML = cardHTML;
            fragment.appendChild(cardElement.firstElementChild);
        }
        container.appendChild(fragment);

        isLoading = false;

        // Double rAF to ensure initial opacity:0 renders before transition
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                updateStackClasses();
            });
        });
    }

;
// js/game/story.js
// Company Story + Post-mortem feature, extracted from company-modal.js.
//
// Surfaces the Story tab inside the company modal: a shareable first-person
// narrative of the run (archetype, story-arc prose, a rasterized share card) plus
// the end-of-run post-mortem that the verdict/exit cards link into via openPostMortem().
//
// Loaded as a plain <script> (no modules/build), so everything here is page-global.
// Entry points called from elsewhere: populateCompanyStory() (ui.js, switchCompanyTab),
// shareCompanyStory() (inline onclick), openPostMortem() (actions.js, endings.js).
// Depends on these globals from company-modal.js: formatCurrency, showAlertDialog,
// showCompanyMetricsModal, switchCompanyTab, getCompanyMonthlySeries.

// ---- Company story (shareable narrative) ----
// Stitches gameState + the player's selections into a natural-language summary of
// the company, surfaced on the Story tab with a share button. Phrase tables below
// map specific card titles to story fragments; unmapped cards just don't contribute
// a clause, so the story stays readable no matter what's been picked.

// Notable business-model cards → a "we're <building ...>" clause (most recent wins).
const STORY_MODEL_PHRASES = {
    "Freemium SaaS": "building a freemium SaaS",
    "Enterprise Licensing": "selling enterprise software",
    "Marketplace Commission": "running a marketplace",
    "Subscription Tiers": "running a subscription business",
    "Global Expansion": "scaling a global business"
};

// Product cards → a short "with ..." clause describing what we've built.
const STORY_PRODUCT_PHRASES = {
    "Real-time Collaboration": "collaboration built in",
    "AI-Powered Recommendations": "an AI recommendation engine",
    "Mobile Application": "native mobile apps",
    "Integration Marketplace": "deep third-party integrations",
    "Customizable Workflows": "fully customizable workflows",
    "Multi-Format Export": "open data import and export",
    "Focus Mode": "a distraction-free focus mode",
    "Carbon Calculator Integration": "a built-in carbon tracker",
    "Proprietary Hardware": "our own custom hardware"
};

// ESG cards → a values clause ("We ...") for the story's mission sentence.
const STORY_VALUES_PHRASES = {
    "Profit & Purpose Balance": "We believe in balancing profit with purpose",
    "1% for the Planet": "We pledge 1% of revenue back to the planet",
    "Carbon Neutral Pledge": "We're committed to carbon neutrality",
    "Divest from Big Oil": "We've turned our back on fossil fuels",
    "Circular Economy Pledge": "We design out waste with a circular model",
    "B-Corp Pitch Deck": "We're on the path to B-Corp certification",
    "Ethical AI Guidelines": "We hold ourselves to clear ethical-AI standards",
    "Community Volunteer Program": "We give our team paid time to give back",
    "Sustainable by Design": "Sustainability is built into everything we make",
    "Open Knowledge Sharing": "We share our tools and playbooks openly",
    "Supply Chain Audit": "We hold our supply chain to ethical standards"
};

// Business cards that represent a corporate partnership / channel deal — counted
// for the "with N corporate partners" traction line.
const STORY_PARTNER_TITLES = new Set([
    "Enterprise Licensing",
    "International Distribution Deal",
    "Distributed Operations",
    "Global Expansion"
]);

// Oxford-style list join: ["a"] -> "a"; ["a","b"] -> "a and b"; 3+ -> "a, b, and c".
function joinStoryList(items) {
    if (items.length <= 1) return items[0] || '';
    if (items.length === 2) return `${items[0]} and ${items[1]}`;
    return `${items.slice(0, -1).join(', ')}, and ${items[items.length - 1]}`;
}

// Rough, game-flavored company valuation: a growth-scaled revenue multiple (3x–8x
// ARR), with a customer-base floor so pre/low-revenue companies still read sensibly.
function estimateValuation() {
    const arr = gameState.monthlyRevenue * 12;
    const multiple = 3 + Math.min(5, gameState.growth / 20);
    return Math.max(arr * multiple, gameState.customers * 120, 50000);
}

// "N years/months after founding" from the elapsed in-game months. In-game time
// accrues in fractional months, so round for display (raw values look like
// "1.2999999999999998 months").
function companyAgePhrase() {
    const months = Math.max(0, gameState.currentMonth - 1);
    if (months < 1) return 'fresh out of founding';
    if (months < 12) {
        const m = Math.round(months);
        return `just ${m} month${m === 1 ? '' : 's'} after founding`;
    }
    const years = Math.round(months / 12 * 10) / 10; // one decimal, float-safe
    const label = Number.isInteger(years) ? String(years) : years.toFixed(1);
    return `${label} year${years === 1 ? '' : 's'} after founding`;
}

// Distill the whole run into a single shareable "founder archetype" — the identity
// hook for the Story tab ("what kind of founder are you?"). Rules are checked in
// priority order, most defining first, so the first match wins; the final entry is
// an always-true catch-all. Each returns { emoji, name, blurb }.
function deriveFounderArchetype() {
    const gs = gameState;
    const decisions = (gs.selectedCards || []).filter(c => c.category !== 'outcome');
    const esgCount = decisions.filter(c => c.category === 'esg').length;
    const challengesSurvived = (gs.selectedCards || [])
        .filter(c => c.category === 'outcome' && c.type === 'challenge').length;
    const netIncome = gs.monthlyRevenue - gs.monthlyBurn;
    const profitable = gs.monthlyRevenue > 0 && netIncome > 0;
    // Profit MARGIN, not raw revenue — "printing money" should mean an efficient,
    // genuinely profitable operation, not just a big top line barely clearing its burn.
    const margin = gs.monthlyRevenue > 0 ? netIncome / gs.monthlyRevenue : 0;
    const runwayMonths = gs.runway > 0 ? gs.runway / Math.max(1, gs.monthlyBurn) : 0;
    const monthsElapsed = Math.max(0, gs.currentMonth - 1);

    if (decisions.length < 3)
        return { emoji: '🌱', name: 'The Dreamer', blurb: 'Still getting the idea off the ground.', colors: ['#16a34a', '#15803d'] };
    if (monthsElapsed >= 4 && !profitable && runwayMonths < 4)
        return { emoji: '⛽', name: 'Running on Fumes', blurb: 'Betting it all on the next move.', colors: ['#ef4444', '#b91c1c'] };
    if (gs.growth >= 40 && netIncome < 0)
        return { emoji: '🚀', name: 'The Rocketship', blurb: 'Growth at all costs — and the costs are real.', colors: ['#3b82f6', '#1e3a8a'] };
    if (esgCount >= 3 || (esgCount >= 4 && gs.credibility >= 50))
        return { emoji: '🌍', name: 'The Mission-Driven Founder', blurb: 'Proof you can do well by doing good.', colors: ['#0d9488', '#0f766e'] };
    if (gs.reach >= 45 && gs.engagement < 25)
        return { emoji: '📣', name: 'The Hype Machine', blurb: "Everyone's heard of you — now make them stay.", colors: ['#f97316', '#ea580c'] };
    if (gs.engagement >= 55)
        return { emoji: '❤️', name: 'The Cult Favorite', blurb: 'A loyal crowd that would follow you anywhere.', colors: ['#ec4899', '#be185d'] };
    if (gs.teamSize >= 8)
        return { emoji: '🏛️', name: 'The Empire Builder', blurb: 'Building something built to last.', colors: ['#6366f1', '#4338ca'] };
    // Demoted below the personality archetypes (so a profitable mission-driven /
    // cult-favorite / empire reads as THAT, not just "Cash Machine") and tightened to
    // a real money-printer bar: a fat margin on serious revenue. Above Bootstrapper, so
    // an efficient earner is a Cash Machine, while merely-profitable-and-lean is not.
    if (profitable && gs.monthlyRevenue >= 60000 && margin >= 0.35)
        return { emoji: '💸', name: 'The Cash Machine', blurb: 'Printing money, month after month.', colors: ['#059669', '#047857'] };
    if (profitable && gs.teamSize <= 5)
        return { emoji: '🥾', name: 'The Bootstrapper', blurb: 'Lean, profitable, and beholden to no one.', colors: ['#d97706', '#b45309'] };
    if (challengesSurvived >= 3)
        return { emoji: '🛡️', name: 'The Survivor', blurb: 'Took the hits and kept on building.', colors: ['#0ea5e9', '#0369a1'] };
    if (gs.teamSize === 1 && monthsElapsed >= 9)
        return { emoji: '🐺', name: 'The Lone Wolf', blurb: 'One founder, no excuses.', colors: ['#64748b', '#334155'] };
    return { emoji: '🧭', name: 'The Operator', blurb: 'Steadily turning decisions into a real company.', colors: ['#1e3a8a', '#3730a3'] };
}

// Outcome cards whose *title* survives into selectedCards (challenges, milestones and
// notable positives all go through acknowledgeOutcome, which keeps the original card)
// map here to a story beat. NB: opportunity cards do NOT — handleOpportunityChoice
// records the chosen option's text, not the opportunity's name — so raises/pivots are
// mined from the history time-series and the decision log instead (see below).
// Each entry: { priority, mood, clause(name, date) -> first-person fragment }. The
// fragment weaves the date in itself, starts lowercase and ends without a period — the
// composer capitalizes it and stitches it into a sentence. Higher priority survives the
// "most dramatic beats" cut on long runs.
const STORY_MILESTONE_BEATS = {
    "First $1K MRR! 🎉":             { priority: 6, mood: 'up', clause: (n, d) => `in ${d}, we banked our first $1K of recurring revenue — small money, enormous proof` },
    "Ramen Profitability Achieved":  { priority: 7, mood: 'up', clause: (n, d) => `by ${d}, we'd reached ramen profitability and were finally paying our own way` },
    "Industry Award":                { priority: 5, mood: 'up', clause: (n, d) => `in ${d}, the industry took notice and handed us an award` },
    "Viral Product Demo":            { priority: 5, mood: 'up', clause: (n, d) => `a demo of ours caught fire in ${d} and raced across the internet` },
    "Partnership Goldmine":          { priority: 5, mood: 'up', clause: (n, d) => `in ${d}, a breakthrough partnership fell into place` },
    "Audience Takes Off":            { priority: 4, mood: 'up', clause: (n, d) => `around ${d}, our audience finally caught on and took off` },
    "Key Hire Success":              { priority: 4, mood: 'up', clause: (n, d) => `one pivotal hire in ${d} quietly changed everything for us` },
    "MVP Launched!":                 { priority: 6, mood: 'up', clause: (n, d) => `in ${d}, we shipped our first real product into the world — the MVP was finally live` },
    "Early Customer Traction":       { priority: 5, mood: 'up', clause: (n, d) => `in ${d}, our earliest conversations turned into our first pre-orders — proof the thing might actually work` },
    "Loyal Customer Base":           { priority: 5, mood: 'up', clause: (n, d) => `by ${d}, our obsession with support had paid off — customers were sticking around and pulling their friends in` },
    "Glowing Reviews":               { priority: 4, mood: 'up', clause: (n, d) => `in ${d}, the five-star reviews started rolling in and the social proof took on a life of its own` },
    "Community Champions":           { priority: 4, mood: 'up', clause: (n, d) => `by ${d}, our own community had started doing the marketing for us, churning out tutorials and content` },
    "Your Podcast Catches On":       { priority: 4, mood: 'up', clause: (n, d) => `by ${d}, our podcast had taken on a life of its own — we caught strangers quoting it back to each other` },
    "On to Bigger Things":           { priority: 4, mood: 'neutral', clause: (n, d) => `in ${d}, one of our earliest teammates moved on to bigger things — proud, and a little wistful, we wished them well` },
    "Personal Growth":               { priority: 3, mood: 'up', clause: (n, d) => `by ${d}, we'd learned to look after ourselves as much as the company — and it showed` }
};

// Compose the shareable story as flowing, first-person prose — the founder telling the
// tale of the company they built, the way they'd write it in a social post. Rather than
// four fixed slots keyed off card categories, it mines the *whole record* for turning
// points and keeps only the most dramatic, so two players with the same card count but
// different trajectories get genuinely different stories. Sources:
//   • the founding decision (the aim) and the present-day snapshot — the two anchors;
//   • the per-month history time-series (getCompanyMonthlySeries): the profit flip, a
//     capital raise (a one-step jump UP in runway), a near-death runway dip + recovery,
//     the single biggest growth month, a survived burnout stress spike;
//   • the decision log: first hire/revenue, a business-model pivot;
//   • outcome cards: a weathered challenge, plus the named milestones/wins above.
// Each middle beat is a lowercase, date-woven clause with a `mood` (up/down/neutral);
// the composer keeps the top few, orders them chronologically, and stitches them into a
// paragraph with mood-aware transitions ("But we clawed back…", "Then trouble struck…").
// The tone is deliberately plucky and a little self-mythologizing — it's the founder's
// own highlight reel — and invents harmless colour (caffeine, case studies) since the
// whole company is fictional. Returns an array of paragraph strings (the "acts"):
// founding, the middle drama (omitted on brand-new runs), and where we stand now.
function generateStoryArc(cards, archetype) {
    const name = gameState.companyName || 'our startup';
    const decisions = cards.filter(c => c.category !== 'outcome');
    if (!decisions.length) return [];

    const series = (typeof getCompanyMonthlySeries === 'function') ? getCompanyMonthlySeries() : [];
    const founded = new Date(gameState.founded);
    // "Month YYYY" reads better in prose than the card's "Mon DD, YYYY".
    const longDate = (d) => d.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
    const dateOfMonth = (m) => {
        const d = new Date(founded);
        d.setMonth(d.getMonth() + Math.max(0, Math.round(m) - 1));
        return longDate(d);
    };
    const dateOfCard = (c) => (c.selectedMonth ? dateOfMonth(c.selectedMonth) : (c.selectedAt || 'those early days'));
    const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

    // ── Deterministic per-run wording variation. Seeded by the founding instant (which
    // never changes for a run, so the story stays put every time you reopen it) and
    // salted per section, so each beat draws its phrasing independently — two different
    // founders are vanishingly unlikely to land on the same wording across every
    // section. This gives the whole arc the same "no two stories alike" treatment the
    // opening paragraph already had. Variants are plain strings: all are built eagerly
    // (cheap) and the seed picks one. ──
    const storySeed = Math.abs(Math.floor(founded.getTime() / 60000));
    const variant = (salt, arr) => {
        let h = storySeed >>> 0;
        for (let i = 0; i < salt.length; i++) h = ((h * 31) + salt.charCodeAt(i)) >>> 0;
        return arr[h % arr.length];
    };

    // Middle beats: { sort, priority, mood, clause }. The two anchors are composed
    // separately as the opening and closing paragraphs.
    const mids = [];

    // ── First building blocks: first hire and/or first revenue, in the order they happened. ──
    const hireIdx = cards.findIndex(c => isHireCard(c));
    const revIdx = cards.findIndex(c => c.impact && c.impact.monthlyRevenue > 0);
    if (hireIdx !== -1 || revIdx !== -1) {
        const ev = [];
        if (hireIdx !== -1) ev.push({ idx: hireIdx, card: cards[hireIdx], kind: 'hire' });
        if (revIdx !== -1) ev.push({ idx: revIdx, card: cards[revIdx], kind: 'rev' });
        ev.sort((a, b) => a.idx - b.idx);
        const phrases = ev.map(e => e.kind === 'hire'
            ? variant('hire' + e.card.title, [
                `our first hire — a ${e.card.title} — came aboard`,
                `we brought our first ${e.card.title} on board`,
                `a ${e.card.title} became employee number one`])
            : variant('rev' + e.card.title, [
                `the first dollars trickled in through ${e.card.title}`,
                `${e.card.title} put the first real money on the board`,
                `our first revenue arrived by way of ${e.card.title}`]));
        mids.push({
            sort: ev[0].card.selectedMonth || 1, priority: 3, mood: 'up',
            clause: variant('firstblocks', [
                `we found our feet in ${dateOfCard(ev[0].card)} as ${joinStoryList(phrases)}`,
                `${dateOfCard(ev[0].card)} was when it all started to feel real — ${joinStoryList(phrases)}`,
                `the early shape of a company emerged in ${dateOfCard(ev[0].card)}: ${joinStoryList(phrases)}`])
        });
    }

    // ── Pivot: the business model actually changed across the run. ──
    const modelCards = decisions.filter(c => c.category === 'business' && STORY_MODEL_PHRASES[c.title]);
    if (modelCards.length >= 2) {
        const from = modelCards[0], to = modelCards[modelCards.length - 1];
        if (STORY_MODEL_PHRASES[from.title] !== STORY_MODEL_PHRASES[to.title]) {
            mids.push({
                sort: to.selectedMonth || 2, priority: 8, mood: 'neutral',
                clause: variant('pivot', [
                    `in ${dateOfCard(to)}, with our first plan sputtering, we made the kind of pivot they write case studies about — trading ${STORY_MODEL_PHRASES[from.title]} for ${STORY_MODEL_PHRASES[to.title]}`,
                    `by ${dateOfCard(to)} the original plan had run its course, so we pivoted hard — from ${STORY_MODEL_PHRASES[from.title]} to ${STORY_MODEL_PHRASES[to.title]}`,
                    `in ${dateOfCard(to)} we bet the company on a pivot, leaving ${STORY_MODEL_PHRASES[from.title]} behind for ${STORY_MODEL_PHRASES[to.title]}`])
            });
        }
    }

    // ── History-mined turning points (need ≥2 monthly points to compare). ──
    if (series.length >= 2) {
        // Capital raised: a one-step jump UP in runway. Runway otherwise only falls via
        // burn, so a big positive delta is a cash injection (a round lands as oneTimeRevenue).
        let raise = null;
        for (let i = 1; i < series.length; i++) {
            const jump = series[i].runway - series[i - 1].runway;
            if (jump >= 250000 && (!raise || jump > raise.jump)) raise = { jump, m: series[i].monthBucket };
        }
        if (raise) mids.push({
            sort: raise.m, priority: 9, mood: 'up',
            clause: variant('raise', [
                `in ${dateOfMonth(raise.m)}, investors came calling, and ${formatCurrency(raise.jump)} in fresh capital hit our account — rocket fuel for everything that followed`,
                `${dateOfMonth(raise.m)} brought the round we needed: ${formatCurrency(raise.jump)} landed in the bank and changed what was possible`,
                `in ${dateOfMonth(raise.m)} we closed ${formatCurrency(raise.jump)} in funding, and suddenly the runway stretched out in front of us`])
        });

        // First profit: net income crosses from ≤0 up to >0.
        for (let i = 0; i < series.length; i++) {
            if (series[i].netIncome > 0 && (i === 0 || series[i - 1].netIncome <= 0)) {
                mids.push({
                    sort: series[i].monthBucket, priority: 8, mood: 'up',
                    clause: variant('profit', [
                        `by ${dateOfMonth(series[i].monthBucket)}, our books had tipped into the black, and we were finally earning more than we burned`,
                        `${dateOfMonth(series[i].monthBucket)} was the month the math finally worked — revenue overtook burn and stayed there`,
                        `by ${dateOfMonth(series[i].monthBucket)} we'd crossed into profit, taking in more than we spent for the first time`])
                });
                break;
            }
        }

        // Near-death + recovery: runway dipped to a scary low, then climbed back. Most
        // dramatic beat in the deck, so it outranks everything else.
        let low = null;
        series.forEach(s => {
            const months = s.runway / Math.max(1, s.monthlyBurn);
            if (s.runway > 0 && (!low || months < low.months)) low = { months, m: s.monthBucket };
        });
        const lastSeries = series[series.length - 1];
        const lastMonths = lastSeries.runway / Math.max(1, lastSeries.monthlyBurn);
        if (low && low.months < 2 && low.m < lastSeries.monthBucket && lastMonths > low.months + 1) {
            const wk = Math.max(1, Math.round(low.months * 4.345));
            // End on the brink — the recovery is delivered by the next up-beat's
            // transition (or, if this is the last beat, by the present-day paragraph),
            // so we don't say "clawed back" twice.
            mids.push({
                sort: low.m, priority: 10, mood: 'down',
                clause: variant('neardeath', [
                    `by ${dateOfMonth(low.m)}, our runway had withered to barely ${wk} week${wk === 1 ? '' : 's'} — close enough to the edge to look right over it`,
                    `${dateOfMonth(low.m)} nearly ended us: ${wk} week${wk === 1 ? '' : 's'} of cash left and a very short list of options`,
                    `by ${dateOfMonth(low.m)} we were down to ${wk} week${wk === 1 ? '' : 's'} of runway, staring straight at the end`])
            });
        }

        // Layoffs: a month-over-month drop in headcount. teamSize only ever falls when the
        // founder lets someone go (hires raise it; quits/departures are narrative-only and
        // don't touch it), so a drop is unambiguously a layoff — one of the hardest, most
        // human calls in the whole run. We surface the single biggest cut.
        let cut = null;
        for (let i = 1; i < series.length; i++) {
            const drop = (series[i - 1].teamSize || 0) - (series[i].teamSize || 0);
            if (drop >= 1 && (!cut || drop > cut.n)) cut = { n: drop, m: series[i].monthBucket };
        }
        if (cut) {
            const who = cut.n === 1 ? 'someone' : `${cut.n} people`;
            const people = cut.n === 1 ? 'a teammate' : `${cut.n} teammates`;
            const own = cut.n === 1 ? 'one of our own' : `${cut.n} of our own`;
            mids.push({
                sort: cut.m, priority: 8, mood: 'down',
                clause: variant('layoff', [
                    `in ${dateOfMonth(cut.m)} we made the hardest call there is — letting ${who} go to keep the lights on`,
                    `${dateOfMonth(cut.m)} forced the cruelest math: we laid off ${own} to give the company a fighting chance`,
                    `to keep ${name} alive, we had to shrink — ${dateOfMonth(cut.m)} meant saying goodbye to ${people}`])
            });
        }

        // Breakout month: the single biggest one-month customer gain.
        let grow = null;
        series.forEach(s => { if (s.newCustomers > 0 && (!grow || s.newCustomers > grow.n)) grow = { n: s.newCustomers, m: s.monthBucket }; });
        if (grow && grow.n >= 50) mids.push({
            sort: grow.m, priority: 6, mood: 'up',
            clause: variant('breakout', [
                `${dateOfMonth(grow.m)} became our breakout month, ${Math.round(grow.n).toLocaleString()} new customers rushing in at once`,
                `everything broke our way in ${dateOfMonth(grow.m)} — ${Math.round(grow.n).toLocaleString()} new customers in a single month`,
                `${dateOfMonth(grow.m)} was the inflection point, ${Math.round(grow.n).toLocaleString()} customers pouring in at once`])
        });

        // Burnout dodged: stress spiked high, then eased back off the ceiling.
        let peak = null;
        series.forEach(s => { if (!peak || s.stress > peak.stress) peak = { stress: s.stress, m: s.monthBucket }; });
        if (peak && peak.stress >= 75 && peak.m < lastSeries.monthBucket && lastSeries.stress < peak.stress - 15) {
            mids.push({
                sort: peak.m, priority: 5, mood: 'down',
                clause: variant('burndodge', [
                    `around ${dateOfMonth(peak.m)}, we came within inches of burning out, the stress pinned at ${Math.round(peak.stress)}%, before pulling back from the brink`,
                    `${dateOfMonth(peak.m)} pushed us to the edge — stress maxed at ${Math.round(peak.stress)}% — before we eased off and recovered`,
                    `by ${dateOfMonth(peak.m)} the pace had nearly broken us, stress spiking to ${Math.round(peak.stress)}%, until we stepped back from the cliff`])
            });
        }
    }

    // ── A weathered challenge: the first storm, with a count when there's been more. ──
    const challenges = cards.filter(c => c.category === 'outcome' && c.type === 'challenge');
    if (challenges.length) {
        const first = challenges[0];
        const more = challenges.length > 1 ? `, just one of ${challenges.length} storms we'd survive` : '';
        mids.push({
            sort: first.selectedMonth || 2, priority: 7, mood: 'down',
            clause: variant('challenge', [
                `in ${dateOfCard(first)}, “${first.title}” nearly knocked the whole thing over — but we weathered it${more}`,
                `${dateOfCard(first)} threw “${first.title}” at us and very nearly won — but we held on${more}`,
                `we took “${first.title}” on the chin in ${dateOfCard(first)} and stayed standing${more}`])
        });
    }

    // ── Named milestones / standout wins (title preserved on the card). ──
    cards.forEach(c => {
        if (c.category !== 'outcome') return;
        const b = STORY_MILESTONE_BEATS[c.title];
        if (!b) return;
        mids.push({ sort: c.selectedMonth || 2, priority: b.priority, mood: b.mood, clause: b.clause(name, dateOfCard(c)) });
    });

    // ── Opening paragraph. We keep several openings and lock to one per company —
    // seeded by the founding instant, which never changes for a run — so the hook varies
    // across startups but stays put every time you reopen this one. The values-led
    // opening unlocks once an ESG card has been played; the rest are always available. ──
    let foundingAim = null;
    for (let i = 0; i < decisions.length; i++) {
        if (decisions[i].category === 'business' && STORY_MODEL_PHRASES[decisions[i].title]) {
            foundingAim = STORY_MODEL_PHRASES[decisions[i].title]; // gerund: "building a freemium SaaS"
            break;
        }
    }
    const aimClause = foundingAim ? `a wild bet on ${foundingAim}` : `chasing an idea the rest of the world hadn't caught up to yet`;
    const date0 = longDate(founded);
    let valuesPhrase = '';
    for (let i = decisions.length - 1; i >= 0; i--) {
        if (STORY_VALUES_PHRASES[decisions[i].title]) { valuesPhrase = STORY_VALUES_PHRASES[decisions[i].title]; break; }
    }
    const valuesLower = valuesPhrase ? valuesPhrase.charAt(0).toLowerCase() + valuesPhrase.slice(1) : '';
    const openings = [
        { ok: true, text: () => `Every great company starts with a leap. We took ours in ${date0} and called it ${name} — ${aimClause}, backed by little more than conviction and caffeine.` },
        { ok: !!valuesPhrase, text: () => `At ${name}, we stand for something bigger than the bottom line: ${valuesLower}. We've believed that since the beginning, back in ${date0}.` },
        { ok: true, text: () => `They told us it couldn't be done — or worse, that it wasn't worth doing. We started ${name} in ${date0} anyway, ${aimClause}.` },
        { ok: true, text: () => `${name} didn't begin with a boardroom or a war chest. It started in ${date0} with ${aimClause} and a stubborn refusal to quit.` },
        { ok: true, text: () => `This is the story of ${name} — the company we started in ${date0}, ${aimClause}.` },
        { ok: true, text: () => `It started, the way these things often do, with a problem we couldn't stop turning over. We founded ${name} in ${date0} — ${aimClause}.` },
        { ok: true, text: () => `Some companies are years in the planning. ${name} began on conviction alone, in ${date0}, ${aimClause}.` },
        { ok: true, text: () => `In ${date0}, with more belief than budget, we founded ${name} — ${aimClause}.` },
        { ok: true, text: () => `Looking back, ${date0} was the month everything changed: that's when ${name} began, ${aimClause}.` },
        { ok: true, text: () => `There was no master plan — just a blank page and a deadline we'd set ourselves. ${name} was born in ${date0}, ${aimClause}.` },
        { ok: true, text: () => `${name} began the way every honest startup does: underfunded, overcommitted, and absolutely certain. We started in ${date0}, ${aimClause}.` },
        { ok: true, text: () => `The idea kept us up long before it had a name. We finally gave it one — ${name} — in ${date0}, ${aimClause}.` },
        { ok: !!valuesPhrase, text: () => `Profit was never the whole point of ${name}. ${valuesPhrase} — and we've meant it since ${date0}.` }
    ];
    // Seed from the run's founding instant, then walk forward to the next eligible
    // opening (the first is always eligible, so this always terminates).
    let oi = storySeed % openings.length;
    for (let k = 0; k < openings.length && !openings[oi].ok; k++) oi = (oi + 1) % openings.length;
    const openP = openings[oi].text();

    // ── Middle paragraph: keep the most dramatic beats, order them in time, stitch them
    // together with mood-aware transitions so it reads as one running account. ──
    const kept = mids.sort((a, b) => b.priority - a.priority).slice(0, 4).sort((a, b) => a.sort - b.sort);
    // Transition into a beat. `gap` is the months since the previous kept beat (sort is
    // an in-game month number). The gap leads once beats are far apart — runs can span
    // many years, so a short-gap phrase like "Soon after," would lie about a multi-year
    // jump. Only when beats are genuinely close (< 6 months) do we fall back to the
    // mood-aware turns; the exact dates live in the clauses regardless.
    const connect = (i, mood, prev, gap) => {
        // Salt with the beat position so consecutive transitions still differ within one
        // story, and with the seed (via variant) so they also differ across founders.
        const v = (arr) => variant('connect' + i, arr);
        if (gap >= 24) return v(['Years later, ', 'A long road later, ', 'Much further down the line, ']);
        if (gap >= 12) return v(['A year on, ', 'The following year, ', 'Some time later, ']);
        if (gap >= 6) return v(['Months later, ', 'In the months that followed, ', 'Before long, ']);
        if (mood === 'up' && prev === 'down') return v(['Then the tide turned — ', 'But we clawed back: ', 'Against the odds, ']);
        if (mood === 'down' && prev !== 'down') return v(['Then trouble struck: ', "But it wasn't all smooth — ", 'The ground shifted under us: ']);
        return v(['Then ', 'Soon after, ', 'And then ']);
    };
    let midP = '';
    if (kept.length) {
        midP = kept.map((b, i) => i === 0
            ? cap(b.clause) + '.'
            : connect(i, b.mood, kept[i - 1].mood, b.sort - kept[i - 1].sort) + b.clause + '.'
        ).join(' ');
    }

    // ── Closing paragraph. An archetype sign-off (its own seeded frames) caps a lead-in
    // that is either the present-tense "where we stand now" (a live run) or, once the run
    // has ended, a past-tense retrospective keyed off how it ended (the narrative half of
    // the post-mortem — the verdict block above carries the numbers). ──
    // companyAgePhrase() reads "N years after founding"; reshape to "N years in".
    const ageNow = companyAgePhrase().replace('after founding', 'in');
    // The archetype sign-off closes *every* story (live or ended), so it gets its own
    // frames — salted with the archetype name so two founders who share an archetype don't
    // end on a byte-identical sentence. The blurb (already a full sentence) trails it.
    const archName = archetype && archetype.name;
    const archBlurb = (archetype && archetype.blurb) ? ` ${archetype.blurb}` : '';
    const signoff = archName
        ? variant('signoff' + archName, [
            ` Call us what we are: ${archName}.`,
            ` If you need a label for us, it's ${archName}.`,
            ` History might remember us as ${archName}.`,
            ` That, in the end, makes us ${archName}.`,
            ` Some would call us ${archName}; we'd wear it.`]) + archBlurb
        : '';

    const outcome = (typeof getRunOutcome === 'function') ? getRunOutcome() : null;
    let leadIn;
    if (outcome) {
        const endDate = dateOfMonth(gameState.currentMonth);
        const custStrong = gameState.customers > 0
            ? `${gameState.customers.toLocaleString()} customer${gameState.customers === 1 ? '' : 's'}`
            : 'a handful of believers';
        if (outcome === 'exit') {
            leadIn = variant('exit', [
                `Then, in ${endDate}, the offer came — and we took it. We sold ${name} for ${formatCurrency(gameState.exitSalePrice || 0)}, ${custStrong} and ${ageNow}. We'd built something worth buying.`,
                `In ${endDate}, ${ageNow}, someone wanted what we'd built badly enough to buy it: ${name} sold for ${formatCurrency(gameState.exitSalePrice || 0)}, ${custStrong} at our back. We'd made something that mattered.`,
                `The exit came in ${endDate}: ${name} acquired for ${formatCurrency(gameState.exitSalePrice || 0)}, ${custStrong} and ${ageNow}. We'd turned an idea into something others would pay for.`]);
        } else if (outcome === 'ideaFlop') {
            leadIn = variant('flop', [
                `By ${endDate}, ${ageNow}, we had to admit it: the idea never found its people. We built, and waited, and built some more, but ${custStrong} was as far as it ever went — and we finally chose to stop.`,
                `By ${endDate}, ${ageNow}, the truth was unavoidable: the market never showed up. ${cap(custStrong)} was the ceiling no matter what we tried, and we made our peace with stopping.`,
                `By ${endDate}, ${ageNow}, we let it go. The idea was a good one to us, but ${custStrong} was all it ever convinced — and we'd run out of reasons to keep pushing.`]);
        } else if (outcome === 'burnout') {
            leadIn = variant('burnout', [
                `By ${endDate}, ${ageNow}, it wasn't the company that gave out — it was us. The stress had been pinned at the ceiling for months, and no business is worth your health. We stepped away to put ourselves back together.`,
                `By ${endDate}, ${ageNow}, the business was still breathing — but we weren't, not really. Months at full stress had taken their toll, and we chose ourselves over the company and walked away to recover.`,
                `By ${endDate}, ${ageNow}, we hit the wall. The company could have gone on; we couldn't. After months pinned at the redline, we put it down and went to heal.`]);
        } else { // insolvency
            leadIn = variant('insolv', [
                `By ${endDate}, ${ageNow}, the money was gone. We'd grown to ${custStrong}, but the burn always ran ahead of the revenue, and one month there was nothing left to make payroll. ${name} closed its doors.`,
                `By ${endDate}, ${ageNow}, the account hit empty. ${cap(custStrong)} wasn't enough to outrun the burn, and the month came when payroll simply couldn't be met. ${name} shut down.`,
                `By ${endDate}, ${ageNow}, we ran out of road. ${cap(custStrong)} couldn't close the gap between burn and revenue, and the cash finally gave out. ${name} wound down.`]);
        }
    } else {
        const cred = gameState.credibility;
        let standing;
        if (cred >= 60) standing = variant('stand60', ['a genuine leader in our space', 'one of the names that defines our space', 'the company others in our space measure themselves against']);
        else if (cred >= 35) standing = variant('stand35', ['a company people actually know', 'a name that opens doors now', 'a known quantity in our market']);
        else if (cred >= 15) standing = variant('stand15', ['a rising name with real momentum', 'an up-and-comer people are starting to watch', 'a young company with a real head of steam']);
        else standing = variant('stand0', ['scrappy, unproven, and utterly unbowed', 'small, unproven, and impossible to discourage', 'an underdog with everything still to prove']);
        // Human-scale facts ground the close; we tack on at most one "big number" so the
        // line stays narrative, not a financial readout. The big number is sometimes the
        // valuation and sometimes total revenue (the figure founders most love to tout) —
        // but only when it's substantial — and sometimes we skip it entirely.
        const tractionWords = [];
        if (gameState.customers > 0) tractionWords.push(`${gameState.customers.toLocaleString()} customer${gameState.customers === 1 ? '' : 's'} strong`);
        tractionWords.push(`a team of ${gameState.teamSize}`);
        const bigNumbers = [`a valuation circling ${formatCurrency(estimateValuation())}`];
        if (gameState.totalRevenue >= 10000) {
            bigNumbers.push(`${formatCurrency(gameState.totalRevenue)} earned to date`);
            bigNumbers.push(`${formatCurrency(gameState.totalRevenue)} through the door so far`);
        }
        // ~2 in 3 runs close on a big number (revenue weighted ahead of valuation once it
        // qualifies); the rest let the people-and-product facts stand on their own.
        if (variant('bignum', [true, true, false])) tractionWords.push(variant('bignumpick', bigNumbers));
        let momentum = variant('mom0', [' And the next chapter is still unwritten.', ' And the best chapter is still ahead.', ' And the story is far from finished.']);
        if (series.length >= 3) {
            const recentGain = series[series.length - 1].customers - series[series.length - 3].customers;
            if (recentGain > 0) momentum = variant('momUp', [" And we're only picking up speed.", " And the momentum is all ours.", " And we're accelerating into it."]);
            else if (recentGain < 0) momentum = variant('momDn', [" The last stretch has tested us — but we're still standing.", " The recent road has been rough — but we haven't blinked.", " The last few months bit hard — but we're still here."]);
        }
        // Rotate the traction facts so they don't always read customers → team → valuation.
        const rot = variant('tracrot', [0, 1, 2]) % tractionWords.length;
        const traction = joinStoryList(tractionWords.slice(rot).concat(tractionWords.slice(0, rot)));
        // Frames that genuinely re-shape the sentence (lead with the standing, lead with the
        // facts, pose it as a question…) rather than just swapping the first word.
        leadIn = variant('live', [
            `Today, ${ageNow}, we stand as ${standing} — ${traction}.${momentum}`,
            `Now, ${ageNow}, we're ${standing}, with ${traction}.${momentum}`,
            `${cap(ageNow)}, ${traction} — and ${standing}.${momentum}`,
            `Where do we stand ${ageNow}? ${cap(standing)}, with ${traction}.${momentum}`,
            `These days we're ${standing} — ${traction}, ${ageNow}.${momentum}`]);
    }
    // Archetype blurbs already end in a period, so don't add one.
    const closeP = leadIn + signoff;

    const paragraphs = [openP];
    if (midP) paragraphs.push(midP);
    paragraphs.push(closeP);
    return paragraphs;
}

// Assemble the narrative. Returns { paragraph, shareText, archetype, arc } or null if
// the player hasn't made any real decisions yet (so the empty state can show instead).
// `paragraph` is the snapshot baked into the share image; `arc` is the chapter timeline
// shown (and copied) on the Story tab.
function generateCompanyStory() {
    const cards = gameState.selectedCards.filter(c => c.category !== 'outcome');
    if (!cards.length) return null;

    const name = gameState.companyName || 'our startup';
    const sentences = [];

    // 1) Who we are + what we build.
    const teamPhrase = gameState.teamSize <= 1 ? 'a solo founder' : `a team of ${gameState.teamSize}`;

    let modelPhrase = 'building a startup';
    for (let i = cards.length - 1; i >= 0; i--) {
        if (cards[i].category === 'business' && STORY_MODEL_PHRASES[cards[i].title]) {
            modelPhrase = STORY_MODEL_PHRASES[cards[i].title];
            break;
        }
    }

    const productClauses = [];
    const seenProduct = new Set();
    for (let i = cards.length - 1; i >= 0 && productClauses.length < 2; i--) {
        const phrase = STORY_PRODUCT_PHRASES[cards[i].title];
        if (phrase && !seenProduct.has(cards[i].title)) {
            seenProduct.add(cards[i].title);
            productClauses.push(phrase);
        }
    }
    const productPhrase = productClauses.length ? ` with ${joinStoryList(productClauses)}` : '';
    sentences.push(`We're ${name}, ${teamPhrase} ${modelPhrase}${productPhrase}.`);

    // 2) Values / mission (only if a values card has been picked).
    for (let i = cards.length - 1; i >= 0; i--) {
        if (STORY_VALUES_PHRASES[cards[i].title]) {
            sentences.push(`${STORY_VALUES_PHRASES[cards[i].title]}.`);
            break;
        }
    }

    // 3) Market position + traction (partners, customers).
    const cred = gameState.credibility;
    let position;
    if (cred >= 60) position = "We're a recognized leader in our space";
    else if (cred >= 35) position = "We've built a real reputation in our industry";
    else if (cred >= 15) position = "We're a rising name in our market";
    else position = "We're still earning our place in the market";

    const partnerCount = cards.filter(c => STORY_PARTNER_TITLES.has(c.title)).length;
    const traction = [];
    if (partnerCount > 0) traction.push(`${partnerCount} corporate partner${partnerCount === 1 ? '' : 's'}`);
    if (gameState.customers > 0) traction.push(`${gameState.customers.toLocaleString()} customer${gameState.customers === 1 ? '' : 's'}`);
    sentences.push(traction.length ? `${position}, with ${joinStoryList(traction)}.` : `${position}.`);

    // 4) Engagement (skipped when there's nothing flattering to say).
    const eng = gameState.engagement;
    if (eng >= 60) sentences.push('Our users are highly engaged.');
    else if (eng >= 35) sentences.push('Our users are solidly engaged.');
    else if (eng >= 15) sentences.push("We're working hard to deepen engagement.");

    // 5) Finances + age.
    const valuation = estimateValuation();
    const finance = gameState.totalRevenue > 0
        ? `We're valued around ${formatCurrency(valuation)} on ${formatCurrency(gameState.totalRevenue)} of lifetime revenue`
        : `We're valued around ${formatCurrency(valuation)} and still pre-revenue`;
    sentences.push(`${finance}, ${companyAgePhrase()}.`);

    const paragraph = sentences.join(' ');
    const archetype = deriveFounderArchetype();

    // The shareable copy is the first-person story arc (the social-post text that rides
    // alongside the image), not the image's snapshot paragraph — so it reads as the
    // founder's own telling. `arc` is an array of paragraph strings.
    const arc = generateStoryArc(gameState.selectedCards, archetype);
    const shareText = `${archetype.emoji} ${name} — ${archetype.name}\n\n`
        + arc.join('\n\n')
        + `\n\nWhat kind of founder are you? → https://dlightning.org/games`;
    return { paragraph, shareText, archetype, arc };
}

// Short age label for the image card's stat chip, e.g. "8mo" or "4.4y".
function storyAgeShort() {
    const months = Math.max(0, gameState.currentMonth - 1);
    if (months < 12) return `${Math.round(months)}mo`;
    const years = Math.round(months / 12 * 10) / 10; // one decimal, float-safe
    return `${Number.isInteger(years) ? years : years.toFixed(1)}y`;
}

// Brand wordmark for the share card header. Inlined (not fetched) so it works under
// file:// and — being a data: URL — never taints the canvas on export. Recolored to
// white at load so it reads on any themed band: a root fill covers the (black)
// "startup" glyphs and the `.e` rule covers the (green) "cards" glyphs. Source of
// truth: svg/startupCards.svg — keep this in sync if the logo ever changes.
const STORY_LOGO_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1193.52 546.68"><defs><style>.d{fill:none;}.e{fill:#059669;}</style></defs><g id="b" shape-rendering="geometricPrecision"><rect class="d" x="98.7" y="49.46" width="0" height="7.27"/><path d="M6.26,196.41h46.53c-1.85,23.73,17.87,40.68,47.46,40.68,25.58,0,42.22-12.63,43.45-28.35,4.01-46.53-135.59-7.4-127.88-94.6,3.7-43.14,42.83-72.72,95.83-72.72s89.06,32.05,85.36,76.11h-44.99c2.16-21.57-16.02-36.98-42.52-36.98-24.34,0-41.6,11.4-42.83,26.81-4.01,44.68,135.9,6.16,128.19,93.99-3.7,43.76-43.76,74.88-99.53,74.88S2.25,242.63,6.26,196.41Z"/><path d="M241.69,145.87h-22.19l3.08-35.13h24.34l8.63-39.75h38.83l-3.39,39.75h35.75l-3.08,35.13h-35.75l-5.85,66.87c-1.23,13.25,6.16,22.19,19.11,22.19,4.31,0,11.09-.92,16.33-2.16l-3.39,36.98c-9.55,3.08-22.19,4.93-32.05,4.93-31.43,0-49.61-23.73-46.53-57.32l6.16-71.49Z"/><path d="M483.28,110.74h46.22l-13.87,157.77h-46.22l1.85-21.88c-13.87,17.56-33.59,28.04-56.08,28.04-44.37,0-72.42-35.13-68.1-85.05,4.62-49.92,38.83-85.05,83.2-85.05,22.5,0,40.37,10.48,51.15,28.04l1.85-21.88ZM475.88,189.63c2.46-25.58-13.25-44.37-37.29-44.37s-42.83,18.8-45.3,44.37c-2.16,25.58,13.56,44.37,37.59,44.37s42.83-18.8,44.99-44.37Z"/><path d="M674.95,108.89l-3.39,40.98c-8.63-3.7-18.8-5.85-25.58-5.85-20.03,0-34.51,16.95-36.67,40.68l-7.4,83.82h-46.22l13.87-157.77h44.37l-1.85,20.03c10.79-15.72,26.81-25.88,44.37-25.88,6.16,0,12.63,1.54,18.49,4.01Z"/><path d="M710.7,145.87h-22.19l3.08-35.13h24.34l8.63-39.75h38.83l-3.39,39.75h35.75l-3.08,35.13h-35.75l-5.85,66.87c-1.23,13.25,6.16,22.19,19.11,22.19,4.31,0,11.09-.92,16.33-2.16l-3.39,36.98c-9.55,3.08-22.19,4.93-32.05,4.93-31.43,0-49.61-23.73-46.53-57.32l6.16-71.49Z"/><path d="M818.55,209.35l13.63-151.64h46.22l-13.01,143.63c-1.54,19.11,8.32,32.66,26.5,32.66s34.2-14.48,36.05-34.51l7.7-88.75h46.22l-13.87,157.77h-44.99l1.85-21.26c-12.63,16.95-32.05,27.43-52.69,27.43-35.44,0-57.01-27.43-53.62-65.33Z"/><path d="M1048.13,339.39h-46.22l20.03-228.65h45.61l-1.85,19.11c13.87-15.72,33.28-25.27,55.16-25.27,43.76,0,71.8,35.13,67.18,85.05-4.31,49.92-38.21,85.05-82.28,85.05-21.57,0-38.83-9.24-49.92-25.27l-7.7,89.98ZM1104.52,146.18c-24.04,0-43.14,18.49-45.3,43.45s13.56,43.45,37.59,43.45,42.83-18.49,44.99-43.45c2.46-25.27-13.56-43.45-37.29-43.45Z"/><path class="e" d="M348.31,454.6c-11.4,48.38-60.09,83.2-116.17,83.2-67.79,0-112.78-49.3-106.93-117.41,5.85-68.1,59.47-117.41,127.27-117.41,55.47,0,97.99,35.75,101.38,85.36l-48.69,5.55c-4.01-27.12-26.81-46.53-55.16-46.53-39.14,0-69.33,30.2-73.03,73.03s21.26,73.03,60.09,73.03c27.73,0,54.54-19.11,63.48-44.99l47.76,6.16Z"/><path class="e" d="M512.55,372.33h46.22l-13.87,157.77h-46.22l1.85-21.88c-13.87,17.56-33.59,28.04-56.08,28.04-44.37,0-72.42-35.13-68.1-85.05,4.62-49.92,38.83-85.05,83.2-85.05,22.5,0,40.37,10.48,51.15,28.04l1.85-21.88ZM505.16,451.21c2.46-25.58-13.25-44.37-37.29-44.37s-42.83,18.8-45.3,44.37c-2.16,25.58,13.56,44.37,37.59,44.37s42.83-18.8,44.99-44.37Z"/><path class="e" d="M704.23,370.48l-3.39,40.98c-8.63-3.7-18.8-5.85-25.58-5.85-20.03,0-34.51,16.95-36.67,40.68l-7.4,83.82h-46.22l13.87-157.77h44.37l-1.85,20.03c10.79-15.72,26.81-25.88,44.37-25.88,6.16,0,12.63,1.54,18.49,4.01Z"/><path class="e" d="M857.07,301.45h46.22l-20.03,228.65h-45.61l1.54-19.11c-13.56,15.72-32.66,25.27-54.85,25.27-43.76,0-71.8-35.13-67.49-85.05,4.62-49.92,38.83-85.05,82.58-85.05,21.57,0,38.83,9.24,49.61,25.27l8.01-89.98ZM800.68,494.66c24.04,0,42.83-18.49,44.99-43.45,2.16-24.96-13.25-43.45-37.29-43.45s-43.14,18.49-45.3,43.45c-2.16,25.27,13.87,43.45,37.59,43.45Z"/><path class="e" d="M921.78,477.41h39.13c-1.23,15.72,12.33,26.81,32.36,26.81,16.95,0,30.2-8.01,31.12-18.8,2.46-31.74-101.69-.31-95.83-66.87,2.77-30.82,33.9-53,72.42-53,42.22,0,70.57,22.8,68.1,54.54h-40.68c.92-12.94-12.02-21.88-30.51-21.88-14.48,0-26.5,7.4-27.43,17.56-2.77,30.2,103.54,5.24,98.61,64.71-2.77,32.66-35.44,56.39-79.19,56.39s-71.18-24.96-68.1-59.47Z"/><polygon points="863.1 6.22 812.84 51.79 901.36 51.79 863.1 6.22"/></g></svg>`
    .replace('.e{fill:#059669;}', '.e{fill:#ffffff;}')
    .replace('<svg ', '<svg fill="#ffffff" ');
const STORY_LOGO_RATIO = 1193.52 / 546.68; // width : height of the wordmark

let storyLogoImg = null;
let storyLogoReady = false;

// Lazily decode the inlined wordmark for the share image. Preloaded when the Story
// tab renders so it's ready by the time the player clicks Share; if it hasn't
// decoded yet, buildStoryImageCanvas falls back to a text label.
function ensureStoryLogo() {
    if (storyLogoImg) return;
    storyLogoImg = new Image();
    storyLogoImg.onload = () => { storyLogoReady = true; };
    storyLogoImg.onerror = () => { storyLogoReady = false; }; // keep the text fallback
    storyLogoImg.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(STORY_LOGO_SVG);
}

// Draw the bare card (themed band, archetype, narrative, chips, CTA) onto a canvas
// sized to its content — 1080 wide, square corners. buildStoryImageCanvas() frames
// this on a gray backdrop for sharing. Text + an inlined data-URL logo only, so the
// canvas never taints and toDataURL/toBlob always succeed.
function buildStoryCardCanvas(story) {
    const W = 1080, PAD = 64, maxW = W - PAD * 2;
    const canvas = document.createElement('canvas');
    canvas.width = W;
    const ctx = canvas.getContext('2d');
    // Canvas fillText (unlike the DOM) won't fall back to the system color-emoji
    // font unless it's named explicitly, so the archetype emoji renders as tofu/
    // nothing without these trailing families.
    const font = (spec) => `${spec} -apple-system, "Segoe UI", Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif`;
    const [c0, c1] = story.archetype.colors;

    const roundRect = (x, y, w, h, r) => {
        ctx.beginPath();
        ctx.moveTo(x + r, y);
        ctx.arcTo(x + w, y, x + w, y + h, r);
        ctx.arcTo(x + w, y + h, x, y + h, r);
        ctx.arcTo(x, y + h, x, y, r);
        ctx.arcTo(x, y, x + w, y, r);
        ctx.closePath();
    };

    // ── Pass 1: word-wrap the narrative so we can size the card to its content
    // (a fixed height left a big gap under short stories). ──
    ctx.font = font('400 31px');
    const lineH = 46;
    const lines = [];
    let line = '';
    story.paragraph.split(' ').forEach(word => {
        const test = line ? line + ' ' + word : word;
        if (ctx.measureText(test).width > maxW && line) { lines.push(line); line = word; }
        else line = test;
    });
    if (line) lines.push(line);

    // ── Layout (baselines), derived from the wrapped line count ──
    const BAND_H = 320;
    const nameY = 432;
    const pStart = 502;
    const lastLineY = pStart + (lines.length - 1) * lineH;
    const chipH = 130;
    const chipY = lastLineY + 50;
    const ctaY = chipY + chipH + 66;     // "What kind of founder are you?"
    const urlY = ctaY + 44;              // play link
    const H = Math.round(urlY + 46);
    canvas.height = H; // NB: resets ctx state — every draw below re-sets its font/style

    // Card background + themed header band
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, W, H);
    const band = ctx.createLinearGradient(0, 0, W, BAND_H);
    band.addColorStop(0, c0);
    band.addColorStop(1, c1);
    ctx.fillStyle = band;
    ctx.fillRect(0, 0, W, BAND_H);

    // Brand wordmark (white logo), with a text label as the cold-start fallback.
    ctx.textBaseline = 'alphabetic';
    ensureStoryLogo();
    if (storyLogoReady && storyLogoImg.naturalWidth) {
        const logoH = 50;
        ctx.drawImage(storyLogoImg, PAD, 34, logoH * STORY_LOGO_RATIO, logoH);
    } else {
        ctx.fillStyle = 'rgba(255,255,255,0.85)';
        ctx.font = font('700 26px');
        ctx.fillText('⚡ STARTUP CARDS', PAD, 72);
    }

    // Archetype: emoji, name, blurb
    ctx.fillStyle = '#ffffff';
    ctx.font = font('400 96px');
    ctx.fillText(story.archetype.emoji, PAD, 225);
    ctx.font = font('800 56px');
    ctx.fillText(story.archetype.name, PAD + 130, 190);
    ctx.fillStyle = 'rgba(255,255,255,0.9)';
    ctx.font = font('400 28px');
    ctx.fillText(story.archetype.blurb, PAD + 130, 235);

    // Company name
    ctx.fillStyle = c1;
    ctx.font = font('800 60px');
    ctx.fillText(gameState.companyName || 'Our Startup', PAD, nameY);

    // Narrative paragraph
    ctx.fillStyle = '#1e293b';
    ctx.font = font('400 31px');
    lines.forEach((ln, i) => ctx.fillText(ln, PAD, pStart + i * lineH));

    // Stat chips
    const chips = [
        [formatCurrency(estimateValuation()), 'Valuation'],
        [gameState.customers.toLocaleString(), 'Customers'],
        [String(gameState.teamSize), 'Team'],
        [storyAgeShort(), 'Age']
    ];
    const gap = 20, chipW = (maxW - gap * 3) / 4;
    chips.forEach(([val, label], i) => {
        const x = PAD + i * (chipW + gap);
        ctx.fillStyle = '#f1f5f9';
        roundRect(x, chipY, chipW, chipH, 18);
        ctx.fill();
        ctx.textAlign = 'center';
        ctx.fillStyle = c0;
        let vf = 38;
        ctx.font = font('800 38px');
        while (ctx.measureText(val).width > chipW - 20 && vf > 22) {
            vf -= 2;
            ctx.font = font(`800 ${vf}px`);
        }
        ctx.fillText(val, x + chipW / 2, chipY + 62);
        ctx.fillStyle = '#64748b';
        ctx.font = font('600 22px');
        ctx.fillText(label, x + chipW / 2, chipY + 100);
        ctx.textAlign = 'left';
    });

    // Footer call-to-action
    ctx.textAlign = 'center';
    ctx.fillStyle = c1;
    ctx.font = font('800 34px');
    ctx.fillText('What kind of founder are you?', W / 2, ctaY);
    ctx.fillStyle = '#64748b';
    ctx.font = font('600 26px');
    ctx.fillText('Play free → dlightning.org/games', W / 2, urlY);
    ctx.textAlign = 'left';

    return canvas;
}

// Frame the bare card on a gray, 4:5-portrait backdrop (LinkedIn/Instagram-friendly)
// with rounded corners and a drop shadow — matching the live preview and giving the
// shared image breathing room instead of bleeding to the edges.
function buildStoryImageCanvas(story) {
    const card = buildStoryCardCanvas(story);
    const MARGIN = 64;   // gray frame around the card
    const RADIUS = 36;
    const OUTER_W = card.width + MARGIN * 2;
    // Target a 4:5 portrait, but grow if an unusually long story makes the card tall
    // (so we never crop) — typical stories land exactly on 4:5.
    const OUTER_H = Math.max(Math.round(OUTER_W * 5 / 4), card.height + MARGIN * 2);
    const cardX = MARGIN;
    const cardY = Math.round((OUTER_H - card.height) / 2);

    const out = document.createElement('canvas');
    out.width = OUTER_W;
    out.height = OUTER_H;
    const ctx = out.getContext('2d');

    const roundRect = (x, y, w, h, r) => {
        ctx.beginPath();
        ctx.moveTo(x + r, y);
        ctx.arcTo(x + w, y, x + w, y + h, r);
        ctx.arcTo(x + w, y + h, x, y + h, r);
        ctx.arcTo(x, y + h, x, y, r);
        ctx.arcTo(x, y, x + w, y, r);
        ctx.closePath();
    };

    // Gray backdrop
    ctx.fillStyle = '#e7eaed';
    ctx.fillRect(0, 0, OUTER_W, OUTER_H);

    // Drop shadow, cast by a rounded white silhouette the card then fills
    ctx.save();
    ctx.shadowColor = 'rgba(15, 23, 42, 0.22)';
    ctx.shadowBlur = 48;
    ctx.shadowOffsetY = 18;
    ctx.fillStyle = '#ffffff';
    roundRect(cardX, cardY, card.width, card.height, RADIUS);
    ctx.fill();
    ctx.restore();

    // Clip to the rounded card and paint the bare card bitmap into it (rounds corners)
    ctx.save();
    roundRect(cardX, cardY, card.width, card.height, RADIUS);
    ctx.clip();
    ctx.drawImage(card, cardX, cardY);
    ctx.restore();

    return out;
}

// Build a fresh share canvas for the current state.
function getStoryCanvas() {
    const story = generateCompanyStory();
    return story ? buildStoryImageCanvas(story) : null;
}

// Synchronous data-URL -> Blob so navigator.share is still called inside the click's
// user-gesture window (an async toBlob can drop that activation in some browsers).
function dataURLtoBlob(dataURL) {
    const [head, b64] = dataURL.split(',');
    const mime = (head.match(/:(.*?);/) || [])[1] || 'image/png';
    const bin = atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
    return new Blob([arr], { type: mime });
}

function downloadStoryImage(canvas, filename, setHint) {
    const link = document.createElement('a');
    link.href = canvas.toDataURL('image/png');
    link.download = filename;
    link.click();
    if (setHint) setHint('Image saved — share it anywhere! 🖼️');
}

// Share the image card via the native share sheet (with the story text attached),
// falling back to a PNG download when file-sharing isn't supported.
function shareStoryImage() {
    const canvas = getStoryCanvas();
    if (!canvas) return;
    const story = generateCompanyStory();
    const hint = document.getElementById('companyStoryHint');
    const setHint = (msg) => { if (hint) hint.textContent = msg; };
    const filename = (gameState.companyName || 'startup').replace(/[^a-z0-9]+/gi, '_').toLowerCase() + '-startup-cards.png';

    let file = null;
    try {
        file = new File([dataURLtoBlob(canvas.toDataURL('image/png'))], filename, { type: 'image/png' });
    } catch (e) { /* fall back to download */ }

    if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
        navigator.share({
            files: [file],
            title: gameState.companyName || 'My startup',
            text: story ? story.shareText : ''
        })
            .then(() => setHint('Shared! 🎉'))
            .catch(err => { if (!err || err.name !== 'AbortError') downloadStoryImage(canvas, filename, setHint); });
        return;
    }
    downloadStoryImage(canvas, filename, setHint);
}

// Render the Story tab: archetype headline (themed), the narrative pull-quote, a
// live preview of the shareable image card, and image/text share buttons. Falls
// back to an empty state prompting the player to make a few decisions first.
// ---- Post-mortem (end-of-run retrospective on the Story tab) ----
//
// When a run has ENDED — a failure (endings.js) or a winning exit (actions.js) —
// the Story tab gains a retrospective: a verdict block up top (renderPostMortemBlock)
// and a past-tense closing act in the narrative arc (see generateStoryArc). The
// verdict/exit cards link straight here via openPostMortem().

// How this run ended, or null if it's still going. Maps the failure endingKey and
// the exit flag onto a single outcome key shared by POST_MORTEM and the story close.
function getRunOutcome() {
    if (gameState.exited) return 'exit';
    if (gameState.gameOver && gameState.endingKey) return gameState.endingKey;
    return null;
}

// Verdict copy per outcome: a dramatic headline + a terse one-line summary. `tone`
// drives the block's colour (down = somber, up = celebratory).
const POST_MORTEM = {
    insolvency: { tone: 'down', kicker: 'Post-mortem', headline: '…and the money ran out.',
        verdict: () => 'Burned the last dollar with the bills still coming in.' },
    ideaFlop:   { tone: 'down', kicker: 'Post-mortem', headline: '…and we finally called it.',
        verdict: () => 'Built for years; the customers we needed never came.' },
    burnout:    { tone: 'down', kicker: 'Post-mortem', headline: '…and the founder stepped away.',
        verdict: () => 'Ran on empty too long — and chose, bravely, to recover.' },
    exit:       { tone: 'up',   kicker: 'The exit',    headline: '…and then we sold.',
        verdict: (gs) => `Acquired for ${formatCurrency(gs.exitSalePrice || 0)} — we built something worth buying.` }
};

// Headline numbers for the verdict block: how far the run got before it ended.
function buildPostMortemStats() {
    const months = Math.max(0, Math.round(gameState.currentMonth - 1));
    let survived;
    if (months < 12) {
        survived = `${months} month${months === 1 ? '' : 's'}`;
    } else {
        const y = Math.floor(months / 12), m = months % 12;
        survived = m ? `${y}y ${m}mo` : `${y} year${y === 1 ? '' : 's'}`;
    }
    const series = (typeof getCompanyMonthlySeries === 'function') ? getCompanyMonthlySeries() : [];
    const peakCustomers = Math.max(gameState.customers || 0, ...series.map(s => s.customers || 0));
    const peakRevenue = Math.max(gameState.monthlyRevenue || 0, ...series.map(s => s.monthlyRevenue || 0));
    return {
        survived,
        peakCustomers,
        peakRevenue,
        lifetimeRevenue: Math.max(0, Math.round(gameState.totalRevenue || 0)),
        decisions: (gameState.selectedCards || []).length
    };
}

// ---- Post-mortem cause analysis ----
// The verdict block above just restates headline numbers (which the player can
// already read elsewhere). THIS is the part that isn't surfaced anywhere else: a
// short diagnosis of WHY the run ended the way it did, read straight out of the
// decision log (gameState.selectedCards). Each ending has a different fatal metric,
// so each reads the same log through a different lens:
//   • burnout    → which decisions piled the most founder stress on
//   • insolvency → the monthly burn-vs-revenue gap + the heaviest one-time spends
//   • ideaFlop   → where the effort went while customers never showed
//   • exit       → (celebratory) the moves that built something worth buying
// Decisions repeated across the run (e.g. two "Proprietary Hardware" builds) are
// grouped by title so a recurring culprit reads as one line ("×2").

// Group cards by title and sum one metric, keeping only same-signed contributions
// (keepSign +1 = the metric pushed UP, -1 = pushed DOWN). Returns rows sorted by
// magnitude, biggest first — so the top of the list is the biggest driver.
function sumImpactByTitle(cards, metric, keepSign) {
    const map = new Map();
    (cards || []).forEach(c => {
        const v = (c.impact && c.impact[metric]) || 0;
        if (keepSign > 0 ? v > 0 : v < 0) {
            const e = map.get(c.title) || { title: c.title, total: 0, count: 0 };
            e.total += v;
            e.count += 1;
            map.set(c.title, e);
        }
    });
    return Array.from(map.values())
        .sort((a, b) => keepSign > 0 ? b.total - a.total : a.total - b.total);
}

// Build the "what led here" diagnosis for an ended run, or null when there's not
// enough in the log to say anything useful. { lead, drivers:[{label,value}], note }.
function buildPostMortemCause(outcome) {
    const cards = gameState.selectedCards || [];
    const driverLabel = (r) => r.count > 1 ? `${r.title} ×${r.count}` : r.title;

    if (outcome === 'burnout') {
        const adders = sumImpactByTitle(cards, 'stress', +1);
        const relievers = sumImpactByTitle(cards, 'stress', -1);
        if (!adders.length) return null;
        const addedCount = adders.reduce((n, r) => n + r.count, 0);
        const easedCount = relievers.reduce((n, r) => n + r.count, 0);
        const lead = `Founder stress only ever climbed. ${addedCount} decision${addedCount === 1 ? '' : 's'} `
            + `piled on pressure against just ${easedCount} that eased it — and these weighed heaviest:`;
        return {
            lead,
            drivers: adders.slice(0, 3).map(r => ({ label: driverLabel(r), value: `+${Math.round(r.total)} stress` })),
            note: 'Stress never decays on its own — only a deliberate breather brings it down. It sat pinned at the max long enough that the founder, not the business, gave out.'
        };
    }

    if (outcome === 'insolvency') {
        const costs = sumImpactByTitle(cards, 'cost', +1);
        const gap = Math.round((gameState.monthlyBurn || 0) - (gameState.monthlyRevenue || 0));
        const lead = gap > 0
            ? `The burn outran the revenue. By the end you were spending ${formatCurrency(Math.round(gameState.monthlyBurn || 0))} a month `
              + `against ${formatCurrency(Math.round(gameState.monthlyRevenue || 0))} coming in — losing ${formatCurrency(gap)} every month with no cash left to absorb it.`
            : `The cash ran out before the revenue could catch up.`;
        if (!costs.length) return { lead, drivers: [], note: '' };
        return {
            lead: lead + ` The heaviest one-time spends along the way:`,
            drivers: costs.slice(0, 3).map(r => ({ label: driverLabel(r), value: `−${formatCurrency(Math.round(r.total))}` })),
            note: ''
        };
    }

    if (outcome === 'ideaFlop') {
        const count = (cat) => cards.filter(c => c.category === cat).length;
        const marketing = count('marketing');
        const validation = count('validation');
        const product = count('product');
        const lead = `Years in, the market never answered. The product got built — ${product} product `
            + `decision${product === 1 ? '' : 's'} — but only ${marketing} marketing push${marketing === 1 ? '' : 'es'} `
            + `to get the word out, and ${validation} time${validation === 1 ? '' : 's'} asking customers what they actually wanted.`;
        return {
            lead,
            drivers: [
                { label: 'Marketing pushes', value: String(marketing) },
                { label: 'Customer validation', value: String(validation) },
                { label: 'Product builds', value: String(product) }
            ],
            note: 'Building was never the problem. Being found — and building the right thing — was.'
        };
    }

    if (outcome === 'exit') {
        const growth = sumImpactByTitle(cards, 'growth', +1);
        if (!growth.length) return null;
        return {
            lead: `You built something worth buying. The moves that drove the most growth along the way:`,
            drivers: growth.slice(0, 3).map(r => ({ label: driverLabel(r), value: `+${Math.round(r.total)} growth` })),
            note: ''
        };
    }

    return null;
}

// Render the cause block (or '' when there's nothing to diagnose).
function renderPostMortemCause(outcome) {
    const cause = buildPostMortemCause(outcome);
    if (!cause) return '';
    const drivers = (cause.drivers || []).map(d =>
        `<li><span class="pm-driver-label">${d.label}</span><span class="pm-driver-val">${d.value}</span></li>`).join('');
    return `
        <div class="pm-cause">
            <div class="pm-cause-title">What led here</div>
            <p class="pm-cause-lead">${cause.lead}</p>
            ${drivers ? `<ul class="pm-drivers">${drivers}</ul>` : ''}
            ${cause.note ? `<p class="pm-note">${cause.note}</p>` : ''}
        </div>`;
}

// On an exit, show how the acquirer arrived at the price — the step-by-step
// derivation that used to crowd the offer card (moved here at the player's
// request). Reads the breakdown stashed by acceptExit; '' for non-exit runs or
// older saves without it. This is the teaching payoff: acquirers pay a multiple
// on recurring revenue (richer the faster you grow) plus the strategic value of
// an engaged customer base, adjusted for company health and buyer appetite.
function renderExitValuation() {
    const b = gameState.exitValuation;
    if (!b) return '';
    const money = (v) => formatCurrency(Math.round(v || 0));
    const mult = (x) => `${(x || 0).toFixed(1)}×`;
    const pct = (x) => `${Math.round((x || 0) * 100)}%`;
    const headline = (b.effectiveMultiple != null)
        ? `Sold for <strong>${mult(b.effectiveMultiple)}</strong> annual revenue (${money(b.arr)} ARR).`
        : `Pre-revenue at exit — bought for the customer base and momentum, not earnings.`;
    return `
        <div class="pm-cause pm-valuation">
            <div class="pm-cause-title">How the buyer valued you</div>
            <p class="pm-cause-lead">${headline}</p>
            <table class="acq-table">
                <tr><td>Annual revenue (ARR)</td><td>${money(b.arr)}</td></tr>
                <tr><td>× Revenue multiple <span class="acq-note">(faster growth earns a richer multiple)</span></td><td>${mult(b.revenueMultiple)}</td></tr>
                <tr class="acq-subtotal"><td>Revenue-based value</td><td>${money(b.revenueValue)}</td></tr>
                <tr><td>+ Customer base <span class="acq-note">(${Math.round(b.customers || 0).toLocaleString()} × ${money(b.perCustomer)} ea., richer when engaged)</span></td><td>${money(b.customerValue)}</td></tr>
                <tr class="acq-subtotal"><td>Enterprise value</td><td>${money(b.enterpriseValue)}</td></tr>
                <tr><td>× Company health <span class="acq-note">(reputation, reach, confidence — burnout drags it down)</span></td><td>${pct(b.healthFactor)}</td></tr>
                <tr><td>× Buyer appetite <span class="acq-note">(how much this acquirer wanted the deal)</span></td><td>${pct(b.sentiment)}</td></tr>
                <tr><td>+ Cash credited <span class="acq-note">(part of your ${money(b.cash)} runway)</span></td><td>${money(b.cashCredit)}</td></tr>
                <tr class="acq-total"><td>Offer <span class="acq-note">(rounded)</span></td><td>${money(b.offer)}</td></tr>
            </table>
        </div>`;
}

// The verdict block shown at the top of the Story tab for an ended run (or '' when
// the run is still live, so the Story tab renders unchanged mid-game).
function renderPostMortemBlock() {
    const outcome = getRunOutcome();
    const pm = outcome && POST_MORTEM[outcome];
    if (!pm) return '';
    const s = buildPostMortemStats();
    const peakLine = `${Math.round(s.peakCustomers).toLocaleString()} · ${formatCurrency(s.peakRevenue)}/mo`;
    return `
        <div class="story-postmortem ${pm.tone}">
            <div class="pm-kicker">${pm.kicker}</div>
            <div class="pm-headline">${pm.headline}</div>
            <ul class="pm-stats">
                <li><span>Lasted</span><strong>${s.survived}</strong></li>
                <li><span>Peak</span><strong>${peakLine}</strong></li>
                <li><span>Lifetime revenue</span><strong>${formatCurrency(s.lifetimeRevenue)}</strong></li>
                <li><span>Decisions</span><strong>${s.decisions}</strong></li>
            </ul>
            <blockquote class="pm-verdict">${pm.verdict(gameState)}</blockquote>
            ${renderPostMortemCause(outcome)}
            ${outcome === 'exit' ? renderExitValuation() : ''}
        </div>`;
}

// Open the company modal straight to the Story tab — the "Read the post-mortem"
// entry point from the verdict (endings.js) and exit (actions.js) cards.
function openPostMortem() {
    if (typeof showCompanyMetricsModal === 'function') showCompanyMetricsModal();
    if (typeof switchCompanyTab === 'function') switchCompanyTab('story');
}

function populateCompanyStory() {
    const body = document.getElementById('companyStoryBody');
    if (!body) return;

    const story = generateCompanyStory();
    if (!story) {
        body.innerHTML = `
            <div class="story-empty">
                <div class="story-empty-icon">📖</div>
                <h3>Your story starts with a decision</h3>
                <p>Add a few cards and your company's story will write itself here — ready to share.</p>
            </div>`;
        return;
    }

    // Preload the brand logo now so the share image (rasterized on click) has it ready.
    ensureStoryLogo();

    const a = story.archetype;
    const [c0, c1] = a.colors;
    const chips = [
        [formatCurrency(estimateValuation()), 'Valuation'],
        [gameState.customers.toLocaleString(), 'Customers'],
        [String(gameState.teamSize), 'Team'],
        [storyAgeShort(), 'Age']
    ];
    const chipsHTML = chips.map(([v, l]) =>
        `<div class="story-card-chip"><span class="v">${v}</span><span class="l">${l}</span></div>`).join('');

    // The story that goes *below* the image — the first-person prose a player pastes
    // alongside the card in a social post. Rendered as flowing paragraphs (acts).
    const arcHTML = (story.arc || []).map(p => `<p class="story-arc-para">${p}</p>`).join('');

    // The .story-card is a live HTML replica of the share image — same logo, themed
    // band, archetype, narrative, chips, and CTA. The PNG is only built on share, so
    // there's no per-turn canvas raster while the panel is pinned open.
    body.innerHTML = `
        <div class="company-story">
            ${renderPostMortemBlock()}
            <div class="story-image-caption">Your shareable card</div>
            <div class="story-card" style="--c0:${c0};--c1:${c1}">
                <div class="story-card-band">
                    <img class="story-card-logo" src="svg/startupCards.svg" alt="Startup Cards" />
                    <div class="story-card-arch">
                        <span class="story-card-emoji" aria-hidden="true">${a.emoji}</span>
                        <div>
                            <div class="story-card-arch-name">${a.name}</div>
                            <div class="story-card-arch-blurb">${a.blurb}</div>
                        </div>
                    </div>
                </div>
                <div class="story-card-body">
                    <div class="story-card-company">${gameState.companyName || 'Our Startup'}</div>
                    <p class="story-card-narrative">${story.paragraph}</p>
                    <div class="story-card-chips">${chipsHTML}</div>
                    <div class="story-card-cta">What kind of founder are you?</div>
                    <div class="story-card-url">Play free → dlightning.org/games</div>
                </div>
            </div>
            <div class="story-arc">
                <div class="story-arc-title">Your shareable story</div>
                <p class="story-arc-sub">The tale to post with your card — it grows richer the longer you build.</p>
                <div class="story-arc-prose">${arcHTML}</div>
            </div>
            <div class="company-story-actions">
                <button type="button" class="btn-share" onclick="shareStoryImage()">📣 Share image</button>
                <button type="button" class="btn-share btn-share-secondary" onclick="shareCompanyStory()">🔗 Copy text</button>
            </div>
            <p class="company-story-hint" id="companyStoryHint" role="status" aria-live="polite"></p>
        </div>`;
}

// Copy the story text to the clipboard, falling back to a selectable dialog where
// the clipboard API isn't available (e.g. file:// or older browsers).
async function shareCompanyStory() {
    const story = generateCompanyStory();
    if (!story) return;
    const hint = document.getElementById('companyStoryHint');
    const setHint = (msg) => { if (hint) hint.textContent = msg; };

    // The image button owns the native share sheet; this "Copy text" path goes
    // straight to the clipboard, with a selectable dialog as the last resort.
    if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
            await navigator.clipboard.writeText(story.shareText);
            setHint('Copied to clipboard — paste it anywhere! 📋');
            return;
        } catch (err) { /* fall through to the manual dialog */ }
    }

    showAlertDialog({
        icon: '📣',
        title: 'Copy your story',
        message: story.shareText.replace(/\n/g, '<br>')
    });
}

;
// persistence — localStorage save/load + multi-startup management (see CLAUDE.md / js/game)
//
// gameState lives in memory, so a refresh wipes a run back to the baseline. This
// module mirrors the full state into localStorage after every decision, keyed by a
// per-startup id, so a founder can leave and return to any business they started.
// Saved businesses are surfaced on the second card (see generateSavedGamesCard +
// main.js); loading one replaces the fresh blank slate the player is sitting on.

const SAVE_INDEX_KEY = 'startupSim:index';     // lightweight list of saves, for the picker
const SAVE_GAME_PREFIX = 'startupSim:game:';   // SAVE_GAME_PREFIX + id → full serialized state
const SAVE_VERSION = 1;

// Id of the game currently in play, assigned lazily the first time there's a
// decision worth saving. Null until then (and after a save is deleted).
let currentGameId = null;

// Sentinel for JSON, which can't represent Infinity (a stream paying out forever
// stores monthsRemaining: Infinity). Round-tripped via the reviver/replacer below.
const INFINITY_SENTINEL = '__Infinity__';

function storageAvailable() {
    try {
        const k = '__ss_test__';
        localStorage.setItem(k, '1');
        localStorage.removeItem(k);
        return true;
    } catch (e) {
        return false;
    }
}

function genGameId() {
    return 'g_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
}

// ── (de)serialization ────────────────────────────────────────────────────────
// gameState is JSON-friendly except for three things, all handled here:
//  • Date fields (founded, each selected card's selectedAtDate) — Date.toJSON
//    already emits ISO strings on save; we revive them to Date objects on load.
//  • Infinity stream lifetimes — swapped for a sentinel via the replacer/reviver.
//  • employee.card — a live reference into selectedCards (promotions/layoffs
//    re-scale it in place). We store its index instead and re-link on load so
//    the restored employee points at the SAME card object, not a duplicate.

function serializeGameState() {
    const cards = gameState.selectedCards || [];
    const out = JSON.parse(JSON.stringify(gameState, (key, value) =>
        value === Infinity ? INFINITY_SENTINEL : value
    ));
    out.employees = (gameState.employees || []).map(e => {
        const copy = Object.assign({}, e);
        delete copy.card;
        copy.cardIndex = e.card ? cards.indexOf(e.card) : -1;
        return copy;
    });
    return out;
}

function deserializeGameState(raw) {
    const gs = raw;
    if (gs.founded) gs.founded = new Date(gs.founded);
    // Market state postdates early saves — default to a neutral market so restored runs
    // don't divide acquisition by an undefined climate (see advanceCustomers / engine tick).
    if (typeof gs.marketClimate !== 'number') gs.marketClimate = 1;
    if (typeof gs.competitorPressure !== 'number') gs.competitorPressure = 0;
    if (typeof gs.investorEquity !== 'number') gs.investorEquity = 0;
    (gs.selectedCards || []).forEach(c => {
        if (c.selectedAtDate) c.selectedAtDate = new Date(c.selectedAtDate);
    });
    (gs.employees || []).forEach(e => {
        const idx = (typeof e.cardIndex === 'number') ? e.cardIndex : -1;
        e.card = idx >= 0 ? gs.selectedCards[idx] : null;
        delete e.cardIndex;
    });
    return gs;
}

// Mutate the live gameState object in place rather than reassigning it, so every
// module that closed over the original reference keeps seeing the restored state.
function replaceGameState(obj) {
    Object.keys(gameState).forEach(k => delete gameState[k]);
    Object.assign(gameState, obj);
}

// ── save index (the picker's source of truth) ────────────────────────────────

function readIndex() {
    try {
        const str = localStorage.getItem(SAVE_INDEX_KEY);
        const arr = str ? JSON.parse(str) : [];
        return Array.isArray(arr) ? arr : [];
    } catch (e) {
        return [];
    }
}

function writeIndex(arr) {
    try {
        localStorage.setItem(SAVE_INDEX_KEY, JSON.stringify(arr));
    } catch (e) { /* quota or unavailable — game still runs in memory */ }
}

// Compact, display-ready summary stored in the index so the picker doesn't have
// to parse every full save blob just to render the list.
function buildSaveSummary(id) {
    return {
        id,
        companyName: gameState.companyName,
        founded: gameState.founded instanceof Date ? gameState.founded.toISOString() : gameState.founded,
        savedAt: new Date().toISOString(),
        currentMonth: gameState.currentMonth,
        currentYear: gameState.currentYear,
        runway: Math.round(gameState.runway),
        monthlyRevenue: Math.round(gameState.monthlyRevenue),
        teamSize: gameState.teamSize,
        customers: gameState.customers,
        decisions: (gameState.selectedCards || []).length,
        exited: !!gameState.exited,
        exitSalePrice: Math.round(gameState.exitSalePrice || 0),
        gameOver: !!gameState.gameOver,
        endingKey: gameState.endingKey || null
    };
}

// ── public-ish API ────────────────────────────────────────────────────────────

// Persist the current run. Called after every decision / team change / price set.
// No-ops until the founder has actually made a choice, so we never litter the
// picker with untouched blank slates.
function saveCurrentGame() {
    if (!storageAvailable()) return;
    if (!gameState.selectedCards || gameState.selectedCards.length === 0) return;
    if (!currentGameId) currentGameId = genGameId();
    try {
        const blob = { version: SAVE_VERSION, savedAt: Date.now(), state: serializeGameState() };
        localStorage.setItem(SAVE_GAME_PREFIX + currentGameId, JSON.stringify(blob));
        const index = readIndex().filter(s => s.id !== currentGameId);
        index.push(buildSaveSummary(currentGameId));
        writeIndex(index);
    } catch (e) {
        console.warn('Could not save game:', e);
    }
}

// Saves for the picker: only those whose full blob still exists, newest first.
function listSavedGames() {
    if (!storageAvailable()) return [];
    return readIndex()
        .filter(s => s && s.id && localStorage.getItem(SAVE_GAME_PREFIX + s.id))
        .sort((a, b) => new Date(b.savedAt) - new Date(a.savedAt));
}

// Restore a saved business over the current (in-memory) state. Returns false if
// the blob is missing or unreadable so callers can surface the failure.
function loadSavedGame(id) {
    if (!storageAvailable()) return false;
    let blob;
    try {
        const str = localStorage.getItem(SAVE_GAME_PREFIX + id);
        if (!str) return false;
        blob = JSON.parse(str, (key, value) => value === INFINITY_SENTINEL ? Infinity : value);
    } catch (e) {
        return false;
    }
    const state = blob && blob.state ? blob.state : blob; // tolerate a future/legacy flat shape
    replaceGameState(deserializeGameState(state));
    currentGameId = id;
    return true;
}

function deleteSavedGame(id) {
    try { localStorage.removeItem(SAVE_GAME_PREFIX + id); } catch (e) { /* ignore */ }
    writeIndex(readIndex().filter(s => s.id !== id));
    if (currentGameId === id) currentGameId = null;
}

// ── the "Saved Businesses" card (second card) ────────────────────────────────

function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, c =>
        ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
}

function formatSaveMonth(s) {
    // currentMonth can be fractional (0.5-month cards), so round to a whole month
    // and recompute year/month from it — never show a decimal or desync at a year line.
    const absMonth = Math.max(1, Math.round(s.currentMonth));
    const year = Math.floor((absMonth - 1) / 12) + 1;
    const month = ((absMonth - 1) % 12) + 1;
    return year > 1 ? `Y${year} M${month}` : `M${month}`;
}

function savedGameRowHTML(s) {
    // How a failed run reads in the picker, keyed by which ending it hit.
    const failCause = s.endingKey === 'ideaFlop' ? 'Never found traction'
        : (s.endingKey === 'burnout' ? 'Founder burnt out' : 'Ran out of money');
    const failBadge = s.endingKey === 'ideaFlop' ? '💡 Closed'
        : (s.endingKey === 'burnout' ? '🔥 Closed' : '💸 Closed');
    const tag = s.exited
        ? '<span class="saved-game-tag">🎉 Exited</span>'
        : (s.gameOver ? `<span class="saved-game-tag failed">${failBadge}</span>` : '');
    const name = escapeHtml(s.companyName || 'Untitled Startup');
    // Exited businesses are sold; closed (failed) ones are over — both read as a
    // record rather than a live runway. Otherwise show the live runway/revenue.
    let meta;
    if (s.exited) {
        meta = `${formatSaveMonth(s)} · Sold for ${formatMoney(s.exitSalePrice || 0)} · ${s.teamSize} team · ${s.decisions} decisions`;
    } else if (s.gameOver) {
        meta = `${formatSaveMonth(s)} · ${failCause} · ${s.teamSize} team · ${s.decisions} decisions`;
    } else {
        meta = `${formatSaveMonth(s)} · ${formatMoney(s.runway)} runway · ${formatMoney(s.monthlyRevenue)}/mo · ${s.teamSize} team · ${s.decisions} decisions`;
    }
    const loadLabel = s.exited ? 'Buy back' : (s.gameOver ? 'Review' : 'Load');
    return `
        <li class="saved-game-row" data-id="${s.id}" data-name="${name}">
            <div class="saved-game-info">
                <div class="saved-game-name">${name}${tag}</div>
                <div class="saved-game-meta">${meta}</div>
            </div>
            <div class="saved-game-actions">
                <button class="saved-game-load" onclick="loadGameFromCard('${s.id}', this)">${loadLabel}</button>
                <button class="saved-game-delete" onclick="deleteGameFromCard('${s.id}', this)" aria-label="Delete ${name}" title="Delete">✕</button>
            </div>
        </li>`;
}

function generateSavedGamesCard() {
    const rows = listSavedGames().map(savedGameRowHTML).join('');
    // no-swipe keeps it from being flung off by an errant drag (see swipe-cards.js)
    // — the per-row Load buttons and the Start-fresh skip button drive it instead.
    return `
        <div class="business-card no-swipe saved-games-card">
            <div class="card-header opportunity">
                <div class="card-type-wrapper">
                    <div><p>Welcome back</p></div>
                    <div class="card-type">SAVED&nbsp; 💾</div>
                </div>
                <h2>Your Businesses</h2>
            </div>
            <div class="card-body">
                <div style="margin-top: 6px;" class="content-desc">Pick up where you left off. Loading a business replaces the blank slate you're on now.</div>
                <ul class="saved-games-list">${rows}</ul>
                <div class="action-buttons">
                    <button class="btn btn-skip" onclick="skipCard(this)">Start fresh &rarr;</button>
                </div>
            </div>
        </div>`;
}

// ── card button handlers ──────────────────────────────────────────────────────

// Set the company-name button to the restored name. updateCompanyName() picks a
// RANDOM name and is only right for a brand-new game; on resume we keep the saved one.
function applyRestoredCompanyName() {
    if (!domCache.companyName) initDOMCache();
    if (domCache.companyName) domCache.companyName.textContent = gameState.companyName;
}

function loadGameFromCard(id, button) {
    // An exited (sold) business can't just be resumed — the founder has to buy it
    // back at what it sold for, which usually means going into the red.
    const summary = listSavedGames().find(s => s.id === id);
    if (summary && summary.exited) {
        promptBuyBack(id, summary);
        return;
    }
    if (!loadSavedGame(id)) {
        showAlertDialog({
            tone: 'danger',
            icon: '⚠️',
            title: 'Could not load',
            message: 'Sorry — that saved business could not be loaded. Its data may be missing or corrupted.'
        });
        return;
    }
    resumeLoadedGame();
}

// Confirm and apply a buy-back of a sold company: pay the sale price out of its
// own runway (debt allowed), clear the exit, then resume play.
function promptBuyBack(id, summary) {
    const price = summary.exitSalePrice || 0;
    const after = Math.round((summary.runway || 0) - price);
    showConfirmDialog({
        tone: 'founder',
        icon: '↩️',
        title: `Buy back ${summary.companyName || 'this business'}?`,
        rows: [
            ['Reacquisition price', formatMoney(price)],
            ['Runway after', formatMoney(after)]
        ],
        note: after < 0
            ? `Reacquiring costs what it sold for. You'll start ${formatMoney(after)} in the red and have to dig your way back out.`
            : 'Reacquiring costs what it sold for, paid out of the company\'s runway.',
        cancelLabel: 'Cancel',
        confirmLabel: 'Buy back',
        onConfirm: () => {
            if (!loadSavedGame(id)) {
                showAlertDialog({
                    tone: 'danger',
                    icon: '⚠️',
                    title: 'Could not load',
                    message: 'Sorry — that saved business could not be loaded. Its data may be missing or corrupted.'
                });
                return;
            }
            // Apply the repurchase to the now-loaded state: cash out, exit undone.
            gameState.runway -= price;
            gameState.exited = false;
            delete gameState.exitSalePrice;
            recomputeMonthlyRevenue();
            // Mark the outlay on the financial chart so the debt shows immediately.
            if (typeof recordHistorySnapshot === 'function') recordHistorySnapshot(price > 0 ? price : 0);
            saveCurrentGame();
            resumeLoadedGame();
        }
    });
}

// Swap the fresh blank stack out for the just-loaded business and refresh the UI.
// (Instructions is already gone, since the picker had to be the active card to
// click Load.) Shared by a normal load and a buy-back.
function resumeLoadedGame() {
    const container = domCache.simulatorContainer || document.getElementById('simulatorContainer');
    container.querySelectorAll('.business-card').forEach(c => c.remove());
    if (typeof outcomeQueue !== 'undefined' && Array.isArray(outcomeQueue)) outcomeQueue.length = 0;

    applyRestoredCompanyName();
    recomputeMonthlyRevenue();
    updatePriceDisplay();
    updateUI();
    if (typeof updateSelectionsButtonText === 'function') updateSelectionsButtonText();
    // A failed run is terminal: re-show its verdict card rather than dealing fresh
    // cards (loadMoreCards is gated on gameOver and would leave an empty stack).
    if (gameState.gameOver && gameState.endingKey && typeof renderEnding === 'function') {
        renderEnding(gameState.endingKey);
    } else {
        loadMoreCards(4, true); // skip outcome checks on the restore deal (see loadMoreCards)
    }
    if (typeof updateOpenModals === 'function') updateOpenModals();
}

function deleteGameFromCard(id, button) {
    const row = button.closest('.saved-game-row');
    const list = button.closest('.saved-games-list');
    const name = (row && row.dataset.name) || 'this business';
    showConfirmDialog({
        tone: 'danger',
        icon: '🗑️',
        title: `Delete ${name}?`,
        note: "This permanently removes the saved business. This can't be undone.",
        cancelLabel: 'Keep',
        confirmLabel: 'Delete',
        onConfirm: () => {
            deleteSavedGame(id);
            if (row) row.remove();
            if (list && !list.querySelector('.saved-game-row')) {
                list.innerHTML = '<li class="saved-games-empty">No saved businesses left — start fresh below.</li>';
            }
        }
    });
}

;
/* Fullscreen support — two entry points, kept entirely separate from the card
   deck so they can't introduce card-render bugs:

     • Desktop: a persistent toggle button pinned bottom-right (shown only on
       fine-pointer/hover devices via CSS).
     • Touch/small screens: a prompt overlay on load (mirrors the help
       modal — a standalone dialog, NOT a deck card), offering "Go fullscreen"
       or "Not now". Asked once per page load so the player can choose each
       reload (no persistence).

   Note: iOS Safari does not implement the Fullscreen API at all, so when it's
   unsupported we create neither the button nor the prompt — nothing to break. */
(function () {
    const docEl = document.documentElement;

    function fsElement() {
        return document.fullscreenElement || document.webkitFullscreenElement || null;
    }
    function fsSupported() {
        return !!(docEl.requestFullscreen || docEl.webkitRequestFullscreen);
    }
    function enterFullscreen() {
        const req = docEl.requestFullscreen || docEl.webkitRequestFullscreen;
        if (!req) return;
        const p = req.call(docEl);
        if (p && p.catch) p.catch(() => {}); // user-gesture/permission rejections are non-fatal
    }
    function exitFullscreen() {
        const exit = document.exitFullscreen || document.webkitExitFullscreen;
        if (!exit) return;
        const p = exit.call(document);
        if (p && p.catch) p.catch(() => {});
    }
    function toggleFullscreen() {
        if (fsElement()) exitFullscreen(); else enterFullscreen();
    }
    window.toggleFullscreen = toggleFullscreen;

    const ICON_EXPAND =
        '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 3H5a2 2 0 0 0-2 2v3M21 8V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3M16 21h3a2 2 0 0 0 2-2v-3"/></svg>';
    const ICON_COMPRESS =
        '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 3v3a2 2 0 0 1-2 2H3M21 8h-3a2 2 0 0 1-2-2V3M3 16h3a2 2 0 0 1 2 2v3M16 21v-3a2 2 0 0 1 2-2h3"/></svg>';

    let toggleBtn = null;

    function syncToggleIcon() {
        if (!toggleBtn) return;
        const on = !!fsElement();
        toggleBtn.innerHTML = on ? ICON_COMPRESS : ICON_EXPAND;
        toggleBtn.setAttribute('aria-label', on ? 'Exit fullscreen' : 'Enter fullscreen');
        toggleBtn.setAttribute('aria-pressed', String(on));
        toggleBtn.title = on ? 'Exit fullscreen' : 'Fullscreen';
    }

    function createToggleButton() {
        toggleBtn = document.createElement('button');
        toggleBtn.type = 'button';
        toggleBtn.id = 'fullscreenToggle';
        toggleBtn.className = 'fullscreen-toggle';
        toggleBtn.addEventListener('click', toggleFullscreen);
        document.body.appendChild(toggleBtn);
        syncToggleIcon();
    }

    /* One-time prompt overlay for touch/small screens. Reuses the global
       openDialog/closeDialog focus management and the .help-modal backdrop. */
    function createPrompt() {
        const modal = document.createElement('div');
        modal.className = 'help-modal fs-prompt';
        modal.id = 'fsPrompt';
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-modal', 'true');
        modal.setAttribute('aria-labelledby', 'fsPromptTitle');
        modal.innerHTML = `
            <div class="help-modal-content fs-prompt-content">
                <div class="help-header">
                    <h2 id="fsPromptTitle">📱 Go fullscreen?</h2>
                </div>
                <div class="help-body">
                    <p class="fs-prompt-text">Hide the browser bars for more room to play. You can exit anytime from the menu.</p>
                    <div class="fs-prompt-actions">
                        <button type="button" class="btn btn-skip" id="fsPromptSkip">Not now</button>
                        <button type="button" class="btn btn-select" id="fsPromptGo">Go fullscreen</button>
                    </div>
                </div>
            </div>`;
        document.body.appendChild(modal);

        function dismiss(goFullscreen) {
            if (goFullscreen) enterFullscreen(); // must run inside the click gesture
            if (typeof closeDialog === 'function') closeDialog(modal);
            else modal.remove();
        }
        modal.querySelector('#fsPromptGo').addEventListener('click', () => dismiss(true));
        modal.querySelector('#fsPromptSkip').addEventListener('click', () => dismiss(false));
        return modal;
    }

    function maybeShowPrompt() {
        if (fsElement()) return; // already fullscreen — nothing to ask
        // Touch devices only — desktop gets the corner button instead.
        const isTouch = window.matchMedia('(pointer: coarse)').matches;
        const isSmall = window.matchMedia('(max-width: 767px), (max-height: 640px)').matches;
        if (!isTouch || !isSmall) return;

        const modal = createPrompt();
        if (typeof openDialog === 'function') openDialog(modal);
        else { modal.style.display = 'flex'; setTimeout(() => modal.classList.add('show'), 10); }
    }

    function init() {
        if (!fsSupported()) return; // iOS Safari etc. — skip both entry points
        createToggleButton();
        document.addEventListener('fullscreenchange', syncToggleIcon);
        document.addEventListener('webkitfullscreenchange', syncToggleIcon);
        maybeShowPrompt();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

;
// main — extracted from biz-sim.js (see CLAUDE.md / js/game)


// Enhanced initialization with better error handling
function initializeSimulator() {
    try {
        initDOMCache();

        // Returning founder who just exited and chose "Start a new business": seed the
        // fresh runway with their take-home proceeds. Handed off via sessionStorage
        // rather than a URL param (which would be trivially editable to cheat), and
        // consumed immediately so it's a true one-time hand-off — a later refresh then
        // behaves like any normal visit (picker shown, no re-seeding).
        let exitProceeds = 0;
        try {
            const stored = sessionStorage.getItem('startupSim:proceeds');
            if (stored) {
                const amount = parseInt(stored, 10);
                if (!isNaN(amount) && amount > 0) {
                    gameState.runway = amount;
                    exitProceeds = amount;
                }
                sessionStorage.removeItem('startupSim:proceeds');
            }
        } catch (e) { /* sessionStorage unavailable — skip the hand-off */ }

        const container = domCache.simulatorContainer;
        if (!container) {
            console.error('Simulator container not found');
            return;
        }
        
        // Add instructions card first, then load the rest of the initial stack
        const instructionsHTML = generateInstructionsCard();
        const instructionsElement = document.createElement('div');
        instructionsElement.innerHTML = instructionsHTML;
        container.appendChild(instructionsElement.firstElementChild);

        // If the founder has saved businesses from a previous visit, surface them on
        // the second card so they can pick up where they left off. Nothing has
        // happened in this fresh session yet, so loading over it is lossless.
        // Skip this when arriving from the exit flow: the founder just sold up and is
        // deliberately starting a new business with their winnings.
        if (!exitProceeds && typeof listSavedGames === 'function' && listSavedGames().length > 0) {
            const savedElement = document.createElement('div');
            savedElement.innerHTML = generateSavedGamesCard();
            container.appendChild(savedElement.firstElementChild);
        }

        loadMoreCards(4);

        updateCompanyName();
        //Calculate metrics for existing selections
        if (gameState.selectedCards.length > 0) {
            recalculateAllMetrics();
        }
        recomputeMonthlyRevenue();
        updatePriceDisplay();
        updateUI();
        // Seed the graph history with a starting baseline so charts have a point
        // to draw from before any decisions are made.
        if (gameState.history.length === 0) {
            recordHistorySnapshot();
        }
        initializeCompanyMetricsModal();
        
        // Add event listeners
        domCache.selectionsBtn?.addEventListener('click', toggleSelectionsModal);

        // Bottom-nav price stepper
        document.getElementById('priceUp')?.addEventListener('click', () => changePrice(PRICE_STEP));
        document.getElementById('priceDown')?.addEventListener('click', () => changePrice(-PRICE_STEP));

        // Modal event listeners
        document.addEventListener('click', (e) => {
            const modal = document.getElementById('selectionsModal');
            if (modal && e.target === modal) {
                closeSelectionsModal();
            }
        });
        
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                closeSelectionsModal();
            }
        });

    } catch (error) {
        console.error('Failed to initialize simulator:', error);
    }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initializeSimulator);

;
(function ($) {
    const SWIPE_THRESHOLD = 90;     // px to trigger on slow drags
    const VELOCITY_THRESHOLD = 0.4; // px/ms to trigger on fast flicks
    const ROTATION_FACTOR = 0.12;   // degrees per px of horizontal drag

    let dragging = false;
    let lockedAxis = null; // 'h' | 'v' | null
    let startX = 0, startY = 0;
    let currentCard = null;
    let recentPositions = []; // [{x, t}] for velocity calc
    let lastTouchTime = 0;    // timestamp of the last touch event — used to ignore
                              // the synthetic mouse events mobile browsers dispatch
                              // after a tap (which otherwise flip the card twice)

    function clientXY(e) {
        const src = e.touches ? e.touches[0] : e;
        return { x: src.clientX, y: src.clientY };
    }

    function endXY(e) {
        const src = e.changedTouches ? e.changedTouches[0] : e;
        return { x: src.clientX, y: src.clientY };
    }

    // ── drag start ────────────────────────────────────────────────────────────
    $(document).on('mousedown touchstart', '.business-card.stack-active', function (e) {
        // The document-level touchstart listener is passive in mobile Chrome, so the
        // preventDefault below can't stop the ghost mouse events that trail a tap.
        // Track touches instead and drop any mouse event that follows one closely —
        // otherwise the ghost mousedown/mouseup re-runs the tap and re-flips the card.
        if (e.type === 'touchstart') lastTouchTime = Date.now();
        else if (Date.now() - lastTouchTime < 700) return;

        if ($(e.target).closest('button, a, input, select, textarea').length) return;

        // Management cards (e.g. the saved-games picker) opt out of drag-to-dismiss
        // so a stray swipe can't fling them away mid-decision.
        if (this.classList.contains('no-swipe')) return;

        const pt = clientXY(e);
        dragging = true;
        lockedAxis = null;
        startX = pt.x;
        startY = pt.y;
        currentCard = this;
        recentPositions = [{ x: pt.x, t: Date.now() }];

        $(this).css('transition', 'none');
        e.preventDefault();
    });

    // ── drag move ─────────────────────────────────────────────────────────────
    $(document).on('mousemove touchmove', function (e) {
        if (!dragging || !currentCard) return;

        const pt = clientXY(e);
        const dx = pt.x - startX;
        const dy = pt.y - startY;

        // Lock axis after first 6px so vertical scrolls don't become swipes
        if (!lockedAxis && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
            lockedAxis = Math.abs(dx) >= Math.abs(dy) ? 'h' : 'v';
        }

        if (lockedAxis === 'v') {
            resetCard(currentCard);
            dragging = false;
            currentCard = null;
            return;
        }

        e.preventDefault();

        // Track recent positions (keep last 5) for velocity calculation
        recentPositions.push({ x: pt.x, t: Date.now() });
        if (recentPositions.length > 5) recentPositions.shift();

        const rot = dx * ROTATION_FACTOR;
        const vertDrift = dy * 0.15;
        $(currentCard).css('transform', `translateX(${dx}px) translateY(${vertDrift}px) rotate(${rot}deg)`);

        const progress = Math.min(Math.abs(dx) / SWIPE_THRESHOLD, 1);
        setIndicator(currentCard, dx > 0 ? 'add' : 'skip', progress);
    });

    // ── drag end ──────────────────────────────────────────────────────────────
    $(document).on('mouseup touchend', function (e) {
        if (e.type === 'touchend') lastTouchTime = Date.now();
        else if (Date.now() - lastTouchTime < 700) return; // ghost mouseup after a tap

        if (!dragging || !currentCard) return;
        dragging = false;

        const pt = endXY(e);
        const dx = pt.x - startX;

        // Compute velocity from the last two tracked positions
        let velocity = 0;
        if (recentPositions.length >= 2) {
            const a = recentPositions[recentPositions.length - 2];
            const b = recentPositions[recentPositions.length - 1];
            const dt = b.t - a.t;
            if (dt > 0) velocity = (b.x - a.x) / dt; // px/ms, signed
        }

        clearIndicator(currentCard);

        const pastDistThreshold = lockedAxis === 'h' && Math.abs(dx) >= SWIPE_THRESHOLD;
        const pastVelThreshold  = Math.abs(velocity) >= VELOCITY_THRESHOLD;

        if (pastDistThreshold || pastVelThreshold) {
            // Direction: velocity wins on fast flicks, dx wins on slow drags
            const goRight = pastVelThreshold ? velocity > 0 : dx > 0;
            const card = currentCard;
            currentCard = null;
            fling(card, goRight ? 'select' : 'skip');
        } else {
            resetCard(currentCard);
            // A press that never locked to an axis and barely moved is a tap, not a
            // drag — flip the card to reveal its full metrics (back face).
            const dy = pt.y - startY;
            const isTap = lockedAxis === null && Math.abs(dx) < 10 && Math.abs(dy) < 10;
            if (isTap && currentCard.classList.contains('flippable')) {
                flipCard(currentCard);
            }
            currentCard = null;
        }

        lockedAxis = null;
        recentPositions = [];
    });

    // ── helpers ───────────────────────────────────────────────────────────────
    function resetCard(card) {
        $(card).css('transition', '').css('transform', '');
    }

    // Toggle the card's face and play the lift-and-flip keyframes. The animation
    // is restarted explicitly (clear + reflow) so repeated taps always replay it,
    // and the direction is chosen so the card flips back the way it came.
    function flipCard(card) {
        const inner = card.querySelector('.card-inner');
        const toBack = !card.classList.contains('flipped');
        card.classList.toggle('flipped');
        if (!inner) return;

        inner.style.animation = 'none';
        void inner.offsetWidth; // force reflow so the animation can restart
        inner.style.animation = (toBack ? 'cardFlipToBack' : 'cardFlipToFront') +
            ' 0.6s cubic-bezier(0.4, 0, 0.2, 1) forwards';

        // Sweep a diagonal sheen across the ARRIVING face in time with the flip.
        // The direction class selects which face's sheen runs, so the two faces'
        // sheens never overlap into an "X". Restart it (clear + reflow) so it
        // replays on every tap, and drop the classes when done.
        card.classList.remove('flipping', 'flip-to-back', 'flip-to-front');
        void card.offsetWidth;
        card.classList.add('flipping', toBack ? 'flip-to-back' : 'flip-to-front');
        clearTimeout(card._sheenTimer);
        card._sheenTimer = setTimeout(function () {
            card.classList.remove('flipping', 'flip-to-back', 'flip-to-front');
        }, 600);
    }

    // Resolve the button a swipe/key should trigger, falling back to the card's
    // other action button when the matching one is absent. This is what lets a left
    // swipe on an acknowledge-only outcome card (which has just an Acknowledge button,
    // a .btn-select, and no .btn-skip) still acknowledge — otherwise the card flings
    // away with no button to fire and the stack freezes.
    function actionButton(card, action) {
        const primary  = action === 'select' ? '.btn-select' : '.btn-skip';
        const fallback = action === 'select' ? '.btn-skip'  : '.btn-select';
        return card.querySelector(primary) || card.querySelector(fallback);
    }

    function fling(card, action) {
        // If there's nothing to trigger, don't fling — leaving the card off-screen
        // with no button to fire would freeze the stack.
        const btn = actionButton(card, action);
        if (!btn) { resetCard(card); return; }

        // Mark the card so selectCard/skipCard know not to re-animate it
        card.dataset.swiping = 'true';

        const targetX = action === 'select' ? '140%' : '-140%';
        const rot     = action === 'select' ? '20deg'  : '-20deg';

        $(card).css({
            transition: 'transform 0.28s ease-in, opacity 0.2s ease-in',
            transform: `translateX(${targetX}) rotate(${rot})`,
            opacity: 0
        });

        // Fire the button immediately — selectCard/skipCard will see dataset.swiping
        // and skip their own dismiss animation, just handling game state + DOM cleanup
        btn.click();
    }

    // Stamp overlay (ADD / SKIP) shown while dragging
    function setIndicator(card, direction, progress) {
        let el = card.querySelector('.swipe-stamp');
        if (!el) {
            el = document.createElement('div');
            el.className = 'swipe-stamp';
            el.setAttribute('aria-hidden', 'true');
            card.appendChild(el);
        }
        el.classList.toggle('stamp-add',  direction === 'add');
        el.classList.toggle('stamp-skip', direction === 'skip');
        el.textContent = direction === 'add' ? 'ADD' : 'SKIP';
        el.style.opacity = progress;
    }

    function clearIndicator(card) {
        const el = card && card.querySelector('.swipe-stamp');
        if (el) el.style.opacity = 0;
    }

    // ── keyboard controls ───────────────────────────────────────────────────────
    // Mirror the swipe gestures for keyboard users: ← skips, → adds, and Enter / F
    // flips the focused card. Skip/Add fall back to whichever action button the
    // card actually has, so outcome cards (no Skip) just ignore the missing one.
    function triggerAction(card, action) {
        if (card.dataset.swiping) return; // already animating out
        if (!actionButton(card, action)) return; // no actionable button at all
        fling(card, action);
    }

    // Track input modality so the next-card focus ring only shows for keyboard use.
    $(document).on('pointerdown', function () {
        if (window.gameState) gameState.lastActionViaKeyboard = false;
    });

    $(document).on('keydown', function (e) {
        // Bail only when keyboard focus is inside a *focus-trapping* dialog — there
        // the keys belong to the dialog. On desktop the metrics/selections panels are
        // pinned open beside the cards (see the min-width:1330px layout) and run with
        // aria-modal="false", so focus may rest on one of their controls (e.g. the Org
        // Chart tab button) while the player keeps driving cards. Only true modals
        // (mobile overlays, the help/confirm dialogs) carry aria-modal="true".
        const dialog = $(e.target).closest('.selections-modal, .company-metrics-modal, .help-modal')[0];
        if (dialog && dialog.getAttribute('aria-modal') === 'true') return;

        const card = document.querySelector('.business-card.stack-active');
        if (!card) return;

        // Whether focus is on something that handles its own keys (a button, link,
        // or form field) — Enter there should activate it, not flip the card.
        const onInteractive = $(e.target).closest('button, a, input, select, textarea').length > 0;
        // 'f' types into fields but does nothing on a button/link, so it can flip
        // even when focus rests on a control (e.g. the trigger button after opening
        // a pinned panel) — only a text field should swallow it.
        const inTextField = $(e.target).closest('input, textarea, select').length > 0;

        switch (e.key) {
            case 'ArrowRight':
                if (inTextField) break; // arrows move the caret while typing (e.g. renaming the company)
                e.preventDefault();
                if (window.gameState) gameState.lastActionViaKeyboard = true;
                triggerAction(card, 'select');
                break;
            case 'ArrowLeft':
                if (inTextField) break;
                e.preventDefault();
                if (window.gameState) gameState.lastActionViaKeyboard = true;
                triggerAction(card, 'skip');
                break;
            case 'Enter':
                if (!onInteractive && card.classList.contains('flippable')) {
                    e.preventDefault();
                    flipCard(card);
                }
                break;
            case 'f':
            case 'F':
                if (!inTextField && card.classList.contains('flippable')) {
                    e.preventDefault();
                    flipCard(card);
                }
                break;
            case 'Escape':
                // No modal is open here (guarded above), so Esc just flips a
                // flipped card back to its front face.
                if (card.classList.contains('flipped')) {
                    e.preventDefault();
                    flipCard(card);
                }
                break;
        }
    });

})(jQuery);

;
